
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("59TQn", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require1, module1, exports) {
                (function(global1) {
                    (function() {
                        /*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $jscomp = $jscomp || {};
                        $jscomp.scope = {};
                        $jscomp.createTemplateTagFirstArg = function(a) {
                            return a.raw = a;
                        };
                        $jscomp.createTemplateTagFirstArgWithRaw = function(a, b) {
                            a.raw = b;
                            return a;
                        };
                        $jscomp.arrayIteratorImpl = function(a) {
                            var b = 0;
                            return function() {
                                return b < a.length ? {
                                    done: !1,
                                    value: a[b++]
                                } : {
                                    done: !0
                                };
                            };
                        };
                        $jscomp.arrayIterator = function(a) {
                            return {
                                next: $jscomp.arrayIteratorImpl(a)
                            };
                        };
                        $jscomp.makeIterator = function(a) {
                            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
                            return b ? b.call(a) : $jscomp.arrayIterator(a);
                        };
                        $jscomp.arrayFromIterator = function(a) {
                            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                            return c;
                        };
                        $jscomp.arrayFromIterable = function(a) {
                            return a instanceof Array ? a : $jscomp.arrayFromIterator($jscomp.makeIterator(a));
                        };
                        $jscomp.checkStringArgs = function(a, b, c) {
                            if (null == a) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
                            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
                            return a + "";
                        };
                        $jscomp.ASSUME_ES5 = !1;
                        $jscomp.ASSUME_NO_NATIVE_MAP = !1;
                        $jscomp.ASSUME_NO_NATIVE_SET = !1;
                        $jscomp.SIMPLE_FROUND_POLYFILL = !1;
                        $jscomp.ISOLATE_POLYFILLS = !1;
                        $jscomp.FORCE_POLYFILL_PROMISE = !1;
                        $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
                        $jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
                            if (a == Array.prototype || a == Object.prototype) return a;
                            a[b] = c.value;
                            return a;
                        };
                        $jscomp.getGlobal = function(a) {
                            a = [
                                "object" == typeof globalThis && globalThis,
                                a,
                                "object" == typeof window && window,
                                "object" == typeof self && self,
                                "object" == typeof global1 && global1
                            ];
                            for(var b = 0; b < a.length; ++b){
                                var c = a[b];
                                if (c && c.Math == Math) return c;
                            }
                            throw Error("Cannot find global object");
                        };
                        $jscomp.global = $jscomp.getGlobal(this);
                        $jscomp.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
                        $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
                        $jscomp.polyfills = {};
                        $jscomp.propertyToPolyfillSymbol = {};
                        $jscomp.POLYFILL_PREFIX = "$jscp$";
                        var $jscomp$lookupPolyfilledValue = function(a, b) {
                            var c = $jscomp.propertyToPolyfillSymbol[b];
                            if (null == c) return a[b];
                            c = a[c];
                            return void 0 !== c ? c : a[b];
                        };
                        $jscomp.polyfill = function(a, b, c, d) {
                            b && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(a, b, c, d) : $jscomp.polyfillUnisolated(a, b, c, d));
                        };
                        $jscomp.polyfillUnisolated = function(a, b, c, d) {
                            c = $jscomp.global;
                            a = a.split(".");
                            for(d = 0; d < a.length - 1; d++){
                                var e = a[d];
                                if (!(e in c)) return;
                                c = c[e];
                            }
                            a = a[a.length - 1];
                            d = c[a];
                            b = b(d);
                            b != d && null != b && $jscomp.defineProperty(c, a, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            });
                        };
                        $jscomp.polyfillIsolated = function(a, b, c, d) {
                            var e = a.split(".");
                            a = 1 === e.length;
                            d = e[0];
                            d = !a && d in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
                            for(var f = 0; f < e.length - 1; f++){
                                var g = e[f];
                                if (!(g in d)) return;
                                d = d[g];
                            }
                            e = e[e.length - 1];
                            c = $jscomp.IS_SYMBOL_NATIVE && "es6" === c ? d[e] : null;
                            b = b(c);
                            null != b && (a ? $jscomp.defineProperty($jscomp.polyfills, e, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            }) : b !== c && ($jscomp.propertyToPolyfillSymbol[e] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(e) : $jscomp.POLYFILL_PREFIX + e, e = $jscomp.propertyToPolyfillSymbol[e], $jscomp.defineProperty(d, e, {
                                configurable: !0,
                                writable: !0,
                                value: b
                            })));
                        };
                        $jscomp.polyfill("String.prototype.endsWith", function(a) {
                            return a ? a : function(b, c) {
                                var d = $jscomp.checkStringArgs(this, b, "endsWith");
                                b += "";
                                void 0 === c && (c = d.length);
                                c = Math.max(0, Math.min(c | 0, d.length));
                                for(var e = b.length; 0 < e && 0 < c;)if (d[--c] != b[--e]) return !1;
                                return 0 >= e;
                            };
                        }, "es6", "es3");
                        $jscomp.findInternal = function(a, b, c) {
                            a instanceof String && (a = String(a));
                            for(var d = a.length, e = 0; e < d; e++){
                                var f = a[e];
                                if (b.call(c, f, e, a)) return {
                                    i: e,
                                    v: f
                                };
                            }
                            return {
                                i: -1,
                                v: void 0
                            };
                        };
                        $jscomp.polyfill("Array.prototype.find", function(a) {
                            return a ? a : function(b, c) {
                                return $jscomp.findInternal(this, b, c).v;
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("String.prototype.startsWith", function(a) {
                            return a ? a : function(b, c) {
                                var d = $jscomp.checkStringArgs(this, b, "startsWith");
                                b += "";
                                var e = d.length, f = b.length;
                                c = Math.max(0, Math.min(c | 0, d.length));
                                for(var g = 0; g < f && c < e;)if (d[c++] != b[g++]) return !1;
                                return g >= f;
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("String.prototype.repeat", function(a) {
                            return a ? a : function(b) {
                                var c = $jscomp.checkStringArgs(this, null, "repeat");
                                if (0 > b || 1342177279 < b) throw new RangeError("Invalid count value");
                                b |= 0;
                                for(var d = ""; b;)if (b & 1 && (d += c), b >>>= 1) c += c;
                                return d;
                            };
                        }, "es6", "es3");
                        $jscomp.initSymbol = function() {};
                        $jscomp.polyfill("Symbol", function(a) {
                            if (a) return a;
                            var b = function(e, f) {
                                this.$jscomp$symbol$id_ = e;
                                $jscomp.defineProperty(this, "description", {
                                    configurable: !0,
                                    writable: !0,
                                    value: f
                                });
                            };
                            b.prototype.toString = function() {
                                return this.$jscomp$symbol$id_;
                            };
                            var c = 0, d = function(e) {
                                if (this instanceof d) throw new TypeError("Symbol is not a constructor");
                                return new b("jscomp_symbol_" + (e || "") + "_" + c++, e);
                            };
                            return d;
                        }, "es6", "es3");
                        $jscomp.polyfill("Symbol.iterator", function(a) {
                            if (a) return a;
                            a = Symbol("Symbol.iterator");
                            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                                var d = $jscomp.global[b[c]];
                                "function" === typeof d && "function" != typeof d.prototype[a] && $jscomp.defineProperty(d.prototype, a, {
                                    configurable: !0,
                                    writable: !0,
                                    value: function() {
                                        return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
                                    }
                                });
                            }
                            return a;
                        }, "es6", "es3");
                        $jscomp.iteratorPrototype = function(a) {
                            a = {
                                next: a
                            };
                            a[Symbol.iterator] = function() {
                                return this;
                            };
                            return a;
                        };
                        $jscomp.iteratorFromArray = function(a, b) {
                            a instanceof String && (a += "");
                            var c = 0, d = !1, e = {
                                next: function() {
                                    if (!d && c < a.length) {
                                        var f = c++;
                                        return {
                                            value: b(f, a[f]),
                                            done: !1
                                        };
                                    }
                                    d = !0;
                                    return {
                                        done: !0,
                                        value: void 0
                                    };
                                }
                            };
                            e[Symbol.iterator] = function() {
                                return e;
                            };
                            return e;
                        };
                        $jscomp.polyfill("Array.prototype.keys", function(a) {
                            return a ? a : function() {
                                return $jscomp.iteratorFromArray(this, function(b) {
                                    return b;
                                });
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("Object.is", function(a) {
                            return a ? a : function(b, c) {
                                return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
                            };
                        }, "es6", "es3");
                        $jscomp.polyfill("Array.prototype.includes", function(a) {
                            return a ? a : function(b, c) {
                                var d = this;
                                d instanceof String && (d = String(d));
                                var e = d.length;
                                c = c || 0;
                                for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                                    var f = d[c];
                                    if (f === b || Object.is(f, b)) return !0;
                                }
                                return !1;
                            };
                        }, "es7", "es3");
                        $jscomp.polyfill("String.prototype.includes", function(a) {
                            return a ? a : function(b, c) {
                                return -1 !== $jscomp.checkStringArgs(this, b, "includes").indexOf(b, c || 0);
                            };
                        }, "es6", "es3");
                        var COMPILED = !0, goog = goog || {};
                        goog.global = this || self;
                        goog.exportPath_ = function(a, b, c, d) {
                            a = a.split(".");
                            d = d || goog.global;
                            a[0] in d || "undefined" == typeof d.execScript || d.execScript("var " + a[0]);
                            for(var e; a.length && (e = a.shift());)if (a.length || void 0 === b) d = d[e] && d[e] !== Object.prototype[e] ? d[e] : d[e] = {};
                            else if (!c && goog.isObject(b) && goog.isObject(d[e])) for(var f in b)b.hasOwnProperty(f) && (d[e][f] = b[f]);
                            else d[e] = b;
                        };
                        goog.define = function(a, b) {
                            if (!COMPILED) {
                                var c = goog.global.CLOSURE_UNCOMPILED_DEFINES, d = goog.global.CLOSURE_DEFINES;
                                c && void 0 === c.nodeType && Object.prototype.hasOwnProperty.call(c, a) ? b = c[a] : d && void 0 === d.nodeType && Object.prototype.hasOwnProperty.call(d, a) && (b = d[a]);
                            }
                            return b;
                        };
                        goog.FEATURESET_YEAR = 2012;
                        goog.DEBUG = !0;
                        goog.LOCALE = "en";
                        goog.TRUSTED_SITE = !0;
                        goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
                        goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
                        goog.provide = function(a) {
                            if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
                            if (!COMPILED && goog.isProvided_(a)) throw Error('Namespace "' + a + '" already declared.');
                            goog.constructNamespace_(a);
                        };
                        goog.constructNamespace_ = function(a, b, c) {
                            if (!COMPILED) {
                                delete goog.implicitNamespaces_[a];
                                for(var d = a; (d = d.substring(0, d.lastIndexOf("."))) && !goog.getObjectByName(d);)goog.implicitNamespaces_[d] = !0;
                            }
                            goog.exportPath_(a, b, c);
                        };
                        goog.getScriptNonce = function(a) {
                            if (a && a != goog.global) return goog.getScriptNonce_(a.document);
                            null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
                            return goog.cspNonce_;
                        };
                        goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
                        goog.cspNonce_ = null;
                        goog.getScriptNonce_ = function(a) {
                            return (a = a.querySelector && a.querySelector("script[nonce]")) && (a = a.nonce || a.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(a) ? a : "";
                        };
                        goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
                        goog.module = function(a) {
                            if ("string" !== typeof a || !a || -1 == a.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
                            if (!goog.isInGoogModuleLoader_()) throw Error("Module " + a + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
                            if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
                            goog.moduleLoaderState_.moduleName = a;
                            if (!COMPILED) {
                                if (goog.isProvided_(a)) throw Error('Namespace "' + a + '" already declared.');
                                delete goog.implicitNamespaces_[a];
                            }
                        };
                        goog.module.get = function(a) {
                            return goog.module.getInternal_(a);
                        };
                        goog.module.getInternal_ = function(a) {
                            if (!COMPILED) {
                                if (a in goog.loadedModules_) return goog.loadedModules_[a].exports;
                                if (!goog.implicitNamespaces_[a]) return a = goog.getObjectByName(a), null != a ? a : null;
                            }
                            return null;
                        };
                        goog.ModuleType = {
                            ES6: "es6",
                            GOOG: "goog"
                        };
                        goog.moduleLoaderState_ = null;
                        goog.isInModuleLoader_ = function() {
                            return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
                        };
                        goog.isInGoogModuleLoader_ = function() {
                            return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
                        };
                        goog.isInEs6ModuleLoader_ = function() {
                            if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
                            var a = goog.global.$jscomp;
                            return a ? "function" != typeof a.getCurrentModulePath ? !1 : !!a.getCurrentModulePath() : !1;
                        };
                        goog.module.declareLegacyNamespace = function() {
                            if (!COMPILED && !goog.isInGoogModuleLoader_()) throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
                            if (!COMPILED && !goog.moduleLoaderState_.moduleName) throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
                            goog.moduleLoaderState_.declareLegacyNamespace = !0;
                        };
                        goog.declareModuleId = function(a) {
                            if (!COMPILED) {
                                if (!goog.isInEs6ModuleLoader_()) throw Error("goog.declareModuleId may only be called from within an ES6 module");
                                if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName) throw Error("goog.declareModuleId may only be called once per module.");
                                if (a in goog.loadedModules_) throw Error('Module with namespace "' + a + '" already exists.');
                            }
                            if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = a;
                            else {
                                var b = goog.global.$jscomp;
                                if (!b || "function" != typeof b.getCurrentModulePath) throw Error('Module with namespace "' + a + '" has been loaded incorrectly.');
                                b = b.require(b.getCurrentModulePath());
                                goog.loadedModules_[a] = {
                                    exports: b,
                                    type: goog.ModuleType.ES6,
                                    moduleId: a
                                };
                            }
                        };
                        goog.setTestOnly = function(a) {
                            if (goog.DISALLOW_TEST_ONLY_CODE) throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
                        };
                        goog.forwardDeclare = function(a) {};
                        COMPILED || (goog.isProvided_ = function(a) {
                            return a in goog.loadedModules_ || !goog.implicitNamespaces_[a] && null != goog.getObjectByName(a);
                        }, goog.implicitNamespaces_ = {
                            "goog.module": !0
                        });
                        goog.getObjectByName = function(a, b) {
                            a = a.split(".");
                            b = b || goog.global;
                            for(var c = 0; c < a.length; c++)if (b = b[a[c]], null == b) return null;
                            return b;
                        };
                        goog.addDependency = function(a, b, c, d) {
                            !COMPILED && goog.DEPENDENCIES_ENABLED && goog.debugLoader_.addDependency(a, b, c, d);
                        };
                        goog.ENABLE_DEBUG_LOADER = !0;
                        goog.logToConsole_ = function(a) {
                            goog.global.console && goog.global.console.error(a);
                        };
                        goog.require = function(a) {
                            if (!COMPILED) {
                                goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested(a);
                                if (goog.isProvided_(a)) {
                                    if (goog.isInModuleLoader_()) return goog.module.getInternal_(a);
                                } else if (goog.ENABLE_DEBUG_LOADER) {
                                    var b = goog.moduleLoaderState_;
                                    goog.moduleLoaderState_ = null;
                                    try {
                                        goog.debugLoader_.load_(a);
                                    } finally{
                                        goog.moduleLoaderState_ = b;
                                    }
                                }
                                return null;
                            }
                        };
                        goog.requireType = function(a) {
                            return {};
                        };
                        goog.basePath = "";
                        goog.nullFunction = function() {};
                        goog.abstractMethod = function() {
                            throw Error("unimplemented abstract method");
                        };
                        goog.addSingletonGetter = function(a) {
                            a.instance_ = void 0;
                            a.getInstance = function() {
                                if (a.instance_) return a.instance_;
                                goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
                                return a.instance_ = new a;
                            };
                        };
                        goog.instantiatedSingletons_ = [];
                        goog.LOAD_MODULE_USING_EVAL = !0;
                        goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
                        goog.loadedModules_ = {};
                        goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
                        goog.TRANSPILE = "detect";
                        goog.ASSUME_ES_MODULES_TRANSPILED = !1;
                        goog.TRANSPILE_TO_LANGUAGE = "";
                        goog.TRANSPILER = "transpile.js";
                        goog.hasBadLetScoping = null;
                        goog.useSafari10Workaround = function() {
                            if (null == goog.hasBadLetScoping) {
                                try {
                                    var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
                                } catch (b) {
                                    a = !1;
                                }
                                goog.hasBadLetScoping = a;
                            }
                            return goog.hasBadLetScoping;
                        };
                        goog.workaroundSafari10EvalBug = function(a) {
                            return "(function(){" + a + "\n;})();\n";
                        };
                        goog.loadModule = function(a) {
                            var b = goog.moduleLoaderState_;
                            try {
                                goog.moduleLoaderState_ = {
                                    moduleName: "",
                                    declareLegacyNamespace: !1,
                                    type: goog.ModuleType.GOOG
                                };
                                var c = {}, d = c;
                                if ("function" === typeof a) d = a.call(void 0, d);
                                else if ("string" === typeof a) goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)), d = goog.loadModuleFromSource_.call(void 0, d, a);
                                else throw Error("Invalid module definition");
                                var e = goog.moduleLoaderState_.moduleName;
                                if ("string" === typeof e && e) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(e, d, c !== d) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof d && null != d && Object.seal(d), goog.loadedModules_[e] = {
                                    exports: d,
                                    type: goog.ModuleType.GOOG,
                                    moduleId: goog.moduleLoaderState_.moduleName
                                };
                                else throw Error('Invalid module name "' + e + '"');
                            } finally{
                                goog.moduleLoaderState_ = b;
                            }
                        };
                        goog.loadModuleFromSource_ = function(a, b) {
                            eval(b);
                            return a;
                        };
                        goog.normalizePath_ = function(a) {
                            a = a.split("/");
                            for(var b = 0; b < a.length;)"." == a[b] ? a.splice(b, 1) : b && ".." == a[b] && a[b - 1] && ".." != a[b - 1] ? a.splice(--b, 2) : b++;
                            return a.join("/");
                        };
                        goog.loadFileSync_ = function(a) {
                            if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
                            try {
                                var b = new goog.global.XMLHttpRequest;
                                b.open("get", a, !1);
                                b.send();
                                return 0 == b.status || 200 == b.status ? b.responseText : null;
                            } catch (c) {
                                return null;
                            }
                        };
                        goog.transpile_ = function(a, b, c) {
                            var d = goog.global.$jscomp;
                            d || (goog.global.$jscomp = d = {});
                            var e = d.transpile;
                            if (!e) {
                                var f = goog.basePath + goog.TRANSPILER, g = goog.loadFileSync_(f);
                                if (g) {
                                    (function() {
                                        (0, eval)(g + "\n//# sourceURL=" + f);
                                    }).call(goog.global);
                                    if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
                                    goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
                                    d = goog.global.$jscomp;
                                    e = d.transpile;
                                }
                            }
                            e || (e = d.transpile = function(h, k) {
                                goog.logToConsole_(k + " requires transpilation but no transpiler was found.");
                                return h;
                            });
                            return e(a, b, c);
                        };
                        goog.typeOf = function(a) {
                            var b = typeof a;
                            return "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
                        };
                        goog.isArrayLike = function(a) {
                            var b = goog.typeOf(a);
                            return "array" == b || "object" == b && "number" == typeof a.length;
                        };
                        goog.isDateLike = function(a) {
                            return goog.isObject(a) && "function" == typeof a.getFullYear;
                        };
                        goog.isObject = function(a) {
                            var b = typeof a;
                            return "object" == b && null != a || "function" == b;
                        };
                        goog.getUid = function(a) {
                            return Object.prototype.hasOwnProperty.call(a, goog.UID_PROPERTY_) && a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
                        };
                        goog.hasUid = function(a) {
                            return !!a[goog.UID_PROPERTY_];
                        };
                        goog.removeUid = function(a) {
                            null !== a && "removeAttribute" in a && a.removeAttribute(goog.UID_PROPERTY_);
                            try {
                                delete a[goog.UID_PROPERTY_];
                            } catch (b) {}
                        };
                        goog.UID_PROPERTY_ = "closure_uid_" + (1E9 * Math.random() >>> 0);
                        goog.uidCounter_ = 0;
                        goog.cloneObject = function(a) {
                            var b = goog.typeOf(a);
                            if ("object" == b || "array" == b) {
                                if ("function" === typeof a.clone) return a.clone();
                                b = "array" == b ? [] : {};
                                for(var c in a)b[c] = goog.cloneObject(a[c]);
                                return b;
                            }
                            return a;
                        };
                        goog.bindNative_ = function(a, b, c) {
                            return a.call.apply(a.bind, arguments);
                        };
                        goog.bindJs_ = function(a, b, c) {
                            if (!a) throw Error();
                            if (2 < arguments.length) {
                                var d = Array.prototype.slice.call(arguments, 2);
                                return function() {
                                    var e = Array.prototype.slice.call(arguments);
                                    Array.prototype.unshift.apply(e, d);
                                    return a.apply(b, e);
                                };
                            }
                            return function() {
                                return a.apply(b, arguments);
                            };
                        };
                        goog.bind = function(a, b, c) {
                            Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
                            return goog.bind.apply(null, arguments);
                        };
                        goog.partial = function(a, b) {
                            var c = Array.prototype.slice.call(arguments, 1);
                            return function() {
                                var d = c.slice();
                                d.push.apply(d, arguments);
                                return a.apply(this, d);
                            };
                        };
                        goog.mixin = function(a, b) {
                            for(var c in b)a[c] = b[c];
                        };
                        goog.now = function() {
                            return Date.now();
                        };
                        goog.globalEval = function(a) {
                            (0, eval)(a);
                        };
                        goog.getCssName = function(a, b) {
                            if ("." == String(a).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);
                            var c = function(e) {
                                return goog.cssNameMapping_[e] || e;
                            }, d = function(e) {
                                e = e.split("-");
                                for(var f = [], g = 0; g < e.length; g++)f.push(c(e[g]));
                                return f.join("-");
                            };
                            d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function(e) {
                                return e;
                            };
                            a = b ? a + "-" + d(b) : d(a);
                            return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(a) : a;
                        };
                        goog.setCssNameMapping = function(a, b) {
                            goog.cssNameMapping_ = a;
                            goog.cssNameMappingStyle_ = b;
                        };
                        !COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
                        goog.getMsg = function(a, b, c) {
                            c && c.html && (a = a.replace(/</g, "&lt;"));
                            c && c.unescapeHtmlEntities && (a = a.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, "&"));
                            b && (a = a.replace(/\{\$([^}]+)}/g, function(d, e) {
                                return null != b && e in b ? b[e] : d;
                            }));
                            return a;
                        };
                        goog.getMsgWithFallback = function(a, b) {
                            return a;
                        };
                        goog.exportSymbol = function(a, b, c) {
                            goog.exportPath_(a, b, !0, c);
                        };
                        goog.exportProperty = function(a, b, c) {
                            a[b] = c;
                        };
                        goog.inherits = function(a, b) {
                            function c() {}
                            c.prototype = b.prototype;
                            a.superClass_ = b.prototype;
                            a.prototype = new c;
                            a.prototype.constructor = a;
                            a.base = function(d, e, f) {
                                for(var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++)g[h - 2] = arguments[h];
                                return b.prototype[e].apply(d, g);
                            };
                        };
                        goog.scope = function(a) {
                            if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
                            a.call(goog.global);
                        };
                        COMPILED || (goog.global.COMPILED = COMPILED);
                        goog.defineClass = function(a, b) {
                            var c = b.constructor, d = b.statics;
                            c && c != Object.prototype.constructor || (c = function() {
                                throw Error("cannot instantiate an interface (no constructor defined).");
                            });
                            c = goog.defineClass.createSealingConstructor_(c, a);
                            a && goog.inherits(c, a);
                            delete b.constructor;
                            delete b.statics;
                            goog.defineClass.applyProperties_(c.prototype, b);
                            null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
                            return c;
                        };
                        goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
                        goog.defineClass.createSealingConstructor_ = function(a, b) {
                            return goog.defineClass.SEAL_CLASS_INSTANCES ? function() {
                                var c = a.apply(this, arguments) || this;
                                c[goog.UID_PROPERTY_] = c[goog.UID_PROPERTY_];
                                return c;
                            } : a;
                        };
                        goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
                        goog.defineClass.applyProperties_ = function(a, b) {
                            for(var c in b)Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
                            for(var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++)c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
                        };
                        !COMPILED && goog.DEPENDENCIES_ENABLED && (goog.inHtmlDocument_ = function() {
                            var a = goog.global.document;
                            return null != a && "write" in a;
                        }, goog.isDocumentLoading_ = function() {
                            var a = goog.global.document;
                            return a.attachEvent ? "complete" != a.readyState : "loading" == a.readyState;
                        }, goog.findBasePath_ = function() {
                            if (void 0 != goog.global.CLOSURE_BASE_PATH && "string" === typeof goog.global.CLOSURE_BASE_PATH) goog.basePath = goog.global.CLOSURE_BASE_PATH;
                            else if (goog.inHtmlDocument_()) {
                                var a = goog.global.document, b = a.currentScript;
                                a = b ? [
                                    b
                                ] : a.getElementsByTagName("SCRIPT");
                                for(b = a.length - 1; 0 <= b; --b){
                                    var c = a[b].src, d = c.lastIndexOf("?");
                                    d = -1 == d ? c.length : d;
                                    if ("base.js" == c.substr(d - 7, 7)) {
                                        goog.basePath = c.substr(0, d - 7);
                                        break;
                                    }
                                }
                            }
                        }, goog.findBasePath_(), goog.Transpiler = function() {
                            this.requiresTranspilation_ = null;
                            this.transpilationTarget_ = goog.TRANSPILE_TO_LANGUAGE;
                        }, goog.Transpiler.prototype.createRequiresTranspilation_ = function() {
                            function a(g, h) {
                                e ? d[g] = !0 : h() ? (c = g, d[g] = !1) : e = d[g] = !0;
                            }
                            function b(g) {
                                try {
                                    return !!eval(g);
                                } catch (h) {
                                    return !1;
                                }
                            }
                            var c = "es3", d = {
                                es3: !1
                            }, e = !1, f = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "";
                            a("es5", function() {
                                return b("[1,].length==1");
                            });
                            a("es6", function() {
                                return f.match(/Edge\/(\d+)(\.\d)*/i) ? !1 : b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
                            });
                            a("es7", function() {
                                return b("2 ** 2 == 4");
                            });
                            a("es8", function() {
                                return b("async () => 1, true");
                            });
                            a("es9", function() {
                                return b("({...rest} = {}), true");
                            });
                            a("es_next", function() {
                                return !1;
                            });
                            return {
                                target: c,
                                map: d
                            };
                        }, goog.Transpiler.prototype.needsTranspile = function(a, b) {
                            if ("always" == goog.TRANSPILE) return !0;
                            if ("never" == goog.TRANSPILE) return !1;
                            if (!this.requiresTranspilation_) {
                                var c = this.createRequiresTranspilation_();
                                this.requiresTranspilation_ = c.map;
                                this.transpilationTarget_ = this.transpilationTarget_ || c.target;
                            }
                            if (a in this.requiresTranspilation_) return this.requiresTranspilation_[a] ? !0 : !goog.inHtmlDocument_() || "es6" != b || "noModule" in goog.global.document.createElement("script") ? !1 : !0;
                            throw Error("Unknown language mode: " + a);
                        }, goog.Transpiler.prototype.transpile = function(a, b) {
                            return goog.transpile_(a, b, this.transpilationTarget_);
                        }, goog.transpiler_ = new goog.Transpiler, goog.protectScriptTag_ = function(a) {
                            return a.replace(/<\/(SCRIPT)/ig, "\\x3c/$1");
                        }, goog.DebugLoader_ = function() {
                            this.dependencies_ = {};
                            this.idToPath_ = {};
                            this.written_ = {};
                            this.loadingDeps_ = [];
                            this.depsToLoad_ = [];
                            this.paused_ = !1;
                            this.factory_ = new goog.DependencyFactory(goog.transpiler_);
                            this.deferredCallbacks_ = {};
                            this.deferredQueue_ = [];
                        }, goog.DebugLoader_.prototype.bootstrap = function(a, b) {
                            function c() {
                                d && (goog.global.setTimeout(d, 0), d = null);
                            }
                            var d = b;
                            if (a.length) {
                                b = [];
                                for(var e = 0; e < a.length; e++){
                                    var f = this.getPathFromDeps_(a[e]);
                                    if (!f) throw Error("Unregonized namespace: " + a[e]);
                                    b.push(this.dependencies_[f]);
                                }
                                f = goog.require;
                                var g = 0;
                                for(e = 0; e < a.length; e++)f(a[e]), b[e].onLoad(function() {
                                    ++g == a.length && c();
                                });
                            } else c();
                        }, goog.DebugLoader_.prototype.loadClosureDeps = function() {
                            this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath + "deps.js"), "deps.js", [], [], {}, !1));
                            this.loadDeps_();
                        }, goog.DebugLoader_.prototype.requested = function(a, b) {
                            (a = this.getPathFromDeps_(a)) && (b || this.areDepsLoaded_(this.dependencies_[a].requires)) && (b = this.deferredCallbacks_[a]) && (delete this.deferredCallbacks_[a], b());
                        }, goog.DebugLoader_.prototype.setDependencyFactory = function(a) {
                            this.factory_ = a;
                        }, goog.DebugLoader_.prototype.load_ = function(a) {
                            if (this.getPathFromDeps_(a)) {
                                var b = this, c = [], d = function(e) {
                                    var f = b.getPathFromDeps_(e);
                                    if (!f) throw Error("Bad dependency path or symbol: " + e);
                                    if (!b.written_[f]) {
                                        b.written_[f] = !0;
                                        e = b.dependencies_[f];
                                        for(f = 0; f < e.requires.length; f++)goog.isProvided_(e.requires[f]) || d(e.requires[f]);
                                        c.push(e);
                                    }
                                };
                                d(a);
                                a = !!this.depsToLoad_.length;
                                this.depsToLoad_ = this.depsToLoad_.concat(c);
                                this.paused_ || a || this.loadDeps_();
                            } else throw a = "goog.require could not find: " + a, goog.logToConsole_(a), Error(a);
                        }, goog.DebugLoader_.prototype.loadDeps_ = function() {
                            for(var a = this, b = this.paused_; this.depsToLoad_.length && !b;)(function() {
                                var c = !1, d = a.depsToLoad_.shift(), e = !1;
                                a.loading_(d);
                                var f = {
                                    pause: function() {
                                        if (c) throw Error("Cannot call pause after the call to load.");
                                        b = !0;
                                    },
                                    resume: function() {
                                        c ? a.resume_() : b = !1;
                                    },
                                    loaded: function() {
                                        if (e) throw Error("Double call to loaded.");
                                        e = !0;
                                        a.loaded_(d);
                                    },
                                    pending: function() {
                                        for(var g = [], h = 0; h < a.loadingDeps_.length; h++)g.push(a.loadingDeps_[h]);
                                        return g;
                                    },
                                    setModuleState: function(g) {
                                        goog.moduleLoaderState_ = {
                                            type: g,
                                            moduleName: "",
                                            declareLegacyNamespace: !1
                                        };
                                    },
                                    registerEs6ModuleExports: function(g, h, k) {
                                        k && (goog.loadedModules_[k] = {
                                            exports: h,
                                            type: goog.ModuleType.ES6,
                                            moduleId: k || ""
                                        });
                                    },
                                    registerGoogModuleExports: function(g, h) {
                                        goog.loadedModules_[g] = {
                                            exports: h,
                                            type: goog.ModuleType.GOOG,
                                            moduleId: g
                                        };
                                    },
                                    clearModuleState: function() {
                                        goog.moduleLoaderState_ = null;
                                    },
                                    defer: function(g) {
                                        if (c) throw Error("Cannot register with defer after the call to load.");
                                        a.defer_(d, g);
                                    },
                                    areDepsLoaded: function() {
                                        return a.areDepsLoaded_(d.requires);
                                    }
                                };
                                try {
                                    d.load(f);
                                } finally{
                                    c = !0;
                                }
                            })();
                            b && this.pause_();
                        }, goog.DebugLoader_.prototype.pause_ = function() {
                            this.paused_ = !0;
                        }, goog.DebugLoader_.prototype.resume_ = function() {
                            this.paused_ && (this.paused_ = !1, this.loadDeps_());
                        }, goog.DebugLoader_.prototype.loading_ = function(a) {
                            this.loadingDeps_.push(a);
                        }, goog.DebugLoader_.prototype.loaded_ = function(a) {
                            for(var b = 0; b < this.loadingDeps_.length; b++)if (this.loadingDeps_[b] == a) {
                                this.loadingDeps_.splice(b, 1);
                                break;
                            }
                            for(b = 0; b < this.deferredQueue_.length; b++)if (this.deferredQueue_[b] == a.path) {
                                this.deferredQueue_.splice(b, 1);
                                break;
                            }
                            if (this.loadingDeps_.length == this.deferredQueue_.length && !this.depsToLoad_.length) for(; this.deferredQueue_.length;)this.requested(this.deferredQueue_.shift(), !0);
                            a.loaded();
                        }, goog.DebugLoader_.prototype.areDepsLoaded_ = function(a) {
                            for(var b = 0; b < a.length; b++){
                                var c = this.getPathFromDeps_(a[b]);
                                if (!c || !(c in this.deferredCallbacks_ || goog.isProvided_(a[b]))) return !1;
                            }
                            return !0;
                        }, goog.DebugLoader_.prototype.getPathFromDeps_ = function(a) {
                            return a in this.idToPath_ ? this.idToPath_[a] : a in this.dependencies_ ? a : null;
                        }, goog.DebugLoader_.prototype.defer_ = function(a, b) {
                            this.deferredCallbacks_[a.path] = b;
                            this.deferredQueue_.push(a.path);
                        }, goog.LoadController = function() {}, goog.LoadController.prototype.pause = function() {}, goog.LoadController.prototype.resume = function() {}, goog.LoadController.prototype.loaded = function() {}, goog.LoadController.prototype.pending = function() {}, goog.LoadController.prototype.registerEs6ModuleExports = function(a, b, c) {}, goog.LoadController.prototype.setModuleState = function(a) {}, goog.LoadController.prototype.clearModuleState = function() {}, goog.LoadController.prototype.defer = function(a) {}, goog.LoadController.prototype.areDepsLoaded = function() {}, goog.Dependency = function(a, b, c, d, e) {
                            this.path = a;
                            this.relativePath = b;
                            this.provides = c;
                            this.requires = d;
                            this.loadFlags = e;
                            this.loaded_ = !1;
                            this.loadCallbacks_ = [];
                        }, goog.Dependency.prototype.getPathName = function() {
                            var a = this.path, b = a.indexOf("://");
                            0 <= b && (a = a.substring(b + 3), b = a.indexOf("/"), 0 <= b && (a = a.substring(b + 1)));
                            return a;
                        }, goog.Dependency.prototype.onLoad = function(a) {
                            this.loaded_ ? a() : this.loadCallbacks_.push(a);
                        }, goog.Dependency.prototype.loaded = function() {
                            this.loaded_ = !0;
                            var a = this.loadCallbacks_;
                            this.loadCallbacks_ = [];
                            for(var b = 0; b < a.length; b++)a[b]();
                        }, goog.Dependency.defer_ = !1, goog.Dependency.callbackMap_ = {}, goog.Dependency.registerCallback_ = function(a) {
                            var b = Math.random().toString(32);
                            goog.Dependency.callbackMap_[b] = a;
                            return b;
                        }, goog.Dependency.unregisterCallback_ = function(a) {
                            delete goog.Dependency.callbackMap_[a];
                        }, goog.Dependency.callback_ = function(a, b) {
                            if (a in goog.Dependency.callbackMap_) {
                                for(var c = goog.Dependency.callbackMap_[a], d = [], e = 1; e < arguments.length; e++)d.push(arguments[e]);
                                c.apply(void 0, d);
                            } else throw Error("Callback key " + a + " does not exist (was base.js loaded more than once?).");
                        }, goog.Dependency.prototype.load = function(a) {
                            if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
                            else if (goog.inHtmlDocument_()) {
                                var b = goog.global.document;
                                if ("complete" == b.readyState && !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING) {
                                    if (/\bdeps.js$/.test(this.path)) {
                                        a.loaded();
                                        return;
                                    }
                                    throw Error('Cannot write "' + this.path + '" after document load');
                                }
                                var c = goog.getScriptNonce();
                                if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && goog.isDocumentLoading_()) {
                                    var d = function(h) {
                                        h.readyState && "complete" != h.readyState ? h.onload = d : (goog.Dependency.unregisterCallback_(e), a.loaded());
                                    };
                                    var e = goog.Dependency.registerCallback_(d);
                                    c = c ? ' nonce="' + c + '"' : "";
                                    var f = '<script src="' + this.path + '"' + c + (goog.Dependency.defer_ ? " defer" : "") + ' id="script-' + e + '"></script>';
                                    f += "<script" + c + ">";
                                    f = goog.Dependency.defer_ ? f + ("document.getElementById('script-" + e + "').onload = function() {\n  goog.Dependency.callback_('" + e + "', this);\n};\n") : f + ("goog.Dependency.callback_('" + e + "', document.getElementById('script-" + e + "'));");
                                    f += "</script>";
                                    b.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(f) : f);
                                } else {
                                    var g = b.createElement("script");
                                    g.defer = goog.Dependency.defer_;
                                    g.async = !1;
                                    c && (g.nonce = c);
                                    goog.DebugLoader_.IS_OLD_IE_ ? (a.pause(), g.onreadystatechange = function() {
                                        if ("loaded" == g.readyState || "complete" == g.readyState) a.loaded(), a.resume();
                                    }) : g.onload = function() {
                                        g.onload = null;
                                        a.loaded();
                                    };
                                    g.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path) : this.path;
                                    b.head.appendChild(g);
                                }
                            } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), "deps.js" == this.relativePath ? (goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."), a.loaded()) : a.pause();
                        }, goog.Es6ModuleDependency = function(a, b, c, d, e) {
                            goog.Dependency.call(this, a, b, c, d, e);
                        }, goog.inherits(goog.Es6ModuleDependency, goog.Dependency), goog.Es6ModuleDependency.prototype.load = function(a) {
                            function b(l, p) {
                                var m = "", n = goog.getScriptNonce();
                                n && (m = ' nonce="' + n + '"');
                                l = p ? '<script type="module" crossorigin' + m + ">" + p + "</script>" : '<script type="module" crossorigin src="' + l + '"' + m + "></script>";
                                d.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(l) : l);
                            }
                            function c(l, p) {
                                var m = d.createElement("script");
                                m.defer = !0;
                                m.async = !1;
                                m.type = "module";
                                m.setAttribute("crossorigin", !0);
                                var n = goog.getScriptNonce();
                                n && (m.nonce = n);
                                p ? m.text = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScript(p) : p : m.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(l) : l;
                                d.head.appendChild(m);
                            }
                            if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
                            else if (goog.inHtmlDocument_()) {
                                var d = goog.global.document, e = this;
                                if (goog.isDocumentLoading_()) {
                                    var f = b;
                                    goog.Dependency.defer_ = !0;
                                } else f = c;
                                var g = goog.Dependency.registerCallback_(function() {
                                    goog.Dependency.unregisterCallback_(g);
                                    a.setModuleState(goog.ModuleType.ES6);
                                });
                                f(void 0, 'goog.Dependency.callback_("' + g + '")');
                                f(this.path, void 0);
                                var h = goog.Dependency.registerCallback_(function(l) {
                                    goog.Dependency.unregisterCallback_(h);
                                    a.registerEs6ModuleExports(e.path, l, goog.moduleLoaderState_.moduleName);
                                });
                                f(void 0, 'import * as m from "' + this.path + '"; goog.Dependency.callback_("' + h + '", m)');
                                var k = goog.Dependency.registerCallback_(function() {
                                    goog.Dependency.unregisterCallback_(k);
                                    a.clearModuleState();
                                    a.loaded();
                                });
                                f(void 0, 'goog.Dependency.callback_("' + k + '")');
                            } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), a.pause();
                        }, goog.TransformedDependency = function(a, b, c, d, e) {
                            goog.Dependency.call(this, a, b, c, d, e);
                            this.contents_ = null;
                            this.lazyFetch_ = !goog.inHtmlDocument_() || !("noModule" in goog.global.document.createElement("script"));
                        }, goog.inherits(goog.TransformedDependency, goog.Dependency), goog.TransformedDependency.prototype.load = function(a) {
                            function b() {
                                e.contents_ = goog.loadFileSync_(e.path);
                                e.contents_ && (e.contents_ = e.transform(e.contents_), e.contents_ && (e.contents_ += "\n//# sourceURL=" + e.path));
                            }
                            function c() {
                                e.lazyFetch_ && b();
                                if (e.contents_) {
                                    f && a.setModuleState(goog.ModuleType.ES6);
                                    try {
                                        var p = e.contents_;
                                        e.contents_ = null;
                                        goog.globalEval(p);
                                        if (f) var m = goog.moduleLoaderState_.moduleName;
                                    } finally{
                                        f && a.clearModuleState();
                                    }
                                    f && goog.global.$jscomp.require.ensure([
                                        e.getPathName()
                                    ], function() {
                                        a.registerEs6ModuleExports(e.path, goog.global.$jscomp.require(e.getPathName()), m);
                                    });
                                    a.loaded();
                                }
                            }
                            function d() {
                                var p = goog.global.document, m = goog.Dependency.registerCallback_(function() {
                                    goog.Dependency.unregisterCallback_(m);
                                    c();
                                }), n = goog.getScriptNonce();
                                n = "<script" + (n ? ' nonce="' + n + '"' : "") + ">" + goog.protectScriptTag_('goog.Dependency.callback_("' + m + '");') + "</script>";
                                p.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(n) : n);
                            }
                            var e = this;
                            if (goog.global.CLOSURE_IMPORT_SCRIPT) b(), this.contents_ && goog.global.CLOSURE_IMPORT_SCRIPT("", this.contents_) ? (this.contents_ = null, a.loaded()) : a.pause();
                            else {
                                var f = this.loadFlags.module == goog.ModuleType.ES6;
                                this.lazyFetch_ || b();
                                var g = 1 < a.pending().length, h = g && goog.DebugLoader_.IS_OLD_IE_;
                                g = goog.Dependency.defer_ && (g || goog.isDocumentLoading_());
                                if (h || g) a.defer(function() {
                                    c();
                                });
                                else {
                                    var k = goog.global.document;
                                    h = goog.inHtmlDocument_() && "ActiveXObject" in goog.global;
                                    if (f && goog.inHtmlDocument_() && goog.isDocumentLoading_() && !h) {
                                        goog.Dependency.defer_ = !0;
                                        a.pause();
                                        var l = k.onreadystatechange;
                                        k.onreadystatechange = function() {
                                            "interactive" == k.readyState && (k.onreadystatechange = l, c(), a.resume());
                                            "function" === typeof l && l.apply(void 0, arguments);
                                        };
                                    } else !goog.DebugLoader_.IS_OLD_IE_ && goog.inHtmlDocument_() && goog.isDocumentLoading_() ? d() : c();
                                }
                            }
                        }, goog.TransformedDependency.prototype.transform = function(a) {}, goog.TranspiledDependency = function(a, b, c, d, e, f) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                            this.transpiler = f;
                        }, goog.inherits(goog.TranspiledDependency, goog.TransformedDependency), goog.TranspiledDependency.prototype.transform = function(a) {
                            return this.transpiler.transpile(a, this.getPathName());
                        }, goog.PreTranspiledEs6ModuleDependency = function(a, b, c, d, e) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                        }, goog.inherits(goog.PreTranspiledEs6ModuleDependency, goog.TransformedDependency), goog.PreTranspiledEs6ModuleDependency.prototype.transform = function(a) {
                            return a;
                        }, goog.GoogModuleDependency = function(a, b, c, d, e, f, g) {
                            goog.TransformedDependency.call(this, a, b, c, d, e);
                            this.needsTranspile_ = f;
                            this.transpiler_ = g;
                        }, goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency), goog.GoogModuleDependency.prototype.transform = function(a) {
                            this.needsTranspile_ && (a = this.transpiler_.transpile(a, this.getPathName()));
                            return goog.LOAD_MODULE_USING_EVAL && void 0 !== goog.global.JSON ? "goog.loadModule(" + goog.global.JSON.stringify(a + "\n//# sourceURL=" + this.path + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + a + "\n;return exports});\n//# sourceURL=" + this.path + "\n";
                        }, goog.DebugLoader_.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.DebugLoader_.prototype.addDependency = function(a, b, c, d) {
                            b = b || [];
                            a = a.replace(/\\/g, "/");
                            var e = goog.normalizePath_(goog.basePath + a);
                            d && "boolean" !== typeof d || (d = d ? {
                                module: goog.ModuleType.GOOG
                            } : {});
                            c = this.factory_.createDependency(e, a, b, c, d, goog.transpiler_.needsTranspile(d.lang || "es3", d.module));
                            this.dependencies_[e] = c;
                            for(c = 0; c < b.length; c++)this.idToPath_[b[c]] = e;
                            this.idToPath_[a] = e;
                        }, goog.DependencyFactory = function(a) {
                            this.transpiler = a;
                        }, goog.DependencyFactory.prototype.createDependency = function(a, b, c, d, e, f) {
                            return e.module == goog.ModuleType.GOOG ? new goog.GoogModuleDependency(a, b, c, d, e, f, this.transpiler) : f ? new goog.TranspiledDependency(a, b, c, d, e, this.transpiler) : e.module == goog.ModuleType.ES6 ? "never" == goog.TRANSPILE && goog.ASSUME_ES_MODULES_TRANSPILED ? new goog.PreTranspiledEs6ModuleDependency(a, b, c, d, e) : new goog.Es6ModuleDependency(a, b, c, d, e) : new goog.Dependency(a, b, c, d, e);
                        }, goog.debugLoader_ = new goog.DebugLoader_, goog.loadClosureDeps = function() {
                            goog.debugLoader_.loadClosureDeps();
                        }, goog.setDependencyFactory = function(a) {
                            goog.debugLoader_.setDependencyFactory(a);
                        }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null, goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(), goog.bootstrap = function(a, b) {
                            goog.debugLoader_.bootstrap(a, b);
                        });
                        goog.TRUSTED_TYPES_POLICY_NAME = "goog";
                        goog.identity_ = function(a) {
                            return a;
                        };
                        goog.createTrustedTypesPolicy = function(a) {
                            var b = null, c = goog.global.trustedTypes;
                            if (!c || !c.createPolicy) return b;
                            try {
                                b = c.createPolicy(a, {
                                    createHTML: goog.identity_,
                                    createScript: goog.identity_,
                                    createScriptURL: goog.identity_
                                });
                            } catch (d) {
                                goog.logToConsole_(d.message);
                            }
                            return b;
                        };
                        goog.debug = {};
                        function module$contents$goog$debug$Error_DebugError(a) {
                            if (Error.captureStackTrace) Error.captureStackTrace(this, module$contents$goog$debug$Error_DebugError);
                            else {
                                var b = Error().stack;
                                b && (this.stack = b);
                            }
                            a && (this.message = String(a));
                            this.reportErrorToServer = !0;
                        }
                        goog.inherits(module$contents$goog$debug$Error_DebugError, Error);
                        module$contents$goog$debug$Error_DebugError.prototype.name = "CustomError";
                        goog.debug.Error = module$contents$goog$debug$Error_DebugError;
                        goog.dom = {};
                        goog.dom.NodeType = {
                            ELEMENT: 1,
                            ATTRIBUTE: 2,
                            TEXT: 3,
                            CDATA_SECTION: 4,
                            ENTITY_REFERENCE: 5,
                            ENTITY: 6,
                            PROCESSING_INSTRUCTION: 7,
                            COMMENT: 8,
                            DOCUMENT: 9,
                            DOCUMENT_TYPE: 10,
                            DOCUMENT_FRAGMENT: 11,
                            NOTATION: 12
                        };
                        goog.asserts = {};
                        goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
                        goog.asserts.AssertionError = function(a, b) {
                            module$contents$goog$debug$Error_DebugError.call(this, goog.asserts.subs_(a, b));
                            this.messagePattern = a;
                        };
                        goog.inherits(goog.asserts.AssertionError, module$contents$goog$debug$Error_DebugError);
                        goog.asserts.AssertionError.prototype.name = "AssertionError";
                        goog.asserts.DEFAULT_ERROR_HANDLER = function(a) {
                            throw a;
                        };
                        goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
                        goog.asserts.subs_ = function(a, b) {
                            a = a.split("%s");
                            for(var c = "", d = a.length - 1, e = 0; e < d; e++)c += a[e] + (e < b.length ? b[e] : "%s");
                            return c + a[d];
                        };
                        goog.asserts.doAssertFailure_ = function(a, b, c, d) {
                            var e = "Assertion failed";
                            if (c) {
                                e += ": " + c;
                                var f = d;
                            } else a && (e += ": " + a, f = b);
                            a = new goog.asserts.AssertionError("" + e, f || []);
                            goog.asserts.errorHandler_(a);
                        };
                        goog.asserts.setErrorHandler = function(a) {
                            goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a);
                        };
                        goog.asserts.assert = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !a && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertExists = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && null == a && goog.asserts.doAssertFailure_("Expected to exist: %s.", [
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.fail = function(a, b) {
                            goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1)));
                        };
                        goog.asserts.assertNumber = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "number" !== typeof a && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertString = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "string" !== typeof a && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertFunction = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "function" !== typeof a && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertObject = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !goog.isObject(a) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertArray = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && !Array.isArray(a) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertBoolean = function(a, b, c) {
                            goog.asserts.ENABLE_ASSERTS && "boolean" !== typeof a && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertElement = function(a, b, c) {
                            !goog.asserts.ENABLE_ASSERTS || goog.isObject(a) && a.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [
                                goog.typeOf(a),
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertInstanceof = function(a, b, c, d) {
                            !goog.asserts.ENABLE_ASSERTS || a instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [
                                goog.asserts.getType_(b),
                                goog.asserts.getType_(a)
                            ], c, Array.prototype.slice.call(arguments, 3));
                            return a;
                        };
                        goog.asserts.assertFinite = function(a, b, c) {
                            !goog.asserts.ENABLE_ASSERTS || "number" == typeof a && isFinite(a) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [
                                a
                            ], b, Array.prototype.slice.call(arguments, 2));
                            return a;
                        };
                        goog.asserts.assertObjectPrototypeIsIntact = function() {
                            for(var a in Object.prototype)goog.asserts.fail(a + " should not be enumerable in Object.prototype.");
                        };
                        goog.asserts.getType_ = function(a) {
                            return a instanceof Function ? a.displayName || a.name || "unknown type name" : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? "null" : typeof a;
                        };
                        goog.array = {};
                        goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
                        var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
                        goog.array.ASSUME_NATIVE_FUNCTIONS = module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;
                        function module$contents$goog$array_peek(a) {
                            return a[a.length - 1];
                        }
                        goog.array.peek = module$contents$goog$array_peek;
                        goog.array.last = module$contents$goog$array_peek;
                        var module$contents$goog$array_indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.indexOf.call(a, b, c);
                        } : function(a, b, c) {
                            c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
                            if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, c);
                            for(; c < a.length; c++)if (c in a && a[c] === b) return c;
                            return -1;
                        };
                        goog.array.indexOf = module$contents$goog$array_indexOf;
                        var module$contents$goog$array_lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.lastIndexOf.call(a, b, null == c ? a.length - 1 : c);
                        } : function(a, b, c) {
                            c = null == c ? a.length - 1 : c;
                            0 > c && (c = Math.max(0, a.length + c));
                            if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.lastIndexOf(b, c);
                            for(; 0 <= c; c--)if (c in a && a[c] === b) return c;
                            return -1;
                        };
                        goog.array.lastIndexOf = module$contents$goog$array_lastIndexOf;
                        var module$contents$goog$array_forEach = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            Array.prototype.forEach.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
                        };
                        goog.array.forEach = module$contents$goog$array_forEach;
                        function module$contents$goog$array_forEachRight(a, b, c) {
                            var d = a.length, e = "string" === typeof a ? a.split("") : a;
                            for(--d; 0 <= d; --d)d in e && b.call(c, e[d], d, a);
                        }
                        goog.array.forEachRight = module$contents$goog$array_forEachRight;
                        var module$contents$goog$array_filter = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.filter.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = [], f = 0, g = "string" === typeof a ? a.split("") : a, h = 0; h < d; h++)if (h in g) {
                                var k = g[h];
                                b.call(c, k, h, a) && (e[f++] = k);
                            }
                            return e;
                        };
                        goog.array.filter = module$contents$goog$array_filter;
                        var module$contents$goog$array_map = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.map.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = Array(d), f = "string" === typeof a ? a.split("") : a, g = 0; g < d; g++)g in f && (e[g] = b.call(c, f[g], g, a));
                            return e;
                        };
                        goog.array.map = module$contents$goog$array_map;
                        var module$contents$goog$array_reduce = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            d && (b = goog.bind(b, d));
                            return Array.prototype.reduce.call(a, b, c);
                        } : function(a, b, c, d) {
                            var e = c;
                            module$contents$goog$array_forEach(a, function(f, g) {
                                e = b.call(d, e, f, g, a);
                            });
                            return e;
                        };
                        goog.array.reduce = module$contents$goog$array_reduce;
                        var module$contents$goog$array_reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            goog.asserts.assert(null != b);
                            d && (b = goog.bind(b, d));
                            return Array.prototype.reduceRight.call(a, b, c);
                        } : function(a, b, c, d) {
                            var e = c;
                            module$contents$goog$array_forEachRight(a, function(f, g) {
                                e = b.call(d, e, f, g, a);
                            });
                            return e;
                        };
                        goog.array.reduceRight = module$contents$goog$array_reduceRight;
                        var module$contents$goog$array_some = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.some.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)if (f in e && b.call(c, e[f], f, a)) return !0;
                            return !1;
                        };
                        goog.array.some = module$contents$goog$array_some;
                        var module$contents$goog$array_every = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.every.call(a, b, c);
                        } : function(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)if (f in e && !b.call(c, e[f], f, a)) return !1;
                            return !0;
                        };
                        goog.array.every = module$contents$goog$array_every;
                        function module$contents$goog$array_count(a, b, c) {
                            var d = 0;
                            module$contents$goog$array_forEach(a, function(e, f, g) {
                                b.call(c, e, f, g) && ++d;
                            }, c);
                            return d;
                        }
                        goog.array.count = module$contents$goog$array_count;
                        function module$contents$goog$array_find(a, b, c) {
                            b = module$contents$goog$array_findIndex(a, b, c);
                            return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
                        }
                        goog.array.find = module$contents$goog$array_find;
                        function module$contents$goog$array_findIndex(a, b, c) {
                            for(var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)if (f in e && b.call(c, e[f], f, a)) return f;
                            return -1;
                        }
                        goog.array.findIndex = module$contents$goog$array_findIndex;
                        function module$contents$goog$array_findRight(a, b, c) {
                            b = module$contents$goog$array_findIndexRight(a, b, c);
                            return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b];
                        }
                        goog.array.findRight = module$contents$goog$array_findRight;
                        function module$contents$goog$array_findIndexRight(a, b, c) {
                            var d = a.length, e = "string" === typeof a ? a.split("") : a;
                            for(--d; 0 <= d; d--)if (d in e && b.call(c, e[d], d, a)) return d;
                            return -1;
                        }
                        goog.array.findIndexRight = module$contents$goog$array_findIndexRight;
                        function module$contents$goog$array_contains(a, b) {
                            return 0 <= module$contents$goog$array_indexOf(a, b);
                        }
                        goog.array.contains = module$contents$goog$array_contains;
                        function module$contents$goog$array_isEmpty(a) {
                            return 0 == a.length;
                        }
                        goog.array.isEmpty = module$contents$goog$array_isEmpty;
                        function module$contents$goog$array_clear(a) {
                            if (!Array.isArray(a)) for(var b = a.length - 1; 0 <= b; b--)delete a[b];
                            a.length = 0;
                        }
                        goog.array.clear = module$contents$goog$array_clear;
                        function module$contents$goog$array_insert(a, b) {
                            module$contents$goog$array_contains(a, b) || a.push(b);
                        }
                        goog.array.insert = module$contents$goog$array_insert;
                        function module$contents$goog$array_insertAt(a, b, c) {
                            module$contents$goog$array_splice(a, c, 0, b);
                        }
                        goog.array.insertAt = module$contents$goog$array_insertAt;
                        function module$contents$goog$array_insertArrayAt(a, b, c) {
                            goog.partial(module$contents$goog$array_splice, a, c, 0).apply(null, b);
                        }
                        goog.array.insertArrayAt = module$contents$goog$array_insertArrayAt;
                        function module$contents$goog$array_insertBefore(a, b, c) {
                            var d;
                            2 == arguments.length || 0 > (d = module$contents$goog$array_indexOf(a, c)) ? a.push(b) : module$contents$goog$array_insertAt(a, b, d);
                        }
                        goog.array.insertBefore = module$contents$goog$array_insertBefore;
                        function module$contents$goog$array_remove(a, b) {
                            b = module$contents$goog$array_indexOf(a, b);
                            var c;
                            (c = 0 <= b) && module$contents$goog$array_removeAt(a, b);
                            return c;
                        }
                        goog.array.remove = module$contents$goog$array_remove;
                        function module$contents$goog$array_removeLast(a, b) {
                            b = module$contents$goog$array_lastIndexOf(a, b);
                            return 0 <= b ? (module$contents$goog$array_removeAt(a, b), !0) : !1;
                        }
                        goog.array.removeLast = module$contents$goog$array_removeLast;
                        function module$contents$goog$array_removeAt(a, b) {
                            goog.asserts.assert(null != a.length);
                            return 1 == Array.prototype.splice.call(a, b, 1).length;
                        }
                        goog.array.removeAt = module$contents$goog$array_removeAt;
                        function module$contents$goog$array_removeIf(a, b, c) {
                            b = module$contents$goog$array_findIndex(a, b, c);
                            return 0 <= b ? (module$contents$goog$array_removeAt(a, b), !0) : !1;
                        }
                        goog.array.removeIf = module$contents$goog$array_removeIf;
                        function module$contents$goog$array_removeAllIf(a, b, c) {
                            var d = 0;
                            module$contents$goog$array_forEachRight(a, function(e, f) {
                                b.call(c, e, f, a) && module$contents$goog$array_removeAt(a, f) && d++;
                            });
                            return d;
                        }
                        goog.array.removeAllIf = module$contents$goog$array_removeAllIf;
                        function module$contents$goog$array_concat(a) {
                            return Array.prototype.concat.apply([], arguments);
                        }
                        goog.array.concat = module$contents$goog$array_concat;
                        function module$contents$goog$array_join(a) {
                            return Array.prototype.concat.apply([], arguments);
                        }
                        goog.array.join = module$contents$goog$array_join;
                        function module$contents$goog$array_toArray(a) {
                            var b = a.length;
                            if (0 < b) {
                                for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
                                return c;
                            }
                            return [];
                        }
                        var module$contents$goog$array_clone = goog.array.toArray = module$contents$goog$array_toArray;
                        goog.array.clone = module$contents$goog$array_clone;
                        function module$contents$goog$array_extend(a, b) {
                            for(var c = 1; c < arguments.length; c++){
                                var d = arguments[c];
                                if (goog.isArrayLike(d)) {
                                    var e = a.length || 0, f = d.length || 0;
                                    a.length = e + f;
                                    for(var g = 0; g < f; g++)a[e + g] = d[g];
                                } else a.push(d);
                            }
                        }
                        goog.array.extend = module$contents$goog$array_extend;
                        function module$contents$goog$array_splice(a, b, c, d) {
                            goog.asserts.assert(null != a.length);
                            return Array.prototype.splice.apply(a, module$contents$goog$array_slice(arguments, 1));
                        }
                        goog.array.splice = module$contents$goog$array_splice;
                        function module$contents$goog$array_slice(a, b, c) {
                            goog.asserts.assert(null != a.length);
                            return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
                        }
                        goog.array.slice = module$contents$goog$array_slice;
                        function module$contents$goog$array_removeDuplicates(a, b, c) {
                            b = b || a;
                            var d = function(k) {
                                return goog.isObject(k) ? "o" + goog.getUid(k) : (typeof k).charAt(0) + k;
                            };
                            c = c || d;
                            d = {};
                            for(var e = 0, f = 0; f < a.length;){
                                var g = a[f++], h = c(g);
                                Object.prototype.hasOwnProperty.call(d, h) || (d[h] = !0, b[e++] = g);
                            }
                            b.length = e;
                        }
                        goog.array.removeDuplicates = module$contents$goog$array_removeDuplicates;
                        function module$contents$goog$array_binarySearch(a, b, c) {
                            return module$contents$goog$array_binarySearch_(a, c || module$contents$goog$array_defaultCompare, !1, b);
                        }
                        goog.array.binarySearch = module$contents$goog$array_binarySearch;
                        function module$contents$goog$array_binarySelect(a, b, c) {
                            return module$contents$goog$array_binarySearch_(a, b, !0, void 0, c);
                        }
                        goog.array.binarySelect = module$contents$goog$array_binarySelect;
                        function module$contents$goog$array_binarySearch_(a, b, c, d, e) {
                            for(var f = 0, g = a.length, h; f < g;){
                                var k = f + (g - f >>> 1);
                                var l = c ? b.call(e, a[k], k, a) : b(d, a[k]);
                                0 < l ? f = k + 1 : (g = k, h = !l);
                            }
                            return h ? f : -f - 1;
                        }
                        function module$contents$goog$array_sort(a, b) {
                            a.sort(b || module$contents$goog$array_defaultCompare);
                        }
                        goog.array.sort = module$contents$goog$array_sort;
                        function module$contents$goog$array_stableSort(a, b) {
                            for(var c = Array(a.length), d = 0; d < a.length; d++)c[d] = {
                                index: d,
                                value: a[d]
                            };
                            var e = b || module$contents$goog$array_defaultCompare;
                            module$contents$goog$array_sort(c, function(f, g) {
                                return e(f.value, g.value) || f.index - g.index;
                            });
                            for(d = 0; d < a.length; d++)a[d] = c[d].value;
                        }
                        goog.array.stableSort = module$contents$goog$array_stableSort;
                        function module$contents$goog$array_sortByKey(a, b, c) {
                            var d = c || module$contents$goog$array_defaultCompare;
                            module$contents$goog$array_sort(a, function(e, f) {
                                return d(b(e), b(f));
                            });
                        }
                        goog.array.sortByKey = module$contents$goog$array_sortByKey;
                        function module$contents$goog$array_sortObjectsByKey(a, b, c) {
                            module$contents$goog$array_sortByKey(a, function(d) {
                                return d[b];
                            }, c);
                        }
                        goog.array.sortObjectsByKey = module$contents$goog$array_sortObjectsByKey;
                        function module$contents$goog$array_isSorted(a, b, c) {
                            b = b || module$contents$goog$array_defaultCompare;
                            for(var d = 1; d < a.length; d++){
                                var e = b(a[d - 1], a[d]);
                                if (0 < e || 0 == e && c) return !1;
                            }
                            return !0;
                        }
                        goog.array.isSorted = module$contents$goog$array_isSorted;
                        function module$contents$goog$array_equals(a, b, c) {
                            if (!goog.isArrayLike(a) || !goog.isArrayLike(b) || a.length != b.length) return !1;
                            var d = a.length;
                            c = c || module$contents$goog$array_defaultCompareEquality;
                            for(var e = 0; e < d; e++)if (!c(a[e], b[e])) return !1;
                            return !0;
                        }
                        goog.array.equals = module$contents$goog$array_equals;
                        function module$contents$goog$array_compare3(a, b, c) {
                            c = c || module$contents$goog$array_defaultCompare;
                            for(var d = Math.min(a.length, b.length), e = 0; e < d; e++){
                                var f = c(a[e], b[e]);
                                if (0 != f) return f;
                            }
                            return module$contents$goog$array_defaultCompare(a.length, b.length);
                        }
                        goog.array.compare3 = module$contents$goog$array_compare3;
                        function module$contents$goog$array_defaultCompare(a, b) {
                            return a > b ? 1 : a < b ? -1 : 0;
                        }
                        goog.array.defaultCompare = module$contents$goog$array_defaultCompare;
                        function module$contents$goog$array_inverseDefaultCompare(a, b) {
                            return -module$contents$goog$array_defaultCompare(a, b);
                        }
                        goog.array.inverseDefaultCompare = module$contents$goog$array_inverseDefaultCompare;
                        function module$contents$goog$array_defaultCompareEquality(a, b) {
                            return a === b;
                        }
                        goog.array.defaultCompareEquality = module$contents$goog$array_defaultCompareEquality;
                        function module$contents$goog$array_binaryInsert(a, b, c) {
                            c = module$contents$goog$array_binarySearch(a, b, c);
                            return 0 > c ? (module$contents$goog$array_insertAt(a, b, -(c + 1)), !0) : !1;
                        }
                        goog.array.binaryInsert = module$contents$goog$array_binaryInsert;
                        function module$contents$goog$array_binaryRemove(a, b, c) {
                            b = module$contents$goog$array_binarySearch(a, b, c);
                            return 0 <= b ? module$contents$goog$array_removeAt(a, b) : !1;
                        }
                        goog.array.binaryRemove = module$contents$goog$array_binaryRemove;
                        function module$contents$goog$array_bucket(a, b, c) {
                            for(var d = {}, e = 0; e < a.length; e++){
                                var f = a[e], g = b.call(c, f, e, a);
                                void 0 !== g && (d[g] || (d[g] = [])).push(f);
                            }
                            return d;
                        }
                        goog.array.bucket = module$contents$goog$array_bucket;
                        function module$contents$goog$array_toObject(a, b, c) {
                            var d = {};
                            module$contents$goog$array_forEach(a, function(e, f) {
                                d[b.call(c, e, f, a)] = e;
                            });
                            return d;
                        }
                        goog.array.toObject = module$contents$goog$array_toObject;
                        function module$contents$goog$array_range(a, b, c) {
                            var d = [], e = 0, f = a;
                            c = c || 1;
                            void 0 !== b && (e = a, f = b);
                            if (0 > c * (f - e)) return [];
                            if (0 < c) for(a = e; a < f; a += c)d.push(a);
                            else for(a = e; a > f; a += c)d.push(a);
                            return d;
                        }
                        goog.array.range = module$contents$goog$array_range;
                        function module$contents$goog$array_repeat(a, b) {
                            for(var c = [], d = 0; d < b; d++)c[d] = a;
                            return c;
                        }
                        goog.array.repeat = module$contents$goog$array_repeat;
                        function module$contents$goog$array_flatten(a) {
                            for(var b = [], c = 0; c < arguments.length; c++){
                                var d = arguments[c];
                                if (Array.isArray(d)) for(var e = 0; e < d.length; e += 8192){
                                    var f = module$contents$goog$array_slice(d, e, e + 8192);
                                    f = module$contents$goog$array_flatten.apply(null, f);
                                    for(var g = 0; g < f.length; g++)b.push(f[g]);
                                }
                                else b.push(d);
                            }
                            return b;
                        }
                        goog.array.flatten = module$contents$goog$array_flatten;
                        function module$contents$goog$array_rotate(a, b) {
                            goog.asserts.assert(null != a.length);
                            a.length && (b %= a.length, 0 < b ? Array.prototype.unshift.apply(a, a.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a, a.splice(0, -b)));
                            return a;
                        }
                        goog.array.rotate = module$contents$goog$array_rotate;
                        function module$contents$goog$array_moveItem(a, b, c) {
                            goog.asserts.assert(0 <= b && b < a.length);
                            goog.asserts.assert(0 <= c && c < a.length);
                            b = Array.prototype.splice.call(a, b, 1);
                            Array.prototype.splice.call(a, c, 0, b[0]);
                        }
                        goog.array.moveItem = module$contents$goog$array_moveItem;
                        function module$contents$goog$array_zip(a) {
                            if (!arguments.length) return [];
                            for(var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++)arguments[d].length < c && (c = arguments[d].length);
                            for(d = 0; d < c; d++){
                                for(var e = [], f = 0; f < arguments.length; f++)e.push(arguments[f][d]);
                                b.push(e);
                            }
                            return b;
                        }
                        goog.array.zip = module$contents$goog$array_zip;
                        function module$contents$goog$array_shuffle(a, b) {
                            b = b || Math.random;
                            for(var c = a.length - 1; 0 < c; c--){
                                var d = Math.floor(b() * (c + 1)), e = a[c];
                                a[c] = a[d];
                                a[d] = e;
                            }
                        }
                        goog.array.shuffle = module$contents$goog$array_shuffle;
                        function module$contents$goog$array_copyByIndex(a, b) {
                            var c = [];
                            module$contents$goog$array_forEach(b, function(d) {
                                c.push(a[d]);
                            });
                            return c;
                        }
                        goog.array.copyByIndex = module$contents$goog$array_copyByIndex;
                        function module$contents$goog$array_concatMap(a, b, c) {
                            return module$contents$goog$array_concat.apply([], module$contents$goog$array_map(a, b, c));
                        }
                        goog.array.concatMap = module$contents$goog$array_concatMap;
                        goog.dom.asserts = {};
                        goog.dom.asserts.assertIsLocation = function(a) {
                            if (goog.asserts.ENABLE_ASSERTS) {
                                var b = goog.dom.asserts.getWindow_(a);
                                b && (!a || !(a instanceof b.Location) && a instanceof b.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(a));
                            }
                            return a;
                        };
                        goog.dom.asserts.assertIsElementType_ = function(a, b) {
                            if (goog.asserts.ENABLE_ASSERTS) {
                                var c = goog.dom.asserts.getWindow_(a);
                                c && "undefined" != typeof c[b] && (a && (a instanceof c[b] || !(a instanceof c.Location || a instanceof c.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, goog.dom.asserts.debugStringForType_(a)));
                            }
                            return a;
                        };
                        goog.dom.asserts.assertIsHTMLAnchorElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLAnchorElement");
                        };
                        goog.dom.asserts.assertIsHTMLButtonElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLButtonElement");
                        };
                        goog.dom.asserts.assertIsHTMLLinkElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLLinkElement");
                        };
                        goog.dom.asserts.assertIsHTMLImageElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLImageElement");
                        };
                        goog.dom.asserts.assertIsHTMLAudioElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLAudioElement");
                        };
                        goog.dom.asserts.assertIsHTMLVideoElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLVideoElement");
                        };
                        goog.dom.asserts.assertIsHTMLInputElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLInputElement");
                        };
                        goog.dom.asserts.assertIsHTMLTextAreaElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLTextAreaElement");
                        };
                        goog.dom.asserts.assertIsHTMLCanvasElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLCanvasElement");
                        };
                        goog.dom.asserts.assertIsHTMLEmbedElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLEmbedElement");
                        };
                        goog.dom.asserts.assertIsHTMLFormElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLFormElement");
                        };
                        goog.dom.asserts.assertIsHTMLFrameElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLFrameElement");
                        };
                        goog.dom.asserts.assertIsHTMLIFrameElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLIFrameElement");
                        };
                        goog.dom.asserts.assertIsHTMLObjectElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLObjectElement");
                        };
                        goog.dom.asserts.assertIsHTMLScriptElement = function(a) {
                            return goog.dom.asserts.assertIsElementType_(a, "HTMLScriptElement");
                        };
                        goog.dom.asserts.debugStringForType_ = function(a) {
                            if (goog.isObject(a)) try {
                                return a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
                            } catch (b) {
                                return "<object could not be stringified>";
                            }
                            else return void 0 === a ? "undefined" : null === a ? "null" : typeof a;
                        };
                        goog.dom.asserts.getWindow_ = function(a) {
                            try {
                                var b = a && a.ownerDocument, c = b && (b.defaultView || b.parentWindow);
                                c = c || goog.global;
                                if (c.Element && c.Location) return c;
                            } catch (d) {}
                            return null;
                        };
                        goog.dom.HtmlElement = function() {};
                        goog.functions = {};
                        goog.functions.constant = function(a) {
                            return function() {
                                return a;
                            };
                        };
                        goog.functions.FALSE = function() {
                            return !1;
                        };
                        goog.functions.TRUE = function() {
                            return !0;
                        };
                        goog.functions.NULL = function() {
                            return null;
                        };
                        goog.functions.identity = function(a, b) {
                            return a;
                        };
                        goog.functions.error = function(a) {
                            return function() {
                                throw Error(a);
                            };
                        };
                        goog.functions.fail = function(a) {
                            return function() {
                                throw a;
                            };
                        };
                        goog.functions.lock = function(a, b) {
                            b = b || 0;
                            return function() {
                                return a.apply(this, Array.prototype.slice.call(arguments, 0, b));
                            };
                        };
                        goog.functions.nth = function(a) {
                            return function() {
                                return arguments[a];
                            };
                        };
                        goog.functions.partialRight = function(a, b) {
                            var c = Array.prototype.slice.call(arguments, 1);
                            return function() {
                                var d = this;
                                d === goog.global && (d = void 0);
                                var e = Array.prototype.slice.call(arguments);
                                e.push.apply(e, c);
                                return a.apply(d, e);
                            };
                        };
                        goog.functions.withReturnValue = function(a, b) {
                            return goog.functions.sequence(a, goog.functions.constant(b));
                        };
                        goog.functions.equalTo = function(a, b) {
                            return function(c) {
                                return b ? a == c : a === c;
                            };
                        };
                        goog.functions.compose = function(a, b) {
                            var c = arguments, d = c.length;
                            return function() {
                                var e;
                                d && (e = c[d - 1].apply(this, arguments));
                                for(var f = d - 2; 0 <= f; f--)e = c[f].call(this, e);
                                return e;
                            };
                        };
                        goog.functions.sequence = function(a) {
                            var b = arguments, c = b.length;
                            return function() {
                                for(var d, e = 0; e < c; e++)d = b[e].apply(this, arguments);
                                return d;
                            };
                        };
                        goog.functions.and = function(a) {
                            var b = arguments, c = b.length;
                            return function() {
                                for(var d = 0; d < c; d++)if (!b[d].apply(this, arguments)) return !1;
                                return !0;
                            };
                        };
                        goog.functions.or = function(a) {
                            var b = arguments, c = b.length;
                            return function() {
                                for(var d = 0; d < c; d++)if (b[d].apply(this, arguments)) return !0;
                                return !1;
                            };
                        };
                        goog.functions.not = function(a) {
                            return function() {
                                return !a.apply(this, arguments);
                            };
                        };
                        goog.functions.create = function(a, b) {
                            var c = function() {};
                            c.prototype = a.prototype;
                            c = new c;
                            a.apply(c, Array.prototype.slice.call(arguments, 1));
                            return c;
                        };
                        goog.functions.CACHE_RETURN_VALUE = !0;
                        goog.functions.cacheReturnValue = function(a) {
                            var b = !1, c;
                            return function() {
                                if (!goog.functions.CACHE_RETURN_VALUE) return a();
                                b || (c = a(), b = !0);
                                return c;
                            };
                        };
                        goog.functions.once = function(a) {
                            var b = a;
                            return function() {
                                if (b) {
                                    var c = b;
                                    b = null;
                                    c();
                                }
                            };
                        };
                        goog.functions.debounce = function(a, b, c) {
                            var d = 0;
                            return function(e) {
                                goog.global.clearTimeout(d);
                                var f = arguments;
                                d = goog.global.setTimeout(function() {
                                    a.apply(c, f);
                                }, b);
                            };
                        };
                        goog.functions.throttle = function(a, b, c) {
                            var d = 0, e = !1, f = [], g = function() {
                                d = 0;
                                e && (e = !1, h());
                            }, h = function() {
                                d = goog.global.setTimeout(g, b);
                                a.apply(c, f);
                            };
                            return function(k) {
                                f = arguments;
                                d ? e = !0 : h();
                            };
                        };
                        goog.functions.rateLimit = function(a, b, c) {
                            var d = 0, e = function() {
                                d = 0;
                            };
                            return function(f) {
                                d || (d = goog.global.setTimeout(e, b), a.apply(c, arguments));
                            };
                        };
                        goog.functions.isFunction = function(a) {
                            return "function" === typeof a;
                        };
                        goog.dom.TagName = function() {};
                        goog.dom.TagName.cast = function(a, b) {
                            return a;
                        };
                        goog.dom.TagName.prototype.toString = function() {};
                        goog.dom.TagName.A = "A";
                        goog.dom.TagName.ABBR = "ABBR";
                        goog.dom.TagName.ACRONYM = "ACRONYM";
                        goog.dom.TagName.ADDRESS = "ADDRESS";
                        goog.dom.TagName.APPLET = "APPLET";
                        goog.dom.TagName.AREA = "AREA";
                        goog.dom.TagName.ARTICLE = "ARTICLE";
                        goog.dom.TagName.ASIDE = "ASIDE";
                        goog.dom.TagName.AUDIO = "AUDIO";
                        goog.dom.TagName.B = "B";
                        goog.dom.TagName.BASE = "BASE";
                        goog.dom.TagName.BASEFONT = "BASEFONT";
                        goog.dom.TagName.BDI = "BDI";
                        goog.dom.TagName.BDO = "BDO";
                        goog.dom.TagName.BIG = "BIG";
                        goog.dom.TagName.BLOCKQUOTE = "BLOCKQUOTE";
                        goog.dom.TagName.BODY = "BODY";
                        goog.dom.TagName.BR = "BR";
                        goog.dom.TagName.BUTTON = "BUTTON";
                        goog.dom.TagName.CANVAS = "CANVAS";
                        goog.dom.TagName.CAPTION = "CAPTION";
                        goog.dom.TagName.CENTER = "CENTER";
                        goog.dom.TagName.CITE = "CITE";
                        goog.dom.TagName.CODE = "CODE";
                        goog.dom.TagName.COL = "COL";
                        goog.dom.TagName.COLGROUP = "COLGROUP";
                        goog.dom.TagName.COMMAND = "COMMAND";
                        goog.dom.TagName.DATA = "DATA";
                        goog.dom.TagName.DATALIST = "DATALIST";
                        goog.dom.TagName.DD = "DD";
                        goog.dom.TagName.DEL = "DEL";
                        goog.dom.TagName.DETAILS = "DETAILS";
                        goog.dom.TagName.DFN = "DFN";
                        goog.dom.TagName.DIALOG = "DIALOG";
                        goog.dom.TagName.DIR = "DIR";
                        goog.dom.TagName.DIV = "DIV";
                        goog.dom.TagName.DL = "DL";
                        goog.dom.TagName.DT = "DT";
                        goog.dom.TagName.EM = "EM";
                        goog.dom.TagName.EMBED = "EMBED";
                        goog.dom.TagName.FIELDSET = "FIELDSET";
                        goog.dom.TagName.FIGCAPTION = "FIGCAPTION";
                        goog.dom.TagName.FIGURE = "FIGURE";
                        goog.dom.TagName.FONT = "FONT";
                        goog.dom.TagName.FOOTER = "FOOTER";
                        goog.dom.TagName.FORM = "FORM";
                        goog.dom.TagName.FRAME = "FRAME";
                        goog.dom.TagName.FRAMESET = "FRAMESET";
                        goog.dom.TagName.H1 = "H1";
                        goog.dom.TagName.H2 = "H2";
                        goog.dom.TagName.H3 = "H3";
                        goog.dom.TagName.H4 = "H4";
                        goog.dom.TagName.H5 = "H5";
                        goog.dom.TagName.H6 = "H6";
                        goog.dom.TagName.HEAD = "HEAD";
                        goog.dom.TagName.HEADER = "HEADER";
                        goog.dom.TagName.HGROUP = "HGROUP";
                        goog.dom.TagName.HR = "HR";
                        goog.dom.TagName.HTML = "HTML";
                        goog.dom.TagName.I = "I";
                        goog.dom.TagName.IFRAME = "IFRAME";
                        goog.dom.TagName.IMG = "IMG";
                        goog.dom.TagName.INPUT = "INPUT";
                        goog.dom.TagName.INS = "INS";
                        goog.dom.TagName.ISINDEX = "ISINDEX";
                        goog.dom.TagName.KBD = "KBD";
                        goog.dom.TagName.KEYGEN = "KEYGEN";
                        goog.dom.TagName.LABEL = "LABEL";
                        goog.dom.TagName.LEGEND = "LEGEND";
                        goog.dom.TagName.LI = "LI";
                        goog.dom.TagName.LINK = "LINK";
                        goog.dom.TagName.MAIN = "MAIN";
                        goog.dom.TagName.MAP = "MAP";
                        goog.dom.TagName.MARK = "MARK";
                        goog.dom.TagName.MATH = "MATH";
                        goog.dom.TagName.MENU = "MENU";
                        goog.dom.TagName.MENUITEM = "MENUITEM";
                        goog.dom.TagName.META = "META";
                        goog.dom.TagName.METER = "METER";
                        goog.dom.TagName.NAV = "NAV";
                        goog.dom.TagName.NOFRAMES = "NOFRAMES";
                        goog.dom.TagName.NOSCRIPT = "NOSCRIPT";
                        goog.dom.TagName.OBJECT = "OBJECT";
                        goog.dom.TagName.OL = "OL";
                        goog.dom.TagName.OPTGROUP = "OPTGROUP";
                        goog.dom.TagName.OPTION = "OPTION";
                        goog.dom.TagName.OUTPUT = "OUTPUT";
                        goog.dom.TagName.P = "P";
                        goog.dom.TagName.PARAM = "PARAM";
                        goog.dom.TagName.PICTURE = "PICTURE";
                        goog.dom.TagName.PRE = "PRE";
                        goog.dom.TagName.PROGRESS = "PROGRESS";
                        goog.dom.TagName.Q = "Q";
                        goog.dom.TagName.RP = "RP";
                        goog.dom.TagName.RT = "RT";
                        goog.dom.TagName.RTC = "RTC";
                        goog.dom.TagName.RUBY = "RUBY";
                        goog.dom.TagName.S = "S";
                        goog.dom.TagName.SAMP = "SAMP";
                        goog.dom.TagName.SCRIPT = "SCRIPT";
                        goog.dom.TagName.SECTION = "SECTION";
                        goog.dom.TagName.SELECT = "SELECT";
                        goog.dom.TagName.SMALL = "SMALL";
                        goog.dom.TagName.SOURCE = "SOURCE";
                        goog.dom.TagName.SPAN = "SPAN";
                        goog.dom.TagName.STRIKE = "STRIKE";
                        goog.dom.TagName.STRONG = "STRONG";
                        goog.dom.TagName.STYLE = "STYLE";
                        goog.dom.TagName.SUB = "SUB";
                        goog.dom.TagName.SUMMARY = "SUMMARY";
                        goog.dom.TagName.SUP = "SUP";
                        goog.dom.TagName.SVG = "SVG";
                        goog.dom.TagName.TABLE = "TABLE";
                        goog.dom.TagName.TBODY = "TBODY";
                        goog.dom.TagName.TD = "TD";
                        goog.dom.TagName.TEMPLATE = "TEMPLATE";
                        goog.dom.TagName.TEXTAREA = "TEXTAREA";
                        goog.dom.TagName.TFOOT = "TFOOT";
                        goog.dom.TagName.TH = "TH";
                        goog.dom.TagName.THEAD = "THEAD";
                        goog.dom.TagName.TIME = "TIME";
                        goog.dom.TagName.TITLE = "TITLE";
                        goog.dom.TagName.TR = "TR";
                        goog.dom.TagName.TRACK = "TRACK";
                        goog.dom.TagName.TT = "TT";
                        goog.dom.TagName.U = "U";
                        goog.dom.TagName.UL = "UL";
                        goog.dom.TagName.VAR = "VAR";
                        goog.dom.TagName.VIDEO = "VIDEO";
                        goog.dom.TagName.WBR = "WBR";
                        goog.object = {};
                        goog.object.forEach = function(a, b, c) {
                            for(var d in a)b.call(c, a[d], d, a);
                        };
                        goog.object.filter = function(a, b, c) {
                            var d = {}, e;
                            for(e in a)b.call(c, a[e], e, a) && (d[e] = a[e]);
                            return d;
                        };
                        goog.object.map = function(a, b, c) {
                            var d = {}, e;
                            for(e in a)d[e] = b.call(c, a[e], e, a);
                            return d;
                        };
                        goog.object.some = function(a, b, c) {
                            for(var d in a)if (b.call(c, a[d], d, a)) return !0;
                            return !1;
                        };
                        goog.object.every = function(a, b, c) {
                            for(var d in a)if (!b.call(c, a[d], d, a)) return !1;
                            return !0;
                        };
                        goog.object.getCount = function(a) {
                            var b = 0, c;
                            for(c in a)b++;
                            return b;
                        };
                        goog.object.getAnyKey = function(a) {
                            for(var b in a)return b;
                        };
                        goog.object.getAnyValue = function(a) {
                            for(var b in a)return a[b];
                        };
                        goog.object.contains = function(a, b) {
                            return goog.object.containsValue(a, b);
                        };
                        goog.object.getValues = function(a) {
                            var b = [], c = 0, d;
                            for(d in a)b[c++] = a[d];
                            return b;
                        };
                        goog.object.getKeys = function(a) {
                            var b = [], c = 0, d;
                            for(d in a)b[c++] = d;
                            return b;
                        };
                        goog.object.getValueByKeys = function(a, b) {
                            var c = goog.isArrayLike(b), d = c ? b : arguments;
                            for(c = c ? 0 : 1; c < d.length; c++){
                                if (null == a) return;
                                a = a[d[c]];
                            }
                            return a;
                        };
                        goog.object.containsKey = function(a, b) {
                            return null !== a && b in a;
                        };
                        goog.object.containsValue = function(a, b) {
                            for(var c in a)if (a[c] == b) return !0;
                            return !1;
                        };
                        goog.object.findKey = function(a, b, c) {
                            for(var d in a)if (b.call(c, a[d], d, a)) return d;
                        };
                        goog.object.findValue = function(a, b, c) {
                            return (b = goog.object.findKey(a, b, c)) && a[b];
                        };
                        goog.object.isEmpty = function(a) {
                            for(var b in a)return !1;
                            return !0;
                        };
                        goog.object.clear = function(a) {
                            for(var b in a)delete a[b];
                        };
                        goog.object.remove = function(a, b) {
                            var c;
                            (c = b in a) && delete a[b];
                            return c;
                        };
                        goog.object.add = function(a, b, c) {
                            if (null !== a && b in a) throw Error('The object already contains the key "' + b + '"');
                            goog.object.set(a, b, c);
                        };
                        goog.object.get = function(a, b, c) {
                            return null !== a && b in a ? a[b] : c;
                        };
                        goog.object.set = function(a, b, c) {
                            a[b] = c;
                        };
                        goog.object.setIfUndefined = function(a, b, c) {
                            return b in a ? a[b] : a[b] = c;
                        };
                        goog.object.setWithReturnValueIfNotSet = function(a, b, c) {
                            if (b in a) return a[b];
                            c = c();
                            return a[b] = c;
                        };
                        goog.object.equals = function(a, b) {
                            for(var c in a)if (!(c in b) || a[c] !== b[c]) return !1;
                            for(var d in b)if (!(d in a)) return !1;
                            return !0;
                        };
                        goog.object.clone = function(a) {
                            var b = {}, c;
                            for(c in a)b[c] = a[c];
                            return b;
                        };
                        goog.object.unsafeClone = function(a) {
                            if (!a || "object" !== typeof a) return a;
                            if ("function" === typeof a.clone) return a.clone();
                            var b = Array.isArray(a) ? [] : "function" !== typeof ArrayBuffer || "function" !== typeof ArrayBuffer.isView || !ArrayBuffer.isView(a) || a instanceof DataView ? {} : new a.constructor(a.length), c;
                            for(c in a)b[c] = goog.object.unsafeClone(a[c]);
                            return b;
                        };
                        goog.object.transpose = function(a) {
                            var b = {}, c;
                            for(c in a)b[a[c]] = c;
                            return b;
                        };
                        goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
                        goog.object.extend = function(a, b) {
                            for(var c, d, e = 1; e < arguments.length; e++){
                                d = arguments[e];
                                for(c in d)a[c] = d[c];
                                for(var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++)c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
                            }
                        };
                        goog.object.create = function(a) {
                            var b = arguments.length;
                            if (1 == b && Array.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
                            if (b % 2) throw Error("Uneven number of arguments");
                            for(var c = {}, d = 0; d < b; d += 2)c[arguments[d]] = arguments[d + 1];
                            return c;
                        };
                        goog.object.createSet = function(a) {
                            var b = arguments.length;
                            if (1 == b && Array.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
                            for(var c = {}, d = 0; d < b; d++)c[arguments[d]] = !0;
                            return c;
                        };
                        goog.object.createImmutableView = function(a) {
                            var b = a;
                            Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
                            return b;
                        };
                        goog.object.isImmutableView = function(a) {
                            return !!Object.isFrozen && Object.isFrozen(a);
                        };
                        goog.object.getAllPropertyNames = function(a, b, c) {
                            if (!a) return [];
                            if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(a);
                            for(var d = {}; a && (a !== Object.prototype || b) && (a !== Function.prototype || c);){
                                for(var e = Object.getOwnPropertyNames(a), f = 0; f < e.length; f++)d[e[f]] = !0;
                                a = Object.getPrototypeOf(a);
                            }
                            return goog.object.getKeys(d);
                        };
                        goog.object.getSuperClass = function(a) {
                            return (a = Object.getPrototypeOf(a.prototype)) && a.constructor;
                        };
                        goog.dom.tags = {};
                        goog.dom.tags.VOID_TAGS_ = {
                            area: !0,
                            base: !0,
                            br: !0,
                            col: !0,
                            command: !0,
                            embed: !0,
                            hr: !0,
                            img: !0,
                            input: !0,
                            keygen: !0,
                            link: !0,
                            meta: !0,
                            param: !0,
                            source: !0,
                            track: !0,
                            wbr: !0
                        };
                        goog.dom.tags.isVoidTag = function(a) {
                            return !0 === goog.dom.tags.VOID_TAGS_[a];
                        };
                        goog.string = {};
                        goog.string.TypedString = function() {};
                        goog.string.Const = function(a, b) {
                            this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = a === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && b || "";
                            this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
                        };
                        goog.string.Const.prototype.implementsGoogStringTypedString = !0;
                        goog.string.Const.prototype.getTypedStringValue = function() {
                            return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
                        };
                        goog.DEBUG && (goog.string.Const.prototype.toString = function() {
                            return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
                        });
                        goog.string.Const.unwrap = function(a) {
                            if (a instanceof goog.string.Const && a.constructor === goog.string.Const && a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_) return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
                            goog.asserts.fail("expected object of type Const, got '" + a + "'");
                            return "type_error:Const";
                        };
                        goog.string.Const.from = function(a) {
                            return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, a);
                        };
                        goog.string.Const.TYPE_MARKER_ = {};
                        goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.string.Const.EMPTY = goog.string.Const.from("");
                        goog.html = {};
                        goog.html.trustedtypes = {};
                        goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse = function() {
                            if (!goog.TRUSTED_TYPES_POLICY_NAME) return null;
                            void 0 === goog.html.trustedtypes.cachedPolicy_ && (goog.html.trustedtypes.cachedPolicy_ = goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html"));
                            return goog.html.trustedtypes.cachedPolicy_;
                        };
                        var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeScript_SafeScript = function(a, b) {
                            this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = b === module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE ? a : "";
                            this.implementsGoogStringTypedString = !0;
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromConstant = function(a) {
                            a = goog.string.Const.unwrap(a);
                            return 0 === a.length ? module$contents$goog$html$SafeScript_SafeScript.EMPTY : module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs = function(a, b) {
                            for(var c = [], d = 1; d < arguments.length; d++)c.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[d]));
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(a) + ")(" + c.join(", ") + ");");
                        };
                        module$contents$goog$html$SafeScript_SafeScript.fromJson = function(a) {
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(a));
                        };
                        module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
                        };
                        module$contents$goog$html$SafeScript_SafeScript.unwrap = function(a) {
                            return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(a).toString();
                        };
                        module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript = function(a) {
                            if (a instanceof module$contents$goog$html$SafeScript_SafeScript && a.constructor === module$contents$goog$html$SafeScript_SafeScript) return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;
                            (0, goog.asserts.fail)("expected object of type SafeScript, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeScript";
                        };
                        module$contents$goog$html$SafeScript_SafeScript.stringify_ = function(a) {
                            return JSON.stringify(a).replace(/</g, "\\x3c");
                        };
                        module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(a) {
                            var b = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = b ? b.createScript(a) : a;
                            return new module$contents$goog$html$SafeScript_SafeScript(a, module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE);
                        };
                        goog.DEBUG && (module$contents$goog$html$SafeScript_SafeScript.prototype.toString = function() {
                            return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
                        });
                        module$contents$goog$html$SafeScript_SafeScript.EMPTY = function() {
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
                        }();
                        goog.html.SafeScript = module$contents$goog$html$SafeScript_SafeScript;
                        goog.fs = {};
                        goog.fs.url = {};
                        goog.fs.url.createObjectUrl = function(a) {
                            return goog.fs.url.getUrlObject_().createObjectURL(a);
                        };
                        goog.fs.url.revokeObjectUrl = function(a) {
                            goog.fs.url.getUrlObject_().revokeObjectURL(a);
                        };
                        goog.fs.url.UrlObject_ = function() {};
                        goog.fs.url.UrlObject_.prototype.createObjectURL = function(a) {};
                        goog.fs.url.UrlObject_.prototype.revokeObjectURL = function(a) {};
                        goog.fs.url.getUrlObject_ = function() {
                            var a = goog.fs.url.findUrlObject_();
                            if (null != a) return a;
                            throw Error("This browser doesn't seem to support blob URLs");
                        };
                        goog.fs.url.findUrlObject_ = function() {
                            return void 0 !== goog.global.URL && void 0 !== goog.global.URL.createObjectURL ? goog.global.URL : void 0 !== goog.global.webkitURL && void 0 !== goog.global.webkitURL.createObjectURL ? goog.global.webkitURL : void 0 !== goog.global.createObjectURL ? goog.global : null;
                        };
                        goog.fs.url.browserSupportsObjectUrls = function() {
                            return null != goog.fs.url.findUrlObject_();
                        };
                        goog.fs.blob = {};
                        goog.fs.blob.getBlob = function(a) {
                            var b = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
                            if (void 0 !== b) {
                                b = new b;
                                for(var c = 0; c < arguments.length; c++)b.append(arguments[c]);
                                return b.getBlob();
                            }
                            return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments));
                        };
                        goog.fs.blob.getBlobWithProperties = function(a, b, c) {
                            var d = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
                            if (void 0 !== d) {
                                d = new d;
                                for(var e = 0; e < a.length; e++)d.append(a[e], c);
                                return d.getBlob(b);
                            }
                            if (void 0 !== goog.global.Blob) return d = {}, b && (d.type = b), c && (d.endings = c), new Blob(a, d);
                            throw Error("This browser doesn't seem to support creating Blobs");
                        };
                        goog.i18n = {};
                        goog.i18n.bidi = {};
                        goog.i18n.bidi.FORCE_RTL = !1;
                        goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ("ar" == goog.LOCALE.substring(0, 2).toLowerCase() || "fa" == goog.LOCALE.substring(0, 2).toLowerCase() || "he" == goog.LOCALE.substring(0, 2).toLowerCase() || "iw" == goog.LOCALE.substring(0, 2).toLowerCase() || "ps" == goog.LOCALE.substring(0, 2).toLowerCase() || "sd" == goog.LOCALE.substring(0, 2).toLowerCase() || "ug" == goog.LOCALE.substring(0, 2).toLowerCase() || "ur" == goog.LOCALE.substring(0, 2).toLowerCase() || "yi" == goog.LOCALE.substring(0, 2).toLowerCase()) && (2 == goog.LOCALE.length || "-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && "ckb" == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || "-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) && ("adlm" == goog.LOCALE.substring(3, 7).toLowerCase() || "arab" == goog.LOCALE.substring(3, 7).toLowerCase() || "hebr" == goog.LOCALE.substring(3, 7).toLowerCase() || "nkoo" == goog.LOCALE.substring(3, 7).toLowerCase() || "rohg" == goog.LOCALE.substring(3, 7).toLowerCase() || "thaa" == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) && ("adlm" == goog.LOCALE.substring(4, 8).toLowerCase() || "arab" == goog.LOCALE.substring(4, 8).toLowerCase() || "hebr" == goog.LOCALE.substring(4, 8).toLowerCase() || "nkoo" == goog.LOCALE.substring(4, 8).toLowerCase() || "rohg" == goog.LOCALE.substring(4, 8).toLowerCase() || "thaa" == goog.LOCALE.substring(4, 8).toLowerCase());
                        goog.i18n.bidi.Format = {
                            LRE: "\u202A",
                            RLE: "\u202B",
                            PDF: "\u202C",
                            LRM: "\u200E",
                            RLM: "\u200F"
                        };
                        goog.i18n.bidi.Dir = {
                            LTR: 1,
                            RTL: -1,
                            NEUTRAL: 0
                        };
                        goog.i18n.bidi.RIGHT = "right";
                        goog.i18n.bidi.LEFT = "left";
                        goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT;
                        goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT;
                        goog.i18n.bidi.toDir = function(a, b) {
                            return "number" == typeof a ? 0 < a ? goog.i18n.bidi.Dir.LTR : 0 > a ? goog.i18n.bidi.Dir.RTL : b ? null : goog.i18n.bidi.Dir.NEUTRAL : null == a ? null : a ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
                        };
                        goog.i18n.bidi.ltrChars_ = "A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02B8\u0300-\u0590\u0900-\u1FFF\u200E\u2C00-\ud801\ud804-\ud839\ud83c-\udbff\uF900-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF";
                        goog.i18n.bidi.rtlChars_ = "\u0591-\u06EF\u06FA-\u08FF\u200F\ud802-\ud803\ud83a-\ud83b\uFB1D-\uFDFF\uFE70-\uFEFC";
                        goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g;
                        goog.i18n.bidi.stripHtmlIfNeeded_ = function(a, b) {
                            return b ? a.replace(goog.i18n.bidi.htmlSkipReg_, "") : a;
                        };
                        goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]");
                        goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]");
                        goog.i18n.bidi.hasAnyRtl = function(a, b) {
                            return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl;
                        goog.i18n.bidi.hasAnyLtr = function(a, b) {
                            return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]");
                        goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]");
                        goog.i18n.bidi.isRtlChar = function(a) {
                            return goog.i18n.bidi.rtlRe_.test(a);
                        };
                        goog.i18n.bidi.isLtrChar = function(a) {
                            return goog.i18n.bidi.ltrRe_.test(a);
                        };
                        goog.i18n.bidi.isNeutralChar = function(a) {
                            return !goog.i18n.bidi.isLtrChar(a) && !goog.i18n.bidi.isRtlChar(a);
                        };
                        goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]");
                        goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]");
                        goog.i18n.bidi.startsWithRtl = function(a, b) {
                            return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl;
                        goog.i18n.bidi.startsWithLtr = function(a, b) {
                            return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr;
                        goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/;
                        goog.i18n.bidi.isNeutralText = function(a, b) {
                            a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b);
                            return goog.i18n.bidi.isRequiredLtrRe_.test(a) || !goog.i18n.bidi.hasAnyLtr(a) && !goog.i18n.bidi.hasAnyRtl(a);
                        };
                        goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$");
                        goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$");
                        goog.i18n.bidi.endsWithLtr = function(a, b) {
                            return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr;
                        goog.i18n.bidi.endsWithRtl = function(a, b) {
                            return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
                        };
                        goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl;
                        goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;
                        goog.i18n.bidi.isRtlLanguage = function(a) {
                            return goog.i18n.bidi.rtlLocalesRe_.test(a);
                        };
                        goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
                        goog.i18n.bidi.guardBracketInText = function(a, b) {
                            b = (void 0 === b ? goog.i18n.bidi.hasAnyRtl(a) : b) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM;
                            return a.replace(goog.i18n.bidi.bracketGuardTextRe_, b + "$&" + b);
                        };
                        goog.i18n.bidi.enforceRtlInHtml = function(a) {
                            return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + a + "</span>";
                        };
                        goog.i18n.bidi.enforceRtlInText = function(a) {
                            return goog.i18n.bidi.Format.RLE + a + goog.i18n.bidi.Format.PDF;
                        };
                        goog.i18n.bidi.enforceLtrInHtml = function(a) {
                            return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + a + "</span>";
                        };
                        goog.i18n.bidi.enforceLtrInText = function(a) {
                            return goog.i18n.bidi.Format.LRE + a + goog.i18n.bidi.Format.PDF;
                        };
                        goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;
                        goog.i18n.bidi.leftRe_ = /left/gi;
                        goog.i18n.bidi.rightRe_ = /right/gi;
                        goog.i18n.bidi.tempRe_ = /%%%%/g;
                        goog.i18n.bidi.mirrorCSS = function(a) {
                            return a.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
                        };
                        goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g;
                        goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g;
                        goog.i18n.bidi.normalizeHebrewQuote = function(a) {
                            return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1\u05F4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1\u05F3");
                        };
                        goog.i18n.bidi.wordSeparatorRe_ = /\s+/;
                        goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/;
                        goog.i18n.bidi.rtlDetectionThreshold_ = .4;
                        goog.i18n.bidi.estimateDirection = function(a, b) {
                            var c = 0, d = 0, e = !1;
                            a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b).split(goog.i18n.bidi.wordSeparatorRe_);
                            for(b = 0; b < a.length; b++){
                                var f = a[b];
                                goog.i18n.bidi.startsWithRtl(f) ? (c++, d++) : goog.i18n.bidi.isRequiredLtrRe_.test(f) ? e = !0 : goog.i18n.bidi.hasAnyLtr(f) ? d++ : goog.i18n.bidi.hasNumeralsRe_.test(f) && (e = !0);
                            }
                            return 0 == d ? e ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : c / d > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
                        };
                        goog.i18n.bidi.detectRtlDirectionality = function(a, b) {
                            return goog.i18n.bidi.estimateDirection(a, b) == goog.i18n.bidi.Dir.RTL;
                        };
                        goog.i18n.bidi.setElementDirAndAlign = function(a, b) {
                            a && (b = goog.i18n.bidi.toDir(b)) && (a.style.textAlign = b == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, a.dir = b == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
                        };
                        goog.i18n.bidi.setElementDirByTextDirectionality = function(a, b) {
                            switch(goog.i18n.bidi.estimateDirection(b)){
                                case goog.i18n.bidi.Dir.LTR:
                                    "ltr" !== a.dir && (a.dir = "ltr");
                                    break;
                                case goog.i18n.bidi.Dir.RTL:
                                    "rtl" !== a.dir && (a.dir = "rtl");
                                    break;
                                default:
                                    a.removeAttribute("dir");
                            }
                        };
                        goog.i18n.bidi.DirectionalString = function() {};
                        goog.html.TrustedResourceUrl = function(a, b) {
                            this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = b === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                        };
                        goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0;
                        goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
                        };
                        goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.TrustedResourceUrl.prototype.getDirection = function() {
                            return goog.i18n.bidi.Dir.LTR;
                        };
                        goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(a, b) {
                            var c = goog.html.TrustedResourceUrl.unwrap(this);
                            c = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);
                            var d = c[3] || "";
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", c[2] || "", a) + goog.html.TrustedResourceUrl.stringifyParams_("#", d, b));
                        };
                        goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
                            return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
                        });
                        goog.html.TrustedResourceUrl.unwrap = function(a) {
                            return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString();
                        };
                        goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(a) {
                            if (a instanceof goog.html.TrustedResourceUrl && a.constructor === goog.html.TrustedResourceUrl) return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;
                            goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:TrustedResourceUrl";
                        };
                        goog.html.TrustedResourceUrl.format = function(a, b) {
                            var c = goog.string.Const.unwrap(a);
                            if (!goog.html.TrustedResourceUrl.BASE_URL_.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);
                            a = c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(d, e) {
                                if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
                                d = b[e];
                                return d instanceof goog.string.Const ? goog.string.Const.unwrap(d) : encodeURIComponent(String(d));
                            });
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g;
                        goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;
                        goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
                        goog.html.TrustedResourceUrl.formatWithParams = function(a, b, c, d) {
                            return goog.html.TrustedResourceUrl.format(a, b).cloneWithParams(c, d);
                        };
                        goog.html.TrustedResourceUrl.fromConstant = function(a) {
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
                        };
                        goog.html.TrustedResourceUrl.fromConstants = function(a) {
                            for(var b = "", c = 0; c < a.length; c++)b += goog.string.Const.unwrap(a[c]);
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.TrustedResourceUrl.fromSafeScript = function(a) {
                            a = goog.fs.blob.getBlobWithProperties([
                                module$contents$goog$html$SafeScript_SafeScript.unwrap(a)
                            ], "text/javascript");
                            a = goog.fs.url.createObjectUrl(a);
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(a) {
                            var b = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = b ? b.createScriptURL(a) : a;
                            return new goog.html.TrustedResourceUrl(a, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.TrustedResourceUrl.stringifyParams_ = function(a, b, c) {
                            if (null == c) return b;
                            if ("string" === typeof c) return c ? a + encodeURIComponent(c) : "";
                            for(var d in c)if (Object.prototype.hasOwnProperty.call(c, d)) {
                                var e = c[d];
                                e = Array.isArray(e) ? e : [
                                    e
                                ];
                                for(var f = 0; f < e.length; f++){
                                    var g = e[f];
                                    null != g && (b || (b = a), b += (b.length > a.length ? "&" : "") + encodeURIComponent(d) + "=" + encodeURIComponent(String(g)));
                                }
                            }
                            return b;
                        };
                        goog.string.internal = {};
                        goog.string.internal.startsWith = function(a, b) {
                            return 0 == a.lastIndexOf(b, 0);
                        };
                        goog.string.internal.endsWith = function(a, b) {
                            var c = a.length - b.length;
                            return 0 <= c && a.indexOf(b, c) == c;
                        };
                        goog.string.internal.caseInsensitiveStartsWith = function(a, b) {
                            return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(0, b.length));
                        };
                        goog.string.internal.caseInsensitiveEndsWith = function(a, b) {
                            return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(a.length - b.length, b.length));
                        };
                        goog.string.internal.caseInsensitiveEquals = function(a, b) {
                            return a.toLowerCase() == b.toLowerCase();
                        };
                        goog.string.internal.isEmptyOrWhitespace = function(a) {
                            return /^[\s\xa0]*$/.test(a);
                        };
                        goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a) {
                            return a.trim();
                        } : function(a) {
                            return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
                        };
                        goog.string.internal.caseInsensitiveCompare = function(a, b) {
                            a = String(a).toLowerCase();
                            b = String(b).toLowerCase();
                            return a < b ? -1 : a == b ? 0 : 1;
                        };
                        goog.string.internal.newLineToBr = function(a, b) {
                            return a.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
                        };
                        goog.string.internal.htmlEscape = function(a, b) {
                            if (b) a = a.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
                            else {
                                if (!goog.string.internal.ALL_RE_.test(a)) return a;
                                -1 != a.indexOf("&") && (a = a.replace(goog.string.internal.AMP_RE_, "&amp;"));
                                -1 != a.indexOf("<") && (a = a.replace(goog.string.internal.LT_RE_, "&lt;"));
                                -1 != a.indexOf(">") && (a = a.replace(goog.string.internal.GT_RE_, "&gt;"));
                                -1 != a.indexOf('"') && (a = a.replace(goog.string.internal.QUOT_RE_, "&quot;"));
                                -1 != a.indexOf("'") && (a = a.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;"));
                                -1 != a.indexOf("\0") && (a = a.replace(goog.string.internal.NULL_RE_, "&#0;"));
                            }
                            return a;
                        };
                        goog.string.internal.AMP_RE_ = /&/g;
                        goog.string.internal.LT_RE_ = /</g;
                        goog.string.internal.GT_RE_ = />/g;
                        goog.string.internal.QUOT_RE_ = /"/g;
                        goog.string.internal.SINGLE_QUOTE_RE_ = /'/g;
                        goog.string.internal.NULL_RE_ = /\x00/g;
                        goog.string.internal.ALL_RE_ = /[\x00&<>"']/;
                        goog.string.internal.whitespaceEscape = function(a, b) {
                            return goog.string.internal.newLineToBr(a.replace(/  /g, " &#160;"), b);
                        };
                        goog.string.internal.contains = function(a, b) {
                            return -1 != a.indexOf(b);
                        };
                        goog.string.internal.caseInsensitiveContains = function(a, b) {
                            return goog.string.internal.contains(a.toLowerCase(), b.toLowerCase());
                        };
                        goog.string.internal.compareVersions = function(a, b) {
                            var c = 0;
                            a = goog.string.internal.trim(String(a)).split(".");
                            b = goog.string.internal.trim(String(b)).split(".");
                            for(var d = Math.max(a.length, b.length), e = 0; 0 == c && e < d; e++){
                                var f = a[e] || "", g = b[e] || "";
                                do {
                                    f = /(\d*)(\D*)(.*)/.exec(f) || [
                                        "",
                                        "",
                                        "",
                                        ""
                                    ];
                                    g = /(\d*)(\D*)(.*)/.exec(g) || [
                                        "",
                                        "",
                                        "",
                                        ""
                                    ];
                                    if (0 == f[0].length && 0 == g[0].length) break;
                                    c = 0 == f[1].length ? 0 : parseInt(f[1], 10);
                                    var h = 0 == g[1].length ? 0 : parseInt(g[1], 10);
                                    c = goog.string.internal.compareElements_(c, h) || goog.string.internal.compareElements_(0 == f[2].length, 0 == g[2].length) || goog.string.internal.compareElements_(f[2], g[2]);
                                    f = f[3];
                                    g = g[3];
                                }while (0 == c);
                            }
                            return c;
                        };
                        goog.string.internal.compareElements_ = function(a, b) {
                            return a < b ? -1 : a > b ? 1 : 0;
                        };
                        goog.html.SafeUrl = function(a, b) {
                            this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = b === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                        };
                        goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez";
                        goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeUrl.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
                        };
                        goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.SafeUrl.prototype.getDirection = function() {
                            return goog.i18n.bidi.Dir.LTR;
                        };
                        goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
                            return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
                        });
                        goog.html.SafeUrl.unwrap = function(a) {
                            if (a instanceof goog.html.SafeUrl && a.constructor === goog.html.SafeUrl) return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;
                            goog.asserts.fail("expected object of type SafeUrl, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeUrl";
                        };
                        goog.html.SafeUrl.fromConstant = function(a) {
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
                        };
                        goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i;
                        goog.html.SafeUrl.isSafeMimeType = function(a) {
                            return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a);
                        };
                        goog.html.SafeUrl.fromBlob = function(a) {
                            a = goog.html.SafeUrl.isSafeMimeType(a.type) ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.revokeObjectUrl = function(a) {
                            a = a.getTypedStringValue();
                            a !== goog.html.SafeUrl.INNOCUOUS_STRING && goog.fs.url.revokeObjectUrl(a);
                        };
                        goog.html.SafeUrl.fromMediaSource = function(a) {
                            goog.asserts.assert("MediaSource" in goog.global, "No support for MediaSource");
                            a = a instanceof MediaSource ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i;
                        goog.html.SafeUrl.tryFromDataUrl = function(a) {
                            a = String(a);
                            a = a.replace(/(%0A|%0D)/g, "");
                            var b = a.match(goog.html.DATA_URL_PATTERN_);
                            return b && goog.html.SafeUrl.isSafeMimeType(b[1]) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a) : null;
                        };
                        goog.html.SafeUrl.fromDataUrl = function(a) {
                            return goog.html.SafeUrl.tryFromDataUrl(a) || goog.html.SafeUrl.INNOCUOUS_URL;
                        };
                        goog.html.SafeUrl.fromTelUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "tel:") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;
                        goog.html.SafeUrl.fromSipUrl = function(a) {
                            goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a)) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromFacebookMessengerUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "fb-messenger://share") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromWhatsAppUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "whatsapp://send") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.fromSmsUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.isSmsUrlBodyValid_ = function(a) {
                            var b = a.indexOf("#");
                            0 < b && (a = a.substring(0, b));
                            b = a.match(/[?&]body=/gi);
                            if (!b) return !0;
                            if (1 < b.length) return !1;
                            a = a.match(/[?&]body=([^&]*)/)[1];
                            if (!a) return !0;
                            try {
                                decodeURIComponent(a);
                            } catch (c) {
                                return !1;
                            }
                            return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a);
                        };
                        goog.html.SafeUrl.fromSshUrl = function(a) {
                            goog.string.internal.caseInsensitiveStartsWith(a, "ssh://") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(a, b) {
                            return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, a, b);
                        };
                        goog.html.SafeUrl.sanitizeExtensionUrl_ = function(a, b, c) {
                            (a = a.exec(b)) ? (a = a[1], -1 == (c instanceof goog.string.Const ? [
                                goog.string.Const.unwrap(c)
                            ] : c.map(function(d) {
                                return goog.string.Const.unwrap(d);
                            })).indexOf(a) && (b = goog.html.SafeUrl.INNOCUOUS_STRING)) : b = goog.html.SafeUrl.INNOCUOUS_STRING;
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.SafeUrl.fromTrustedResourceUrl = function(a) {
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a));
                        };
                        goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
                        goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_;
                        goog.html.SafeUrl.trySanitize = function(a) {
                            if (a instanceof goog.html.SafeUrl) return a;
                            a = "object" == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            return goog.html.SAFE_URL_PATTERN_.test(a) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a) : goog.html.SafeUrl.tryFromDataUrl(a);
                        };
                        goog.html.SafeUrl.sanitize = function(a) {
                            return goog.html.SafeUrl.trySanitize(a) || goog.html.SafeUrl.INNOCUOUS_URL;
                        };
                        goog.html.SafeUrl.sanitizeAssertUnchanged = function(a, b) {
                            if (a instanceof goog.html.SafeUrl) return a;
                            a = "object" == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            if (b && /^data:/i.test(a) && (b = goog.html.SafeUrl.fromDataUrl(a), b.getTypedStringValue() == a)) return b;
                            goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a), "%s does not match the safe URL pattern", a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(a) {
                            return new goog.html.SafeUrl(a, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeUrl.INNOCUOUS_URL = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING);
                        goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");
                        goog.html.SafeStyle = function(a, b) {
                            this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = b === goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                        };
                        goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeStyle.fromConstant = function(a) {
                            a = goog.string.Const.unwrap(a);
                            if (0 === a.length) return goog.html.SafeStyle.EMPTY;
                            goog.asserts.assert(goog.string.internal.endsWith(a, ";"), "Last character of style string is not ';': " + a);
                            goog.asserts.assert(goog.string.internal.contains(a, ":"), "Style string must contain at least one ':', to specify a \"name: value\" pair: " + a);
                            return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a);
                        };
                        goog.html.SafeStyle.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
                        };
                        goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
                            return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
                        });
                        goog.html.SafeStyle.unwrap = function(a) {
                            if (a instanceof goog.html.SafeStyle && a.constructor === goog.html.SafeStyle) return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;
                            goog.asserts.fail("expected object of type SafeStyle, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeStyle";
                        };
                        goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(a) {
                            return new goog.html.SafeStyle(a, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");
                        goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez";
                        goog.html.SafeStyle.create = function(a) {
                            var b = "", c;
                            for(c in a)if (Object.prototype.hasOwnProperty.call(a, c)) {
                                if (!/^[-_a-zA-Z0-9]+$/.test(c)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + c);
                                var d = a[c];
                                null != d && (d = Array.isArray(d) ? module$contents$goog$array_map(d, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(d), b += c + ":" + d + ";");
                            }
                            return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
                        };
                        goog.html.SafeStyle.sanitizePropertyValue_ = function(a) {
                            if (a instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(a).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
                            a = a instanceof goog.string.Const ? goog.string.Const.unwrap(a) : goog.html.SafeStyle.sanitizePropertyValueString_(String(a));
                            if (/[{;}]/.test(a)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [
                                a
                            ]);
                            return a;
                        };
                        goog.html.SafeStyle.sanitizePropertyValueString_ = function(a) {
                            var b = a.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
                            if (goog.html.SafeStyle.VALUE_RE_.test(b)) {
                                if (goog.html.SafeStyle.COMMENT_RE_.test(a)) return goog.asserts.fail("String value disallows comments, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                                if (!goog.html.SafeStyle.hasBalancedQuotes_(a)) return goog.asserts.fail("String value requires balanced quotes, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                                if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(a)) return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                            } else return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
                            return goog.html.SafeStyle.sanitizeUrl_(a);
                        };
                        goog.html.SafeStyle.hasBalancedQuotes_ = function(a) {
                            for(var b = !0, c = !0, d = 0; d < a.length; d++){
                                var e = a.charAt(d);
                                "'" == e && c ? b = !b : '"' == e && b && (c = !c);
                            }
                            return b && c;
                        };
                        goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(a) {
                            for(var b = !0, c = /^[-_a-zA-Z0-9]$/, d = 0; d < a.length; d++){
                                var e = a.charAt(d);
                                if ("]" == e) {
                                    if (b) return !1;
                                    b = !0;
                                } else if ("[" == e) {
                                    if (!b) return !1;
                                    b = !1;
                                } else if (!b && !c.test(e)) return !1;
                            }
                            return b;
                        };
                        goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = "[-,.\"'%_!# a-zA-Z0-9\\[\\]]";
                        goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$");
                        goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;
                        goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = "calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" ");
                        goog.html.SafeStyle.FUNCTIONS_RE_ = new RegExp("\\b(" + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|") + ")\\([-+*/0-9a-z.%\\[\\], ]+\\)", "g");
                        goog.html.SafeStyle.COMMENT_RE_ = /\/\*/;
                        goog.html.SafeStyle.sanitizeUrl_ = function(a) {
                            return a.replace(goog.html.SafeStyle.URL_RE_, function(b, c, d, e) {
                                var f = "";
                                d = d.replace(/^(['"])(.*)\1$/, function(g, h, k) {
                                    f = h;
                                    return k;
                                });
                                b = goog.html.SafeUrl.sanitize(d).getTypedStringValue();
                                return c + f + b + f + e;
                            });
                        };
                        goog.html.SafeStyle.concat = function(a) {
                            var b = "", c = function(d) {
                                Array.isArray(d) ? module$contents$goog$array_forEach(d, c) : b += goog.html.SafeStyle.unwrap(d);
                            };
                            module$contents$goog$array_forEach(arguments, c);
                            return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
                        };
                        var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet = function(a, b) {
                            this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = b === module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE ? a : "";
                            this.implementsGoogStringTypedString = !0;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule = function(a, b) {
                            if ((0, goog.string.internal.contains)(a, "<")) throw Error("Selector does not allow '<', got: " + a);
                            var c = a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
                            if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + a);
                            if (!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(c)) throw Error("() and [] in selector must be balanced, got: " + a);
                            b instanceof goog.html.SafeStyle || (b = goog.html.SafeStyle.create(b));
                            a = a + "{" + goog.html.SafeStyle.unwrap(b).replace(/</g, "\\3C ") + "}";
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_ = function(a) {
                            for(var b = {
                                "(": ")",
                                "[": "]"
                            }, c = [], d = 0; d < a.length; d++){
                                var e = a[d];
                                if (b[e]) c.push(b[e]);
                                else if (goog.object.contains(b, e) && c.pop() != e) return !1;
                            }
                            return 0 == c.length;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat = function(a) {
                            var b = "", c = function(d) {
                                Array.isArray(d) ? module$contents$goog$array_forEach(d, c) : b += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(d);
                            };
                            module$contents$goog$array_forEach(arguments, c);
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant = function(a) {
                            a = goog.string.Const.unwrap(a);
                            if (0 === a.length) return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY;
                            (0, goog.asserts.assert)(!(0, goog.string.internal.contains)(a, "<"), "Forbidden '<' character in style sheet string: " + a);
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap = function(a) {
                            if (a instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet && a.constructor === module$contents$goog$html$SafeStyleSheet_SafeStyleSheet) return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
                            (0, goog.asserts.fail)("expected object of type SafeStyleSheet, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeStyleSheet";
                        };
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(a) {
                            return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(a, module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE);
                        };
                        goog.DEBUG && (module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString = function() {
                            return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
                        });
                        module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");
                        goog.html.SafeStyleSheet = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet;
                        goog.labs = {};
                        goog.labs.userAgent = {};
                        goog.labs.userAgent.util = {};
                        goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
                            var a = goog.labs.userAgent.util.getNavigator_();
                            return a && (a = a.userAgent) ? a : "";
                        };
                        goog.labs.userAgent.util.getNavigator_ = function() {
                            return goog.global.navigator;
                        };
                        goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_();
                        goog.labs.userAgent.util.setUserAgent = function(a) {
                            goog.labs.userAgent.util.userAgent_ = a || goog.labs.userAgent.util.getNativeUserAgentString_();
                        };
                        goog.labs.userAgent.util.getUserAgent = function() {
                            return goog.labs.userAgent.util.userAgent_;
                        };
                        goog.labs.userAgent.util.matchUserAgent = function(a) {
                            var b = goog.labs.userAgent.util.getUserAgent();
                            return goog.string.internal.contains(b, a);
                        };
                        goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(a) {
                            var b = goog.labs.userAgent.util.getUserAgent();
                            return goog.string.internal.caseInsensitiveContains(b, a);
                        };
                        goog.labs.userAgent.util.extractVersionTuples = function(a) {
                            for(var b = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, c = [], d; d = b.exec(a);)c.push([
                                d[1],
                                d[2],
                                d[3] || void 0
                            ]);
                            return c;
                        };
                        goog.labs.userAgent.browser = {};
                        goog.labs.userAgent.browser.matchOpera_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Opera");
                        };
                        goog.labs.userAgent.browser.matchIE_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
                        };
                        goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Edge");
                        };
                        goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Edg/");
                        };
                        goog.labs.userAgent.browser.matchOperaChromium_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("OPR");
                        };
                        goog.labs.userAgent.browser.matchFirefox_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
                        };
                        goog.labs.userAgent.browser.matchSafari_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
                        };
                        goog.labs.userAgent.browser.matchCoast_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Coast");
                        };
                        goog.labs.userAgent.browser.matchIosWebview_ = function() {
                            return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
                        };
                        goog.labs.userAgent.browser.matchChrome_ = function() {
                            return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
                        };
                        goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
                        };
                        goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_;
                        goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_;
                        goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_;
                        goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_;
                        goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_;
                        goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_;
                        goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_;
                        goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_;
                        goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_;
                        goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_;
                        goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_;
                        goog.labs.userAgent.browser.isSilk = function() {
                            return goog.labs.userAgent.util.matchUserAgent("Silk");
                        };
                        goog.labs.userAgent.browser.getVersion = function() {
                            function a(e) {
                                e = module$contents$goog$array_find(e, d);
                                return c[e] || "";
                            }
                            var b = goog.labs.userAgent.util.getUserAgent();
                            if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(b);
                            b = goog.labs.userAgent.util.extractVersionTuples(b);
                            var c = {};
                            module$contents$goog$array_forEach(b, function(e) {
                                c[e[0]] = e[1];
                            });
                            var d = goog.partial(goog.object.containsKey, c);
                            return goog.labs.userAgent.browser.isOpera() ? a([
                                "Version",
                                "Opera"
                            ]) : goog.labs.userAgent.browser.isEdge() ? a([
                                "Edge"
                            ]) : goog.labs.userAgent.browser.isEdgeChromium() ? a([
                                "Edg"
                            ]) : goog.labs.userAgent.browser.isChrome() ? a([
                                "Chrome",
                                "CriOS",
                                "HeadlessChrome"
                            ]) : (b = b[2]) && b[1] || "";
                        };
                        goog.labs.userAgent.browser.isVersionOrHigher = function(a) {
                            return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), a);
                        };
                        goog.labs.userAgent.browser.getIEVersion_ = function(a) {
                            var b = /rv: *([\d\.]*)/.exec(a);
                            if (b && b[1]) return b[1];
                            b = "";
                            var c = /MSIE +([\d\.]+)/.exec(a);
                            if (c && c[1]) {
                                if (a = /Trident\/(\d.\d)/.exec(a), "7.0" == c[1]) {
                                    if (a && a[1]) switch(a[1]){
                                        case "4.0":
                                            b = "8.0";
                                            break;
                                        case "5.0":
                                            b = "9.0";
                                            break;
                                        case "6.0":
                                            b = "10.0";
                                            break;
                                        case "7.0":
                                            b = "11.0";
                                    }
                                    else b = "7.0";
                                } else b = c[1];
                            }
                            return b;
                        };
                        goog.html.SafeHtml = function(a, b, c) {
                            this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = c === goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ ? a : "";
                            this.dir_ = b;
                        };
                        goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG;
                        goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = !0;
                        goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0;
                        goog.html.SafeHtml.prototype.getDirection = function() {
                            return this.dir_;
                        };
                        goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0;
                        goog.html.SafeHtml.prototype.getTypedStringValue = function() {
                            return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
                        };
                        goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
                            return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
                        });
                        goog.html.SafeHtml.unwrap = function(a) {
                            return goog.html.SafeHtml.unwrapTrustedHTML(a).toString();
                        };
                        goog.html.SafeHtml.unwrapTrustedHTML = function(a) {
                            if (a instanceof goog.html.SafeHtml && a.constructor === goog.html.SafeHtml) return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;
                            goog.asserts.fail("expected object of type SafeHtml, got '" + a + "' of type " + goog.typeOf(a));
                            return "type_error:SafeHtml";
                        };
                        goog.html.SafeHtml.htmlEscape = function(a) {
                            if (a instanceof goog.html.SafeHtml) return a;
                            var b = "object" == typeof a, c = null;
                            b && a.implementsGoogI18nBidiDirectionalString && (c = a.getDirection());
                            a = b && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a), c);
                        };
                        goog.html.SafeHtml.htmlEscapePreservingNewlines = function(a) {
                            if (a instanceof goog.html.SafeHtml) return a;
                            a = goog.html.SafeHtml.htmlEscape(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)), a.getDirection());
                        };
                        goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(a) {
                            if (a instanceof goog.html.SafeHtml) return a;
                            a = goog.html.SafeHtml.htmlEscape(a);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)), a.getDirection());
                        };
                        goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape;
                        goog.html.SafeHtml.comment = function(a) {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!--" + goog.string.internal.htmlEscape(a) + "-->", null);
                        };
                        goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/;
                        goog.html.SafeHtml.URL_ATTRIBUTES_ = {
                            action: !0,
                            cite: !0,
                            data: !0,
                            formaction: !0,
                            href: !0,
                            manifest: !0,
                            poster: !0,
                            src: !0
                        };
                        goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = goog.object.createSet(goog.dom.TagName.APPLET, goog.dom.TagName.BASE, goog.dom.TagName.EMBED, goog.dom.TagName.IFRAME, goog.dom.TagName.LINK, goog.dom.TagName.MATH, goog.dom.TagName.META, goog.dom.TagName.OBJECT, goog.dom.TagName.SCRIPT, goog.dom.TagName.STYLE, goog.dom.TagName.SVG, goog.dom.TagName.TEMPLATE);
                        goog.html.SafeHtml.create = function(a, b, c) {
                            goog.html.SafeHtml.verifyTagName(String(a));
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a), b, c);
                        };
                        goog.html.SafeHtml.verifyTagName = function(a) {
                            if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Invalid tag name <" + a + ">." : "");
                            if (a.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Tag name <" + a + "> is not allowed for SafeHtml." : "");
                        };
                        goog.html.SafeHtml.createIframe = function(a, b, c, d) {
                            a && goog.html.TrustedResourceUrl.unwrap(a);
                            var e = {};
                            e.src = a || null;
                            e.srcdoc = b && goog.html.SafeHtml.unwrap(b);
                            a = goog.html.SafeHtml.combineAttributes(e, {
                                sandbox: ""
                            }, c);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
                        };
                        goog.html.SafeHtml.createSandboxIframe = function(a, b, c, d) {
                            if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "The browser does not support sandboxed iframes." : "");
                            var e = {};
                            e.src = a ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)) : null;
                            e.srcdoc = b || null;
                            e.sandbox = "";
                            a = goog.html.SafeHtml.combineAttributes(e, {}, c);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
                        };
                        goog.html.SafeHtml.canUseSandboxIframe = function() {
                            return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
                        };
                        goog.html.SafeHtml.createScriptSrc = function(a, b) {
                            goog.html.TrustedResourceUrl.unwrap(a);
                            a = goog.html.SafeHtml.combineAttributes({
                                src: a
                            }, {}, b);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", a);
                        };
                        goog.html.SafeHtml.createScript = function(a, b) {
                            for(var c in b)if (Object.prototype.hasOwnProperty.call(b, c)) {
                                var d = c.toLowerCase();
                                if ("language" == d || "src" == d || "text" == d || "type" == d) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + d + '" attribute' : "");
                            }
                            c = "";
                            a = module$contents$goog$array_concat(a);
                            for(d = 0; d < a.length; d++)c += module$contents$goog$html$SafeScript_SafeScript.unwrap(a[d]);
                            a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", b, a);
                        };
                        goog.html.SafeHtml.createStyle = function(a, b) {
                            b = goog.html.SafeHtml.combineAttributes({
                                type: "text/css"
                            }, {}, b);
                            var c = "";
                            a = module$contents$goog$array_concat(a);
                            for(var d = 0; d < a.length; d++)c += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(a[d]);
                            a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", b, a);
                        };
                        goog.html.SafeHtml.createMetaRefresh = function(a, b) {
                            a = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));
                            (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'");
                            return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {
                                "http-equiv": "refresh",
                                content: (b || 0) + "; url=" + a
                            });
                        };
                        goog.html.SafeHtml.getAttrNameAndValue_ = function(a, b, c) {
                            if (c instanceof goog.string.Const) c = goog.string.Const.unwrap(c);
                            else if ("style" == b.toLowerCase()) {
                                if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE) c = goog.html.SafeHtml.getStyleValue_(c);
                                else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : "");
                            } else {
                                if (/^on/i.test(b)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b + '" requires goog.string.Const value, "' + c + '" given.' : "");
                                if (b.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) {
                                    if (c instanceof goog.html.TrustedResourceUrl) c = goog.html.TrustedResourceUrl.unwrap(c);
                                    else if (c instanceof goog.html.SafeUrl) c = goog.html.SafeUrl.unwrap(c);
                                    else if ("string" === typeof c) c = goog.html.SafeUrl.sanitize(c).getTypedStringValue();
                                    else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + b + '" on tag "' + a + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + c + '" given.' : "");
                                }
                            }
                            c.implementsGoogStringTypedString && (c = c.getTypedStringValue());
                            goog.asserts.assert("string" === typeof c || "number" === typeof c, "String or number value expected, got " + typeof c + " with value: " + c);
                            return b + '="' + goog.string.internal.htmlEscape(String(c)) + '"';
                        };
                        goog.html.SafeHtml.getStyleValue_ = function(a) {
                            if (!goog.isObject(a)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof a + " given: " + a : "");
                            a instanceof goog.html.SafeStyle || (a = goog.html.SafeStyle.create(a));
                            return goog.html.SafeStyle.unwrap(a);
                        };
                        goog.html.SafeHtml.createWithDir = function(a, b, c, d) {
                            b = goog.html.SafeHtml.create(b, c, d);
                            b.dir_ = a;
                            return b;
                        };
                        goog.html.SafeHtml.join = function(a, b) {
                            a = goog.html.SafeHtml.htmlEscape(a);
                            var c = a.getDirection(), d = [], e = function(f) {
                                Array.isArray(f) ? module$contents$goog$array_forEach(f, e) : (f = goog.html.SafeHtml.htmlEscape(f), d.push(goog.html.SafeHtml.unwrap(f)), f = f.getDirection(), c == goog.i18n.bidi.Dir.NEUTRAL ? c = f : f != goog.i18n.bidi.Dir.NEUTRAL && c != f && (c = null));
                            };
                            module$contents$goog$array_forEach(b, e);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a)), c);
                        };
                        goog.html.SafeHtml.concat = function(a) {
                            return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
                        };
                        goog.html.SafeHtml.concatWithDir = function(a, b) {
                            var c = goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments, 1));
                            c.dir_ = a;
                            return c;
                        };
                        goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ = {};
                        goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(a, b) {
                            var c = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
                            a = c ? c.createHTML(a) : a;
                            return new goog.html.SafeHtml(a, b, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
                        };
                        goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(a, b, c) {
                            var d = null;
                            var e = "<" + a + goog.html.SafeHtml.stringifyAttributes(a, b);
                            null == c ? c = [] : Array.isArray(c) || (c = [
                                c
                            ]);
                            goog.dom.tags.isVoidTag(a.toLowerCase()) ? (goog.asserts.assert(!c.length, "Void tag <" + a + "> does not allow content."), e += ">") : (d = goog.html.SafeHtml.concat(c), e += ">" + goog.html.SafeHtml.unwrap(d) + "</" + a + ">", d = d.getDirection());
                            (a = b && b.dir) && (d = /^(ltr|rtl|auto)$/i.test(a) ? goog.i18n.bidi.Dir.NEUTRAL : null);
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e, d);
                        };
                        goog.html.SafeHtml.stringifyAttributes = function(a, b) {
                            var c = "";
                            if (b) {
                                for(var d in b)if (Object.prototype.hasOwnProperty.call(b, d)) {
                                    if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + d + '".' : "");
                                    var e = b[d];
                                    null != e && (c += " " + goog.html.SafeHtml.getAttrNameAndValue_(a, d, e));
                                }
                            }
                            return c;
                        };
                        goog.html.SafeHtml.combineAttributes = function(a, b, c) {
                            var d = {}, e;
                            for(e in a)Object.prototype.hasOwnProperty.call(a, e) && (goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = a[e]);
                            for(e in b)Object.prototype.hasOwnProperty.call(b, e) && (goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = b[e]);
                            if (c) {
                                for(e in c)if (Object.prototype.hasOwnProperty.call(c, e)) {
                                    var f = e.toLowerCase();
                                    if (f in a) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + f + '" attribute, got "' + e + '" with value "' + c[e] + '"' : "");
                                    f in b && delete d[f];
                                    d[e] = c[e];
                                }
                            }
                            return d;
                        };
                        goog.html.SafeHtml.DOCTYPE_HTML = function() {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
                        }();
                        goog.html.SafeHtml.EMPTY = new goog.html.SafeHtml(goog.global.trustedTypes && goog.global.trustedTypes.emptyHTML || "", goog.i18n.bidi.Dir.NEUTRAL, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
                        goog.html.SafeHtml.BR = function() {
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
                        }();
                        goog.html.uncheckedconversions = {};
                        goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(a, b, c) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b, c || null);
                        };
                        goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(a, b) {
                            goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
                            goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
                            return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
                        };
                        goog.dom.safe = {};
                        goog.dom.safe.InsertAdjacentHtmlPosition = {
                            AFTERBEGIN: "afterbegin",
                            AFTEREND: "afterend",
                            BEFOREBEGIN: "beforebegin",
                            BEFOREEND: "beforeend"
                        };
                        goog.dom.safe.insertAdjacentHtml = function(a, b, c) {
                            a.insertAdjacentHTML(b, goog.html.SafeHtml.unwrapTrustedHTML(c));
                        };
                        goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
                            MATH: !0,
                            SCRIPT: !0,
                            STYLE: !0,
                            SVG: !0,
                            TEMPLATE: !0
                        };
                        goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
                            if (goog.DEBUG && "undefined" === typeof document) return !1;
                            var a = document.createElement("div"), b = document.createElement("div");
                            b.appendChild(document.createElement("div"));
                            a.appendChild(b);
                            if (goog.DEBUG && !a.firstChild) return !1;
                            b = a.firstChild.firstChild;
                            a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);
                            return !b.parentElement;
                        });
                        goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(a, b) {
                            if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for(; a.lastChild;)a.removeChild(a.lastChild);
                            a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setInnerHtml = function(a, b) {
                            if (goog.asserts.ENABLE_ASSERTS && a.tagName) {
                                var c = a.tagName.toUpperCase();
                                if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + a.tagName + ".");
                            }
                            goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a, b);
                        };
                        goog.dom.safe.setInnerHtmlFromConstant = function(a, b) {
                            goog.dom.safe.setInnerHtml(a, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML to be immediatelly used."), goog.string.Const.unwrap(b)));
                        };
                        goog.dom.safe.setOuterHtml = function(a, b) {
                            a.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setFormElementAction = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLFormElement(a).action = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setButtonFormAction = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLButtonElement(a).formAction = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setInputFormAction = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            goog.dom.asserts.assertIsHTMLInputElement(a).formAction = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setStyle = function(a, b) {
                            a.style.cssText = goog.html.SafeStyle.unwrap(b);
                        };
                        goog.dom.safe.documentWrite = function(a, b) {
                            a.write(goog.html.SafeHtml.unwrapTrustedHTML(b));
                        };
                        goog.dom.safe.setAnchorHref = function(a, b) {
                            goog.dom.asserts.assertIsHTMLAnchorElement(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.href = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setImageSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLImageElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:image\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setAudioSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLAudioElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:audio\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setVideoSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLVideoElement(a);
                            if (!(b instanceof goog.html.SafeUrl)) {
                                var c = /^data:video\//i.test(b);
                                b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
                            }
                            a.src = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.setEmbedSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLEmbedElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                        };
                        goog.dom.safe.setFrameSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLFrameElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrap(b);
                        };
                        goog.dom.safe.setIframeSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLIFrameElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrap(b);
                        };
                        goog.dom.safe.setIframeSrcdoc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLIFrameElement(a);
                            a.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(b);
                        };
                        goog.dom.safe.setLinkHrefAndRel = function(a, b, c) {
                            goog.dom.asserts.assertIsHTMLLinkElement(a);
                            a.rel = c;
                            goog.string.internal.caseInsensitiveContains(c, "stylesheet") ? (goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), a.href = goog.html.TrustedResourceUrl.unwrap(b)) : a.href = b instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(b) : b instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(b) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(b));
                        };
                        goog.dom.safe.setObjectData = function(a, b) {
                            goog.dom.asserts.assertIsHTMLObjectElement(a);
                            a.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                        };
                        goog.dom.safe.setScriptSrc = function(a, b) {
                            goog.dom.asserts.assertIsHTMLScriptElement(a);
                            a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
                            goog.dom.safe.setNonceForScriptElement_(a);
                        };
                        goog.dom.safe.setScriptContent = function(a, b) {
                            goog.dom.asserts.assertIsHTMLScriptElement(a);
                            a.textContent = module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(b);
                            goog.dom.safe.setNonceForScriptElement_(a);
                        };
                        goog.dom.safe.setNonceForScriptElement_ = function(a) {
                            var b = goog.getScriptNonce(a.ownerDocument && a.ownerDocument.defaultView);
                            b && a.setAttribute("nonce", b);
                        };
                        goog.dom.safe.setLocationHref = function(a, b) {
                            goog.dom.asserts.assertIsLocation(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.href = goog.html.SafeUrl.unwrap(b);
                        };
                        goog.dom.safe.assignLocation = function(a, b) {
                            goog.dom.asserts.assertIsLocation(a);
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.assign(goog.html.SafeUrl.unwrap(b));
                        };
                        goog.dom.safe.replaceLocation = function(a, b) {
                            b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
                            a.replace(goog.html.SafeUrl.unwrap(b));
                        };
                        goog.dom.safe.openInWindow = function(a, b, c, d, e) {
                            a = a instanceof goog.html.SafeUrl ? a : goog.html.SafeUrl.sanitizeAssertUnchanged(a);
                            b = b || goog.global;
                            c = c instanceof goog.string.Const ? goog.string.Const.unwrap(c) : c || "";
                            return b.open(goog.html.SafeUrl.unwrap(a), c, d, e);
                        };
                        goog.dom.safe.parseFromStringHtml = function(a, b) {
                            return goog.dom.safe.parseFromString(a, b, "text/html");
                        };
                        goog.dom.safe.parseFromString = function(a, b, c) {
                            return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b), c);
                        };
                        goog.dom.safe.createImageFromBlob = function(a) {
                            if (!/^image\/.*/g.test(a.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
                            var b = goog.global.URL.createObjectURL(a);
                            a = new goog.global.Image;
                            a.onload = function() {
                                goog.global.URL.revokeObjectURL(b);
                            };
                            goog.dom.safe.setImageSrc(a, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), b));
                            return a;
                        };
                        goog.string.DETECT_DOUBLE_ESCAPING = !1;
                        goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1;
                        goog.string.Unicode = {
                            NBSP: "\xa0"
                        };
                        goog.string.startsWith = goog.string.internal.startsWith;
                        goog.string.endsWith = goog.string.internal.endsWith;
                        goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith;
                        goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith;
                        goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals;
                        goog.string.subs = function(a, b) {
                            for(var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;)d += c.shift() + e.shift();
                            return d + c.join("%s");
                        };
                        goog.string.collapseWhitespace = function(a) {
                            return a.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
                        };
                        goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace;
                        goog.string.isEmptyString = function(a) {
                            return 0 == a.length;
                        };
                        goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
                        goog.string.isEmptyOrWhitespaceSafe = function(a) {
                            return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a));
                        };
                        goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
                        goog.string.isBreakingWhitespace = function(a) {
                            return !/[^\t\n\r ]/.test(a);
                        };
                        goog.string.isAlpha = function(a) {
                            return !/[^a-zA-Z]/.test(a);
                        };
                        goog.string.isNumeric = function(a) {
                            return !/[^0-9]/.test(a);
                        };
                        goog.string.isAlphaNumeric = function(a) {
                            return !/[^a-zA-Z0-9]/.test(a);
                        };
                        goog.string.isSpace = function(a) {
                            return " " == a;
                        };
                        goog.string.isUnicodeChar = function(a) {
                            return 1 == a.length && " " <= a && "~" >= a || "\x80" <= a && "\uFFFD" >= a;
                        };
                        goog.string.stripNewlines = function(a) {
                            return a.replace(/(\r\n|\r|\n)+/g, " ");
                        };
                        goog.string.canonicalizeNewlines = function(a) {
                            return a.replace(/(\r\n|\r|\n)/g, "\n");
                        };
                        goog.string.normalizeWhitespace = function(a) {
                            return a.replace(/\xa0|\s/g, " ");
                        };
                        goog.string.normalizeSpaces = function(a) {
                            return a.replace(/\xa0|[ \t]+/g, " ");
                        };
                        goog.string.collapseBreakingSpaces = function(a) {
                            return a.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
                        };
                        goog.string.trim = goog.string.internal.trim;
                        goog.string.trimLeft = function(a) {
                            return a.replace(/^[\s\xa0]+/, "");
                        };
                        goog.string.trimRight = function(a) {
                            return a.replace(/[\s\xa0]+$/, "");
                        };
                        goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare;
                        goog.string.numberAwareCompare_ = function(a, b, c) {
                            if (a == b) return 0;
                            if (!a) return -1;
                            if (!b) return 1;
                            for(var d = a.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++){
                                c = d[g];
                                var h = e[g];
                                if (c != h) return a = parseInt(c, 10), !isNaN(a) && (b = parseInt(h, 10), !isNaN(b) && a - b) ? a - b : c < h ? -1 : 1;
                            }
                            return d.length != e.length ? d.length - e.length : a < b ? -1 : 1;
                        };
                        goog.string.intAwareCompare = function(a, b) {
                            return goog.string.numberAwareCompare_(a, b, /\d+|\D+/g);
                        };
                        goog.string.floatAwareCompare = function(a, b) {
                            return goog.string.numberAwareCompare_(a, b, /\d+|\.\d+|\D+/g);
                        };
                        goog.string.numerateCompare = goog.string.floatAwareCompare;
                        goog.string.urlEncode = function(a) {
                            return encodeURIComponent(String(a));
                        };
                        goog.string.urlDecode = function(a) {
                            return decodeURIComponent(a.replace(/\+/g, " "));
                        };
                        goog.string.newLineToBr = goog.string.internal.newLineToBr;
                        goog.string.htmlEscape = function(a, b) {
                            a = goog.string.internal.htmlEscape(a, b);
                            goog.string.DETECT_DOUBLE_ESCAPING && (a = a.replace(goog.string.E_RE_, "&#101;"));
                            return a;
                        };
                        goog.string.E_RE_ = /e/g;
                        goog.string.unescapeEntities = function(a) {
                            return goog.string.contains(a, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a) : goog.string.unescapePureXmlEntities_(a) : a;
                        };
                        goog.string.unescapeEntitiesWithDocument = function(a, b) {
                            return goog.string.contains(a, "&") ? goog.string.unescapeEntitiesUsingDom_(a, b) : a;
                        };
                        goog.string.unescapeEntitiesUsingDom_ = function(a, b) {
                            var c = {
                                "&amp;": "&",
                                "&lt;": "<",
                                "&gt;": ">",
                                "&quot;": '"'
                            };
                            var d = b ? b.createElement("div") : goog.global.document.createElement("div");
                            return a.replace(goog.string.HTML_ENTITY_PATTERN_, function(e, f) {
                                var g = c[e];
                                if (g) return g;
                                "#" == f.charAt(0) && (f = Number("0" + f.substr(1)), isNaN(f) || (g = String.fromCharCode(f)));
                                g || (goog.dom.safe.setInnerHtml(d, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), e + " ")), g = d.firstChild.nodeValue.slice(0, -1));
                                return c[e] = g;
                            });
                        };
                        goog.string.unescapePureXmlEntities_ = function(a) {
                            return a.replace(/&([^;]+);/g, function(b, c) {
                                switch(c){
                                    case "amp":
                                        return "&";
                                    case "lt":
                                        return "<";
                                    case "gt":
                                        return ">";
                                    case "quot":
                                        return '"';
                                    default:
                                        return "#" != c.charAt(0) || (c = Number("0" + c.substr(1)), isNaN(c)) ? b : String.fromCharCode(c);
                                }
                            });
                        };
                        goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
                        goog.string.whitespaceEscape = function(a, b) {
                            return goog.string.newLineToBr(a.replace(/  /g, " &#160;"), b);
                        };
                        goog.string.preserveSpaces = function(a) {
                            return a.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
                        };
                        goog.string.stripQuotes = function(a, b) {
                            for(var c = b.length, d = 0; d < c; d++){
                                var e = 1 == c ? b : b.charAt(d);
                                if (a.charAt(0) == e && a.charAt(a.length - 1) == e) return a.substring(1, a.length - 1);
                            }
                            return a;
                        };
                        goog.string.truncate = function(a, b, c) {
                            c && (a = goog.string.unescapeEntities(a));
                            a.length > b && (a = a.substring(0, b - 3) + "...");
                            c && (a = goog.string.htmlEscape(a));
                            return a;
                        };
                        goog.string.truncateMiddle = function(a, b, c, d) {
                            c && (a = goog.string.unescapeEntities(a));
                            if (d && a.length > b) {
                                d > b && (d = b);
                                var e = a.length - d;
                                a = a.substring(0, b - d) + "..." + a.substring(e);
                            } else a.length > b && (d = Math.floor(b / 2), e = a.length - d, a = a.substring(0, d + b % 2) + "..." + a.substring(e));
                            c && (a = goog.string.htmlEscape(a));
                            return a;
                        };
                        goog.string.specialEscapeChars_ = {
                            "\0": "\\0",
                            "\b": "\\b",
                            "\f": "\\f",
                            "\n": "\\n",
                            "\r": "\\r",
                            "	": "\\t",
                            "\v": "\\x0B",
                            '"': '\\"',
                            "\\": "\\\\",
                            "<": "\\u003C"
                        };
                        goog.string.jsEscapeCache_ = {
                            "'": "\\'"
                        };
                        goog.string.quote = function(a) {
                            a = String(a);
                            for(var b = [
                                '"'
                            ], c = 0; c < a.length; c++){
                                var d = a.charAt(c), e = d.charCodeAt(0);
                                b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
                            }
                            b.push('"');
                            return b.join("");
                        };
                        goog.string.escapeString = function(a) {
                            for(var b = [], c = 0; c < a.length; c++)b[c] = goog.string.escapeChar(a.charAt(c));
                            return b.join("");
                        };
                        goog.string.escapeChar = function(a) {
                            if (a in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[a];
                            if (a in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[a] = goog.string.specialEscapeChars_[a];
                            var b = a.charCodeAt(0);
                            if (31 < b && 127 > b) var c = a;
                            else {
                                if (256 > b) {
                                    if (c = "\\x", 16 > b || 256 < b) c += "0";
                                } else c = "\\u", 4096 > b && (c += "0");
                                c += b.toString(16).toUpperCase();
                            }
                            return goog.string.jsEscapeCache_[a] = c;
                        };
                        goog.string.contains = goog.string.internal.contains;
                        goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains;
                        goog.string.countOf = function(a, b) {
                            return a && b ? a.split(b).length - 1 : 0;
                        };
                        goog.string.removeAt = function(a, b, c) {
                            var d = a;
                            0 <= b && b < a.length && 0 < c && (d = a.substr(0, b) + a.substr(b + c, a.length - b - c));
                            return d;
                        };
                        goog.string.remove = function(a, b) {
                            return a.replace(b, "");
                        };
                        goog.string.removeAll = function(a, b) {
                            b = new RegExp(goog.string.regExpEscape(b), "g");
                            return a.replace(b, "");
                        };
                        goog.string.replaceAll = function(a, b, c) {
                            b = new RegExp(goog.string.regExpEscape(b), "g");
                            return a.replace(b, c.replace(/\$/g, "$$$$"));
                        };
                        goog.string.regExpEscape = function(a) {
                            return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
                        };
                        goog.string.repeat = String.prototype.repeat ? function(a, b) {
                            return a.repeat(b);
                        } : function(a, b) {
                            return Array(b + 1).join(a);
                        };
                        goog.string.padNumber = function(a, b, c) {
                            a = void 0 !== c ? a.toFixed(c) : String(a);
                            c = a.indexOf(".");
                            -1 == c && (c = a.length);
                            return goog.string.repeat("0", Math.max(0, b - c)) + a;
                        };
                        goog.string.makeSafe = function(a) {
                            return null == a ? "" : String(a);
                        };
                        goog.string.buildString = function(a) {
                            return Array.prototype.join.call(arguments, "");
                        };
                        goog.string.getRandomString = function() {
                            return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
                        };
                        goog.string.compareVersions = goog.string.internal.compareVersions;
                        goog.string.hashCode = function(a) {
                            for(var b = 0, c = 0; c < a.length; ++c)b = 31 * b + a.charCodeAt(c) >>> 0;
                            return b;
                        };
                        goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
                        goog.string.createUniqueString = function() {
                            return "goog_" + goog.string.uniqueStringCounter_++;
                        };
                        goog.string.toNumber = function(a) {
                            var b = Number(a);
                            return 0 == b && goog.string.isEmptyOrWhitespace(a) ? NaN : b;
                        };
                        goog.string.isLowerCamelCase = function(a) {
                            return /^[a-z]+([A-Z][a-z]*)*$/.test(a);
                        };
                        goog.string.isUpperCamelCase = function(a) {
                            return /^([A-Z][a-z]*)+$/.test(a);
                        };
                        goog.string.toCamelCase = function(a) {
                            return String(a).replace(/\-([a-z])/g, function(b, c) {
                                return c.toUpperCase();
                            });
                        };
                        goog.string.toSelectorCase = function(a) {
                            return String(a).replace(/([A-Z])/g, "-$1").toLowerCase();
                        };
                        goog.string.toTitleCase = function(a, b) {
                            b = "string" === typeof b ? goog.string.regExpEscape(b) : "\\s";
                            return a.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])", "g"), function(c, d, e) {
                                return d + e.toUpperCase();
                            });
                        };
                        goog.string.capitalize = function(a) {
                            return String(a.charAt(0)).toUpperCase() + String(a.substr(1)).toLowerCase();
                        };
                        goog.string.parseInt = function(a) {
                            isFinite(a) && (a = String(a));
                            return "string" === typeof a ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;
                        };
                        goog.string.splitLimit = function(a, b, c) {
                            a = a.split(b);
                            for(var d = []; 0 < c && a.length;)d.push(a.shift()), c--;
                            a.length && d.push(a.join(b));
                            return d;
                        };
                        goog.string.lastComponent = function(a, b) {
                            if (b) "string" == typeof b && (b = [
                                b
                            ]);
                            else return a;
                            for(var c = -1, d = 0; d < b.length; d++)if ("" != b[d]) {
                                var e = a.lastIndexOf(b[d]);
                                e > c && (c = e);
                            }
                            return -1 == c ? a : a.slice(c + 1);
                        };
                        goog.string.editDistance = function(a, b) {
                            var c = [], d = [];
                            if (a == b) return 0;
                            if (!a.length || !b.length) return Math.max(a.length, b.length);
                            for(var e = 0; e < b.length + 1; e++)c[e] = e;
                            for(e = 0; e < a.length; e++){
                                d[0] = e + 1;
                                for(var f = 0; f < b.length; f++)d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a[e] != b[f]));
                                for(f = 0; f < c.length; f++)c[f] = d[f];
                            }
                            return d[b.length];
                        };
                        goog.proto2 = {};
                        goog.proto2.Descriptor = function(a, b, c) {
                            this.messageType_ = a;
                            this.name_ = b.name || null;
                            this.fullName_ = b.fullName || null;
                            this.containingType_ = b.containingType;
                            this.fields_ = {};
                            for(a = 0; a < c.length; a++)b = c[a], this.fields_[b.getTag()] = b;
                        };
                        goog.proto2.Descriptor.prototype.getName = function() {
                            return this.name_;
                        };
                        goog.proto2.Descriptor.prototype.getFullName = function() {
                            return this.fullName_;
                        };
                        goog.proto2.Descriptor.prototype.getContainingType = function() {
                            return this.containingType_ ? this.containingType_.getDescriptor() : null;
                        };
                        goog.proto2.Descriptor.prototype.getFields = function() {
                            var a = goog.object.getValues(this.fields_);
                            module$contents$goog$array_sort(a, function(b, c) {
                                return b.getTag() - c.getTag();
                            });
                            return a;
                        };
                        goog.proto2.Descriptor.prototype.getFieldsMap = function() {
                            return this.fields_;
                        };
                        goog.proto2.Descriptor.prototype.findFieldByName = function(a) {
                            return goog.object.findValue(this.fields_, function(b, c, d) {
                                return b.getName() == a;
                            }) || null;
                        };
                        goog.proto2.Descriptor.prototype.findFieldByTag = function(a) {
                            goog.asserts.assert(goog.string.isNumeric(a));
                            return this.fields_[parseInt(a, 10)] || null;
                        };
                        goog.proto2.Descriptor.prototype.createMessageInstance = function() {
                            return new this.messageType_;
                        };
                        goog.proto2.FieldDescriptor = function(a, b, c) {
                            this.parent_ = a;
                            goog.asserts.assert(goog.string.isNumeric(b));
                            this.tag_ = b;
                            this.name_ = c.name;
                            this.isPacked_ = !!c.packed;
                            this.isRepeated_ = !!c.repeated;
                            this.isRequired_ = !!c.required;
                            this.fieldType_ = c.fieldType;
                            this.nativeType_ = c.type;
                            this.deserializationConversionPermitted_ = !1;
                            switch(this.fieldType_){
                                case goog.proto2.FieldDescriptor.FieldType.INT64:
                                case goog.proto2.FieldDescriptor.FieldType.UINT64:
                                case goog.proto2.FieldDescriptor.FieldType.FIXED64:
                                case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
                                case goog.proto2.FieldDescriptor.FieldType.SINT64:
                                case goog.proto2.FieldDescriptor.FieldType.FLOAT:
                                case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
                                    this.deserializationConversionPermitted_ = !0;
                            }
                            this.defaultValue_ = c.defaultValue;
                        };
                        goog.proto2.FieldDescriptor.FieldType = {
                            DOUBLE: 1,
                            FLOAT: 2,
                            INT64: 3,
                            UINT64: 4,
                            INT32: 5,
                            FIXED64: 6,
                            FIXED32: 7,
                            BOOL: 8,
                            STRING: 9,
                            GROUP: 10,
                            MESSAGE: 11,
                            BYTES: 12,
                            UINT32: 13,
                            ENUM: 14,
                            SFIXED32: 15,
                            SFIXED64: 16,
                            SINT32: 17,
                            SINT64: 18
                        };
                        goog.proto2.FieldDescriptor.prototype.getTag = function() {
                            return this.tag_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
                            return this.parent_.prototype.getDescriptor();
                        };
                        goog.proto2.FieldDescriptor.prototype.getName = function() {
                            return this.name_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
                            if (void 0 === this.defaultValue_) {
                                var a = this.nativeType_;
                                if (a === Boolean) this.defaultValue_ = !1;
                                else if (a === Number) this.defaultValue_ = 0;
                                else if (a === String) this.defaultValue_ = this.deserializationConversionPermitted_ ? "0" : "";
                                else return new a;
                            }
                            return this.defaultValue_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
                            return this.fieldType_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
                            return this.nativeType_;
                        };
                        goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
                            return this.deserializationConversionPermitted_;
                        };
                        goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
                            return this.nativeType_.prototype.getDescriptor();
                        };
                        goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
                            return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
                        };
                        goog.proto2.FieldDescriptor.prototype.isPacked = function() {
                            return this.isPacked_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
                            return this.isRepeated_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isRequired = function() {
                            return this.isRequired_;
                        };
                        goog.proto2.FieldDescriptor.prototype.isOptional = function() {
                            return !this.isRepeated_ && !this.isRequired_;
                        };
                        goog.proto2.Message = function() {
                            this.values_ = {};
                            this.fields_ = this.getDescriptor().getFieldsMap();
                            this.deserializedFields_ = this.lazyDeserializer_ = null;
                        };
                        goog.proto2.Message.FieldType = {
                            DOUBLE: 1,
                            FLOAT: 2,
                            INT64: 3,
                            UINT64: 4,
                            INT32: 5,
                            FIXED64: 6,
                            FIXED32: 7,
                            BOOL: 8,
                            STRING: 9,
                            GROUP: 10,
                            MESSAGE: 11,
                            BYTES: 12,
                            UINT32: 13,
                            ENUM: 14,
                            SFIXED32: 15,
                            SFIXED64: 16,
                            SINT32: 17,
                            SINT64: 18
                        };
                        goog.proto2.Message.prototype.initializeForLazyDeserializer = function(a, b) {
                            this.lazyDeserializer_ = a;
                            this.values_ = b;
                            this.deserializedFields_ = {};
                        };
                        goog.proto2.Message.prototype.setUnknown = function(a, b) {
                            goog.asserts.assert(!this.fields_[a], "Field is not unknown in this message");
                            goog.asserts.assert(1 <= a, "Tag " + a + ' has value "' + b + '" in descriptor ' + this.getDescriptor().getName());
                            goog.asserts.assert(null !== b, "Value cannot be null");
                            this.values_[a] = b;
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.prototype.forEachUnknown = function(a, b) {
                            b = b || this;
                            for(var c in this.values_){
                                var d = Number(c);
                                this.fields_[d] || a.call(b, d, this.values_[c]);
                            }
                        };
                        goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod;
                        goog.proto2.Message.prototype.has = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.has$Value(a.getTag());
                        };
                        goog.proto2.Message.prototype.arrayOf = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.array$Values(a.getTag());
                        };
                        goog.proto2.Message.prototype.countOf = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.count$Values(a.getTag());
                        };
                        goog.proto2.Message.prototype.get = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.get$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.getOrDefault = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            return this.get$ValueOrDefault(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.set = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            this.set$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.add = function(a, b) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            this.add$Value(a.getTag(), b);
                        };
                        goog.proto2.Message.prototype.clear = function(a) {
                            goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
                            this.clear$Field(a.getTag());
                        };
                        goog.proto2.Message.prototype.equals = function(a) {
                            if (!a || this.constructor != a.constructor) return !1;
                            for(var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++){
                                var d = b[c], e = d.getTag();
                                if (this.has$Value(e) != a.has$Value(e)) return !1;
                                if (this.has$Value(e)) {
                                    var f = d.isCompositeType(), g = this.getValueForTag_(e);
                                    e = a.getValueForTag_(e);
                                    if (d.isRepeated()) {
                                        if (g.length != e.length) return !1;
                                        for(d = 0; d < g.length; d++){
                                            var h = g[d], k = e[d];
                                            if (f ? !h.equals(k) : h != k) return !1;
                                        }
                                    } else if (f ? !g.equals(e) : g != e) return !1;
                                }
                            }
                            return !0;
                        };
                        goog.proto2.Message.prototype.copyFrom = function(a) {
                            goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
                            this != a && (this.values_ = {}, this.deserializedFields_ && (this.deserializedFields_ = {}), this.mergeFrom(a));
                        };
                        goog.proto2.Message.prototype.mergeFrom = function(a) {
                            goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
                            for(var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++){
                                var d = b[c], e = d.getTag();
                                if (a.has$Value(e)) {
                                    this.deserializedFields_ && delete this.deserializedFields_[d.getTag()];
                                    var f = d.isCompositeType();
                                    if (d.isRepeated()) {
                                        d = a.array$Values(e);
                                        for(var g = 0; g < d.length; g++)this.add$Value(e, f ? d[g].clone() : d[g]);
                                    } else d = a.getValueForTag_(e), f ? (f = this.getValueForTag_(e)) ? f.mergeFrom(d) : this.set$Value(e, d.clone()) : this.set$Value(e, d);
                                }
                            }
                        };
                        goog.proto2.Message.prototype.clone = function() {
                            var a = new this.constructor;
                            a.copyFrom(this);
                            return a;
                        };
                        goog.proto2.Message.prototype.initDefaults = function(a) {
                            for(var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++){
                                var d = b[c], e = d.getTag(), f = d.isCompositeType();
                                this.has$Value(e) || d.isRepeated() || (f ? this.values_[e] = new (d.getNativeType()) : a && (this.values_[e] = d.getDefaultValue()));
                                if (f) {
                                    if (d.isRepeated()) for(d = this.array$Values(e), e = 0; e < d.length; e++)d[e].initDefaults(a);
                                    else this.get$Value(e).initDefaults(a);
                                }
                            }
                        };
                        goog.proto2.Message.prototype.has$Value = function(a) {
                            return null != this.values_[a];
                        };
                        goog.proto2.Message.prototype.getValueForTag_ = function(a) {
                            var b = this.values_[a];
                            return null == b ? null : this.lazyDeserializer_ ? a in this.deserializedFields_ ? this.deserializedFields_[a] : (b = this.lazyDeserializer_.deserializeField(this, this.fields_[a], b), this.deserializedFields_[a] = b) : b;
                        };
                        goog.proto2.Message.prototype.get$Value = function(a, b) {
                            var c = this.getValueForTag_(a);
                            return this.fields_[a].isRepeated() ? (a = b || 0, goog.asserts.assert(0 <= a && a < c.length, "Given index %s is out of bounds.  Repeated field length: %s", a, c.length), c[a]) : c;
                        };
                        goog.proto2.Message.prototype.get$ValueOrDefault = function(a, b) {
                            return this.has$Value(a) ? this.get$Value(a, b) : this.fields_[a].getDefaultValue();
                        };
                        goog.proto2.Message.prototype.array$Values = function(a) {
                            return this.getValueForTag_(a) || [];
                        };
                        goog.proto2.Message.prototype.count$Values = function(a) {
                            return this.fields_[a].isRepeated() ? this.has$Value(a) ? this.values_[a].length : 0 : this.has$Value(a) ? 1 : 0;
                        };
                        goog.proto2.Message.prototype.set$Value = function(a, b) {
                            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
                            this.values_[a] = b;
                            this.deserializedFields_ && (this.deserializedFields_[a] = b);
                        };
                        goog.proto2.Message.prototype.add$Value = function(a, b) {
                            goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
                            this.values_[a] || (this.values_[a] = []);
                            this.values_[a].push(b);
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.prototype.checkFieldType_ = function(a, b) {
                            a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(b) : goog.asserts.assert(Object(b).constructor == a.getNativeType());
                        };
                        goog.proto2.Message.prototype.clear$Field = function(a) {
                            delete this.values_[a];
                            this.deserializedFields_ && delete this.deserializedFields_[a];
                        };
                        goog.proto2.Message.createDescriptor = function(a, b) {
                            var c = [], d = b[0], e;
                            for(e in b)0 != e && c.push(new goog.proto2.FieldDescriptor(a, e, b[e]));
                            return new goog.proto2.Descriptor(a, d, c);
                        };
                        goog.proto2.Serializer = function() {};
                        goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = !1;
                        goog.proto2.Serializer.prototype.serialize = goog.abstractMethod;
                        goog.proto2.Serializer.prototype.getSerializedValue = function(a, b) {
                            return a.isCompositeType() ? this.serialize(b) : "number" !== typeof b || isFinite(b) ? b : b.toString();
                        };
                        goog.proto2.Serializer.prototype.deserialize = function(a, b) {
                            a = a.createMessageInstance();
                            this.deserializeTo(a, b);
                            goog.asserts.assert(a instanceof goog.proto2.Message);
                            return a;
                        };
                        goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod;
                        goog.proto2.Serializer.prototype.getDeserializedValue = function(a, b) {
                            if (a.isCompositeType()) return b instanceof goog.proto2.Message ? b : this.deserialize(a.getFieldMessageType(), b);
                            if (a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && "string" === typeof b && (a = a.getNativeType(), a.hasOwnProperty(b)) ? a[b] : "string" === typeof b && goog.proto2.Serializer.INTEGER_REGEX.test(b) && (a = Number(b), 0 < a) ? a : b;
                            if (!a.deserializationConversionPermitted()) return b;
                            a = a.getNativeType();
                            if (a === String) {
                                if ("number" === typeof b) return String(b);
                            } else if (a === Number && "string" === typeof b && ("Infinity" === b || "-Infinity" === b || "NaN" === b || goog.proto2.Serializer.INTEGER_REGEX.test(b))) return Number(b);
                            return b;
                        };
                        goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/;
                        goog.proto2.LazyDeserializer = function() {};
                        goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer);
                        goog.proto2.LazyDeserializer.prototype.deserialize = function(a, b) {
                            a = a.createMessageInstance();
                            a.initializeForLazyDeserializer(this, b);
                            goog.asserts.assert(a instanceof goog.proto2.Message);
                            return a;
                        };
                        goog.proto2.LazyDeserializer.prototype.deserializeTo = function(a, b) {
                            throw Error("Unimplemented");
                        };
                        goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod;
                        goog.proto2.PbLiteSerializer = function() {};
                        goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer);
                        goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = !1;
                        goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(a) {
                            this.zeroIndexing_ = a;
                        };
                        goog.proto2.PbLiteSerializer.prototype.serialize = function(a) {
                            for(var b = a.getDescriptor().getFields(), c = [], d = this.zeroIndexing_, e = 0; e < b.length; e++){
                                var f = b[e];
                                if (a.has(f)) {
                                    var g = f.getTag();
                                    g = d ? g - 1 : g;
                                    if (f.isRepeated()) {
                                        c[g] = [];
                                        for(var h = 0; h < a.countOf(f); h++)c[g][h] = this.getSerializedValue(f, a.get(f, h));
                                    } else c[g] = this.getSerializedValue(f, a.get(f));
                                }
                            }
                            a.forEachUnknown(function(k, l) {
                                c[d ? k - 1 : k] = l;
                            });
                            return c;
                        };
                        goog.proto2.PbLiteSerializer.prototype.deserializeField = function(a, b, c) {
                            if (null == c) return c;
                            if (b.isRepeated()) {
                                a = [];
                                goog.asserts.assert(Array.isArray(c), "Value must be array: %s", c);
                                for(var d = 0; d < c.length; d++)a[d] = this.getDeserializedValue(b, c[d]);
                                return a;
                            }
                            return this.getDeserializedValue(b, c);
                        };
                        goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(a, b) {
                            return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? b ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
                        };
                        goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(a, b) {
                            return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert("number" === typeof b || "boolean" === typeof b, "Value is expected to be a number or boolean"), !!b) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
                        };
                        goog.proto2.PbLiteSerializer.prototype.deserialize = function(a, b) {
                            var c = b;
                            if (this.zeroIndexing_) {
                                c = [];
                                for(var d in b)c[parseInt(d, 10) + 1] = b[d];
                            }
                            return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, a, c);
                        };
                        goog.string.StringBuffer = function(a, b) {
                            null != a && this.append.apply(this, arguments);
                        };
                        goog.string.StringBuffer.prototype.buffer_ = "";
                        goog.string.StringBuffer.prototype.set = function(a) {
                            this.buffer_ = "" + a;
                        };
                        goog.string.StringBuffer.prototype.append = function(a, b, c) {
                            this.buffer_ += String(a);
                            if (null != b) for(var d = 1; d < arguments.length; d++)this.buffer_ += arguments[d];
                            return this;
                        };
                        goog.string.StringBuffer.prototype.clear = function() {
                            this.buffer_ = "";
                        };
                        goog.string.StringBuffer.prototype.getLength = function() {
                            return this.buffer_.length;
                        };
                        goog.string.StringBuffer.prototype.toString = function() {
                            return this.buffer_;
                        }; /*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        var i18n = {
                            phonenumbers: {}
                        };
                        i18n.phonenumbers.NumberFormat = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message);
                        i18n.phonenumbers.NumberFormat.descriptor_ = null;
                        i18n.phonenumbers.NumberFormat.prototype.getPattern = function() {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setPattern = function(a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasPattern = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.patternCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearPattern = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getFormat = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setFormat = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasFormat = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.formatCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearFormat = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(a) {
                            return this.get$Value(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(a) {
                            return this.get$ValueOrDefault(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(a) {
                            this.add$Value(3, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
                            return this.array$Values(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneNumberDesc = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message);
                        i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null;
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(a) {
                            return this.get$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(a) {
                            return this.get$ValueOrDefault(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(a) {
                            this.add$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
                            return this.array$Values(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
                            return this.has$Value(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
                            return this.count$Values(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
                            this.clear$Field(9);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(a) {
                            return this.get$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(a) {
                            return this.get$ValueOrDefault(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(a) {
                            this.add$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
                            return this.array$Values(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
                            return this.has$Value(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
                            return this.count$Values(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
                            this.clear$Field(10);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneMetadata = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message);
                        i18n.phonenumbers.PhoneMetadata.descriptor_ = null;
                        i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
                            return this.get$Value(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
                            return this.get$ValueOrDefault(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function(a) {
                            this.set$Value(3, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function(a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
                            return this.get$Value(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
                            return this.get$ValueOrDefault(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(a) {
                            this.set$Value(7, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
                            return this.has$Value(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
                            return this.count$Values(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
                            this.clear$Field(7);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
                            return this.get$Value(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
                            return this.get$ValueOrDefault(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function(a) {
                            this.set$Value(8, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
                            return this.has$Value(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
                            return this.count$Values(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
                            this.clear$Field(8);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPager = function() {
                            return this.get$Value(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
                            return this.get$ValueOrDefault(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPager = function(a) {
                            this.set$Value(21, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
                            return this.has$Value(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
                            return this.count$Values(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
                            this.clear$Field(21);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getUan = function() {
                            return this.get$Value(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
                            return this.get$ValueOrDefault(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setUan = function(a) {
                            this.set$Value(25, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
                            return this.has$Value(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
                            return this.count$Values(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
                            this.clear$Field(25);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
                            return this.get$Value(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
                            return this.get$ValueOrDefault(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function(a) {
                            this.set$Value(27, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
                            return this.has$Value(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
                            return this.count$Values(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
                            this.clear$Field(27);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
                            return this.get$Value(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
                            return this.get$ValueOrDefault(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(a) {
                            this.set$Value(28, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
                            return this.has$Value(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
                            return this.count$Values(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
                            this.clear$Field(28);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getShortCode = function() {
                            return this.get$Value(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault = function() {
                            return this.get$ValueOrDefault(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setShortCode = function(a) {
                            this.set$Value(29, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode = function() {
                            return this.has$Value(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount = function() {
                            return this.count$Values(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode = function() {
                            this.clear$Field(29);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate = function() {
                            return this.get$Value(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault = function() {
                            return this.get$ValueOrDefault(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate = function(a) {
                            this.set$Value(30, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate = function() {
                            return this.has$Value(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount = function() {
                            return this.count$Values(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate = function() {
                            this.clear$Field(30);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific = function() {
                            return this.get$Value(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault = function() {
                            return this.get$ValueOrDefault(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific = function(a) {
                            this.set$Value(31, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific = function() {
                            return this.has$Value(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount = function() {
                            return this.count$Values(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific = function() {
                            this.clear$Field(31);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices = function() {
                            return this.get$Value(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault = function() {
                            return this.get$ValueOrDefault(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices = function(a) {
                            this.set$Value(33, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices = function() {
                            return this.has$Value(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount = function() {
                            return this.count$Values(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices = function() {
                            this.clear$Field(33);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
                            return this.get$Value(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
                            return this.get$ValueOrDefault(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(a) {
                            this.set$Value(24, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
                            return this.has$Value(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
                            return this.count$Values(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
                            this.clear$Field(24);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getId = function() {
                            return this.get$Value(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
                            return this.get$ValueOrDefault(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setId = function(a) {
                            this.set$Value(9, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasId = function() {
                            return this.has$Value(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.idCount = function() {
                            return this.count$Values(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearId = function() {
                            this.clear$Field(9);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
                            return this.get$Value(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
                            return this.get$ValueOrDefault(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(a) {
                            this.set$Value(10, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
                            return this.has$Value(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
                            return this.count$Values(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
                            this.clear$Field(10);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
                            return this.get$Value(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(a) {
                            this.set$Value(11, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
                            return this.has$Value(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
                            return this.count$Values(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
                            this.clear$Field(11);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
                            return this.get$Value(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(a) {
                            this.set$Value(17, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
                            return this.has$Value(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
                            return this.count$Values(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
                            this.clear$Field(17);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
                            return this.get$Value(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(a) {
                            this.set$Value(12, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
                            return this.has$Value(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
                            return this.count$Values(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
                            this.clear$Field(12);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
                            return this.get$Value(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
                            return this.get$ValueOrDefault(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(a) {
                            this.set$Value(13, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
                            return this.has$Value(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
                            return this.count$Values(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
                            this.clear$Field(13);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
                            return this.get$Value(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
                            return this.get$ValueOrDefault(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(a) {
                            this.set$Value(15, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
                            return this.has$Value(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
                            return this.count$Values(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
                            this.clear$Field(15);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
                            return this.get$Value(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
                            return this.get$ValueOrDefault(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(a) {
                            this.set$Value(16, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
                            return this.has$Value(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
                            return this.count$Values(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
                            this.clear$Field(16);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
                            return this.get$Value(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
                            return this.get$ValueOrDefault(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(a) {
                            this.set$Value(18, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
                            return this.has$Value(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
                            return this.count$Values(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
                            this.clear$Field(18);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(a) {
                            return this.get$Value(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(a) {
                            return this.get$ValueOrDefault(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(a) {
                            this.add$Value(19, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
                            return this.array$Values(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
                            return this.has$Value(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
                            return this.count$Values(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
                            this.clear$Field(19);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(a) {
                            return this.get$Value(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(a) {
                            return this.get$ValueOrDefault(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(a) {
                            this.add$Value(20, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
                            return this.array$Values(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
                            return this.has$Value(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
                            return this.count$Values(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
                            this.clear$Field(20);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
                            return this.get$Value(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
                            return this.get$ValueOrDefault(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(a) {
                            this.set$Value(22, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
                            return this.has$Value(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
                            return this.count$Values(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
                            this.clear$Field(22);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
                            return this.get$Value(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
                            return this.get$ValueOrDefault(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(a) {
                            this.set$Value(23, a);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
                            return this.has$Value(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
                            return this.count$Values(23);
                        };
                        i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
                            this.clear$Field(23);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message);
                        i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null;
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(a) {
                            return this.get$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(a) {
                            return this.get$ValueOrDefault(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(a) {
                            this.add$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
                            return this.array$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.NumberFormat.descriptor_;
                            a || (i18n.phonenumbers.NumberFormat.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, {
                                0: {
                                    name: "NumberFormat",
                                    fullName: "i18n.phonenumbers.NumberFormat"
                                },
                                1: {
                                    name: "pattern",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                2: {
                                    name: "format",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                3: {
                                    name: "leading_digits_pattern",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                4: {
                                    name: "national_prefix_formatting_rule",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                6: {
                                    name: "national_prefix_optional_when_formatting",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                5: {
                                    name: "domestic_carrier_code_formatting_rule",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
                            a || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {
                                0: {
                                    name: "PhoneNumberDesc",
                                    fullName: "i18n.phonenumbers.PhoneNumberDesc"
                                },
                                2: {
                                    name: "national_number_pattern",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                9: {
                                    name: "possible_length",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                10: {
                                    name: "possible_length_local_only",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                6: {
                                    name: "example_number",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneMetadata.descriptor_;
                            a || (i18n.phonenumbers.PhoneMetadata.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {
                                0: {
                                    name: "PhoneMetadata",
                                    fullName: "i18n.phonenumbers.PhoneMetadata"
                                },
                                1: {
                                    name: "general_desc",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                2: {
                                    name: "fixed_line",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                3: {
                                    name: "mobile",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                4: {
                                    name: "toll_free",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                5: {
                                    name: "premium_rate",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                6: {
                                    name: "shared_cost",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                7: {
                                    name: "personal_number",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                8: {
                                    name: "voip",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                21: {
                                    name: "pager",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                25: {
                                    name: "uan",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                27: {
                                    name: "emergency",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                28: {
                                    name: "voicemail",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                29: {
                                    name: "short_code",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                30: {
                                    name: "standard_rate",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                31: {
                                    name: "carrier_specific",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                33: {
                                    name: "sms_services",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                24: {
                                    name: "no_international_dialling",
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneNumberDesc
                                },
                                9: {
                                    name: "id",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                10: {
                                    name: "country_code",
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                11: {
                                    name: "international_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                17: {
                                    name: "preferred_international_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                12: {
                                    name: "national_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                13: {
                                    name: "preferred_extn_prefix",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                15: {
                                    name: "national_prefix_for_parsing",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                16: {
                                    name: "national_prefix_transform_rule",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                18: {
                                    name: "same_mobile_and_fixed_line_pattern",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                19: {
                                    name: "number_format",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.NumberFormat
                                },
                                20: {
                                    name: "intl_number_format",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.NumberFormat
                                },
                                22: {
                                    name: "main_country_for_code",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    defaultValue: !1,
                                    type: Boolean
                                },
                                23: {
                                    name: "leading_digits",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
                            a || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, {
                                0: {
                                    name: "PhoneMetadataCollection",
                                    fullName: "i18n.phonenumbers.PhoneMetadataCollection"
                                },
                                1: {
                                    name: "metadata",
                                    repeated: !0,
                                    fieldType: goog.proto2.Message.FieldType.MESSAGE,
                                    type: i18n.phonenumbers.PhoneMetadata
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;
                        i18n.phonenumbers.PhoneNumber = function() {
                            goog.proto2.Message.call(this);
                        };
                        goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message);
                        i18n.phonenumbers.PhoneNumber.descriptor_ = null;
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
                            return this.get$Value(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
                            return this.get$ValueOrDefault(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function(a) {
                            this.set$Value(1, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
                            return this.has$Value(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
                            return this.count$Values(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
                            this.clear$Field(1);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
                            return this.get$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
                            return this.get$ValueOrDefault(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(a) {
                            this.set$Value(2, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
                            return this.has$Value(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
                            return this.count$Values(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
                            this.clear$Field(2);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getExtension = function() {
                            return this.get$Value(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
                            return this.get$ValueOrDefault(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setExtension = function(a) {
                            this.set$Value(3, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
                            return this.has$Value(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
                            return this.count$Values(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
                            this.clear$Field(3);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
                            return this.get$Value(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
                            return this.get$ValueOrDefault(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(a) {
                            this.set$Value(4, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
                            return this.has$Value(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
                            return this.count$Values(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
                            this.clear$Field(4);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
                            return this.get$Value(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
                            return this.get$ValueOrDefault(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(a) {
                            this.set$Value(8, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
                            return this.has$Value(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
                            return this.count$Values(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
                            this.clear$Field(8);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
                            return this.get$Value(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
                            return this.get$ValueOrDefault(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function(a) {
                            this.set$Value(5, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
                            return this.has$Value(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
                            return this.count$Values(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
                            this.clear$Field(5);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
                            return this.get$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
                            return this.get$ValueOrDefault(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(a) {
                            this.set$Value(6, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
                            return this.has$Value(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
                            return this.count$Values(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
                            this.clear$Field(6);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
                            return this.get$Value(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
                            return this.get$ValueOrDefault(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(a) {
                            this.set$Value(7, a);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
                            return this.has$Value(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
                            return this.count$Values(7);
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
                            this.clear$Field(7);
                        };
                        i18n.phonenumbers.PhoneNumber.CountryCodeSource = {
                            UNSPECIFIED: 0,
                            FROM_NUMBER_WITH_PLUS_SIGN: 1,
                            FROM_NUMBER_WITH_IDD: 5,
                            FROM_NUMBER_WITHOUT_PLUS_SIGN: 10,
                            FROM_DEFAULT_COUNTRY: 20
                        };
                        i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
                            var a = i18n.phonenumbers.PhoneNumber.descriptor_;
                            a || (i18n.phonenumbers.PhoneNumber.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {
                                0: {
                                    name: "PhoneNumber",
                                    fullName: "i18n.phonenumbers.PhoneNumber"
                                },
                                1: {
                                    name: "country_code",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    type: Number
                                },
                                2: {
                                    name: "national_number",
                                    required: !0,
                                    fieldType: goog.proto2.Message.FieldType.UINT64,
                                    type: Number
                                },
                                3: {
                                    name: "extension",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                4: {
                                    name: "italian_leading_zero",
                                    fieldType: goog.proto2.Message.FieldType.BOOL,
                                    type: Boolean
                                },
                                8: {
                                    name: "number_of_leading_zeros",
                                    fieldType: goog.proto2.Message.FieldType.INT32,
                                    defaultValue: 1,
                                    type: Number
                                },
                                5: {
                                    name: "raw_input",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                },
                                6: {
                                    name: "country_code_source",
                                    fieldType: goog.proto2.Message.FieldType.ENUM,
                                    defaultValue: i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED,
                                    type: i18n.phonenumbers.PhoneNumber.CountryCodeSource
                                },
                                7: {
                                    name: "preferred_domestic_carrier_code",
                                    fieldType: goog.proto2.Message.FieldType.STRING,
                                    type: String
                                }
                            }));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber;
                        i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor; /*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        i18n.phonenumbers.metadata = {};
                        i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {
                            1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
                            7: [
                                "RU",
                                "KZ"
                            ],
                            20: [
                                "EG"
                            ],
                            27: [
                                "ZA"
                            ],
                            30: [
                                "GR"
                            ],
                            31: [
                                "NL"
                            ],
                            32: [
                                "BE"
                            ],
                            33: [
                                "FR"
                            ],
                            34: [
                                "ES"
                            ],
                            36: [
                                "HU"
                            ],
                            39: [
                                "IT",
                                "VA"
                            ],
                            40: [
                                "RO"
                            ],
                            41: [
                                "CH"
                            ],
                            43: [
                                "AT"
                            ],
                            44: [
                                "GB",
                                "GG",
                                "IM",
                                "JE"
                            ],
                            45: [
                                "DK"
                            ],
                            46: [
                                "SE"
                            ],
                            47: [
                                "NO",
                                "SJ"
                            ],
                            48: [
                                "PL"
                            ],
                            49: [
                                "DE"
                            ],
                            51: [
                                "PE"
                            ],
                            52: [
                                "MX"
                            ],
                            53: [
                                "CU"
                            ],
                            54: [
                                "AR"
                            ],
                            55: [
                                "BR"
                            ],
                            56: [
                                "CL"
                            ],
                            57: [
                                "CO"
                            ],
                            58: [
                                "VE"
                            ],
                            60: [
                                "MY"
                            ],
                            61: [
                                "AU",
                                "CC",
                                "CX"
                            ],
                            62: [
                                "ID"
                            ],
                            63: [
                                "PH"
                            ],
                            64: [
                                "NZ"
                            ],
                            65: [
                                "SG"
                            ],
                            66: [
                                "TH"
                            ],
                            81: [
                                "JP"
                            ],
                            82: [
                                "KR"
                            ],
                            84: [
                                "VN"
                            ],
                            86: [
                                "CN"
                            ],
                            90: [
                                "TR"
                            ],
                            91: [
                                "IN"
                            ],
                            92: [
                                "PK"
                            ],
                            93: [
                                "AF"
                            ],
                            94: [
                                "LK"
                            ],
                            95: [
                                "MM"
                            ],
                            98: [
                                "IR"
                            ],
                            211: [
                                "SS"
                            ],
                            212: [
                                "MA",
                                "EH"
                            ],
                            213: [
                                "DZ"
                            ],
                            216: [
                                "TN"
                            ],
                            218: [
                                "LY"
                            ],
                            220: [
                                "GM"
                            ],
                            221: [
                                "SN"
                            ],
                            222: [
                                "MR"
                            ],
                            223: [
                                "ML"
                            ],
                            224: [
                                "GN"
                            ],
                            225: [
                                "CI"
                            ],
                            226: [
                                "BF"
                            ],
                            227: [
                                "NE"
                            ],
                            228: [
                                "TG"
                            ],
                            229: [
                                "BJ"
                            ],
                            230: [
                                "MU"
                            ],
                            231: [
                                "LR"
                            ],
                            232: [
                                "SL"
                            ],
                            233: [
                                "GH"
                            ],
                            234: [
                                "NG"
                            ],
                            235: [
                                "TD"
                            ],
                            236: [
                                "CF"
                            ],
                            237: [
                                "CM"
                            ],
                            238: [
                                "CV"
                            ],
                            239: [
                                "ST"
                            ],
                            240: [
                                "GQ"
                            ],
                            241: [
                                "GA"
                            ],
                            242: [
                                "CG"
                            ],
                            243: [
                                "CD"
                            ],
                            244: [
                                "AO"
                            ],
                            245: [
                                "GW"
                            ],
                            246: [
                                "IO"
                            ],
                            247: [
                                "AC"
                            ],
                            248: [
                                "SC"
                            ],
                            249: [
                                "SD"
                            ],
                            250: [
                                "RW"
                            ],
                            251: [
                                "ET"
                            ],
                            252: [
                                "SO"
                            ],
                            253: [
                                "DJ"
                            ],
                            254: [
                                "KE"
                            ],
                            255: [
                                "TZ"
                            ],
                            256: [
                                "UG"
                            ],
                            257: [
                                "BI"
                            ],
                            258: [
                                "MZ"
                            ],
                            260: [
                                "ZM"
                            ],
                            261: [
                                "MG"
                            ],
                            262: [
                                "RE",
                                "YT"
                            ],
                            263: [
                                "ZW"
                            ],
                            264: [
                                "NA"
                            ],
                            265: [
                                "MW"
                            ],
                            266: [
                                "LS"
                            ],
                            267: [
                                "BW"
                            ],
                            268: [
                                "SZ"
                            ],
                            269: [
                                "KM"
                            ],
                            290: [
                                "SH",
                                "TA"
                            ],
                            291: [
                                "ER"
                            ],
                            297: [
                                "AW"
                            ],
                            298: [
                                "FO"
                            ],
                            299: [
                                "GL"
                            ],
                            350: [
                                "GI"
                            ],
                            351: [
                                "PT"
                            ],
                            352: [
                                "LU"
                            ],
                            353: [
                                "IE"
                            ],
                            354: [
                                "IS"
                            ],
                            355: [
                                "AL"
                            ],
                            356: [
                                "MT"
                            ],
                            357: [
                                "CY"
                            ],
                            358: [
                                "FI",
                                "AX"
                            ],
                            359: [
                                "BG"
                            ],
                            370: [
                                "LT"
                            ],
                            371: [
                                "LV"
                            ],
                            372: [
                                "EE"
                            ],
                            373: [
                                "MD"
                            ],
                            374: [
                                "AM"
                            ],
                            375: [
                                "BY"
                            ],
                            376: [
                                "AD"
                            ],
                            377: [
                                "MC"
                            ],
                            378: [
                                "SM"
                            ],
                            380: [
                                "UA"
                            ],
                            381: [
                                "RS"
                            ],
                            382: [
                                "ME"
                            ],
                            383: [
                                "XK"
                            ],
                            385: [
                                "HR"
                            ],
                            386: [
                                "SI"
                            ],
                            387: [
                                "BA"
                            ],
                            389: [
                                "MK"
                            ],
                            420: [
                                "CZ"
                            ],
                            421: [
                                "SK"
                            ],
                            423: [
                                "LI"
                            ],
                            500: [
                                "FK"
                            ],
                            501: [
                                "BZ"
                            ],
                            502: [
                                "GT"
                            ],
                            503: [
                                "SV"
                            ],
                            504: [
                                "HN"
                            ],
                            505: [
                                "NI"
                            ],
                            506: [
                                "CR"
                            ],
                            507: [
                                "PA"
                            ],
                            508: [
                                "PM"
                            ],
                            509: [
                                "HT"
                            ],
                            590: [
                                "GP",
                                "BL",
                                "MF"
                            ],
                            591: [
                                "BO"
                            ],
                            592: [
                                "GY"
                            ],
                            593: [
                                "EC"
                            ],
                            594: [
                                "GF"
                            ],
                            595: [
                                "PY"
                            ],
                            596: [
                                "MQ"
                            ],
                            597: [
                                "SR"
                            ],
                            598: [
                                "UY"
                            ],
                            599: [
                                "CW",
                                "BQ"
                            ],
                            670: [
                                "TL"
                            ],
                            672: [
                                "NF"
                            ],
                            673: [
                                "BN"
                            ],
                            674: [
                                "NR"
                            ],
                            675: [
                                "PG"
                            ],
                            676: [
                                "TO"
                            ],
                            677: [
                                "SB"
                            ],
                            678: [
                                "VU"
                            ],
                            679: [
                                "FJ"
                            ],
                            680: [
                                "PW"
                            ],
                            681: [
                                "WF"
                            ],
                            682: [
                                "CK"
                            ],
                            683: [
                                "NU"
                            ],
                            685: [
                                "WS"
                            ],
                            686: [
                                "KI"
                            ],
                            687: [
                                "NC"
                            ],
                            688: [
                                "TV"
                            ],
                            689: [
                                "PF"
                            ],
                            690: [
                                "TK"
                            ],
                            691: [
                                "FM"
                            ],
                            692: [
                                "MH"
                            ],
                            800: [
                                "001"
                            ],
                            808: [
                                "001"
                            ],
                            850: [
                                "KP"
                            ],
                            852: [
                                "HK"
                            ],
                            853: [
                                "MO"
                            ],
                            855: [
                                "KH"
                            ],
                            856: [
                                "LA"
                            ],
                            870: [
                                "001"
                            ],
                            878: [
                                "001"
                            ],
                            880: [
                                "BD"
                            ],
                            881: [
                                "001"
                            ],
                            882: [
                                "001"
                            ],
                            883: [
                                "001"
                            ],
                            886: [
                                "TW"
                            ],
                            888: [
                                "001"
                            ],
                            960: [
                                "MV"
                            ],
                            961: [
                                "LB"
                            ],
                            962: [
                                "JO"
                            ],
                            963: [
                                "SY"
                            ],
                            964: [
                                "IQ"
                            ],
                            965: [
                                "KW"
                            ],
                            966: [
                                "SA"
                            ],
                            967: [
                                "YE"
                            ],
                            968: [
                                "OM"
                            ],
                            970: [
                                "PS"
                            ],
                            971: [
                                "AE"
                            ],
                            972: [
                                "IL"
                            ],
                            973: [
                                "BH"
                            ],
                            974: [
                                "QA"
                            ],
                            975: [
                                "BT"
                            ],
                            976: [
                                "MN"
                            ],
                            977: [
                                "NP"
                            ],
                            979: [
                                "001"
                            ],
                            992: [
                                "TJ"
                            ],
                            993: [
                                "TM"
                            ],
                            994: [
                                "AZ"
                            ],
                            995: [
                                "GE"
                            ],
                            996: [
                                "KG"
                            ],
                            998: [
                                "UZ"
                            ]
                        };
                        i18n.phonenumbers.metadata.countryToMetadata = {
                            AC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[01589]\\d|[46])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[2-467]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "62889",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "40123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AC",
                                247,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[1-9]|[1589]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "542011",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[78]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "712345",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "690\\d{6}|[356]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "312345",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180[02]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "18001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[19]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "912345",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AD",
                                376,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[135-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-4679][2-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[024-68]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "501234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "400\\d{6}|800\\d{2,9}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[02]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "900234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700[05]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "700012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AE",
                                971,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,9})",
                                        "$1 $2",
                                        [
                                            "60|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[236]|[479][2-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "[479]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "600[25]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "600212345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-7]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "234567890",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AF",
                                93,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:268|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684601234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684641234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "26848[01]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684801234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "AG",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([457]\\d{6})$|1",
                                "268$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "26840[69]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2684061234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                "268",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:264|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "264(?:292|4(?:6[12]|9[78]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2644612345",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2642351234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AI",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2457]\\d{6})$|1",
                                "264$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "264724\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2647241234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                "264",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[78][2-9]|9\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "672123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[1-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "900123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "808[1-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "808123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700[2-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "70021234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AL",
                                355,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "80|9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "4[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2358][2-5]|4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[23578]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-489]\\d|55|60|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "10123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "90[016]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80[1-4]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "60271234"
                                ],
                                "AM",
                                374,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]0"
                                        ],
                                        "0 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2|3[12]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "1|47"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[3-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[29]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "222123456"
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-59]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "923123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AO",
                                244,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[29]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|920)|3(?:4(?:46|8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "91123456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "60[04579]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "6001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AR",
                                54,
                                "00",
                                "0",
                                ,
                                ,
                                "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
                                "9$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})",
                                        "$1",
                                        [
                                            "0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[1-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                                            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "1"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[68]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[23]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                                        "$2 15-$3-$4",
                                        [
                                            "9(?:2[2-469]|3[3-578])",
                                            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                                            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                                        "$2 15-$3-$4",
                                        [
                                            "91"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                                        "$2 15-$3-$4",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                                            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "1"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[68]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[23]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                                        "$1 $2 $3-$4",
                                        [
                                            "9(?:2[2-469]|3[3-578])",
                                            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                                            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                                            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3-$4",
                                        [
                                            "91"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3-$4",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "810\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "810\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8101234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|684|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6846(?:22|33|44|55|77|88|9[19])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6846221234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6847331234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AS",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([267]\\d{6})$|1",
                                "684$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "684",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",
                                    ,
                                    ,
                                    ,
                                    "1234567890",
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",
                                    ,
                                    ,
                                    ,
                                    "664123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:10|2[018])\\d{6,10}|828\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "810123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    "780123456",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                "AT",
                                43,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,12})",
                                        "$1 $2",
                                        [
                                            "1(?:11|[2-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})",
                                        "$1 $2",
                                        [
                                            "517"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "5[079]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[18]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,10})",
                                        "$1 $2",
                                        [
                                            "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,9})",
                                        "$1 $2",
                                        [
                                            "[2-467]|5[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4,7})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3,12})",
                                        "$1 $2",
                                        [
                                            "1(?:11|[2-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})",
                                        "$1 $2",
                                        [
                                            "517"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "5[079]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,10})",
                                        "$1 $2",
                                        [
                                            "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,9})",
                                        "$1 $2",
                                        [
                                            "[2-467]|5[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4,7})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180(?:0\\d{3}|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "190[0-26]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "147101234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "AU",
                                61,
                                "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                                "0",
                                ,
                                ,
                                "(183[12])|0",
                                ,
                                "0011",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "13"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "180",
                                            "1802"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "14|4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2378]"
                                        ],
                                        "(0$1)",
                                        "$CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:30|[89])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "130"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "16"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "14|4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2378]"
                                        ],
                                        "(0$1)",
                                        "$CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:30|[89])"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "163\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    "1631234",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[25-79]\\d\\d|800)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:2\\d|8[1-9])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5212345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5601234"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:28\\d|501)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5011234"
                                ],
                                "AW",
                                297,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[25-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AX: [
                                ,
                                [
                                    ,
                                    ,
                                    "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18[1-8]\\d{3,6}",
                                    ,
                                    ,
                                    ,
                                    "181234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[67]00\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "600123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AX",
                                358,
                                "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "18",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "10112345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "123123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "401234567"
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "881234567"
                                ],
                                [
                                    ,
                                    ,
                                    "900200\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "900200123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "AZ",
                                994,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[28]|2|365|46",
                                            "1[28]|2|365[45]|46",
                                            "1[28]|2|365(?:4|5[02])|46"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[13-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[28]|2|365|46",
                                            "1[28]|2|365[45]|46",
                                            "1[28]|2|365(?:4|5[02])|46"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[13-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BA: [
                                ,
                                [
                                    ,
                                    ,
                                    "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "30212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "61123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8[08]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[0246]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[12]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "82123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BA",
                                387,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[1-3]|[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2-$3",
                                        [
                                            "[3-5]|6[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[1-3]|[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2-$3",
                                        [
                                            "[3-5]|6[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "70341234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BB: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:246|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2464123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "2462501234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:246976|900[2-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9002123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "24631\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2463101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "BB",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "246$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "246",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2464301234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "27111234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1812345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[03]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9604123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "BD",
                                880,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1-$2",
                                        [
                                            "31[5-8]|[459]1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1-$2",
                                        [
                                            "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,6})",
                                        "$1-$2",
                                        [
                                            "[13-9]|22"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7,8})",
                                        "$1-$2",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BE: [
                                ,
                                [
                                    ,
                                    ,
                                    "4\\d{8}|[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4[5-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "470123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800[1-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7879\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "78791234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BE",
                                32,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:80|9)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[239]|4[23]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[15-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "4"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "78102345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[025-7]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "20491234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[1-35-7]|5[0-8]|[67]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BF",
                                226,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[025-7]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BG: [
                                ,
                                [
                                    ,
                                    ,
                                    "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        12
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "2123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "43012345",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:00800\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BG",
                                359,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "43[1-6]|70[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:70|8)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "43[1-7]|7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[48]|9[08]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "43[1-6]|70[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:70|8)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "43[1-7]|7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[48]|9[08]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[136-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "17001234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "36001234"
                                ],
                                [
                                    ,
                                    ,
                                    "8[02369]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:87|9[0-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    "84\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "84123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BH",
                                973,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[13679]|8[02-4679]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[267]\\d|31)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:22|31)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:29|[67][125-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "79561234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BI",
                                257,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2367]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[24-689]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "20211234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[0-6]|[56]\\d|9[013-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90011234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "857[58]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "85751234"
                                ],
                                "BJ",
                                229,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-689]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "81\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "81123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BL: [
                                ,
                                [
                                    ,
                                    ,
                                    "590\\d{6}|(?:69|80|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "590271234"
                                ],
                                [
                                    ,
                                    ,
                                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "690001234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "BL",
                                590,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:441|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4414123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "441(?:[2378]\\d|5[0-39]|92)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "4413701234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BM",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "441$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "441",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-578]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:22[89]|[78]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[34]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "5345678"
                                ],
                                "BN",
                                673,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-578]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-467]\\d\\d|8001)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[67]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "71234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8001[07]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "800171234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BO",
                                591,
                                "00(?:1\\d)?",
                                "0",
                                ,
                                ,
                                "0(1\\d)?",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[23]|4[46]"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{8})",
                                        "$1",
                                        [
                                            "[67]"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "8001[07]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[34]1|7\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "7151234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "3181234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BQ",
                                599,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "[347]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "11961234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "300\\d{6}|[59]00\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "300123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "40041234",
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BR",
                                55,
                                "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
                                "0",
                                ,
                                ,
                                "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
                                "$2",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3,6})",
                                        "$1",
                                        [
                                            "1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "300|4(?:0[02]|37)",
                                            "4(?:02|37)0|[34]00"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-57]",
                                            "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:[358]|90)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[16][1-9]|[2-57-9]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "300|4(?:0[02]|37)",
                                            "4(?:02|37)0|[34]00"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:[358]|90)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[16][1-9]|[2-57-9]"
                                        ],
                                        "($1)",
                                        "0 $CC ($1)"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "30(?:0\\d{5,7}|3\\d{7})|40(?:0\\d|20)\\d{4}|800\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:242|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2423456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2423591234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BS",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([3-8]\\d{6})$|1",
                                "242$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "242",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "242225\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2422250123"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d{7}|[2-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2345678",
                                    ,
                                    ,
                                    [
                                        7
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[67]|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "17123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BT",
                                975,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[2-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-68]|7[246]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[67]|7"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-68]|7[246]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[67]|7"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2401234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:321|7[1-8]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0800|800\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "0800012345",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "79(?:1(?:[01]\\d|2[0-8])|2[0-7]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "79101234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "BW",
                                267,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "90"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[24-6]|3[15-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[37]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "152450911",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "294911911",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8011234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:810|902)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9021234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "249\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "249123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "BY",
                                375,
                                "810",
                                "8",
                                ,
                                ,
                                "0|80?",
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "8 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "800"
                                        ],
                                        "8 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{3})",
                                        "$1 $2-$3",
                                        [
                                            "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                                            "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                                        ],
                                        "8 0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "1(?:[56]|7[467])|2[1-3]"
                                        ],
                                        "8 0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[1-4]"
                                        ],
                                        "8 0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "8 $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0800\\d|[2-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2221234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[0-35-7]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6221234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "08001234123",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "BZ",
                                501,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                                        "$1-$2-$3-$4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CA: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5062345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5062345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "600[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "6002012345",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "CA",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "310\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3101234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CC: [
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "891621234",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180(?:0\\d{3}|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "190[0-26]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "147101234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CC",
                                61,
                                "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                                "0",
                                ,
                                ,
                                "([59]\\d{7})$|0",
                                "8$1",
                                "0011",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d{8}|[1-68]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "12\\d{7}|[1-6]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1234567"
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "991234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CD",
                                243,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "88"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[1-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CF: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[27]\\d{3}|8776)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[12]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21612345"
                                ],
                                [
                                    ,
                                    ,
                                    "7[024-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8776\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "87761234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CF",
                                236,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[278]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CG: [
                                ,
                                [
                                    ,
                                    ,
                                    "222\\d{6}|(?:0\\d|80)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "222[1-589]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "222123456"
                                ],
                                [
                                    ,
                                    ,
                                    "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "061234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-2]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CG",
                                242,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[02]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CH: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{11}|[2-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[35-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "781234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[016]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "84[0248]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "840123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "878\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "878123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CH",
                                41,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8[047]|90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-79]|81"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "74[0248]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "740123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[18]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "581234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "860\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "860123456789",
                                    ,
                                    ,
                                    [
                                        12
                                    ]
                                ]
                            ],
                            CI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[02]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2123456789"
                                ],
                                [
                                    ,
                                    ,
                                    "0[157]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "0123456789"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CI",
                                225,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-578]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2\\d|3[13-7]|4[1-5])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "21234"
                                ],
                                [
                                    ,
                                    ,
                                    "[578]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "71234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CK",
                                682,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[2-578]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CL: [
                                ,
                                [
                                    ,
                                    ,
                                    "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "221234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "221234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:123|8)00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "600\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    "6001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "44\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "441234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CL",
                                56,
                                "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "1(?:[03-589]|21)|[29]0|78"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "219",
                                            "2196"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "44"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[1-36]"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "60|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "60"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "219",
                                            "2196"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "44"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[1-36]"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9[2-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                                        ],
                                        "($1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "60|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "60"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "600\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[26]\\d{8}|88\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:22|33)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "222123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:24[23]|6[25-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "671234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "88012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CM",
                                237,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "88"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[26]|88"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CN: [
                                ,
                                [
                                    ,
                                    ,
                                    "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
                                    ,
                                    ,
                                    ,
                                    "1012345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "13123456789",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:10|21)8|8)00\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "16[08]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "16812345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    "4001234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CN",
                                86,
                                "00|1(?:[12]\\d|79)\\d\\d00",
                                "0",
                                ,
                                ,
                                "(1(?:[12]\\d|79)\\d\\d)|0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5,6})",
                                        "$1",
                                        [
                                            "10|96"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "(?:10|2[0-57-9])[19]",
                                            "(?:10|2[0-57-9])(?:10|9[56])",
                                            "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]",
                                            "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
                                            "1(?:0(?:[0-8]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])|6)|[3-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "16[08]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                                            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                                            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                                            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]",
                                            "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
                                            "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
                                            "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:4|80)0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-578]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1[3-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[12]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "(?:10|2[0-57-9])[19]",
                                            "(?:10|2[0-57-9])(?:10|9[56])",
                                            "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                                            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                                            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                                            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "(?:4|80)0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10|2(?:[02-57-9]|1[1-9])",
                                            "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-578]"
                                        ],
                                        "0$1",
                                        "$CC $1",
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1[3-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[12]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60(?:[124-7][2-9]|8[1-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "6012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3211234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "18001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "19(?:0[01]|4[78])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "19001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CO",
                                57,
                                "00(?:4(?:[14]4|56)|[579])",
                                "0",
                                ,
                                ,
                                "0([3579]|4(?:[14]4|56))?",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "6"
                                        ],
                                        "($1)",
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "3[0-357]|91"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{7})",
                                        "$1-$2-$3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "6"
                                        ],
                                        "($1)",
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "3[0-357]|91"
                                        ],
                                        ,
                                        "0$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{7})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "83123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[059]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:210[0-6]|4\\d{3}|5100)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "40001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "CR",
                                506,
                                "00",
                                ,
                                ,
                                ,
                                "(19(?:0[0-2468]|1[09]|20|66|77|99))",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-7]|8[3-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[89]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        10
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "71234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5\\d|63)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "807\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8071234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CU",
                                53,
                                "119",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "2[1-4]|[34]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{6,7})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[56]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-59]\\d\\d|800)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2211234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:36|5[1-389]|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9911234"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[3-5]|4[356])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3401234"
                                ],
                                "CV",
                                238,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[2-589]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "94351234"
                                ],
                                [
                                    ,
                                    ,
                                    "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "95181234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60[0-2]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CW",
                                599,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[3467]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9[4-8]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "955\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "95581234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                1,
                                "[69]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CX: [
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "891641234",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180(?:0\\d{3}|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "190[0-26]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "147101234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CX",
                                61,
                                "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                                "0",
                                ,
                                ,
                                "([59]\\d{7})$|0",
                                "8$1",
                                "0011",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[279]\\d|[58]0)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[2-6]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22345678"
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:10|[4-79]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "96123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80001234"
                                ],
                                [
                                    ,
                                    ,
                                    "90[09]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345"
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "CY",
                                357,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[257-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:50|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "601123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:0[05689]|76)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[134]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "811234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[01]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[17]0\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "910123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "CZ",
                                420,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-8]|9[015-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "96"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:5\\d|7[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "972123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:3\\d{9}|6\\d{7,10})",
                                    ,
                                    ,
                                    ,
                                    "93123456789"
                                ]
                            ],
                            DE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ],
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
                                    ,
                                    ,
                                    ,
                                    "30123456",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ],
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "15(?:[0-25-9]\\d\\d|310)\\d{6}|1(?:6[023]|7\\d)\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    "15123456789",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,12}",
                                    ,
                                    ,
                                    ,
                                    "8001234567890",
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "18012345",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "70012345678",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DE",
                                49,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,13})",
                                        "$1 $2",
                                        [
                                            "3[02]|40|[68]9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,12})",
                                        "$1 $2",
                                        [
                                            "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                                            "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,11})",
                                        "$1 $2",
                                        [
                                            "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                                            "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "138"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{2,10})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,11})",
                                        "$1 $2",
                                        [
                                            "181"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{4,10})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:3|80)|9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "1[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7,12})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "185",
                                            "1850",
                                            "18500"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "18[68]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "15[1279]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "15[03568]",
                                            "15(?:[0568]|31)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{8})",
                                        "$1 $2",
                                        [
                                            "18"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{7,8})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:6[023]|7)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{7})",
                                        "$1 $2 $3",
                                        [
                                            "15[279]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{8})",
                                        "$1 $2 $3",
                                        [
                                            "15"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "16(?:4\\d{1,10}|[89]\\d{1,11})",
                                    ,
                                    ,
                                    ,
                                    "16412345",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18(?:1\\d{5,11}|[2-9]\\d{8})",
                                    ,
                                    ,
                                    ,
                                    "18500123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "177991234567",
                                    ,
                                    ,
                                    [
                                        12,
                                        13
                                    ]
                                ]
                            ],
                            DJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2\\d|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1[2-5]|7[45])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21360003"
                                ],
                                [
                                    ,
                                    ,
                                    "77\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77831001"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DJ",
                                253,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[27]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "32123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "32123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DK",
                                45,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|767|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7674201234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7672251234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DM",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-7]\\d{6})$|1",
                                "767$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "767",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8092345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[024]9[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8092345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "DO",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "8001|8[024]9",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-4]|[5-79]\\d|80)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "551234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[3-689]1\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "808123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[12]1\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "801123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "98[23]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "983123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "DZ",
                                213,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[1-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-8]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EC: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-7][2-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "991234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{7}|1[78]00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "18001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-7]890\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "28901234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "EC",
                                593,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2-$3",
                                        [
                                            "[2-7]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[2-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EE: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3212345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:40\\d\\d|900)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[0-2]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "EE",
                                372,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                                            "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "[45]|8(?:00|[1-49])",
                                            "[45]|8(?:00[1-9]|[1-49])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "800[2-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "234567890",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[0-25]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "1001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "EG",
                                20,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "[23]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6,7})",
                                        "$1 $2",
                                        [
                                            "1[35]|[4-6]|8[2468]|9[235-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{8})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[5-8]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "528[89]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "528812345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "650123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "89\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "891234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "592401234"
                                ],
                                "EH",
                                212,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "528[89]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ER: [
                                ,
                                [
                                    ,
                                    ,
                                    "[178]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8370362",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:17[1-3]|7\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ER",
                                291,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[178]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ES: [
                                ,
                                [
                                    ,
                                    ,
                                    "[5-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    "[89]00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80[367]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "803123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90[12]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "901123456"
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "701234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ES",
                                34,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "905"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[79]9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]00"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[89]00"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "51\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "511234567"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ET: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:11|[2-579]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "111112345",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "911234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ET",
                                251,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-579]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[3-79][1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    "131234567",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "412345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[67]00\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "600123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FI",
                                358,
                                "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "75[12]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "20[2-59]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "11"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1 $2",
                                        [
                                            "(?:[1-3]0|[68])0|70[07-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,8})",
                                        "$1 $2",
                                        [
                                            "[14]|2[09]|50|7[135]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6,10})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4,9})",
                                        "$1 $2",
                                        [
                                            "(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "20[2-59]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1 $2",
                                        [
                                            "(?:[1-3]0|[68])0|70[07-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,8})",
                                        "$1 $2",
                                        [
                                            "[14]|2[09]|50|7[135]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6,10})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4,9})",
                                        "$1 $2",
                                        [
                                            "(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "1[03-79]|[2-9]",
                                [
                                    ,
                                    ,
                                    "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                                    ,
                                    ,
                                    ,
                                    "10112345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3212345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "08001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FJ",
                                679,
                                "0(?:0|52)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[235-9]|45"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-7]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-47]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "31234"
                                ],
                                [
                                    ,
                                    ,
                                    "[56]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "51234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FK",
                                500,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[39]\\d\\d|820)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "3201234"
                                ],
                                [
                                    ,
                                    ,
                                    "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "3501234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "FM",
                                691,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[389]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:20|[34]\\d|8[19])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[27][1-9]|5\\d|9[16])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "211234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[257-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "802123"
                                ],
                                [
                                    ,
                                    ,
                                    "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "901123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[0-36]|88)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "601234"
                                ],
                                "FO",
                                298,
                                "00",
                                ,
                                ,
                                ,
                                "(10(?:01|[12]0|88))",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[2-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "59[1-9]\\d{6}|(?:[1-3]\\d|4[1-9]|5[0-8])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "123456789"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "891123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[01]|2[0156]|4[02]|84)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "884012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                "FR",
                                33,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "10"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[1-79]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0 $1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[1-79]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[6-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "806123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GA: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[01]1\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "01441234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "06031234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GA",
                                241,
                                "00",
                                ,
                                ,
                                ,
                                "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
                                "$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "11|[67]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1212345678",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7400123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[08]\\d{7}|800\\d{6}|8001111",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                                    ,
                                    ,
                                    ,
                                    "9012345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "GB",
                                44,
                                "00",
                                "0",
                                " x",
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "800",
                                            "8001",
                                            "80011",
                                            "800111",
                                            "8001111"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "845",
                                            "8454",
                                            "84546",
                                            "845464"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "1(?:38|5[23]|69|76|94)",
                                            "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                                            "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "1(?:[2-69][02-9]|[78])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[25]|7(?:0|6[02-9])",
                                            "[25]|7(?:0|6(?:[03-9]|2[356]))"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1389]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7640123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[0347]|55)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:473|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4732691234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4734031234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GD",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "473$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "473",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[3-57]\\d\\d|800)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "322123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|11|22|33|44|5[05]|77|88|9[09])|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "555123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[67]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "706123456"
                                ],
                                "GE",
                                995,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "70"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "32"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[57]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[348]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "70[67]\\d{6}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "594(?:[02-49]\\d|1[0-4]|5[6-9]|6[0-3]|80)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "594101234"
                                ],
                                [
                                    ,
                                    ,
                                    "694(?:[0-249]\\d|3[0-8])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "694201234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:396|76\\d)\\d|476[0-5])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "GF",
                                594,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[56]|9[47]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1481[25-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1481256789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7781123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[08]\\d{7}|800\\d{6}|8001111",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                                    ,
                                    ,
                                    ,
                                    "9012345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "GG",
                                44,
                                "00",
                                "0",
                                ,
                                ,
                                "([25-9]\\d{5})$|0",
                                "1481$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7640123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[0347]|55)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[235]\\d{3}|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "302345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "231234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GH",
                                233,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[237]|8[0-2]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[235]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[235]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[25]\\d|60)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "20012345"
                                ],
                                [
                                    ,
                                    ,
                                    "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "57123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GI",
                                350,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:19|[2-689]\\d|70)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "321000"
                                ],
                                [
                                    ,
                                    ,
                                    "[245]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "221234"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "801234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[89]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "381234"
                                ],
                                "GL",
                                299,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "19|[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "5661234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[23679]\\d|5[0-489])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GM",
                                220,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GN: [
                                ,
                                [
                                    ,
                                    ,
                                    "722\\d{6}|(?:3|6\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "30241234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[0-356]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "601123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "722\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "722123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "GN",
                                224,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "3"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[67]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GP: [
                                ,
                                [
                                    ,
                                    ,
                                    "590\\d{6}|(?:69|80|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "590201234"
                                ],
                                [
                                    ,
                                    ,
                                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "690001234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "GP",
                                590,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[569]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "333091234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:222|55\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "222123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "900123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GQ",
                                240,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[235]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GR: [
                                ,
                                [
                                    ,
                                    ,
                                    "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "68[57-9]\\d{7}|(?:69|94)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "6912345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "90[19]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:0[16]|12|[27]5|50)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8011234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GR",
                                30,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "21|7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2689]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5005000\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "5005000123",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GT: [
                                ,
                                [
                                    ,
                                    ,
                                    "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[267][2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22456789",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[3-5]\\d\\d|80[0-4])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18[01]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "18001112222",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "19\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "19001112222",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GT",
                                502,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|671|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6713001234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6713001234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "GU",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "671$1",
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "671",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[49]\\d{8}|4\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "443\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "443201234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:5\\d|6[569]|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "955012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "40\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "4012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "GW",
                                245,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "40"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[49]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-8]\\d{3}|9008)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:510|6\\d\\d|7(?:0\\d|1[0-8]|25|49))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6091234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:289|8(?:00|6[28]|88|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2891234"
                                ],
                                [
                                    ,
                                    ,
                                    "9008\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "9008123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "515\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5151234"
                                ],
                                "GY",
                                592,
                                "001",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HK: [
                                ,
                                [
                                    ,
                                    ,
                                    "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[59]\\d|6[01]))|58(?:0[1-9]|1[2-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:44[5-9]|6(?:1[0-7]|4[0-57-9]|6[0-4]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-6]|8[0-4])|848[0-25-9]|9(?:29[013-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0156]|6[02357-9])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|709|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "51234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
                                    ,
                                    ,
                                    ,
                                    "90012345678",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "81123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "HK",
                                852,
                                "00(?:30|5[09]|[126-9]?)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,5})",
                                        "$1 $2",
                                        [
                                            "900",
                                            "9003"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "30161234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HN: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{10}|[237-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[37-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "91234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8002\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "80021234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "HN",
                                504,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[237-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[237-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "8002\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[5-7])))\\d{4}|98\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "921234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[01459]\\d{6}|6[01]\\d{4,5}",
                                    ,
                                    ,
                                    ,
                                    "611234",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[45]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "74123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "HR",
                                385,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "6[01]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-5]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "62\\d{6,7}|72\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "62123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HT: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-489]\\d|55)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2\\d|5[1-5]|81|9[149])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22453300"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[34]\\d|55)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "34101234"
                                ],
                                [
                                    ,
                                    ,
                                    "8\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "98901234"
                                ],
                                "HT",
                                509,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-589]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            HU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[235-7]\\d{8}|[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[257]0|3[01])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "201234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[48]0\\d|680[29])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "9[01]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "211234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "HU",
                                36,
                                "00",
                                "06",
                                ,
                                ,
                                "06",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "(06 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                                        ],
                                        "(06 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ],
                                        "06 $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[48]0\\d|680[29])\\d{5}"
                                ],
                                [
                                    ,
                                    ,
                                    "38\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "381234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ID: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
                                    ,
                                    ,
                                    ,
                                    "218350123",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[1-35-9]\\d{7,10}",
                                    ,
                                    ,
                                    ,
                                    "812345678",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "809\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "804\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8041234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ID",
                                62,
                                "00[89]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "15"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,9})",
                                        "$1 $2",
                                        [
                                            "2[124]|[36]1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,8})",
                                        "$1 $2",
                                        [
                                            "[2-79]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "8[1-35-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6,8})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "804"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "80"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "001"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "15"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,9})",
                                        "$1 $2",
                                        [
                                            "2[124]|[36]1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,8})",
                                        "$1 $2",
                                        [
                                            "[2-79]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "8[1-35-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6,8})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "804"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "80"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1-$2-$3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "001803\\d{6,7}|(?:007803\\d|8071)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1500|8071\\d{3})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8071123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2212345",
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:22|[35-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "850123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1520123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18[59]0\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1850123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "76\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "761234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "IE",
                                353,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2[24-9]|47|58|6[237-9]|9[35-9]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[45]0"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2569]|4[1-69]|7[14]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "70"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "81"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[78]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "4"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18[59]0\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "818\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "818123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8551234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ]
                            ],
                            IL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        11,
                                        12
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "502345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:255|80[019]\\d{3})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1919123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1700123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:38(?:0\\d|5[09]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "771234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "IL",
                                972,
                                "0(?:0|1[2-9])",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "125"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{2})",
                                        "$1-$2-$3",
                                        [
                                            "121"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[2-489]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[57]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "12"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "159"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                                        "$1-$2-$3-$4",
                                        [
                                            "1[7-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                                        "$1-$2 $3-$4",
                                        [
                                            "15"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1599\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1599123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "151\\d{8,9}",
                                    ,
                                    ,
                                    ,
                                    "15112340000",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            IM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1624(?:230|[5-8]\\d\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1624756789",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7924123456"
                                ],
                                [
                                    ,
                                    ,
                                    "808162\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8081624567"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9016247890"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678"
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678"
                                ],
                                "IM",
                                44,
                                "00",
                                "0",
                                ,
                                ,
                                "([25-8]\\d{5})$|0",
                                "1624$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "74576|(?:16|7[56])24",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5512345678"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7410410123",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",
                                    ,
                                    ,
                                    ,
                                    "1800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "186[12]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "1861123456789",
                                    ,
                                    ,
                                    [
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1860\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "18603451234",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IN",
                                91,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{7})",
                                        "$1",
                                        [
                                            "575"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{8})",
                                        "$1",
                                        [
                                            "5(?:0|2[23]|3[03]|[67]1|88)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "180",
                                            "1800"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "140"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                                            "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                                            "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                                            "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[6-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:6|8[06])",
                                            "1(?:6|8[06]0)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "18"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{8})",
                                        "$1",
                                        [
                                            "5(?:0|2[23]|3[03]|[67]1|88)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                                            "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "180",
                                            "1800"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "140"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                                            "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                                            "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                                            "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                                            "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                                            "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[6-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:6|8[06])",
                                            "1(?:6|8[06]0)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "18"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"
                                ],
                                [
                                    ,
                                    ,
                                    "140\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1409305260",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IO: [
                                ,
                                [
                                    ,
                                    ,
                                    "3\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "37\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3709100"
                                ],
                                [
                                    ,
                                    ,
                                    "38\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3801234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IO",
                                246,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[3-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7912345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IQ",
                                964,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        10
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "IR",
                                98,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4,5})",
                                        "$1",
                                        [
                                            "96"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-8]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
                                    ,
                                    ,
                                    ,
                                    "9601",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            IS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:38\\d|[4-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4101234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6111234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "49[0-24-79]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4921234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "IS",
                                354,
                                "00|1(?:0(?:01|[12]0)|100)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[4-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "3"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "809\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8091234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:689|8(?:7[18]|80)|95[48])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6891234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ]
                            ],
                            IT: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                                    ,
                                    ,
                                    ,
                                    "0212345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:0\\d{3}|3)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "899123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "84(?:[08]\\d{3}|[17])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "848123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:78\\d|99)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1781234567",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "IT",
                                39,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4,5})",
                                        "$1",
                                        [
                                            "1(?:0|9[246])",
                                            "1(?:0|9(?:2[2-9]|[46]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "1(?:1|92)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                                            "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,6})",
                                        "$1 $2",
                                        [
                                            "0(?:[13-579][2-46-8]|8[236-8])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "894"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]|5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:44|[679])|[378]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[13-57-9][0159]|14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "3"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                                            "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2,6})",
                                        "$1 $2",
                                        [
                                            "0(?:[13-579][2-46-8]|8[236-8])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "894"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]|5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "1(?:44|[679])|[378]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0[13-57-9][0159]|14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "0[26]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "3"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    "848\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "3[2-8]\\d{9,10}",
                                    ,
                                    ,
                                    ,
                                    "33101234501",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            JE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1534[0-24-8]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1534456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7797712345"
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:07(?:35|81)|8901)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8007354567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9018105678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "701511\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7015115678"
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5612345678"
                                ],
                                "JE",
                                44,
                                "00",
                                "0",
                                ,
                                ,
                                "([0-24-8]\\d{5})$|0",
                                "1534$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7640123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5512345678"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|658|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8765230123",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8762101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "JM",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "658|876",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "62001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:[78][0-25-9]|9\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "790123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "85\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "85012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "JO",
                                962,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2356]|87"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "70"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "74(?:66|77)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "746612345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:10|8\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88101234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JP: [
                                ,
                                [
                                    ,
                                    ,
                                    "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14,
                                        15,
                                        16,
                                        17
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "312345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[7-9]0[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",
                                    ,
                                    ,
                                    ,
                                    "120123456"
                                ],
                                [
                                    ,
                                    ,
                                    "990\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "990123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "601234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "JP",
                                81,
                                "010",
                                "0",
                                ,
                                ,
                                "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
                                "$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "007",
                                            "0077",
                                            "00777",
                                            "00777[01]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "(?:12|57|99)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d)(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "60"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[36]|4(?:2[09]|7[01])",
                                            "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{3,4})",
                                        "$1-$2-$3",
                                        [
                                            "007",
                                            "0077"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "008"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[257-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3,4})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{4,5})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})(\\d{5,6})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})(\\d{6,7})",
                                        "$1-$2-$3",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1-$2-$3",
                                        [
                                            "(?:12|57|99)0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d)(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                                            "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "60"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[36]|4(?:2[09]|7[01])",
                                            "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                                            "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "800"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[257-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "2012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"
                                ],
                                [
                                    ,
                                    ,
                                    "570\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "570123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "202012345",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800[2-8]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "800223456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900[02-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "900223456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KE",
                                254,
                                "000",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "[24-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[17]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KG: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{9}|[235-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "312123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "700123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KG",
                                996,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "3(?:1[346]|[24-79])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[235-79]|88"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KH: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{9}|[1-9]\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
                                    ,
                                    ,
                                    ,
                                    "23756789",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "91234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800(?:1\\d|2[019])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900(?:1\\d|2[09])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KH",
                                855,
                                "00[14-9]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "31234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "72001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "30010000",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "KI",
                                686,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[3478]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ],
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[4-7]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7712345",
                                    ,
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[34]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "3212345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KM",
                                269,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[3478]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8692361234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8697652917",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KN",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-7]\\d{6})$|1",
                                "869$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "869",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KP: [
                                ,
                                [
                                    ,
                                    ,
                                    "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "19[1-3]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "1921234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KP",
                                850,
                                "00|99",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-7]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KR: [
                                ,
                                [
                                    ,
                                    ,
                                    "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ],
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    "22123456",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "1020000000",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567",
                                    ,
                                    ,
                                    [
                                        9,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "60[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "602345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50\\d{8,9}",
                                    ,
                                    ,
                                    ,
                                    "5012345678",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "KR",
                                82,
                                "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
                                "0",
                                ,
                                ,
                                "0(8(?:[1-46-8]|5\\d\\d))?",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "1[016-9]1",
                                            "1[016-9]11",
                                            "1[016-9]114"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1-$2",
                                        [
                                            "(?:3[1-3]|[46][1-4]|5[1-5])1"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "60|8"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[1346]|5[1-5]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[57]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "003",
                                            "0030"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "5"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1-$2",
                                        [
                                            "(?:3[1-3]|[46][1-4]|5[1-5])1"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "60|8"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[1346]|5[1-5]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[57]"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "5"
                                        ],
                                        "0$1",
                                        "0$CC-$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "15\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    "1523456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "15441234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KW: [
                                ,
                                [
                                    ,
                                    ,
                                    "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "50012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "18\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1801234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KW",
                                965,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "[169]|2(?:[235]|4[1-35-9])|52"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[245]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KY: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:345|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3452221234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3453231234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:345976|900[2-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "KY",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "345$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "345849\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3458491234"
                                ],
                                ,
                                "345",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        14
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "7710009998",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|108\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "809\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8081234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "751\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "7511234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "KZ",
                                7,
                                "810",
                                "8",
                                ,
                                ,
                                "8",
                                ,
                                "8~10",
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "33|7",
                                [
                                    ,
                                    ,
                                    "751\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21212862",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2023123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LA",
                                856,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2[13]|3[14]|[4-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "30[013-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[23]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "30[013-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "301234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[27-9]\\d{7}|[13-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1123456"
                                ],
                                [
                                    ,
                                    ,
                                    "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "71123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[01]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LB",
                                961,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[27-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|758|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7584305678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7582845678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LC",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-8]\\d{6})$|1",
                                "758$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "758",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2345678",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "660234567"
                                ],
                                [
                                    ,
                                    ,
                                    "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8002222"
                                ],
                                [
                                    ,
                                    ,
                                    "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "9002222",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LI",
                                423,
                                "00",
                                "0",
                                ,
                                ,
                                "(1001)|0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[2379]|8(?:0[09]|7)",
                                            "[2379]|8(?:0(?:02|9)|7)"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "69"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "870(?:28|87)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "8702812",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "697(?:42|56|[78]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "697861234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ]
                            ],
                            LK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "112345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:[0-25-8]\\d|4[0-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LK",
                                94,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[1-689]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1973\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "197312345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "770123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "332(?:02|[34]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "332021234",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LR",
                                231,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[4-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[23578]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[256]\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "22123456"
                                ],
                                [
                                    ,
                                    ,
                                    "[56]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "50123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800[256]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80021234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LS",
                                266,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2568]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LT: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[3469]\\d|52|[78]0)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[1478]|4[124-6]|52)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "31234567"
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "61234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80[02]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:0[0239]|10)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80812345"
                                ],
                                [
                                    ,
                                    ,
                                    "70[05]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70012345"
                                ],
                                [
                                    ,
                                    ,
                                    "[89]01\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                "LT",
                                370,
                                "00",
                                "8",
                                ,
                                ,
                                "[08]",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "52[0-7]"
                                        ],
                                        "(8-$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[7-9]"
                                        ],
                                        "8 $1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "37|4(?:[15]|6[1-8])"
                                        ],
                                        "(8-$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[3-6]"
                                        ],
                                        "(8-$1)",
                                        ,
                                        1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[67]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "70712345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LU: [
                                ,
                                [
                                    ,
                                    ,
                                    "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
                                    ,
                                    ,
                                    ,
                                    "27123456"
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "628123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[015]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:1\\d{5}|[2-689]\\d{1,7})",
                                    ,
                                    ,
                                    ,
                                    "20201234",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                "LU",
                                352,
                                "00",
                                ,
                                ,
                                ,
                                "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "20[2-689]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2(?:[0367]|4[3-8])"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "80[01]|90[015]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "20"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "2(?:[0367]|4[3-8])"
                                        ],
                                        ,
                                        "$CC $1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                                        ],
                                        ,
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[268]\\d|90)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "63123456"
                                ],
                                [
                                    ,
                                    ,
                                    "23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "21234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    "81\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "81123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LV",
                                371,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[269]|8[01]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-6]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "LY",
                                218,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "[2-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[5-8]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "520123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "650123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "89\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "891234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "592401234"
                                ],
                                "MA",
                                212,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5[45]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1-$2",
                                        [
                                            "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                                            "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "[5-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[3489]|6\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:870|9[2-47-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "99123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:800|90\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MC",
                                377,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "87"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[389]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "4"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[389]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "8[07]0\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[235-7]\\d|[89]0)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22212345"
                                ],
                                [
                                    ,
                                    ,
                                    "562\\d{5}|(?:6\\d|7[16-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "62112345"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "90[056]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345"
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80812345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[08]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "30123456"
                                ],
                                "MD",
                                373,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "22|3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[25-7]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "803\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80312345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ME: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "30234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "67622901",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:[0-2578]|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80080002"
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:4[1568]|5[178])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "94515151",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "78[1-49]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "78108780",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "ME",
                                382,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "77[1-9]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "77273012",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MF: [
                                ,
                                [
                                    ,
                                    ,
                                    "590\\d{6}|(?:69|80|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "590271234"
                                ],
                                [
                                    ,
                                    ,
                                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "690001234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976012345"
                                ],
                                "MF",
                                590,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[23]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "202123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[2-47-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "321234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "221234567"
                                ],
                                "MG",
                                261,
                                "00",
                                "0",
                                ,
                                ,
                                "([24-9]\\d{6})$|0",
                                "20$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[23]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MH: [
                                ,
                                [
                                    ,
                                    ,
                                    "329\\d{4}|(?:[256]\\d|45)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:247|45[78]|528|625)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2471234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:23|54)5|329|45[356])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2351234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "635\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6351234"
                                ],
                                "MH",
                                692,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[2-6]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-578]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22012345",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|6[01]|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "72345678"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "5\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "50012345"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:0[1-9]|[1-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MK",
                                389,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2|34[47]|4(?:[37]7|5[47]|64)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[347]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[58]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ML: [
                                ,
                                [
                                    ,
                                    ,
                                    "[24-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "20212345"
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "65012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ML",
                                223,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "67[057-9]|74[045]",
                                            "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "80\\d{6}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "92123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80080(?:0[1-9]|2\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8008001234",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1333\\d{4}|[12]468\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "13331234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "MM",
                                95,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "16|2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[12]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[4-7]|8[1-35]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4,6})",
                                        "$1 $2 $3",
                                        [
                                            "9(?:2[0-4]|[35-9]|4[137-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "92"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{5})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{7,9}|[5-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "53123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "88123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "75123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "MN",
                                976,
                                "001",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[12]1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[5-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "[12]2[1-3]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5,6})",
                                        "$1 $2",
                                        [
                                            "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                                            "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "[12]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MO: [
                                ,
                                [
                                    ,
                                    ,
                                    "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "28212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "66123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "0800501",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MO",
                                853,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[268]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MP: [
                                ,
                                [
                                    ,
                                    ,
                                    "[58]\\d{9}|(?:67|90)0\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6702345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6702345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MP",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "670$1",
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "670",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "596\\d{6}|(?:69|80|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "596(?:[03-7]\\d|10|2[7-9]|8[0-39]|9[04-9])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "596301234"
                                ],
                                [
                                    ,
                                    ,
                                    "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "696201234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:397[0-2]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "976612345"
                                ],
                                "MQ",
                                596,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[569]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-4]\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:25[08]|35\\d|45[1-7])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "35123456"
                                ],
                                [
                                    ,
                                    ,
                                    "[2-4][0-46-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MR",
                                222,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-48]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|664|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6644(?:1[0-3]|91)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6644912345",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6644923456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MS",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([34]\\d{6})$|1",
                                "664$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "664",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MT: [
                                ,
                                [
                                    ,
                                    ,
                                    "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21001234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "96961234"
                                ],
                                [
                                    ,
                                    ,
                                    "800(?:02|[3467]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "80071234"
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "50037123"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3550\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "35501234"
                                ],
                                "MT",
                                356,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2357-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "7117\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "71171234"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "501\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "50112345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "54480123",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-3]|3[013]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "52512345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "802\\d{7}|80[0-2]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "30\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "3012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:20|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3201234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "MU",
                                230,
                                "0(?:0|[24-7]0|3[03])",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "020",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-46]|8[013]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[57]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6701234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:46[46]|[79]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7712345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MV",
                                960,
                                "0(?:0|19)",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[34679]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:0[01]|50)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1234567"
                                ],
                                [
                                    ,
                                    ,
                                    "111\\d{6}|(?:31|77|[89][89])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "991234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MW",
                                265,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1[2-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[137-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MX: [
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ],
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "12221234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|88)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "300\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "500\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MX",
                                52,
                                "0[09]",
                                "01",
                                ,
                                ,
                                "0(?:[12]|4[45])|1",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "53"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "33|5[56]|81"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                                        "$2 $3 $4",
                                        [
                                            "1(?:33|5[56]|81)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                                        "$2 $3 $4",
                                        [
                                            "1"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "33|5[56]|81"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2-9]"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                                        "$2 $3 $4",
                                        [
                                            "1(?:33|5[56]|81)"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                                        "$2 $3 $4",
                                        [
                                            "1"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "323856789",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[378]00\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1300123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1600\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1600123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1546012345",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "MY",
                                60,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "[4-79]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1-$2 $3",
                                        [
                                            "1(?:[02469]|[378][1-9]|53)|8",
                                            "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                                        "$1-$2-$3-$4",
                                        [
                                            "1(?:[367]|80)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "15"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1-$2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2|8\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[2-79]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "821234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "MZ",
                                258,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2|8[2-79]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[68]\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "61221234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:60|8[1245])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "811234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8701\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "870123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:3\\d\\d|86)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88612345"
                                ],
                                "NA",
                                264,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "88"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "87"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:050|[2-57-9]\\d\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "751234"
                                ],
                                [
                                    ,
                                    ,
                                    "050\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "050012"
                                ],
                                [
                                    ,
                                    ,
                                    "36\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "366711"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NC",
                                687,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})",
                                        "$1",
                                        [
                                            "5[6-8]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1.$2.$3",
                                        [
                                            "[02-57-9]"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1.$2.$3",
                                        [
                                            "[02-57-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[027-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "20201234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:23|7[047]|[89]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "93123456"
                                ],
                                [
                                    ,
                                    ,
                                    "08\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "08123456"
                                ],
                                [
                                    ,
                                    ,
                                    "09\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "09123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NE",
                                227,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "08"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[089]|2[013]|7[047]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "106609",
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:14|3[58])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "381234",
                                    ,
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NF",
                                672,
                                "00",
                                ,
                                ,
                                ,
                                "([0-258]\\d{4})$",
                                "3$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "1[0-3]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[13]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "18040123",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8021234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7,11}",
                                    ,
                                    ,
                                    ,
                                    "80017591759",
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NG",
                                234,
                                "009",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "78"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[12]|9(?:0[3-9]|[1-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[3-7]|8[2-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "[78]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})(\\d{5,6})",
                                        "$1 $2 $3",
                                        [
                                            "[78]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "700\\d{7,11}",
                                    ,
                                    ,
                                    ,
                                    "7001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11,
                                        12,
                                        13,
                                        14
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NI: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1800|[25-8]\\d{3})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "21234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81234567"
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "18001234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NI",
                                505,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[125-8]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "101234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[1-58]|970\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "612345678",
                                    ,
                                    ,
                                    [
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[069]\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "9061234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:85|91)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "851234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "NL",
                                31,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})",
                                        "$1",
                                        [
                                            "1[238]|[34]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "14"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,7})",
                                        "$1 $2",
                                        [
                                            "[89]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "66"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{8})",
                                        "$1 $2",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-578]|91"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,7})",
                                        "$1 $2",
                                        [
                                            "[89]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "66"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{8})",
                                        "$1 $2",
                                        [
                                            "6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-578]|91"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "66\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "662345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",
                                    ,
                                    ,
                                    ,
                                    "14020",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0|[2-9]\\d{3})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[015-8]|9\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "40612345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[01]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "82[09]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "82012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "81021234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "880\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "85[0-5]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "85012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "NO",
                                47,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2-79]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "[02-689]|7[0-8]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "02000"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "81[23]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ]
                            ],
                            NP: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "14567890",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9841234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:66001|800\\d\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "16600101234",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NP",
                                977,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1-$2",
                                        [
                                            "1[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{5})",
                                        "$1-$2-$3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1-$2",
                                        [
                                            "1[2-6]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1-$2",
                                        [
                                            "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "444\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4441234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:55[3-9]|666|8\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5551234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NR",
                                674,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[4-68]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NU: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[4-7]|888\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[47]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "7012",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[56]|888[1-9])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8884012"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NU",
                                683,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "32345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "211234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "508\\d{6,7}|80\\d{6,8}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "NZ",
                                64,
                                "0(?:0|161)",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,8})",
                                        "$1 $2",
                                        [
                                            "8[1-79]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "50[036-8]|8|90",
                                            "50(?:[0367]|88)|8|90"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "24|[346]|7[2-57-9]|9[2-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:10|74)|[589]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1|2[028]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,5})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:[169]|7[0-35-9])|7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}",
                                    ,
                                    ,
                                    ,
                                    "83012378"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            OM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[1-6]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "23123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1505\\d{4}|(?:7(?:[1289]\\d|6[89]|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "92123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8007\\d{4,5}|(?:500|800[05])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80071234"
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "OM",
                                968,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "[58]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[179]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PA: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "61234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4,5}|(?:00800|800\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8601234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PA",
                                507,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[1-57-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[68]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[14-8]|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "11234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "912345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "805\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80512345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80112345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[24]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PE",
                                51,
                                "00|19(?:1[124]|77|90)00",
                                "0",
                                " Anexo ",
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "80"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[4-8]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PF: [
                                ,
                                [
                                    ,
                                    ,
                                    "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:0[4-689]|9[4-68])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "40412345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[7-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "87123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "499\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "49901234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "PF",
                                689,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "44"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "4|8[7-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "44\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "44\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "440123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3123456",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7\\d|8[128])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "180\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1801234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0[0-57]|7[568])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2751234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "PG",
                                675,
                                "00|140[1-3]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "18|[2-69]|85"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[78]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "27[01]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2700123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ],
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "232345678",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9051234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    "180012345678",
                                    ,
                                    ,
                                    [
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PH",
                                63,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{5})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                                            "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "346|4(?:27|9[35])|883",
                                            "3469|4(?:279|9(?:30|56))|8834"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-7]|8[2-8]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PK: [
                                ,
                                [
                                    ,
                                    ,
                                    "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "122\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "122044444",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PK",
                                92,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2,7})",
                                        "$1 $2 $3",
                                        [
                                            "[89]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6,7})",
                                        "$1 $2",
                                        [
                                            "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                                            "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7,8})",
                                        "$1 $2",
                                        [
                                            "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "58"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "3"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24-9]"
                                        ],
                                        "(0$1)"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21111825888",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",
                                    ,
                                    ,
                                    ,
                                    "123456789",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21(?:1(?:[145]\\d|3[1-5])|2\\d\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "512345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70[01346-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "39\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "391234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "PL",
                                48,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "11|20|64"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                                            "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "64"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[2-8]|[2-7]|8[1-79]|9[145]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "64\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "641234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "804\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "804123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[45]\\d{5}|(?:708|80\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[1-35-7]|5[01])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "430123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[02-4]|5[056]|708[45][0-5])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "551234"
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PM",
                                508,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[45]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[589]\\d\\d|787)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:787|939)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7872345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:787|939)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "7872345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PR",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "787|939",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[69]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "599123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1700\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1700123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PS",
                                970,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[2489]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "212345678"
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                [
                                    ,
                                    ,
                                    "80[02]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "760123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:8\\d|9[1579])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "808123456"
                                ],
                                [
                                    ,
                                    ,
                                    "884[0-4689]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "884123456"
                                ],
                                [
                                    ,
                                    ,
                                    "30\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "301234567"
                                ],
                                "PT",
                                351,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[12]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "16|[236-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "6222\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "622212345"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "707123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "600\\d{6}|6[06]9233\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "600110000"
                                ]
                            ],
                            PW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[24-8]\\d\\d|345|900)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2771234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6201234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "PW",
                                680,
                                "01[12]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PY: [
                                ,
                                [
                                    ,
                                    ,
                                    "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ],
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "212345678",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "961456789",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9800\\d{5,7}",
                                    ,
                                    ,
                                    ,
                                    "98000123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8700[0-4]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "870012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "PY",
                                595,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "[2-9]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "87"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "9(?:[5-79]|8[1-7])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-8]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[2-9]0\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "201234567",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            QA: [
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "44123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[35-7]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "33123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}|(?:0080[01]|800)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        9,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "QA",
                                974,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "2[16]|8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[3-7]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "2[16]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2123456",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:26|[689]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "262161234"
                                ],
                                [
                                    ,
                                    ,
                                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "692123456"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    "89[1-37-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "891123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:1[019]|2[0156]|84|90)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "939901234"
                                ],
                                "RE",
                                262,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2689]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "211234567"
                                ],
                                [
                                    ,
                                    ,
                                    "7020\\d{5}|(?:6(?:2\\d|40)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712034567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90[0136]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "801\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "801123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RO",
                                40,
                                "00",
                                "0",
                                " int ",
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "2[3-6]",
                                            "2[3-6]\\d9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "219|31"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[23]1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[236-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:37\\d|80[578])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "372123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RS: [
                                ,
                                [
                                    ,
                                    ,
                                    "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",
                                    ,
                                    ,
                                    ,
                                    "10234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ],
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:[0-689]|7\\d)\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "601234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{3,9}",
                                    ,
                                    ,
                                    ,
                                    "80012345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:78\\d|90[0169])\\d{3,7}",
                                    ,
                                    ,
                                    ,
                                    "90012345",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RS",
                                381,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,9})",
                                        "$1 $2",
                                        [
                                            "(?:2[389]|39)0|[7-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,10})",
                                        "$1 $2",
                                        [
                                            "[1-36]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[06]\\d{4,10}",
                                    ,
                                    ,
                                    ,
                                    "700123456"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RU: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{13}|[347-9]\\d{9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10,
                                        14
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3011234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "9123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:0[04]|108\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80[39]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8091234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "808\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8081234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RU",
                                7,
                                "810",
                                "8",
                                ,
                                ,
                                "8",
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})",
                                        "$1-$2-$3",
                                        [
                                            "[0-79]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-8]|2[1-9])",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-68]|2[1-9])",
                                            "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                                            "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[349]|8(?:[02-7]|1[1-8])"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "8 ($1)"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-8]|2[1-9])",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                                            "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "7(?:1[0-68]|2[1-9])",
                                            "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                                            "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[349]|8(?:[02-7]|1[1-8])"
                                        ],
                                        "8 ($1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "8 ($1)"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "3[04-689]|[489]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RW: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:06|[27]\\d\\d|[89]00)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:06|2[23568]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "250123456"
                                ],
                                [
                                    ,
                                    ,
                                    "7[237-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "720123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "RW",
                                250,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[7-9]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SA: [
                                ,
                                [
                                    ,
                                    ,
                                    "92\\d{7}|(?:[15]|8\\d)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "112345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "512345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "925\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "925012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "920\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "920012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SA",
                                966,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "5"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "81"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "811\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8110123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SB: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "40123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7421234"
                                ],
                                [
                                    ,
                                    ,
                                    "1[38]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "18123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[12]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "51123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                "SB",
                                677,
                                "0[01]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "7|8[4-9]|9(?:[1-8]|9[0-8])"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SC: [
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{4}|(?:[249]\\d|64)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4[2-46]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "4217123"
                                ],
                                [
                                    ,
                                    ,
                                    "2[125-8]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2510123"
                                ],
                                [
                                    ,
                                    ,
                                    "800[08]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8000000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "971\\d{4}|(?:64|95)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "6412345"
                                ],
                                "SC",
                                248,
                                "010|0[0-2]",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[246]|9[57]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:5\\d|8[35-7])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "153123456"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[0-2]|9[0-3569])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "911231234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SD",
                                249,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[19]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "8123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[02369]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "701234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20\\d{4,7}",
                                    ,
                                    ,
                                    ,
                                    "20123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "77[0-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "771234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "75[1-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "751234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SE",
                                46,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})",
                                        "$1-$2 $3",
                                        [
                                            "20"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "9(?:00|39|44|9)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})",
                                        "$1-$2 $3",
                                        [
                                            "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{2})",
                                        "$1-$2 $3",
                                        [
                                            "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{3})",
                                        "$1-$2 $3",
                                        [
                                            "9(?:00|39|44)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "10|7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4",
                                        [
                                            "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1-$2 $3 $4",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1-$2 $3 $4 $5",
                                        [
                                            "[26]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "20"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "9(?:00|39|44|9)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2,3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9(?:00|39|44)"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "10|7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4 $5",
                                        [
                                            "[26]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "74[02-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "740123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "10[1-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "102345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:25[245]|67[3-68])\\d{9}",
                                    ,
                                    ,
                                    ,
                                    "254123456789",
                                    ,
                                    ,
                                    [
                                        12
                                    ]
                                ]
                            ],
                            SG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "61234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:08[013-9]|95[0-2])\\d{4}|(?:8(?:0[1-7]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:18|8)00\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "18001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "19001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[12]\\d|666)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "31234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SG",
                                65,
                                "0[0-3]\\d",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4,5})",
                                        "$1",
                                        [
                                            "1[013-9]|77",
                                            "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[369]|8(?:0[1-8]|[1-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[369]|8(?:0[1-8]|[1-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7000\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "70001234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[256]\\d|8)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:[0-57-9]\\d|6[4-9])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "22158"
                                ],
                                [
                                    ,
                                    ,
                                    "[56]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "51234",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "262\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "26212",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                "SH",
                                290,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                "[256]",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[1-357][2-8]|4[24-8])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "31234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "80123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "89[1-3]\\d{2,5}|90\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "90123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "59012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SI",
                                386,
                                "00|10(?:22|66|88|99)",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,6})",
                                        "$1 $2",
                                        [
                                            "8[09]|9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "59|8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[37][01]|4[0139]|51|6"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[1-57]"
                                        ],
                                        "(0$1)"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d{4}|(?:[489]\\d|79)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "79\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "79123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4[015-8]|9\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "41234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[01]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "82[09]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "82012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "810(?:0[0-6]|[2-8]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "81021234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "880\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "88012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "85[0-5]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "85012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SJ",
                                47,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "79",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "02000"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "81[23]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "81212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ]
                            ],
                            SK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "221234567"
                                ],
                                [
                                    ,
                                    ,
                                    "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "912123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:00|[78]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[5-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "850123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6(?:02|5[0-4]|9[0-6])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "690123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "SK",
                                421,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "21"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[3-5][1-8]1",
                                            "[3-5][1-8]1[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "909",
                                            "9090"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1/$2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[689]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1/$2 $3 $4",
                                        [
                                            "[3-5]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{2})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "21"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "[3-5][1-8]1",
                                            "[3-5][1-8]1[67]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                                        "$1/$2 $3 $4",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[689]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1/$2 $3 $4",
                                        [
                                            "[3-5]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9090\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "9090123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "96\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "961234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SL: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[237-9]\\d|66)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22[2-4][2-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22221234",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "25123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SL",
                                232,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[236-9]"
                                        ],
                                        "(0$1)"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SM: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0549|[5-7]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0549(?:8[0157-9]|9\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "0549886377",
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[16]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "66661212",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[178]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[158]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "58001110",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SM",
                                378,
                                "00",
                                ,
                                ,
                                ,
                                "([89]\\d{5})$",
                                "0549$1",
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[89]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[5-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SN: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[378]\\d|93)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "301012345"
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "701234567"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "88[4689]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "884123456"
                                ],
                                [
                                    ,
                                    ,
                                    "81[02468]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "810123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "933301234"
                                ],
                                "SN",
                                221,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[379]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4012345",
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:15|(?:3[59]|4[89]|6\\d|7[79]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "71123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SO",
                                252,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "8[125]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{6})",
                                        "$1",
                                        [
                                            "[134]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{7})",
                                        "$1 $2",
                                        [
                                            "(?:2|90)4|[67]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[348]|64|79|90"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5,7})",
                                        "$1 $2",
                                        [
                                            "1|28|6[0-35-9]|77|9[2-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SR: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-5]|68|[78]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "211234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[124-7]|8[124-9])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7412345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "56\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "561234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                "SR",
                                597,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1-$2-$3",
                                        [
                                            "56"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "[2-5]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[6-8]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[89]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "181234567"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12|9[1257-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "977123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SS",
                                211,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[19]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ST: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:22|9\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2221234"
                                ],
                                [
                                    ,
                                    ,
                                    "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9812345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "ST",
                                239,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[29]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[67]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "70123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{4}(?:\\d{4})?",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{4}(?:\\d{4})?",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SV",
                                503,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[267]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SX: [
                                ,
                                [
                                    ,
                                    ,
                                    "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7215425678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7215205678",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SX",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "(5\\d{6})$|1",
                                "721$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "721",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-39]\\d{8}|[1-5]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ],
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "112345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-689]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "944567890",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "SY",
                                963,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-5]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[23][2-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "22171234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[6-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "76123456",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "08001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "900012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "70012345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                "SZ",
                                268,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[0237]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{5})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "9"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0800\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TA: [
                                ,
                                [
                                    ,
                                    ,
                                    "8\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TA",
                                290,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "8",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|649|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "649(?:266|712|9(?:4\\d|50))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6497121234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6492311234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "649(?:71[01]|966)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "6497101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "TC",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-479]\\d{6})$|1",
                                "649$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "649",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TD: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:22|[69]\\d|77)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "22(?:[37-9]0|5[0-5]|6[89])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22501234"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:6[0235689]|77|9\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "63012345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TD",
                                235,
                                "00|16",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[2679]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[279]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "22212345"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[019]|9[0-36-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "90112345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TG",
                                228,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[279]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TH: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "21234567",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "812345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:001800\\d|1800)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        10,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[08]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "601234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "TH",
                                66,
                                "00[1-9]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[13-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-57-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        3,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "372123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:0[0-57-9]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "917123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TJ",
                                992,
                                "810",
                                ,
                                ,
                                ,
                                ,
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{6})(\\d)(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "331",
                                            "3317"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "44[02-479]|[34]7"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d)(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "3[1-5]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[0-57-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-47]\\d{3,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[2-4]|[34]\\d)\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    "3101"
                                ],
                                [
                                    ,
                                    ,
                                    "7[2-4]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    "7290"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TK",
                                690,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TL: [
                                ,
                                [
                                    ,
                                    ,
                                    "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "2112345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[2-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "77212345",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "8012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "9012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "70\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7012345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TL",
                                670,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[2-489]|70"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-6]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "66123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TM",
                                993,
                                "810",
                                "8",
                                ,
                                ,
                                "8",
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "12"
                                        ],
                                        "(8 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                                        "$1 $2-$3-$4",
                                        [
                                            "[1-5]"
                                        ],
                                        "(8 $1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "6"
                                        ],
                                        "8 $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-57-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "30010123"
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "20123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8010\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "80101234"
                                ],
                                [
                                    ,
                                    ,
                                    "88\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "88123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8[12]10\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "81101234"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TN",
                                216,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-57-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TO: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "20123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7715123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0800\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "0800222",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55[0-37-9]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5510123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "TO",
                                676,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1-$2",
                                        [
                                            "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[5-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TR: [
                                ,
                                [
                                    ,
                                    ,
                                    "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5012345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",
                                    ,
                                    ,
                                    ,
                                    "8001234567",
                                    ,
                                    ,
                                    [
                                        10,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:8[89]8|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "592(?:21[12]|461)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "5922121234",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "850\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8500123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "TR",
                                90,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d)(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "444"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "512|8[01589]|90"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5(?:[0-59]|61)",
                                            "5(?:[0-59]|61[06])",
                                            "5(?:[0-59]|61[06]1)"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24][1-8]|3[1-9]"
                                        ],
                                        "(0$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{6,7})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "512|8[01589]|90"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "5(?:[0-59]|61)",
                                            "5(?:[0-59]|61[06])",
                                            "5(?:[0-59]|61[06]1)"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[24][1-8]|3[1-9]"
                                        ],
                                        "(0$1)",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{6,7})",
                                        "$1 $2 $3",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "512\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5123456789",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:444|811\\d{3})\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "444\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "4441444",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TT: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8682211234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8682911234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TT",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-46-8]\\d{6})$|1",
                                "868$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "868",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "868619\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8686191234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ]
                            ],
                            TV: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2|7\\d\\d|90)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[02-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "20123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[01]\\d|90)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "901234",
                                    ,
                                    ,
                                    [
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "TV",
                                688,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "2"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "90"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "221234567",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "912345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-79]\\d{6}|800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:[013-9]\\d\\d|2)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "203123456",
                                    ,
                                    ,
                                    [
                                        7,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "99\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "990123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "7012345678",
                                    ,
                                    ,
                                    [
                                        10,
                                        11
                                    ]
                                ],
                                "TW",
                                886,
                                "0(?:0[25-79]|19)",
                                "0",
                                "#",
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d)(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "202"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[258]0"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                                            "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[49]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4,5})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "50[0-46-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "500123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[25-8]\\d|41|90)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2[2-8]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "222345678"
                                ],
                                [
                                    ,
                                    ,
                                    "77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "621234567"
                                ],
                                [
                                    ,
                                    ,
                                    "80[08]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "900123456"
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:40|6[01])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "840123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "41\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "412345678"
                                ],
                                "TZ",
                                255,
                                "00[056]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[24]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "5"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[67]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[89]\\d{9}|[3-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "311234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "501234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800[1-8]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "900[239]\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "900212345"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "89[1-579]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "891234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "UA",
                                380,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                "0~0",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                                            "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                                            "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[3-7]|89|9[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UG: [
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "312345678",
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "726[01]\\d{5}|7(?:[015-8]\\d|20|36|4[0-4]|9[89])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712345678"
                                ],
                                [
                                    ,
                                    ,
                                    "800[1-3]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    "90[1-3]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "901123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "UG",
                                256,
                                "00[057]",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "202",
                                            "2024"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "[27-9]|4(?:6[45]|[7-9])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[34]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            US: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{9}|3\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2015550123",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "2015550123",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "US",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "1",
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "310"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "[24-9]|3(?:[02-9]|1[1-9])"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "($1) $2-$3",
                                        [
                                            "[2-9]"
                                        ],
                                        ,
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1-$2",
                                        [
                                            "310"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1-$2-$3",
                                        [
                                            "[2-9]"
                                        ]
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                1,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UY: [
                                ,
                                [
                                    ,
                                    ,
                                    "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12,
                                        13
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:770|9(?:20|87))|(?:2\\d|4[2-7])\\d\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "21231234",
                                    ,
                                    ,
                                    [
                                        8
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[1-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "94231234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0004\\d{2,9}|(?:405|80[05])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "8001234"
                                ],
                                [
                                    ,
                                    ,
                                    "90[0-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "UY",
                                598,
                                "0(?:0|1[3-9]\\d)",
                                "0",
                                " int. ",
                                ,
                                "0",
                                ,
                                "00",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[49]0|8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "9"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[124]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "0"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3 $4",
                                        [
                                            "0"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:20|33|[5-79]\\d|88)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "669050123"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:(?:[25]0|33|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "912345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "UZ",
                                998,
                                "810",
                                "8",
                                ,
                                ,
                                "8",
                                ,
                                "8~10",
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[235-9]"
                                        ],
                                        "8 $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VA: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "06698\\d{1,6}",
                                    ,
                                    ,
                                    ,
                                    "0669812345",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8,
                                        9,
                                        10,
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3123456789",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:0\\d{3}|3)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "800123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "899123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "84(?:[08]\\d{3}|[17])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "848123456",
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:78\\d|99)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "1781234567",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "55\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "5512345678",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "VA",
                                39,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "06698",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "3[2-8]\\d{9,10}",
                                    ,
                                    ,
                                    ,
                                    "33101234501",
                                    ,
                                    ,
                                    [
                                        11,
                                        12
                                    ]
                                ]
                            ],
                            VC: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d\\d|784|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7842661234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7844301234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "78451[0-2]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "7845101234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "VC",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-7]\\d{6})$|1",
                                "784$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "784",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2121234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "4(?:1[24-8]|2[46])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "4121234567"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "8001234567"
                                ],
                                [
                                    ,
                                    ,
                                    "90[01]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "9001234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "VE",
                                58,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{7})",
                                        "$1-$2",
                                        [
                                            "[24-689]"
                                        ],
                                        "0$1",
                                        "$CC $1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "501\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "5010123456",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VG: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:284|[58]\\d\\d|900)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2842291234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "2843001234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "VG",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-578]\\d{6})$|1",
                                "284$1",
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "284",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[58]\\d{9}|(?:34|90)0\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        10
                                    ],
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3406421234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "3406421234",
                                    ,
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8002345678"
                                ],
                                [
                                    ,
                                    ,
                                    "900[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "9002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "5002345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "VI",
                                1,
                                "011",
                                "1",
                                ,
                                ,
                                "([2-9]\\d{6})$|1",
                                "340$1",
                                ,
                                1,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                "340",
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "2101234567",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "912345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "1800123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1900\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "1900123456",
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "672\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "672012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "VN",
                                84,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[17]99"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4,5})",
                                        "$1 $2",
                                        [
                                            "69"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "6"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[357-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[48]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "80"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4,6})",
                                        "$1 $2",
                                        [
                                            "1"
                                        ],
                                        ,
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "6"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[357-9]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "2[48]"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "2"
                                        ],
                                        "0$1",
                                        ,
                                        1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[17]99\\d{4}|69\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
                                    ,
                                    ,
                                    ,
                                    "1992000",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "22123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[58]\\d|7[013-7])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "5912345",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "81[18]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "81123",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:0[1-9]|1[01])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "9010123",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                "VU",
                                678,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[57-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:3[03]|900\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "30123"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            WF: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        6,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "72\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "721234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:72|8[23])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "821234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80[0-5]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800012345",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "WF",
                                681,
                                "00",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3",
                                        [
                                            "[478]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                                        "$1 $2 $3 $4",
                                        [
                                            "8"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[48]0\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "401234",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ]
                            ],
                            WS: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "22123",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "7212345",
                                    ,
                                    ,
                                    [
                                        7,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "800123",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "WS",
                                685,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{5})",
                                        "$1",
                                        [
                                            "[2-5]|6[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,7})",
                                        "$1 $2",
                                        [
                                            "[68]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "7"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            XK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2[89]|39)0\\d{6}|[23][89]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "28012345"
                                ],
                                [
                                    ,
                                    ,
                                    "4[3-9]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "43201234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "80001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "90001234",
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "XK",
                                383,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "[89]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[2-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[23]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YE: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "1234567",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7[01378]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "712345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "YE",
                                967,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-6]|7(?:[24-6]|8[0-7])"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YT: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "269601234"
                                ],
                                [
                                    ,
                                    ,
                                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "639012345"
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "939801234"
                                ],
                                "YT",
                                262,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-79]\\d{8}|8\\d{4,9}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "101234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "711234567",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "801234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:86[2-9]|9[0-2]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "862345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "860\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "860123456",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
                                    ,
                                    ,
                                    ,
                                    "871234567",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                "ZA",
                                27,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})",
                                        "$1 $2",
                                        [
                                            "8[1-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{2,3})",
                                        "$1 $2 $3",
                                        [
                                            "8[1-4]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "860"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1-9]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "861\\d{6,7}",
                                    ,
                                    ,
                                    ,
                                    "861123456",
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZM: [
                                ,
                                [
                                    ,
                                    ,
                                    "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "21[1-8]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "211234567",
                                    ,
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:7[5-79]|9[5-8])\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "955123456"
                                ],
                                [
                                    ,
                                    ,
                                    "800\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "800123456"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "63\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "630123456"
                                ],
                                "ZM",
                                260,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})",
                                        "$1 $2",
                                        [
                                            "[1-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[28]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[79]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[28]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "[79]"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZW: [
                                ,
                                [
                                    ,
                                    ,
                                    "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        7,
                                        8,
                                        9,
                                        10
                                    ],
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "1312345",
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "7(?:[178]\\d|3[1-9])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "712345678",
                                    ,
                                    ,
                                    [
                                        9
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "80(?:[01]\\d|20|8[0-8])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "8001234",
                                    ,
                                    ,
                                    [
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "8686123456",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ],
                                "ZW",
                                263,
                                "00",
                                "0",
                                ,
                                ,
                                "0",
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{2,4})",
                                        "$1 $2 $3",
                                        [
                                            "[49]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "80"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{7})",
                                        "$1 $2",
                                        [
                                            "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                                            "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                                        ],
                                        "(0$1)"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "7"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                                            "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "8"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3})(\\d{3,4})",
                                        "$1 $2 $3",
                                        [
                                            "29[013-9]|39|54"
                                        ],
                                        "0$1"
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{3,5})",
                                        "$1 $2",
                                        [
                                            "(?:25|54)8",
                                            "258|5483"
                                        ],
                                        "0$1"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            800: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:00|[1-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:00|[1-9]\\d)\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                800,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "\\d"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            808: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "12345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                808,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})",
                                        "$1 $2",
                                        [
                                            "[1-9]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            870: [
                                ,
                                [
                                    ,
                                    ,
                                    "7\\d{11}|[35-7]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "301234567"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                870,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "[35-7]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            878: [
                                ,
                                [
                                    ,
                                    ,
                                    "10\\d{10}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "10\\d{10}",
                                    ,
                                    ,
                                    ,
                                    "101234567890"
                                ],
                                "001",
                                878,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "1"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            881: [
                                ,
                                [
                                    ,
                                    ,
                                    "6\\d{9}|[0-36-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9,
                                        10
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "6\\d{9}|[0-36-9]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "612345678"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                881,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "[0-37-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d)(\\d{3})(\\d{5,6})",
                                        "$1 $2 $3",
                                        [
                                            "6"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            882: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "3421234",
                                    ,
                                    ,
                                    [
                                        7,
                                        8,
                                        9,
                                        10,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "390123456789"
                                ],
                                "001",
                                882,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    [
                                        ,
                                        "(\\d{2})(\\d{5})",
                                        "$1 $2",
                                        [
                                            "16|342"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{6})",
                                        "$1 $2",
                                        [
                                            "49"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{2})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "1[36]|9"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "3[23]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{3,4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "16"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "10|23|3(?:[15]|4[57])|4|51"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "34"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{2})(\\d{4,5})(\\d{5})",
                                        "$1 $2 $3",
                                        [
                                            "[1-35]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "348[57]\\d{7}",
                                    ,
                                    ,
                                    ,
                                    "34851234567",
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ]
                            ],
                            883: [
                                ,
                                [
                                    ,
                                    ,
                                    "(?:[1-4]\\d|51)\\d{6,10}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        8,
                                        9,
                                        10,
                                        11,
                                        12
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
                                    ,
                                    ,
                                    ,
                                    "510012345"
                                ],
                                "001",
                                883,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{2,8})",
                                        "$1 $2 $3",
                                        [
                                            "[14]|2[24-689]|3[02-689]|51[24-9]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3",
                                        [
                                            "510"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "21"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{4})(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "51[13]"
                                        ]
                                    ],
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                                        "$1 $2 $3 $4",
                                        [
                                            "[235]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            888: [
                                ,
                                [
                                    ,
                                    ,
                                    "\\d{11}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        11
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                888,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d{3})(\\d{3})(\\d{5})",
                                        "$1 $2 $3"
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "\\d{11}",
                                    ,
                                    ,
                                    ,
                                    "12345678901"
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            979: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1359]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        9
                                    ],
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[1359]\\d{8}",
                                    ,
                                    ,
                                    ,
                                    "123456789",
                                    ,
                                    ,
                                    ,
                                    [
                                        8
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                "001",
                                979,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                1,
                                [
                                    [
                                        ,
                                        "(\\d)(\\d{4})(\\d{4})",
                                        "$1 $2 $3",
                                        [
                                            "[1359]"
                                        ]
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ]
                        }; /*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        i18n.phonenumbers.PhoneNumberUtil = function() {
                            this.regionToMetadataMap = {};
                        };
                        goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);
                        i18n.phonenumbers.Error = {
                            INVALID_COUNTRY_CODE: "Invalid country calling code",
                            NOT_A_NUMBER: "The string supplied did not seem to be a phone number",
                            TOO_SHORT_AFTER_IDD: "Phone number too short after IDD",
                            TOO_SHORT_NSN: "The string supplied is too short to be a phone number",
                            TOO_LONG: "The string supplied is too long to be a phone number"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1;
                        i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3;
                        i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250;
                        i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = "ZZ";
                        i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = {
                            54: "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [
                            52,
                            54,
                            55
                        ];
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = "+";
                        i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = "*";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ";ext=";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = "tel:";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ";phone-context=";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ";isub=";
                        i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            "\uFF10": "0",
                            "\uFF11": "1",
                            "\uFF12": "2",
                            "\uFF13": "3",
                            "\uFF14": "4",
                            "\uFF15": "5",
                            "\uFF16": "6",
                            "\uFF17": "7",
                            "\uFF18": "8",
                            "\uFF19": "9",
                            "\u0660": "0",
                            "\u0661": "1",
                            "\u0662": "2",
                            "\u0663": "3",
                            "\u0664": "4",
                            "\u0665": "5",
                            "\u0666": "6",
                            "\u0667": "7",
                            "\u0668": "8",
                            "\u0669": "9",
                            "\u06F0": "0",
                            "\u06F1": "1",
                            "\u06F2": "2",
                            "\u06F3": "3",
                            "\u06F4": "4",
                            "\u06F5": "5",
                            "\u06F6": "6",
                            "\u06F7": "7",
                            "\u06F8": "8",
                            "\u06F9": "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            "+": i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN,
                            "*": "*",
                            "#": "#"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = {
                            A: "2",
                            B: "2",
                            C: "2",
                            D: "3",
                            E: "3",
                            F: "3",
                            G: "4",
                            H: "4",
                            I: "4",
                            J: "5",
                            K: "5",
                            L: "5",
                            M: "6",
                            N: "6",
                            O: "6",
                            P: "7",
                            Q: "7",
                            R: "7",
                            S: "7",
                            T: "8",
                            U: "8",
                            V: "8",
                            W: "9",
                            X: "9",
                            Y: "9",
                            Z: "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            "\uFF10": "0",
                            "\uFF11": "1",
                            "\uFF12": "2",
                            "\uFF13": "3",
                            "\uFF14": "4",
                            "\uFF15": "5",
                            "\uFF16": "6",
                            "\uFF17": "7",
                            "\uFF18": "8",
                            "\uFF19": "9",
                            "\u0660": "0",
                            "\u0661": "1",
                            "\u0662": "2",
                            "\u0663": "3",
                            "\u0664": "4",
                            "\u0665": "5",
                            "\u0666": "6",
                            "\u0667": "7",
                            "\u0668": "8",
                            "\u0669": "9",
                            "\u06F0": "0",
                            "\u06F1": "1",
                            "\u06F2": "2",
                            "\u06F3": "3",
                            "\u06F4": "4",
                            "\u06F5": "5",
                            "\u06F6": "6",
                            "\u06F7": "7",
                            "\u06F8": "8",
                            "\u06F9": "9",
                            A: "2",
                            B: "2",
                            C: "2",
                            D: "3",
                            E: "3",
                            F: "3",
                            G: "4",
                            H: "4",
                            I: "4",
                            J: "5",
                            K: "5",
                            L: "5",
                            M: "6",
                            N: "6",
                            O: "6",
                            P: "7",
                            Q: "7",
                            R: "7",
                            S: "7",
                            T: "8",
                            U: "8",
                            V: "8",
                            W: "9",
                            X: "9",
                            Y: "9",
                            Z: "9"
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {
                            0: "0",
                            1: "1",
                            2: "2",
                            3: "3",
                            4: "4",
                            5: "5",
                            6: "6",
                            7: "7",
                            8: "8",
                            9: "9",
                            A: "A",
                            B: "B",
                            C: "C",
                            D: "D",
                            E: "E",
                            F: "F",
                            G: "G",
                            H: "H",
                            I: "I",
                            J: "J",
                            K: "K",
                            L: "L",
                            M: "M",
                            N: "N",
                            O: "O",
                            P: "P",
                            Q: "Q",
                            R: "R",
                            S: "S",
                            T: "T",
                            U: "U",
                            V: "V",
                            W: "W",
                            X: "X",
                            Y: "Y",
                            Z: "Z",
                            a: "A",
                            b: "B",
                            c: "C",
                            d: "D",
                            e: "E",
                            f: "F",
                            g: "G",
                            h: "H",
                            i: "I",
                            j: "J",
                            k: "K",
                            l: "L",
                            m: "M",
                            n: "N",
                            o: "O",
                            p: "P",
                            q: "Q",
                            r: "R",
                            s: "S",
                            t: "T",
                            u: "U",
                            v: "V",
                            w: "W",
                            x: "X",
                            y: "Y",
                            z: "Z",
                            "-": "-",
                            "\uFF0D": "-",
                            "\u2010": "-",
                            "\u2011": "-",
                            "\u2012": "-",
                            "\u2013": "-",
                            "\u2014": "-",
                            "\u2015": "-",
                            "\u2212": "-",
                            "/": "/",
                            "\uFF0F": "/",
                            " ": " ",
                            "\u3000": " ",
                            "\u2060": " ",
                            ".": ".",
                            "\uFF0E": "."
                        };
                        i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = "-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xa0\xad\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E";
                        i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
                        i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = "A-Za-z";
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = "+\uFF0B";
                        i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
                        i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
                        i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]+";
                        i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = new RegExp("([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "])");
                        i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]");
                        i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/;
                        i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = new RegExp("[^" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "#]+$");
                        i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/;
                        i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + "}";
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = "[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]*(?:[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + "]*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]){3,}[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]*";
                        i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = " ext. ";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ = "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]|" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ + ")";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*$";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_);
                        i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ = i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_;
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_ = "^(" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ + "\\.)*" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ + "\\.?$";
                        i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_);
                        i18n.phonenumbers.PhoneNumberUtil.extnDigits_ = function(a) {
                            return "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1," + a + "})";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_ = function() {
                            var a = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20"), b = "[ \xa0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)[:\\.\uFF0E]?[ \xa0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20") + "#?", c = "[ \xa0\\t,]*(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)[:\\.\uFF0E]?[ \xa0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?", d = "[- ]+" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("6") + "#", e = "[ \xa0\\t]*(?:,{2}|;)[:\\.\uFF0E]?[ \xa0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("15") + "#?", f = "[ \xa0\\t]*(?:,)+[:\\.\uFF0E]?[ \xa0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?";
                            return a + "|" + b + "|" + c + "|" + d + "|" + e + "|" + f;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = new RegExp("(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")$", "i");
                        i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + "$|^" + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + "(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")?$", "i");
                        i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/;
                        i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/;
                        i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/;
                        i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/;
                        i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/;
                        i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/;
                        i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = "001";
                        i18n.phonenumbers.PhoneNumberFormat = {
                            E164: 0,
                            INTERNATIONAL: 1,
                            NATIONAL: 2,
                            RFC3966: 3
                        };
                        i18n.phonenumbers.PhoneNumberType = {
                            FIXED_LINE: 0,
                            MOBILE: 1,
                            FIXED_LINE_OR_MOBILE: 2,
                            TOLL_FREE: 3,
                            PREMIUM_RATE: 4,
                            SHARED_COST: 5,
                            VOIP: 6,
                            PERSONAL_NUMBER: 7,
                            PAGER: 8,
                            UAN: 9,
                            VOICEMAIL: 10,
                            UNKNOWN: -1
                        };
                        i18n.phonenumbers.PhoneNumberUtil.MatchType = {
                            NOT_A_NUMBER: 0,
                            NO_MATCH: 1,
                            SHORT_NSN_MATCH: 2,
                            NSN_MATCH: 3,
                            EXACT_MATCH: 4
                        };
                        i18n.phonenumbers.PhoneNumberUtil.ValidationResult = {
                            IS_POSSIBLE: 0,
                            IS_POSSIBLE_LOCAL_ONLY: 4,
                            INVALID_COUNTRY_CODE: 1,
                            TOO_SHORT: 2,
                            INVALID_LENGTH: 5,
                            TOO_LONG: 3
                        };
                        i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(a) {
                            var b = a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
                            0 <= b ? (a = a.substring(b), a = a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ""), b = a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= b && (a = a.substring(0, b))) : a = "";
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(a) {
                            return a.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalize = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !0) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(a) {
                            var b = i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());
                            a.clear();
                            a.append(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !1);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(a) {
                            var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
                            return null != b && (b.hasNationalPrefix() || a.hasItalianLeadingZero()) && this.isNumberGeographical(a) ? this.getLengthOfNationalDestinationCode(a) : 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(a) {
                            if (a.hasExtension()) {
                                var b = a.clone();
                                b.clearExtension();
                            } else b = a;
                            b = this.format(b, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);
                            0 == b[0].length && b.shift();
                            return 2 >= b.length ? 0 : this.getNumberType(a) == i18n.phonenumbers.PhoneNumberType.MOBILE && (a = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()), "" != a) ? b[2].length + a.length : b[1].length;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a] || "";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
                            return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a) {
                                return isNaN(a);
                            });
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
                            return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a) {
                                return !isNaN(a);
                            }).map(function(a) {
                                return parseInt(a, 10);
                            });
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function() {
                            var a = Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);
                            return [].concat($jscomp.arrayFromIterable(this.getSupportedGlobalNetworkCallingCodes()), $jscomp.arrayFromIterable(a.map(function(b) {
                                return parseInt(b, 10);
                            })));
                        };
                        i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(a) {
                            return null != a && (1 != a.possibleLengthCount() || -1 != a.possibleLengthArray()[0]);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function(a) {
                            return null != a && (a.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a) || a.hasNationalNumberPattern());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(a) {
                            var b = [];
                            goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function(c) {
                                if (c != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && c != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
                                    var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a, c);
                                    i18n.phonenumbers.PhoneNumberUtil.descHasData_(d) && b.push(c);
                                }
                            });
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(a) {
                            return this.isValidRegionCode_(a) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)) : [];
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(a) {
                            a = this.getMetadataForNonGeographicalRegion(a);
                            return null == a ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(a, b, c) {
                            for(var d = new goog.string.StringBuffer, e, f, g = a.length, h = 0; h < g; ++h)e = a.charAt(h), f = b[e.toUpperCase()], null != f ? d.append(f) : c || d.append(e);
                            return d.toString();
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(a) {
                            return 0 == a.length || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(a) {
                            var b = this.getNumberType(a);
                            return b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_.includes(a.getCountryCodeOrDefault()) && b == i18n.phonenumbers.PhoneNumberType.MOBILE;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(a) {
                            return null != a && isNaN(a) && a.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(a) {
                            return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.format = function(a, b) {
                            if (0 == a.getNationalNumber() && a.hasRawInput()) {
                                var c = a.getRawInputOrDefault();
                                if (0 < c.length) return c;
                            }
                            c = a.getCountryCodeOrDefault();
                            var d = this.getNationalSignificantNumber(a);
                            if (b == i18n.phonenumbers.PhoneNumberFormat.E164) return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.E164, d, "");
                            if (!this.hasValidCountryCallingCode_(c)) return d;
                            var e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            a = this.maybeGetFormattedExtension_(a, e, b);
                            d = this.formatNsn_(d, e, b);
                            return this.prefixNumberWithCountryCallingCode_(c, b, d, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(a, b, c) {
                            var d = a.getCountryCodeOrDefault(), e = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(d)) return e;
                            var f = this.getRegionCodeForCountryCode(d);
                            f = this.getMetadataForRegionOrCallingCode_(d, f);
                            var g = this.chooseFormattingPatternForNumber_(c, e);
                            if (null != g) {
                                c = g.clone();
                                g = g.getNationalPrefixFormattingRuleOrDefault();
                                if (0 < g.length) {
                                    var h = f.getNationalPrefixOrDefault();
                                    0 < h.length ? (g = g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_, h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, "$1"), c.setNationalPrefixFormattingRule(g)) : c.clearNationalPrefixFormattingRule();
                                }
                                e = this.formatNsnUsingPattern_(e, c, b);
                            }
                            a = this.maybeGetFormattedExtension_(a, f, b);
                            return this.prefixNumberWithCountryCallingCode_(d, b, e, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(a, b) {
                            var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(c)) return d;
                            var e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            a = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            b = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b);
                            return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(a, b) {
                            return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == b ? this.getMetadataForNonGeographicalRegion(a) : this.getMetadataForRegion(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(a, b) {
                            return this.formatNationalNumberWithCarrierCode(a, 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? a.getPreferredDomesticCarrierCodeOrDefault() : b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(a, b, c) {
                            var d = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(d)) return a.hasRawInput() ? a.getRawInputOrDefault() : "";
                            var e = "";
                            a = a.clone();
                            a.clearExtension();
                            var f = this.getRegionCodeForCountryCode(d), g = this.getNumberType(a), h = g != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                            if (b == f) e = g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || g == i18n.phonenumbers.PhoneNumberType.MOBILE || g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, "BR" == f && e ? e = 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(a, "") : "" : d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (b = this.getMetadataForRegion(b), e = this.canBeInternationallyDialled(a) && this.testNumberLength_(this.getNationalSignificantNumber(a), b) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : e = (f == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || ("MX" == f || "CL" == f || "UZ" == f) && e) && this.canBeInternationallyDialled(a) ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            else if (h && this.canBeInternationallyDialled(a)) return c ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.E164);
                            return c ? e : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(a, b) {
                            if (!this.isValidRegionCode_(b)) return this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
                            if (!this.hasValidCountryCallingCode_(c)) return d;
                            if (c == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                                if (this.isNANPACountry(b)) return c + " " + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            } else if (c == this.getCountryCodeForValidRegion_(b)) return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            var e = this.getMetadataForRegion(b), f = e.getInternationalPrefixOrDefault();
                            b = "";
                            e.hasPreferredInternationalPrefix() ? b = e.getPreferredInternationalPrefixOrDefault() : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, f) && (b = f);
                            e = this.getRegionCodeForCountryCode(c);
                            e = this.getMetadataForRegionOrCallingCode_(c, e);
                            d = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            a = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            return 0 < b.length ? b + " " + c + " " + d + a : this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, d, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(a, b) {
                            if (a.hasRawInput() && !this.hasFormattingPatternForNumber_(a)) return a.getRawInputOrDefault();
                            if (!a.hasCountryCodeSource()) return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            switch(a.getCountryCodeSource()){
                                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
                                    b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                                    break;
                                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
                                    b = this.formatOutOfCountryCallingNumber(a, b);
                                    break;
                                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
                                    b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
                                    break;
                                default:
                                    var c = this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()), d = this.getNddPrefixForRegion(c, !0);
                                    b = this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                                    if (null != d && 0 != d.length && !this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(), d, c) && (c = this.getMetadataForRegion(c), d = this.getNationalSignificantNumber(a), c = this.chooseFormattingPatternForNumber_(c.numberFormatArray(), d), null != c)) {
                                        d = c.getNationalPrefixFormattingRuleOrDefault();
                                        var e = d.indexOf("$1");
                                        0 >= e || (d = d.substring(0, e), d = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d), 0 != d.length && (b = c.clone(), b.clearNationalPrefixFormattingRule(), b = this.formatByPattern(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [
                                            b
                                        ])));
                                    }
                            }
                            a = a.getRawInputOrDefault();
                            null != b && 0 < a.length && (c = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(b), d = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(a), c != d && (b = a));
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(a, b, c) {
                            a = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
                            if (goog.string.startsWith(a, b)) try {
                                return this.isValidNumber(this.parse(a.substring(b.length), c));
                            } catch (d) {}
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(a) {
                            var b = a.getCountryCodeOrDefault(), c = this.getRegionCodeForCountryCode(b);
                            b = this.getMetadataForRegionOrCallingCode_(b, c);
                            if (null == b) return !1;
                            a = this.getNationalSignificantNumber(a);
                            return null != this.chooseFormattingPatternForNumber_(b.numberFormatArray(), a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(a, b) {
                            var c = a.getRawInputOrDefault();
                            if (0 == c.length) return this.formatOutOfCountryCallingNumber(a, b);
                            var d = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(d)) return c;
                            c = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, !0);
                            var e = this.getNationalSignificantNumber(a);
                            if (3 < e.length) {
                                var f = c.indexOf(e.substring(0, 3));
                                -1 != f && (c = c.substring(f));
                            }
                            f = this.getMetadataForRegion(b);
                            if (d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                                if (this.isNANPACountry(b)) return d + " " + c;
                            } else if (null != f && d == this.getCountryCodeForValidRegion_(b)) {
                                d = this.chooseFormattingPatternForNumber_(f.numberFormatArray(), e);
                                if (null == d) return c;
                                d = d.clone();
                                d.setPattern("(\\d+)(.*)");
                                d.setFormat("$1$2");
                                return this.formatNsnUsingPattern_(c, d, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
                            }
                            b = "";
                            null != f && (b = f.getInternationalPrefixOrDefault(), b = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, b) ? b : f.getPreferredInternationalPrefixOrDefault());
                            f = this.getRegionCodeForCountryCode(d);
                            f = this.getMetadataForRegionOrCallingCode_(d, f);
                            a = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                            return 0 < b.length ? b + " " + d + " " + c + a : this.prefixNumberWithCountryCallingCode_(d, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, c, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(a) {
                            if (!a.hasNationalNumber()) return "";
                            var b = "" + a.getNationalNumber();
                            return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(a, b, c, d) {
                            switch(b){
                                case i18n.phonenumbers.PhoneNumberFormat.E164:
                                    return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + c + d;
                                case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
                                    return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + " " + c + d;
                                case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
                                    return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + "-" + c + d;
                                default:
                                    return c + d;
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(a, b, c, d) {
                            b = 0 == b.intlNumberFormatArray().length || c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? b.numberFormatArray() : b.intlNumberFormatArray();
                            b = this.chooseFormattingPatternForNumber_(b, a);
                            return null == b ? a : this.formatNsnUsingPattern_(a, b, c, d);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(a, b) {
                            for(var c, d = a.length, e = 0; e < d; ++e){
                                c = a[e];
                                var f = c.leadingDigitsPatternCount();
                                if (0 == f || 0 == b.search(c.getLeadingDigitsPattern(f - 1))) {
                                    if (f = new RegExp(c.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, b)) return c;
                                }
                            }
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(a, b, c, d) {
                            var e = b.getFormatOrDefault(), f = new RegExp(b.getPattern()), g = b.getDomesticCarrierCodeFormattingRuleOrDefault();
                            c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != d && 0 < d.length && 0 < g.length ? (b = g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, d), e = e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b), a = a.replace(f, e)) : (b = b.getNationalPrefixFormattingRuleOrDefault(), a = c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != b && 0 < b.length ? a.replace(f, e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b)) : a.replace(f, e));
                            c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (a = a.replace(new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ""), a = a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, "g"), "-"));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(a) {
                            return this.getExampleNumberForType(a, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(a, b) {
                            if (!this.isValidRegionCode_(a)) return null;
                            b = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a), b);
                            try {
                                if (b.hasExampleNumber()) return this.parse(b.getExampleNumber(), a);
                            } catch (c) {}
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(a) {
                            var b = this.getMetadataForNonGeographicalRegion(a);
                            if (null != b && (b = [
                                b.getMobile(),
                                b.getTollFree(),
                                b.getSharedCost(),
                                b.getVoip(),
                                b.getVoicemail(),
                                b.getUan(),
                                b.getPremiumRate()
                            ].find(function(c, d) {
                                return c.hasExampleNumber();
                            }), void 0 !== b)) try {
                                return this.parse("+" + a + b.getExampleNumber(), "ZZ");
                            } catch (c) {}
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(a, b, c) {
                            return a.hasExtension() && 0 != a.getExtension().length ? c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + a.getExtension() : b.hasPreferredExtnPrefix() ? b.getPreferredExtnPrefix() + a.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + a.getExtensionOrDefault() : "";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(a, b) {
                            switch(b){
                                case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
                                    return a.getPremiumRate();
                                case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
                                    return a.getTollFree();
                                case i18n.phonenumbers.PhoneNumberType.MOBILE:
                                    return a.getMobile();
                                case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
                                case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
                                    return a.getFixedLine();
                                case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
                                    return a.getSharedCost();
                                case i18n.phonenumbers.PhoneNumberType.VOIP:
                                    return a.getVoip();
                                case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
                                    return a.getPersonalNumber();
                                case i18n.phonenumbers.PhoneNumberType.PAGER:
                                    return a.getPager();
                                case i18n.phonenumbers.PhoneNumberType.UAN:
                                    return a.getUan();
                                case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
                                    return a.getVoicemail();
                                default:
                                    return a.getGeneralDesc();
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(a) {
                            var b = this.getRegionCodeForNumber(a);
                            b = this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(), b);
                            if (null == b) return i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                            a = this.getNationalSignificantNumber(a);
                            return this.getNumberTypeHelper_(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(a, b) {
                            return this.isNumberMatchingDesc_(a, b.getGeneralDesc()) ? this.isNumberMatchingDesc_(a, b.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(a, b.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(a, b.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(a, b.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(a, b.getPersonalNumber()) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : this.isNumberMatchingDesc_(a, b.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(a, b.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(a, b.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(a, b.getFixedLine()) ? b.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : !b.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(a) {
                            if (null == a) return null;
                            a = a.toUpperCase();
                            var b = this.regionToMetadataMap[a];
                            if (null == b) {
                                b = new goog.proto2.PbLiteSerializer;
                                var c = i18n.phonenumbers.metadata.countryToMetadata[a];
                                if (null == c) return null;
                                b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
                                this.regionToMetadataMap[a] = b;
                            }
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(a) {
                            return this.getMetadataForRegion("" + a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(a, b) {
                            var c = a.length;
                            return 0 < b.possibleLengthCount() && -1 == b.possibleLengthArray().indexOf(c) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(a) {
                            var b = this.getRegionCodeForNumber(a);
                            return this.isValidNumberForRegion(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(a, b) {
                            var c = a.getCountryCodeOrDefault(), d = this.getMetadataForRegionOrCallingCode_(c, b);
                            if (null == d || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != b && c != this.getCountryCodeForValidRegion_(b)) return !1;
                            a = this.getNationalSignificantNumber(a);
                            return this.getNumberTypeHelper_(a, d) != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(a) {
                            if (null == a) return null;
                            var b = a.getCountryCodeOrDefault();
                            b = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];
                            return null == b ? null : 1 == b.length ? b[0] : this.getRegionCodeForNumberFromRegionList_(a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(a, b) {
                            a = this.getNationalSignificantNumber(a);
                            for(var c, d = b.length, e = 0; e < d; e++){
                                c = b[e];
                                var f = this.getMetadataForRegion(c);
                                if (f.hasLeadingDigits()) {
                                    if (0 == a.search(f.getLeadingDigits())) return c;
                                } else if (this.getNumberTypeHelper_(a, f) != i18n.phonenumbers.PhoneNumberType.UNKNOWN) return c;
                            }
                            return null;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(a) {
                            a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
                            return null == a ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : a[0];
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(a) {
                            a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
                            return null == a ? [] : a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(a) {
                            return this.isValidRegionCode_(a) ? this.getCountryCodeForValidRegion_(a) : 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(a) {
                            var b = this.getMetadataForRegion(a);
                            if (null == b) throw Error("Invalid region code: " + a);
                            return b.getCountryCodeOrDefault();
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(a, b) {
                            a = this.getMetadataForRegion(a);
                            if (null == a) return null;
                            a = a.getNationalPrefixOrDefault();
                            if (0 == a.length) return null;
                            b && (a = a.replace("~", ""));
                            return a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(a) {
                            return null != a && i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_].includes(a.toUpperCase());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(a) {
                            if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a)) return !1;
                            a = new goog.string.StringBuffer(a);
                            this.maybeStripExtension(a);
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a.toString());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(a) {
                            a = this.isPossibleNumberWithReason(a);
                            return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(a, b) {
                            a = this.isPossibleNumberForTypeWithReason(a, b);
                            return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(a, b) {
                            return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(a, b, c) {
                            var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, c), e = 0 == d.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : d.possibleLengthArray();
                            d = d.possibleLengthLocalOnlyArray();
                            if (c == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) {
                                if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.FIXED_LINE))) c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c) && (e = e.concat(0 == c.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : c.possibleLengthArray()), e.sort(), 0 == d.length ? d = c.possibleLengthLocalOnlyArray() : (d = d.concat(c.possibleLengthLocalOnlyArray()), d.sort()));
                                else return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.MOBILE);
                            }
                            if (-1 == e[0]) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
                            a = a.length;
                            if (-1 < d.indexOf(a)) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
                            b = e[0];
                            return b == a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : b > a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : e[e.length - 1] < a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < e.indexOf(a, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(a) {
                            return this.isPossibleNumberForTypeWithReason(a, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(a, b) {
                            var c = this.getNationalSignificantNumber(a);
                            a = a.getCountryCodeOrDefault();
                            if (!this.hasValidCountryCallingCode_(a)) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
                            var d = this.getRegionCodeForCountryCode(a);
                            a = this.getMetadataForRegionOrCallingCode_(a, d);
                            return this.testNumberLengthForType_(c, a, b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(a, b) {
                            try {
                                return this.isPossibleNumber(this.parse(a, b));
                            } catch (c) {
                                return !1;
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(a) {
                            if (this.isValidNumber(a)) return !0;
                            var b = a.clone(), c = a.getNationalNumberOrDefault();
                            do if (c = Math.floor(c / 10), b.setNationalNumber(c), 0 == c || this.isPossibleNumberWithReason(b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) return !1;
                            while (!this.isValidNumber(b));
                            a.setNationalNumber(c);
                            return !0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(a, b) {
                            a = a.toString();
                            if (0 == a.length || "0" == a.charAt(0)) return 0;
                            for(var c, d = a.length, e = 1; e <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && e <= d; ++e)if (c = parseInt(a.substring(0, e), 10), c in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap) return b.append(a.substring(e)), c;
                            return 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(a, b, c, d, e) {
                            if (0 == a.length) return 0;
                            a = new goog.string.StringBuffer(a);
                            var f;
                            null != b && (f = b.getInternationalPrefix());
                            null == f && (f = "NonMatch");
                            f = this.maybeStripInternationalPrefixAndNormalize(a, f);
                            d && e.setCountryCodeSource(f);
                            if (f != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
                                if (a.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
                                b = this.extractCountryCode(a, c);
                                if (0 != b) return e.setCountryCode(b), b;
                                throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            }
                            if (null != b) {
                                f = b.getCountryCodeOrDefault();
                                var g = "" + f, h = a.toString();
                                if (goog.string.startsWith(h, g) && (g = new goog.string.StringBuffer(h.substring(g.length)), h = b.getGeneralDesc(), h = new RegExp(h.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(g, b, null), g = g.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, a.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h, g) || this.testNumberLength_(a.toString(), b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) return c.append(g), d && e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), e.setCountryCode(f), f;
                            }
                            e.setCountryCode(0);
                            return 0;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(a, b) {
                            var c = b.toString();
                            if (0 == c.search(a)) {
                                a = c.match(a)[0].length;
                                var d = c.substring(a).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
                                if (d && null != d[1] && 0 < d[1].length && "0" == i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d[1])) return !1;
                                b.clear();
                                b.append(c.substring(a));
                                return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(a, b) {
                            var c = a.toString();
                            if (0 == c.length) return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
                            if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(c)) return c = c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), a.clear(), a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
                            b = new RegExp(b);
                            i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);
                            return this.parsePrefixAsIdd_(b, a) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(a, b, c) {
                            var d = a.toString(), e = d.length, f = b.getNationalPrefixForParsing();
                            if (0 == e || null == f || 0 == f.length) return !1;
                            var g = new RegExp("^(?:" + f + ")");
                            if (e = g.exec(d)) {
                                f = new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault());
                                var h = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d), k = e.length - 1;
                                b = b.getNationalPrefixTransformRule();
                                if (null == b || 0 == b.length || null == e[k] || 0 == e[k].length) {
                                    if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d.substring(e[0].length))) return !1;
                                    null != c && 0 < k && null != e[k] && c.append(e[1]);
                                    a.set(d.substring(e[0].length));
                                } else {
                                    d = d.replace(g, b);
                                    if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f, d)) return !1;
                                    null != c && 0 < k && c.append(e[1]);
                                    a.set(d);
                                }
                                return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(a) {
                            var b = a.toString(), c = b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
                            if (0 <= c && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0, c))) {
                                for(var d = b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), e = d.length, f = 1; f < e; ++f)if (null != d[f] && 0 < d[f].length) return a.clear(), a.append(b.substring(0, c)), d[f];
                            }
                            return "";
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(a, b) {
                            return this.isValidRegionCode_(b) || null != a && 0 < a.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function(a, b) {
                            return this.parseHelper_(a, b, !1, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(a, b) {
                            if (!this.isValidRegionCode_(b) && 0 < a.length && a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            return this.parseHelper_(a, b, !0, !0);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(a, b) {
                            if (1 < a.length && "0" == a.charAt(0)) {
                                b.setItalianLeadingZero(!0);
                                for(var c = 1; c < a.length - 1 && "0" == a.charAt(c);)c++;
                                1 != c && b.setNumberOfLeadingZeros(c);
                            }
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(a, b, c, d) {
                            if (null == a) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (a.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
                            var e = new goog.string.StringBuffer;
                            this.buildNationalNumberForParsing_(a, e);
                            if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString())) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (d && !this.checkRegionForParsing_(e.toString(), b)) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
                            d = new i18n.phonenumbers.PhoneNumber;
                            c && d.setRawInput(a);
                            a = this.maybeStripExtension(e);
                            0 < a.length && d.setExtension(a);
                            var f = this.getMetadataForRegion(b);
                            a = new goog.string.StringBuffer;
                            var g = 0, h = e.toString();
                            try {
                                g = this.maybeExtractCountryCode(h, f, a, c, d);
                            } catch (k) {
                                if (k.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(h)) {
                                    if (h = h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), g = this.maybeExtractCountryCode(h, f, a, c, d), 0 == g) throw k;
                                } else throw k;
                            }
                            0 != g ? (e = this.getRegionCodeForCountryCode(g), e != b && (f = this.getMetadataForRegionOrCallingCode_(g, e))) : (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e), a.append(e.toString()), null != b ? (g = f.getCountryCodeOrDefault(), d.setCountryCode(g)) : c && d.clearCountryCodeSource());
                            if (a.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
                            null != f && (b = new goog.string.StringBuffer, e = new goog.string.StringBuffer(a.toString()), this.maybeStripNationalPrefixAndCarrierCode(e, f, b), f = this.testNumberLength_(e.toString(), f), g = i18n.phonenumbers.PhoneNumberUtil.ValidationResult, f != g.TOO_SHORT && f != g.IS_POSSIBLE_LOCAL_ONLY && f != g.INVALID_LENGTH && (a = e, c && 0 < b.toString().length && d.setPreferredDomesticCarrierCode(b.toString())));
                            c = a.toString();
                            a = c.length;
                            if (a < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
                            if (a > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
                            i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c, d);
                            d.setNationalNumber(parseInt(c, 10));
                            return d;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_ = function(a) {
                            var b = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
                            if (-1 === b) return null;
                            b += i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;
                            if (b >= a.length) return "";
                            var c = a.indexOf(";", b);
                            return -1 !== c ? a.substring(b, c) : a.substring(b);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_ = function(a) {
                            if (null == a) return !0;
                            if (0 === a.length) return !1;
                            var b = i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.exec(a);
                            a = i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_.exec(a);
                            return null !== b || null !== a;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(a, b) {
                            var c = i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_(a);
                            if (!i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_(c)) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
                            if (null != c) {
                                c.charAt(0) === i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && b.append(c);
                                c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);
                                c = 0 <= c ? c + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0;
                                var d = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
                                b.append(a.substring(c, d));
                            } else b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(null != a ? a : ""));
                            a = b.toString();
                            c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);
                            0 < c && (b.clear(), b.append(a.substring(0, c)));
                        };
                        i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(a) {
                            var b = new i18n.phonenumbers.PhoneNumber;
                            b.setCountryCode(a.getCountryCodeOrDefault());
                            b.setNationalNumber(a.getNationalNumberOrDefault());
                            0 < a.getExtensionOrDefault().length && b.setExtension(a.getExtensionOrDefault());
                            a.getItalianLeadingZero() && (b.setItalianLeadingZero(!0), b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));
                            return b;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(a, b) {
                            if ("string" == typeof a) try {
                                var c = this.parse(a, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
                            } catch (f) {
                                if (f.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE) return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                if ("string" != typeof b) {
                                    var d = this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());
                                    if (d != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
                                        try {
                                            c = this.parse(a, d);
                                        } catch (g) {
                                            return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                        }
                                        var e = this.isNumberMatch(c, b);
                                        return e == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : e;
                                    }
                                }
                                try {
                                    c = this.parseHelper_(a, null, !1, !1);
                                } catch (g) {
                                    return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                                }
                            }
                            else c = a.clone();
                            if ("string" == typeof b) try {
                                return e = this.parse(b, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_), this.isNumberMatch(a, e);
                            } catch (f) {
                                return f.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER : this.isNumberMatch(b, c);
                            }
                            else e = b.clone();
                            a = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);
                            e = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);
                            if (a.hasExtension() && e.hasExtension() && a.getExtension() != e.getExtension()) return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                            b = a.getCountryCodeOrDefault();
                            c = e.getCountryCodeOrDefault();
                            if (0 != b && 0 != c) return a.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : b == c && this.isNationalNumberSuffixOfTheOther_(a, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                            a.setCountryCode(0);
                            e.setCountryCode(0);
                            return a.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(a, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(a, b) {
                            a = "" + a.getNationalNumber();
                            b = "" + b.getNationalNumber();
                            return goog.string.endsWith(a, b) || goog.string.endsWith(b, a);
                        };
                        i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(a) {
                            var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
                            if (null == b) return !0;
                            a = this.getNationalSignificantNumber(a);
                            return !this.isNumberMatchingDesc_(a, b.getNoInternationalDialling());
                        };
                        i18n.phonenumbers.PhoneNumberUtil.matchesEntirely = function(a, b) {
                            return (a = "string" == typeof a ? b.match("^(?:" + a + ")$") : b.match(a)) && a[0].length == b.length ? !0 : !1;
                        };
                        i18n.phonenumbers.PhoneNumberUtil.matchesPrefix = function(a, b) {
                            return (a = "string" == typeof a ? b.match("^(?:" + a + ")") : b.match(a)) && goog.string.startsWith(b, a[0]) ? !0 : !1;
                        };
                        i18n.phonenumbers.shortnumbermetadata = {};
                        i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap = {
                            0: "AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ")
                        };
                        i18n.phonenumbers.shortnumbermetadata.countryToMetadata = {
                            AC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AD: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0268]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0268]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[0268]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[149]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|445[16]|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "445\\d",
                                    ,
                                    ,
                                    ,
                                    "4450",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            AF: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|19)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|19)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|19)|40404",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            AG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            AI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            AL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[15]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "50000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[7-9])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "123",
                                    ,
                                    ,
                                    ,
                                    "123",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "131|5\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "131",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ]
                            ],
                            AM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[148]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1|8[1-7])\\d\\d|40404",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            AO: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[235]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[235]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[235]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01389]\\d{1,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911",
                                    ,
                                    ,
                                    ,
                                    "19",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[017]|911",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911",
                                    ,
                                    ,
                                    ,
                                    "19"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "893\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "89300",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:337|893\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "3370",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            AS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[49]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "40404|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            AT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[168]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[0238]|3[03]|4[0-247])|1(?:16\\d\\d|4[58])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[12]2|33|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:17|23)))|2[0238]|3[03]|4(?:[0-247]|5[05]|84))|(?:61|8108[1-3])0",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "610|810\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "610",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-27]\\d{2,7}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:06|12|258885|55\\d)|733",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:2(?:34|456)|9\\d{4,6})",
                                    ,
                                    ,
                                    ,
                                    "1234",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:06|12)",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1[09]\\d|24733)|225|767",
                                    ,
                                    ,
                                    ,
                                    "225",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:258885|55\\d)",
                                    ,
                                    ,
                                    ,
                                    "1550",
                                    ,
                                    ,
                                    [
                                        4,
                                        7
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19\\d{4,6}",
                                    ,
                                    ,
                                    ,
                                    "190000",
                                    ,
                                    ,
                                    [
                                        6,
                                        7,
                                        8
                                    ]
                                ]
                            ],
                            AW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "100|911",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "100|911",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|18|76)|91[13]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            AX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|75[12]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            AZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[148]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "AZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)|(?:404|880)0",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:404|880)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:404|880)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            BA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:16\\d{3}|2[2-4])",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "12[2-4]",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    "122"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[2-689]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "988|[2359]11",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[2359]11",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "988|[2-689]11",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[468]11",
                                    ,
                                    ,
                                    ,
                                    "411"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1579]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-26]|[19]99",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-2]|[19]99",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:11|2[13])|(?:501|959)\\d|786",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "959\\d",
                                    ,
                                    ,
                                    ,
                                    "9590",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            BE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-35-8]|1[0269]|7(?:12|77)|813)|(?:116|8)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "1204",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-8]|16117|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|11[02679]|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "2000",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            BF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|50|6[06])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|50|6[06])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|111))|50|6[06])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0189]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:0[167]|81)\\d{3}|[19]99",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    "9[148]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "91000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "[19]99",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0[67]\\d{3}|88000|98555",
                                    ,
                                    ,
                                    ,
                                    "06000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "88000|98555",
                                    ,
                                    ,
                                    ,
                                    "88000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[16-9]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[237]|611",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[237]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "611|7(?:10|77)|888|900",
                                    ,
                                    ,
                                    ,
                                    "611",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:71|90)0",
                                    ,
                                    ,
                                    ,
                                    "710",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ]
                            ],
                            BJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[78]|7[3-5]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[78]",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|2[02-5]|60)|7[0-5]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "12[02-5]",
                                    ,
                                    ,
                                    ,
                                    "120",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "18",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            BN: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[135]",
                                    ,
                                    ,
                                    ,
                                    "991"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[135]",
                                    ,
                                    ,
                                    ,
                                    "991"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "99[135]",
                                    ,
                                    ,
                                    ,
                                    "991"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]|40404",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BQ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|76)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            BR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-69]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|28|9[023])|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "102|273\\d\\d|321",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)",
                                    ,
                                    ,
                                    ,
                                    "151",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "321"
                                ]
                            ],
                            BS: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:1[19]|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[19]",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:1[19]|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-6]|40404",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[7-9])",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[7-9])",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "131\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13100",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "131\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13100",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            BY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            BZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:0|11|22|66|77|9[09])",
                                    ,
                                    ,
                                    ,
                                    "90"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "BZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:0|11|90)",
                                    ,
                                    ,
                                    ,
                                    "90"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:0|11|22|66|77|9[09])",
                                    ,
                                    ,
                                    ,
                                    "90"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d\\d(?:\\d\\d(?:\\d(?:\\d{2})?)?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|988|[29]11",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|30000\\d{3}|[1-35-9]\\d{4,5}|[2-8]11|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[235-7]11",
                                    ,
                                    ,
                                    ,
                                    "211",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "300\\d{5}|[1-35-9]\\d{4,5}",
                                    ,
                                    ,
                                    ,
                                    "10000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6,
                                        8
                                    ]
                                ]
                            ],
                            CC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[348]|77|88)",
                                    ,
                                    ,
                                    ,
                                    "113",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[348]|77|88)",
                                    ,
                                    ,
                                    ,
                                    "113",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[348]|23|77|88)|40404",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            CF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|22\\d)",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|220)",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[478]|220)",
                                    ,
                                    ,
                                    ,
                                    "114"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[178]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[78]",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[126-8]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[278]|6\\d{3})|4[47])|5200",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:14|8[0-2589])\\d|543|83111",
                                    ,
                                    ,
                                    ,
                                    "543",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[278]|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[0145])|6(?:00|[1-46])|8(?:02|1[189]|[25]0|7|8[08]|99))|[2-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:4[035]|6[1-46])|1(?:41|60)\\d",
                                    ,
                                    ,
                                    ,
                                    "140",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:200|35)",
                                    ,
                                    ,
                                    ,
                                    "535",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    "200",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            CI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[01]|[78]0)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[01]|[78]0)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[01]|[78]0)|4443",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "444\\d",
                                    ,
                                    ,
                                    ,
                                    "4440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "444\\d",
                                    ,
                                    ,
                                    ,
                                    "4440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            CK: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[689]",
                                    ,
                                    ,
                                    ,
                                    "996"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[689]",
                                    ,
                                    ,
                                    ,
                                    "996"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "99[689]",
                                    ,
                                    ,
                                    ,
                                    "996"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:213|3[1-3])|434\\d|911",
                                    ,
                                    ,
                                    ,
                                    "131",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d",
                                    ,
                                    ,
                                    ,
                                    "1060",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "13[1-3]|911",
                                    ,
                                    ,
                                    ,
                                    "131",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:200|333)\\d",
                                    ,
                                    ,
                                    ,
                                    "2000",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d",
                                    ,
                                    ,
                                    ,
                                    "1060",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            CM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[37]|[37])",
                                    ,
                                    ,
                                    ,
                                    "13",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[37]|[37])",
                                    ,
                                    ,
                                    ,
                                    "13",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[37]|[37])|8711",
                                    ,
                                    ,
                                    ,
                                    "13"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "871\\d",
                                    ,
                                    ,
                                    ,
                                    "8710",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "871\\d",
                                    ,
                                    ,
                                    ,
                                    "8710",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            CN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[09]|20)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[09]|20)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00\\d\\d|1[029]|20)|95\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:00\\d\\d|12)|95\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-589]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[29]|23|32|56)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[29]|23|32|56)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|(?:29002|39003)9|40404|5930\\d\\d|85432|(?:[2359][57]|8(?:7|9\\d))\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "106"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:40|85)4\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:40|85)4\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            CR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1359]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:385|5(?:0[34]|51))\\d",
                                    ,
                                    ,
                                    ,
                                    "3850",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            CU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d\\d(?:\\d{3,4})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[4-7]|(?:116|204\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[4-6]",
                                    ,
                                    ,
                                    ,
                                    "104",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[4-7]|1(?:6111|8)|40)|2045252",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CV: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "13[0-2]",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "13[0-2]",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "13[0-2]",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|76)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            CX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|112",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|99)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|99)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|111))|99)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            CZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5\\d)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "CZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5\\d)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5\\d|99)|1(?:16|4)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[02]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|118\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[24]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[24]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[2-48]|6(?:00[06]|111))|619[0-2]|8(?:01|1[0238]|28|30|5[13]|8[18]))",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[39]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            DZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[47]|54\\d)",
                                    ,
                                    ,
                                    ,
                                    "14"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "DZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[47])",
                                    ,
                                    ,
                                    ,
                                    "14",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:055|12|[47]|548)|730",
                                    ,
                                    ,
                                    ,
                                    "14"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    ,
                                    "730",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ]
                            ],
                            EC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[12]|12)|911",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[12]|12)|911",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[12]|12)|911",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            EE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
                                    ,
                                    ,
                                    ,
                                    "123",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
                                    ,
                                    ,
                                    ,
                                    "126",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            EG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:2[23]|80)",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:2[23]|80)",
                                    ,
                                    ,
                                    ,
                                    "122",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:2[23]|[69]\\d{3}|80)|34400",
                                    ,
                                    ,
                                    ,
                                    "122"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "344\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "34400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "344\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "34400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            EH: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "EH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ER: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2-46]|(?:12[47]|20[12])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ER",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ES: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-379]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "016",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                ,
                                ,
                                ,
                                "ES",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "08[58]|112",
                                    ,
                                    ,
                                    ,
                                    "085",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                [
                                    ,
                                    ,
                                    "0(?:[16][0-2]|80|9[12])|21\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "010",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:3[34]|77)|[12]2\\d{1,4}",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "22000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            ET: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:07|11?|2|39?|9[17])",
                                    ,
                                    ,
                                    ,
                                    "91"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ET",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11?|2|39?|9[17])",
                                    ,
                                    ,
                                    ,
                                    "91"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:07|11?|2|39?|45|9[17])",
                                    ,
                                    ,
                                    ,
                                    "91"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[17]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:00[06]|1(?:1[17]|23)))|75[12]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0-579]\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[17]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[17]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75",
                                    ,
                                    ,
                                    ,
                                    "22"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            FK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d|999",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[39]\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "320\\d{3}|911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:32022|91)1",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:32022|91)1",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FO: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[24]|81\\d)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[24]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[248]|819)|1(?:4[124]|71|8[7-9])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            FR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-8]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:07|[13]3)|1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "366\\d\\d|3[2-9]\\d\\d|(?:118|[4-8]\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "3200",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "FR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "10(?:[134]4|2[23]|5\\d|99)|202\\d|634|70[06]|(?:106|61)[14]",
                                    ,
                                    ,
                                    ,
                                    "611",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",
                                    ,
                                    ,
                                    ,
                                    "224",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "114|[3-8]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ]
                            ],
                            GA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "18|1(?:3\\d|73)\\d",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3\\d\\d|730|8)",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3\\d\\d|730|8)",
                                    ,
                                    ,
                                    ,
                                    "18"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-46-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901",
                                    ,
                                    ,
                                    ,
                                    "202",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "1250",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            GD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            GE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[014]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11|33)|11[1-3]|[01]22",
                                    ,
                                    ,
                                    ,
                                    "011",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11|33)|11[1-3]|[01]22",
                                    ,
                                    ,
                                    ,
                                    "011",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11|33)|11[1-3]|40404|[01]22",
                                    ,
                                    ,
                                    ,
                                    "011"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            GF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14589]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1-3]|999",
                                    ,
                                    ,
                                    ,
                                    "191",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1-3]|999",
                                    ,
                                    ,
                                    ,
                                    "191",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[1-3]|40404|(?:54|83)00|999",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d|(?:54|83)0\\d",
                                    ,
                                    ,
                                    ,
                                    "5400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d|(?:54|83)0\\d",
                                    ,
                                    ,
                                    ,
                                    "5400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            GI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[158]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "8[1-69]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "8100",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[09])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "150|87\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "150",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[1-8]\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[6-8]|[6-8])",
                                    ,
                                    ,
                                    ,
                                    "16"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[6-8]|[6-8])",
                                    ,
                                    ,
                                    ,
                                    "16"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[6-8]|[6-8])",
                                    ,
                                    ,
                                    ,
                                    "16"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "12\\d|40404",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            GP: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[089]|1(?:2|6\\d{3})|66|99)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|12|66|99)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "113\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "11300",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:10|2[03])",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:10|2[03])",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "110|40404|1(?:2|[57]\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            GU: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GW: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[378]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[378]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[378]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            GY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[019]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[1-3]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "GY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[1-3]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]",
                                    ,
                                    ,
                                    ,
                                    "002"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "144\\d",
                                    ,
                                    ,
                                    ,
                                    "1440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "144\\d",
                                    ,
                                    ,
                                    ,
                                    "1440",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            HK: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[29]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[29]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "109|1(?:08|85\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "109",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "992",
                                    ,
                                    ,
                                    ,
                                    "992",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ]
                            ],
                            HN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199|40404",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            HR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "93",
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "118\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "11800",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])|9[34]",
                                    ,
                                    ,
                                    ,
                                    "93",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]",
                                    ,
                                    ,
                                    ,
                                    "93"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "139\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13900",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "139\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "13900",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            HT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[48]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[48]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[48]|40404",
                                    ,
                                    ,
                                    ,
                                    "114"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            HU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[457]|12|4[0-4]\\d)|1(?:16\\d|37|45)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "HU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[457]|12)",
                                    ,
                                    ,
                                    ,
                                    "104",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[457]|1(?:2|6(?:000|1(?:11|23))|800)|2(?:0[0-4]|1[013489]|2[0-5]|3[0-46]|4[0-24-68]|5[0-2568]|6[06]|7[0-25-7]|8[028]|9[08])|37(?:00|37|7[07])|4(?:0[0-5]|1[013-8]|2[034]|3[23]|4[02-9]|5(?:00|41|67))|777|8(?:1[27-9]|2[04]|40|[589]))",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:4[0-4]|77)\\d|1(?:18|2|45)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "184\\d",
                                    ,
                                    ,
                                    ,
                                    "1840",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            ID: [
                                ,
                                [
                                    ,
                                    ,
                                    "[178]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02389]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ID",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02389]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02389]|40\\d\\d|50264)|71400|89887",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:714|898)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "71400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "714\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "71400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[159]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "5[37]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "53000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "51\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "51000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "51210",
                                    ,
                                    ,
                                    ,
                                    "51210",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "51210|(?:118|5[037]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "11800",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "104\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "10400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "104\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "10400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "8(?:64|98)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "86400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            IN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12578]\\d{2,8}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8,
                                        9
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "11[67]\\d{4}|56161561",
                                    ,
                                    ,
                                    ,
                                    "1160000",
                                    ,
                                    ,
                                    [
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-28]|12|298)|2611",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:14(?:2[5-9]|[34]\\d)|757555)",
                                    ,
                                    ,
                                    ,
                                    "51425",
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])",
                                    ,
                                    ,
                                    ,
                                    "118",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7,
                                        8
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)",
                                    ,
                                    ,
                                    ,
                                    "139",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        7,
                                        8
                                    ]
                                ]
                            ],
                            IQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1479]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04]|15|22)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IQ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04]|15|22)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04]|15|22)|4432|71117|9988",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:443|711\\d|998)\\d",
                                    ,
                                    ,
                                    ,
                                    "4430",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:443|711\\d|998)\\d",
                                    ,
                                    ,
                                    ,
                                    "4430",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            IR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-68]|2[0-59]|9[0-579])|911",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[025]|25)|911",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:5[0-469]|8[0-489])\\d",
                                    ,
                                    ,
                                    ,
                                    "1500",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d",
                                    ,
                                    ,
                                    ,
                                    "1500",
                                    ,
                                    ,
                                    [
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "990\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "990000",
                                    ,
                                    ,
                                    [
                                        6
                                    ]
                                ]
                            ],
                            IS: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71\\d)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "14(?:0\\d|41)",
                                    ,
                                    ,
                                    ,
                                    "1400",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:415|90\\d)",
                                    ,
                                    ,
                                    ,
                                    "1415",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            IT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[2358]|6\\d{3})|87)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "IT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "43000",
                                    ,
                                    ,
                                    [
                                        5,
                                        7
                                    ]
                                ]
                            ],
                            JE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            JM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[029]|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[029]|911",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[029]|76)|9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "176",
                                    ,
                                    ,
                                    ,
                                    "176"
                                ]
                            ],
                            JO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[235]|1[2-6]|9[127])|911",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[0-4689]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "90000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[127])|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[2359]|1[0-68]|9[0-24-79])|9[0-4689]\\d{3}|911",
                                    ,
                                    ,
                                    ,
                                    "102"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "9[0-4689]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "90000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9[0-4689]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "90000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            JP: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d(?:\\d{7})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        10
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[089]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "JP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[09]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000[259]\\d{6}|1(?:0[24]|1[089]|44|89)",
                                    ,
                                    ,
                                    ,
                                    "102"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000[259]\\d{6}",
                                    ,
                                    ,
                                    ,
                                    "0002000000",
                                    ,
                                    ,
                                    [
                                        10
                                    ]
                                ]
                            ],
                            KE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "909\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "90900",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[24]|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d",
                                    ,
                                    ,
                                    ,
                                    "130"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "141"
                                ]
                            ],
                            KG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "10[1-3]|4040",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            KH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[146]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[7-9]|666",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[7-9]|666",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[7-9]|40404|666",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            KI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[179]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[2-5]|99[2-4]",
                                    ,
                                    ,
                                    ,
                                    "192",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[2-5]|99[2-4]",
                                    ,
                                    ,
                                    ,
                                    "192",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "103",
                                    ,
                                    ,
                                    ,
                                    "103",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[39]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "333|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "333"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KP: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]|819",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]|819",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]|819",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[27-9]|28|330|82)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[29]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[0-7]\\d|89887",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "898\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "89800",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KY: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            KZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[134]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "KZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-4]|12)|(?:3040|404)0",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:304\\d|404)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:304\\d|404)\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            LA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[015]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[015]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[015]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|40|75)|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|40|75)|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|40|75)|999",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LI: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[278]|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[278]|44)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02689]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[02689]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[3489]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "355|911",
                                    ,
                                    ,
                                    ,
                                    "355",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "355|911",
                                    ,
                                    ,
                                    ,
                                    "355",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "355|4040|8(?:400|933)|911",
                                    ,
                                    ,
                                    ,
                                    "355"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:404|8(?:40|93))\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:404|8(?:40|93))\\d",
                                    ,
                                    ,
                                    ,
                                    "4040",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            LS: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LT: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d(?:\\d(?:\\d{3})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11?|22?|33?)|1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[23]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[23]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[018]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-3]|11(?:[023]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1180|821\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1180",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-3]|11[023]",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    "1181",
                                    ,
                                    ,
                                    ,
                                    "1181",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "165\\d",
                                    ,
                                    ,
                                    ,
                                    "1650",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            LY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[013]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "LY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[013]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[013]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[59]|77)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MC: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|41|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MD: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|90[1-3]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ME: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ME",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|2[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|[78])",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|[78])",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|[78])",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MH: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ML: [
                                ,
                                [
                                    ,
                                    ,
                                    "[136-8]\\d{1,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)",
                                    ,
                                    ,
                                    ,
                                    "1220",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ML",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "37(?:433|575)|7400|8001\\d",
                                    ,
                                    ,
                                    ,
                                    "7400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3503\\d|(?:3[67]\\d|800)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "35030",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "7400",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ]
                            ],
                            MM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MN: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-35]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-35]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-35]",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MO: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MP: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MQ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MQ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[29]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "211|9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "211"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d{3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6(?:000|1(?:11|23)))",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[45]|99[59]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[45]|99[59]",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,4}|(?:8\\d\\d|99)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:02|1[89])",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:02|1[89])",
                                    ,
                                    ,
                                    ,
                                    "102",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[45]1",
                                    ,
                                    ,
                                    ,
                                    "141",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199|80400|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "804\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "80400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "804\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "80400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            MX: [
                                ,
                                [
                                    ,
                                    ,
                                    "[0579]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:6[0568]|80)|911",
                                    ,
                                    ,
                                    ,
                                    "060",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:530\\d|776)\\d",
                                    ,
                                    ,
                                    ,
                                    "7760",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:6[0568]|80)|911",
                                    ,
                                    ,
                                    ,
                                    "060",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-9]\\d|53053|7766|911",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "0(?:[249]0|[35][01])",
                                    ,
                                    ,
                                    ,
                                    "020",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            MY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1369]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|999",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "666\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "66600",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:3[23679]\\d|666)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "32000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            MZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[79]|9[78])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "MZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[79]|9[78])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[02-5]\\d\\d|1[79]|9[78])",
                                    ,
                                    ,
                                    ,
                                    "117"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    ,
                                    "10111",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:10|93)111|(?:1\\d|9)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "900"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[135]\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[5-8]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    "5(?:67|88)",
                                    ,
                                    ,
                                    ,
                                    "567",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-3578]\\d(?:\\d(?:\\d{3})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:18|[578])|723\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:18|[578])|723141",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NF: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|55|77)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|55|77)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|55|77)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    ,
                                    "199",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "199|40700",
                                    ,
                                    ,
                                    ,
                                    "199"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "407\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40700",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "407\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40700",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            NI: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12467]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[58]|2[08])|737\\d",
                                    ,
                                    ,
                                    ,
                                    "115"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[58]|2[08])",
                                    ,
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00",
                                    ,
                                    ,
                                    ,
                                    "115"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1349]\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "120\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[34]00\\d",
                                    ,
                                    ,
                                    ,
                                    "3000",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            NO: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[023]|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8[5-9]\\d|90)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NP: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-36]|12)|1(?:09|11)\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NP",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-2]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-2]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-2]|23|92)",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[019]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "01[05]|101|999",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "010",
                                    ,
                                    ,
                                    ,
                                    "010"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            NZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "\\d{3,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "018",
                                    ,
                                    ,
                                    ,
                                    "018",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "NZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",
                                    ,
                                    ,
                                    ,
                                    "018"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    "018"
                                ]
                            ],
                            OM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1444|999\\d",
                                    ,
                                    ,
                                    ,
                                    "1444"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "OM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1444|9999",
                                    ,
                                    ,
                                    ,
                                    "1444"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d",
                                    ,
                                    ,
                                    ,
                                    "1111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "10[2-4]|911",
                                    ,
                                    ,
                                    ,
                                    "102"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[67])",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[67])",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:05|1[67])",
                                    ,
                                    ,
                                    ,
                                    "105"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d{2,6}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|11[01]",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "000|11[01]",
                                    ,
                                    ,
                                    ,
                                    "000",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "000|1(?:1[01]|5\\d\\d|6\\d{2,5})",
                                    ,
                                    ,
                                    ,
                                    "000"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "16\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    "1600",
                                    ,
                                    ,
                                    [
                                        4,
                                        5,
                                        6,
                                        7
                                    ]
                                ]
                            ],
                            PH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[27]|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[27]|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[27]|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{1,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2\\d?|5)|[56])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:22?|5)|[56])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:122|3[014]|[56])|11[2457-9]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[7-9]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[13]\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]|3103",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "310\\d",
                                    ,
                                    ,
                                    ,
                                    "3100",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PR: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PS: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|66)",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "10[0-2]",
                                    ,
                                    ,
                                    ,
                                    "100",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|122|44|66|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "112\\d",
                                    ,
                                    ,
                                    ,
                                    "1120",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[257]|1(?:16\\d\\d|5[1589]|8[279])\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[25]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PW: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            PY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "PY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[1-9]\\d|911",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            QA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99\\d",
                                    ,
                                    ,
                                    ,
                                    "990",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "900",
                                    ,
                                    ,
                                    ,
                                    "900",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "QA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:00|[19]\\d)|(?:1|20|9[27]\\d)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|[578])",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[18]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:1(?:18[39]|[24])|8[48])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:1[24]|8[48])\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1200",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ]
                            ],
                            RS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9[2-4]",
                                    ,
                                    ,
                                    ,
                                    "92",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9[2-4]",
                                    ,
                                    ,
                                    ,
                                    "92",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[189]\\d{1,4}|9[2-4]",
                                    ,
                                    ,
                                    ,
                                    "92"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RU: [
                                ,
                                [
                                    ,
                                    ,
                                    "[01]\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|(?:0|10)[1-3]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|(?:0|10)[1-3]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|(?:0|10)[1-4]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            RW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[14]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[1245]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "RW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[12]",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|6\\d{3})|9(?:11|37|9[7-9])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:11|9[79])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "141\\d",
                                    ,
                                    ,
                                    ,
                                    "1410",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:10|41)\\d|90[24679]",
                                    ,
                                    ,
                                    ,
                                    "902",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SB: [
                                ,
                                [
                                    ,
                                    ,
                                    "[127-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SB",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SC: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[1468]|60)|999",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:[06]\\d|1[0-246-8]|2[0-8]|3[13]|4[0-2]|5[15]|7[124-6]|8[158]|9[015])|9(?:6\\d\\d|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SD: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-37-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|(?:3|6\\d)\\d\\d|414|77)|900\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "11811[89]|72\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "72000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|90000",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912",
                                    ,
                                    ,
                                    ,
                                    "220",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "7\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "70000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SG: [
                                ,
                                [
                                    ,
                                    ,
                                    "[179]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[359]",
                                    ,
                                    ,
                                    ,
                                    "993",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[359]",
                                    ,
                                    ,
                                    ,
                                    "993",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "772\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "77200",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SH: [
                                ,
                                [
                                    ,
                                    ,
                                    "[129]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}|26[01]\\d\\d|9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SI: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[23]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6\\d{3})|5[058])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5[058])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SL: [
                                ,
                                [
                                    ,
                                    ,
                                    "[069]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01|99)9",
                                    ,
                                    ,
                                    ,
                                    "019",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01|99)9",
                                    ,
                                    ,
                                    ,
                                    "019",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "(?:01|99)9|60400",
                                    ,
                                    ,
                                    ,
                                    "019"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "604\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "60400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "604\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "60400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SM: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[358]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[358]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[358]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SN: [
                                ,
                                [
                                    ,
                                    ,
                                    "[12]\\d{1,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:515|[78])|2(?:00|1)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "17",
                                    ,
                                    ,
                                    [
                                        2,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:0[246]|[468])\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "24000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17",
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]",
                                    ,
                                    ,
                                    ,
                                    "12"
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:01|2)\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "22000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "1[46]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "1400",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "2[468]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "24000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SO: [
                                ,
                                [
                                    ,
                                    ,
                                    "[57-9]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "555|888|999",
                                    ,
                                    ,
                                    ,
                                    "555"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "555|888|999",
                                    ,
                                    ,
                                    ,
                                    "555"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "555|777|888|999",
                                    ,
                                    ,
                                    ,
                                    "555"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SR: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    ,
                                    "115",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SS: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ST: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ST",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[149]\\d\\d(?:\\d{2,3})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "116\\d{3}|911",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "91[13]",
                                    ,
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "404\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "40400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            SX: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:19|88)",
                                    ,
                                    ,
                                    ,
                                    "919"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SX",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "919",
                                    ,
                                    ,
                                    ,
                                    "919"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:19|88)",
                                    ,
                                    ,
                                    ,
                                    "919"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SY: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[023]",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            SZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "SZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TD: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TD",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[78]",
                                    ,
                                    ,
                                    ,
                                    "17"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TG: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|7[127])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[78]|7[127])",
                                    ,
                                    ,
                                    ,
                                    "117",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:011|1[078]|7[127])",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TH: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:113|2[23]\\d|5(?:09|56))",
                                    ,
                                    ,
                                    ,
                                    "1113",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TH",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:669|9[19])",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d",
                                    ,
                                    ,
                                    ,
                                    "1103",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "114[89]",
                                    ,
                                    ,
                                    ,
                                    "1148",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TJ: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TJ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TL: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[25]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TL",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[25]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[02]|1[25]|2[0138]|72|9[07])",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TM: [
                                ,
                                [
                                    ,
                                    ,
                                    "0\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-49]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-3]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0[1-49]",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TN: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[078]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[078]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[078]",
                                    ,
                                    ,
                                    ,
                                    "190"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TO: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|22|33|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TO",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|22|33|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|22|33|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TR: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TR",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[02]|55)",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "(?:285|542)0",
                                    ,
                                    ,
                                    ,
                                    "2850",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d",
                                    ,
                                    ,
                                    ,
                                    "144",
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ]
                            ],
                            TT: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:88|9[09])",
                                    ,
                                    ,
                                    ,
                                    "988"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "99[09]",
                                    ,
                                    ,
                                    ,
                                    "990"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:88|9[09])",
                                    ,
                                    ,
                                    ,
                                    "988"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TV: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TV",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d|911",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TW: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0289]|1(?:81|92)\\d",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    "10[56]",
                                    ,
                                    ,
                                    ,
                                    "105",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[029]",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",
                                    ,
                                    ,
                                    ,
                                    "100"
                                ],
                                [
                                    ,
                                    ,
                                    "1(?:65|9(?:1\\d|50|85|98))",
                                    ,
                                    ,
                                    ,
                                    "165"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            TZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[149]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[0-79]|9[09])|999",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "TZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[0-245]|999",
                                    ,
                                    ,
                                    ,
                                    "110",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1\\d|9[09])|46400|999",
                                    ,
                                    ,
                                    ,
                                    "110"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "464\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "46400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "464\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "46400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            UA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[189]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|1(?:2|6\\d{3}))",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-3]|12)",
                                    ,
                                    ,
                                    ,
                                    "101",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "101"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "(?:118|[89]00)\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    "1180",
                                    ,
                                    ,
                                    [
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UG: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "999",
                                    ,
                                    ,
                                    ,
                                    "999"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            US: [
                                ,
                                [
                                    ,
                                    ,
                                    "[1-9]\\d{2,5}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5,
                                        6
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|611|9(?:11|33|88)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7",
                                    ,
                                    ,
                                    ,
                                    "24280",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "US",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|911",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-8]11|9(?:11|33|88)",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    "2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",
                                    ,
                                    ,
                                    ,
                                    "23333",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "336\\d\\d|[2-9]\\d{3}|[2356]11",
                                    ,
                                    ,
                                    ,
                                    "211",
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[2-9]\\d{4,5}",
                                    ,
                                    ,
                                    ,
                                    "20000",
                                    ,
                                    ,
                                    [
                                        5,
                                        6
                                    ]
                                ]
                            ],
                            UY: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d{2,3}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UY",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "128|911",
                                    ,
                                    ,
                                    ,
                                    "128",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0[4-9]|1[2368]|2[0-3568]|787)|911",
                                    ,
                                    ,
                                    ,
                                    "104"
                                ],
                                [
                                    ,
                                    ,
                                    "178\\d",
                                    ,
                                    ,
                                    ,
                                    "1780",
                                    ,
                                    ,
                                    [
                                        4
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            UZ: [
                                ,
                                [
                                    ,
                                    ,
                                    "[04]\\d(?:\\d(?:\\d{2})?)?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:0[1-3]|[1-3]|50)",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "UZ",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:0[1-3]|[1-3]|50)",
                                    ,
                                    ,
                                    ,
                                    "01",
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "0(?:0[1-3]|[1-3]|50)|45400",
                                    ,
                                    ,
                                    ,
                                    "01"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "454\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "45400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "454\\d\\d",
                                    ,
                                    ,
                                    ,
                                    "45400",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            VA: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[2358]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VC: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VC",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VE: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|71)|911",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VG: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VG",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88|99)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VI: [
                                ,
                                [
                                    ,
                                    ,
                                    "9\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VI",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "911",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|88)",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VN: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[3-5]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VN",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "11[3-5]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[3-5]",
                                    ,
                                    ,
                                    ,
                                    "113"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            VU: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "VU",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            WF: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "WF",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1[578]",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            WS: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[4-69])",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "WS",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "9(?:11|9[4-69])",
                                    ,
                                    ,
                                    ,
                                    "911"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])",
                                    ,
                                    ,
                                    ,
                                    "111"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "12[0-6]",
                                    ,
                                    ,
                                    ,
                                    "120"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            XK: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "XK",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|9[2-4])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YE: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1459]",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "YE",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "19[1459]",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "19[1459]",
                                    ,
                                    ,
                                    ,
                                    "191"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            YT: [
                                ,
                                [
                                    ,
                                    ,
                                    "1\\d\\d?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        2,
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "YT",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:12|5)",
                                    ,
                                    ,
                                    ,
                                    "15"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZA: [
                                ,
                                [
                                    ,
                                    ,
                                    "[134]\\d{2,4}",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        4,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:01\\d\\d|12)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "41(?:348|851)",
                                    ,
                                    ,
                                    ,
                                    "41348",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ZA",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:01(?:11|77)|12)",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "107"
                                ],
                                [
                                    ,
                                    ,
                                    "3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699",
                                    ,
                                    ,
                                    ,
                                    "30782",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    ,
                                    "111",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "[34]\\d{4}",
                                    ,
                                    ,
                                    ,
                                    "30000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ]
                            ],
                            ZM: [
                                ,
                                [
                                    ,
                                    ,
                                    "[19]\\d\\d",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[139]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ZM",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[139]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[139]",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ],
                            ZW: [
                                ,
                                [
                                    ,
                                    ,
                                    "[139]\\d\\d(?:\\d{2})?",
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        3,
                                        5
                                    ]
                                ],
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|9(?:5[023]|61|9[3-59])",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "3[013-57-9]\\d{3}",
                                    ,
                                    ,
                                    ,
                                    "30000",
                                    ,
                                    ,
                                    [
                                        5
                                    ]
                                ],
                                ,
                                ,
                                ,
                                "ZW",
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                ,
                                [
                                    ,
                                    ,
                                    "112|99[3-59]",
                                    ,
                                    ,
                                    ,
                                    "112",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    "11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])",
                                    ,
                                    ,
                                    ,
                                    "112"
                                ],
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ],
                                [
                                    ,
                                    ,
                                    "114|9(?:5[023]|6[0-25])",
                                    ,
                                    ,
                                    ,
                                    "114",
                                    ,
                                    ,
                                    [
                                        3
                                    ]
                                ],
                                ,
                                [
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    ,
                                    [
                                        -1
                                    ]
                                ]
                            ]
                        }; /*

 Copyright (C) 2018 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ 
                        i18n.phonenumbers.ShortNumberInfo = function() {
                            this.regionToMetadataMap = {};
                        };
                        goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo);
                        i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_ = [
                            "BR",
                            "CL",
                            "NI"
                        ];
                        i18n.phonenumbers.ShortNumberInfo.ShortNumberCost = {
                            TOLL_FREE: 0,
                            STANDARD_RATE: 1,
                            PREMIUM_RATE: 2,
                            UNKNOWN_COST: 3
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_ = function(a) {
                            return (a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a]) ? a : [];
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_ = function(a, b) {
                            a = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            return null != b && a.includes(b);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            b = this.getMetadataForRegion_(b);
                            if (!b) return !1;
                            a = this.getNationalSignificantNumber_(a).length;
                            return b.getGeneralDesc().possibleLengthArray().includes(a);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber = function(a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            a = this.getNationalSignificantNumber_(a).length;
                            for(var c = 0; c < b.length; c++){
                                var d = this.getMetadataForRegion_(b[c]);
                                if (d && d.getGeneralDesc().possibleLengthArray().includes(a)) return !0;
                            }
                            return !1;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            b = this.getMetadataForRegion_(b);
                            if (!b) return !1;
                            a = this.getNationalSignificantNumber_(a);
                            var c = b.getGeneralDesc();
                            if (!this.matchesPossibleNumberAndNationalNumber_(a, c)) return !1;
                            b = b.getShortCode();
                            return this.matchesPossibleNumberAndNationalNumber_(a, b);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber = function(a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault()), c = this.getRegionCodeForShortNumberFromRegionList_(a, b);
                            return 1 < b.length && null != c ? !0 : this.isValidShortNumberForRegion(a, c);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion = function(a, b) {
                            var c = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return c.UNKNOWN_COST;
                            var d = this.getMetadataForRegion_(b);
                            if (!d) return c.UNKNOWN_COST;
                            a = this.getNationalSignificantNumber_(a);
                            return d.getGeneralDesc().possibleLengthArray().includes(a.length) ? this.matchesPossibleNumberAndNationalNumber_(a, d.getPremiumRate()) ? c.PREMIUM_RATE : this.matchesPossibleNumberAndNationalNumber_(a, d.getStandardRate()) ? c.STANDARD_RATE : this.matchesPossibleNumberAndNationalNumber_(a, d.getTollFree()) || this.isEmergencyNumber(a, b) ? c.TOLL_FREE : c.UNKNOWN_COST : c.UNKNOWN_COST;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost = function(a) {
                            var b = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, c = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            if (0 === c.length) return b.UNKNOWN_COST;
                            if (1 === c.length) return this.getExpectedCostForRegion(a, c[0]);
                            for(var d = b.TOLL_FREE, e = 0; e < c.length; e++){
                                var f = this.getExpectedCostForRegion(a, c[e]);
                                switch(f){
                                    case b.PREMIUM_RATE:
                                        return b.PREMIUM_RATE;
                                    case b.UNKNOWN_COST:
                                        d = b.UNKNOWN_COST;
                                        break;
                                    case b.STANDARD_RATE:
                                        d !== b.UNKNOWN_COST && (d = b.STANDARD_RATE);
                                        break;
                                    case b.TOLL_FREE:
                                        break;
                                    default:
                                        throw Error("Unrecognized cost for region: " + f);
                                }
                            }
                            return d;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_ = function(a, b) {
                            if (0 === b.length) return null;
                            if (1 === b.length) return b[0];
                            a = this.getNationalSignificantNumber_(a);
                            for(var c = 0; c < b.length; c++){
                                var d = b[c], e = this.getMetadataForRegion_(d);
                                if (e && this.matchesPossibleNumberAndNationalNumber_(a, e.getShortCode())) return d;
                            }
                            return null;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions = function() {
                            return Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata).filter(function(a) {
                                return isNaN(a);
                            });
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber = function(a) {
                            a = this.getMetadataForRegion_(a);
                            if (!a) return "";
                            a = a.getShortCode();
                            return a.hasExampleNumber() ? a.getExampleNumber() || "" : "";
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost = function(a, b) {
                            a = this.getMetadataForRegion_(a);
                            if (!a) return "";
                            var c = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, d = null;
                            switch(b){
                                case c.TOLL_FREE:
                                    d = a.getTollFree();
                                    break;
                                case c.STANDARD_RATE:
                                    d = a.getStandardRate();
                                    break;
                                case c.PREMIUM_RATE:
                                    d = a.getPremiumRate();
                            }
                            return d && d.hasExampleNumber() ? d.getExampleNumber() || "" : "";
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber = function(a, b) {
                            return this.matchesEmergencyNumberHelper_(a, b, !0);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber = function(a, b) {
                            return this.matchesEmergencyNumberHelper_(a, b, !1);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_ = function(a) {
                            if (!a) return null;
                            a = a.toUpperCase();
                            var b = this.regionToMetadataMap[a];
                            if (null == b) {
                                b = new goog.proto2.PbLiteSerializer;
                                var c = i18n.phonenumbers.shortnumbermetadata.countryToMetadata[a];
                                if (null == c) return null;
                                b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
                                this.regionToMetadataMap[a] = b;
                            }
                            return b;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_ = function(a, b, c) {
                            var d = i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a);
                            if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d)) return !1;
                            a = this.getMetadataForRegion_(b);
                            if (null == a || !a.hasEmergency()) return !1;
                            d = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d);
                            b = c && !i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_.includes(b);
                            c = a.getEmergency().getNationalNumberPatternOrDefault();
                            return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(c, d) || b && i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(c, d);
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific = function(a) {
                            var b = this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());
                            b = this.getRegionCodeForShortNumberFromRegionList_(a, b);
                            a = this.getNationalSignificantNumber_(a);
                            b = this.getMetadataForRegion_(b);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getCarrierSpecific());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            a = this.getNationalSignificantNumber_(a);
                            b = this.getMetadataForRegion_(b);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getCarrierSpecific());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion = function(a, b) {
                            if (!this.regionDialingFromMatchesNumber_(a, b)) return !1;
                            b = this.getMetadataForRegion_(b);
                            a = this.getNationalSignificantNumber_(a);
                            return !!b && this.matchesPossibleNumberAndNationalNumber_(a, b.getSmsServices());
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_ = function(a) {
                            if (!a.hasNationalNumber()) return "";
                            var b = "" + a.getNationalNumber();
                            return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
                        };
                        i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_ = function(a, b) {
                            return 0 < b.possibleLengthArray().length && !b.possibleLengthArray().includes(a.length) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(), a.toString());
                        };
                        i18n.phonenumbers.AsYouTypeFormatter = function(a) {
                            this.DIGIT_PLACEHOLDER_ = "\u2008";
                            this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_);
                            this.currentOutput_ = "";
                            this.formattingTemplate_ = new goog.string.StringBuffer;
                            this.currentFormattingPattern_ = "";
                            this.accruedInput_ = new goog.string.StringBuffer;
                            this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer;
                            this.ableToFormat_ = !0;
                            this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = !1;
                            this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance();
                            this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0;
                            this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer;
                            this.shouldAddSpaceAfterNationalPrefix_ = !1;
                            this.extractedNationalPrefix_ = "";
                            this.nationalNumber_ = new goog.string.StringBuffer;
                            this.possibleFormats_ = [];
                            this.defaultCountry_ = a;
                            this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = " ";
                        i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata;
                        i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA");
                        i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*\\$1[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*(\\$\\d[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*)*$");
                        i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/;
                        i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3;
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(a) {
                            a = this.phoneUtil_.getCountryCodeForRegion(a);
                            a = this.phoneUtil_.getRegionCodeForCountryCode(a);
                            a = this.phoneUtil_.getMetadataForRegion(a);
                            return null != a ? a : i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
                            for(var a = this.possibleFormats_.length, b = 0; b < a; ++b){
                                var c = this.possibleFormats_[b], d = c.getPatternOrDefault();
                                if (this.currentFormattingPattern_ == d) return !1;
                                if (this.createFormattingTemplate_(c)) return this.currentFormattingPattern_ = d, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, !0;
                            }
                            return this.ableToFormat_ = !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(a) {
                            for(var b = this.isCompleteNumber_ && 0 == this.extractedNationalPrefix_.length && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), c = b.length, d = 0; d < c; ++d){
                                var e = b[d];
                                0 < this.extractedNationalPrefix_.length && this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault()) && !e.getNationalPrefixOptionalWhenFormatting() && !e.hasDomesticCarrierCodeFormattingRule() || (0 != this.extractedNationalPrefix_.length || this.isCompleteNumber_ || this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault()) || e.getNationalPrefixOptionalWhenFormatting()) && i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(e.getFormatOrDefault()) && this.possibleFormats_.push(e);
                            }
                            this.narrowDownPossibleFormats_(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(a) {
                            for(var b = [], c = a.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, d = this.possibleFormats_.length, e = 0; e < d; ++e){
                                var f = this.possibleFormats_[e];
                                if (0 == f.leadingDigitsPatternCount()) b.push(this.possibleFormats_[e]);
                                else {
                                    var g = Math.min(c, f.leadingDigitsPatternCount() - 1);
                                    f = f.getLeadingDigitsPattern(g);
                                    0 == a.search(f) && b.push(this.possibleFormats_[e]);
                                }
                            }
                            this.possibleFormats_ = b;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(a) {
                            var b = a.getPatternOrDefault();
                            this.formattingTemplate_.clear();
                            a = this.getFormattingTemplate_(b, a.getFormatOrDefault());
                            return 0 < a.length ? (this.formattingTemplate_.append(a), !0) : !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(a, b) {
                            var c = "999999999999999".match(a)[0];
                            if (c.length < this.nationalNumber_.getLength()) return "";
                            a = c.replace(new RegExp(a, "g"), b);
                            return a = a.replace(/9/g, this.DIGIT_PLACEHOLDER_);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
                            this.currentOutput_ = "";
                            this.accruedInput_.clear();
                            this.accruedInputWithoutFormatting_.clear();
                            this.formattingTemplate_.clear();
                            this.lastMatchPosition_ = 0;
                            this.currentFormattingPattern_ = "";
                            this.prefixBeforeNationalNumber_.clear();
                            this.extractedNationalPrefix_ = "";
                            this.nationalNumber_.clear();
                            this.ableToFormat_ = !0;
                            this.inputHasFormatting_ = !1;
                            this.originalPosition_ = this.positionToRemember_ = 0;
                            this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = !1;
                            this.possibleFormats_ = [];
                            this.shouldAddSpaceAfterNationalPrefix_ = !1;
                            this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(a) {
                            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !1);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(a) {
                            return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !0);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(a, b) {
                            this.accruedInput_.append(a);
                            b && (this.originalPosition_ = this.accruedInput_.getLength());
                            this.isDigitOrLeadingPlusSign_(a) ? a = this.normalizeAndAccrueDigitsAndPlusSign_(a, b) : (this.ableToFormat_ = !1, this.inputHasFormatting_ = !0);
                            if (!this.ableToFormat_) {
                                if (!this.inputHasFormatting_) {
                                    if (this.attemptToExtractIdd_()) {
                                        if (this.attemptToExtractCountryCallingCode_()) return this.attemptToChoosePatternWithPrefixExtracted_();
                                    } else if (this.ableToExtractLongerNdd_()) return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
                                }
                                return this.accruedInput_.toString();
                            }
                            switch(this.accruedInputWithoutFormatting_.getLength()){
                                case 0:
                                case 1:
                                case 2:
                                    return this.accruedInput_.toString();
                                case 3:
                                    if (this.attemptToExtractIdd_()) this.isExpectingCountryCallingCode_ = !0;
                                    else return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
                                default:
                                    if (this.isExpectingCountryCallingCode_) return this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = !1), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString();
                                    if (0 < this.possibleFormats_.length) {
                                        a = this.inputDigitHelper_(a);
                                        b = this.attemptToFormatAccruedDigits_();
                                        if (0 < b.length) return b;
                                        this.narrowDownPossibleFormats_(this.nationalNumber_.toString());
                                        return this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(a) : this.accruedInput_.toString();
                                    }
                                    return this.attemptToChooseFormattingPattern_();
                            }
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
                            this.ableToFormat_ = !0;
                            this.isExpectingCountryCallingCode_ = !1;
                            this.possibleFormats_ = [];
                            this.lastMatchPosition_ = 0;
                            this.formattingTemplate_.clear();
                            this.currentFormattingPattern_ = "";
                            return this.attemptToChooseFormattingPattern_();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
                            return this.extractedNationalPrefix_;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
                            if (0 < this.extractedNationalPrefix_.length) {
                                var a = this.nationalNumber_.toString();
                                this.nationalNumber_.clear();
                                this.nationalNumber_.append(this.extractedNationalPrefix_);
                                this.nationalNumber_.append(a);
                                a = this.prefixBeforeNationalNumber_.toString();
                                var b = a.lastIndexOf(this.extractedNationalPrefix_);
                                this.prefixBeforeNationalNumber_.clear();
                                this.prefixBeforeNationalNumber_.append(a.substring(0, b));
                            }
                            return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(a) {
                            return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a) || 1 == this.accruedInput_.getLength() && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
                            for(var a = this.nationalNumber_.toString(), b = this.possibleFormats_.length, c = 0; c < b; ++c){
                                var d = this.possibleFormats_[c], e = d.getPatternOrDefault();
                                if (new RegExp("^(?:" + e + ")$").test(a) && (this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()), d = a.replace(new RegExp(e, "g"), d.getFormat()), d = this.appendNationalNumber_(d), i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d) == this.accruedInputWithoutFormatting_)) return d;
                            }
                            return "";
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(a) {
                            var b = this.prefixBeforeNationalNumber_.getLength();
                            return this.shouldAddSpaceAfterNationalPrefix_ && 0 < b && this.prefixBeforeNationalNumber_.toString().charAt(b - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + a : this.prefixBeforeNationalNumber_ + a;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
                            if (!this.ableToFormat_) return this.originalPosition_;
                            for(var a = 0, b = 0, c = this.accruedInputWithoutFormatting_.toString(), d = this.currentOutput_.toString(); a < this.positionToRemember_ && b < d.length;)c.charAt(a) == d.charAt(b) && a++, b++;
                            return b;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
                            var a = this.nationalNumber_.toString();
                            return a.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(a), a = this.attemptToFormatAccruedDigits_(), 0 < a.length ? a : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(a);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
                            var a = this.nationalNumber_.toString(), b = a.length;
                            if (0 < b) {
                                for(var c = "", d = 0; d < b; d++)c = this.inputDigitHelper_(a.charAt(d));
                                return this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
                            }
                            return this.prefixBeforeNationalNumber_.toString();
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
                            if (1 != this.currentMetadata_.getCountryCode()) return !1;
                            var a = this.nationalNumber_.toString();
                            return "1" == a.charAt(0) && "0" != a.charAt(1) && "1" != a.charAt(1);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
                            var a = this.nationalNumber_.toString(), b = 0;
                            if (this.isNanpaNumberWithNationalPrefix_()) b = 1, this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = !0;
                            else if (this.currentMetadata_.hasNationalPrefixForParsing()) {
                                var c = new RegExp("^(?:" + this.currentMetadata_.getNationalPrefixForParsing() + ")");
                                c = a.match(c);
                                null != c && null != c[0] && 0 < c[0].length && (this.isCompleteNumber_ = !0, b = c[0].length, this.prefixBeforeNationalNumber_.append(a.substring(0, b)));
                            }
                            this.nationalNumber_.clear();
                            this.nationalNumber_.append(a.substring(b));
                            return a.substring(0, b);
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
                            var a = this.accruedInputWithoutFormatting_.toString(), b = new RegExp("^(?:\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + "|" + this.currentMetadata_.getInternationalPrefix() + ")");
                            b = a.match(b);
                            return null != b && null != b[0] && 0 < b[0].length ? (this.isCompleteNumber_ = !0, b = b[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(a.substring(b)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(a.substring(0, b)), a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), !0) : !1;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
                            if (0 == this.nationalNumber_.getLength()) return !1;
                            var a = new goog.string.StringBuffer, b = this.phoneUtil_.extractCountryCode(this.nationalNumber_, a);
                            if (0 == b) return !1;
                            this.nationalNumber_.clear();
                            this.nationalNumber_.append(a.toString());
                            a = this.phoneUtil_.getRegionCodeForCountryCode(b);
                            i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == a ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(b) : a != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(a));
                            this.prefixBeforeNationalNumber_.append("" + b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);
                            this.extractedNationalPrefix_ = "";
                            return !0;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(a, b) {
                            if (a == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
                                var c = a;
                                this.accruedInputWithoutFormatting_.append(a);
                            } else c = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a], this.accruedInputWithoutFormatting_.append(c), this.nationalNumber_.append(c);
                            b && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength());
                            return c;
                        };
                        i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(a) {
                            var b = this.formattingTemplate_.toString();
                            if (0 <= b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
                                var c = b.search(this.DIGIT_PATTERN_);
                                a = b.replace(this.DIGIT_PATTERN_, a);
                                this.formattingTemplate_.clear();
                                this.formattingTemplate_.append(a);
                                this.lastMatchPosition_ = c;
                                return a.substring(0, this.lastMatchPosition_ + 1);
                            }
                            1 == this.possibleFormats_.length && (this.ableToFormat_ = !1);
                            this.currentFormattingPattern_ = "";
                            return this.accruedInput_.toString();
                        };
                        Object.defineProperty(exports, "__esModule", {
                            value: !0
                        });
                        exports.default = i18n.phonenumbers;
                        module1.exports = exports["default"];
                    }).call(this);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ]
    }, {}, [
        1
    ])(1);
});

});

parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$var$decodePath(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



parcelRequire("acw62");


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $acw62 = parcelRequire("acw62");


//      
var $7f17f1906b9f3211$var$charCodeOfDot = ".".charCodeAt(0);
var $7f17f1906b9f3211$var$reEscapeChar = /\\(\\)?/g;
var $7f17f1906b9f3211$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7f17f1906b9f3211$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $7f17f1906b9f3211$var$charCodeOfDot) result.push("");
    string.replace($7f17f1906b9f3211$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($7f17f1906b9f3211$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $7f17f1906b9f3211$var$keysCache = {};
var $7f17f1906b9f3211$var$keysRegex = /[.[\]]+/;
var $7f17f1906b9f3211$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($7f17f1906b9f3211$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $7f17f1906b9f3211$var$keysCache[key] = key.split($7f17f1906b9f3211$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $7f17f1906b9f3211$var$keysCache[key] = $7f17f1906b9f3211$var$stringToPath(key);
    }
    return $7f17f1906b9f3211$var$keysCache[key];
};
//      
var $7f17f1906b9f3211$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $7f17f1906b9f3211$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $7f17f1906b9f3211$var$_toPropertyKey(arg) {
    var key = $7f17f1906b9f3211$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7f17f1906b9f3211$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7f17f1906b9f3211$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(current, [
                key
            ].map($7f17f1906b9f3211$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $7f17f1906b9f3211$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $7f17f1906b9f3211$var$setInRecursor(state, 0, $7f17f1906b9f3211$var$toPath(key), value1, destroyArrays);
};
var $7f17f1906b9f3211$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $7f17f1906b9f3211$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $7f17f1906b9f3211$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $7f17f1906b9f3211$export$c52e5867d5879e24(values, name);
    var error = $7f17f1906b9f3211$export$c52e5867d5879e24(errors, name);
    if (error && error[$7f17f1906b9f3211$export$735bebc8ffabf28a]) error = error[$7f17f1906b9f3211$export$735bebc8ffabf28a];
    var submitError = submitErrors && $7f17f1906b9f3211$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $7f17f1906b9f3211$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $7f17f1906b9f3211$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $7f17f1906b9f3211$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $7f17f1906b9f3211$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$7f17f1906b9f3211$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $7f17f1906b9f3211$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $7f17f1906b9f3211$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $7f17f1906b9f3211$var$subscriptionFilter(result, state, previousState, subscription, $7f17f1906b9f3211$export$41e855cb628c1b55, $7f17f1906b9f3211$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $7f17f1906b9f3211$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $7f17f1906b9f3211$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $7f17f1906b9f3211$var$subscriptionFilter(result, state, previousState, subscription, $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3, $7f17f1906b9f3211$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $7f17f1906b9f3211$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$7f17f1906b9f3211$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $7f17f1906b9f3211$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $7f17f1906b9f3211$export$83d89fbfd8236492 = "4.20.10";
var $7f17f1906b9f3211$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $7f17f1906b9f3211$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $7f17f1906b9f3211$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $7f17f1906b9f3211$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $7f17f1906b9f3211$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $7f17f1906b9f3211$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $7f17f1906b9f3211$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $7f17f1906b9f3211$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($7f17f1906b9f3211$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $7f17f1906b9f3211$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $7f17f1906b9f3211$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $7f17f1906b9f3211$export$e6bdf135a54e021b,
                    shallowEqual: $7f17f1906b9f3211$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.formState.values)); // clone to avoid writing
            if ($7f17f1906b9f3211$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $7f17f1906b9f3211$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $7f17f1906b9f3211$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $7f17f1906b9f3211$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $7f17f1906b9f3211$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $7f17f1906b9f3211$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$7f17f1906b9f3211$export$735bebc8ffabf28a]) {
                    var existing = $7f17f1906b9f3211$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$7f17f1906b9f3211$export$735bebc8ffabf28a] = error[$7f17f1906b9f3211$export$735bebc8ffabf28a];
                    merged = $7f17f1906b9f3211$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$7f17f1906b9f3211$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$7f17f1906b9f3211$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $7f17f1906b9f3211$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $7f17f1906b9f3211$var$notify(fieldSubscriber, fieldState, lastFieldState, $7f17f1906b9f3211$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $7f17f1906b9f3211$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$7f17f1906b9f3211$var$hasAnyError(formState.errors) && !(formState.submitErrors && $7f17f1906b9f3211$var$hasAnyError(formState.submitErrors));
        var nextFormState = $7f17f1906b9f3211$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $7f17f1906b9f3211$var$notify(state.subscribers, nextFormState, lastFormState, $7f17f1906b9f3211$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $7f17f1906b9f3211$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $7f17f1906b9f3211$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name) === $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $7f17f1906b9f3211$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$7f17f1906b9f3211$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $7f17f1906b9f3211$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $7f17f1906b9f3211$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $7f17f1906b9f3211$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $7f17f1906b9f3211$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}


var $a22611c327162735$var$_excluded$3 = [
    "render",
    "children",
    "component"
];
// shared logic between components that use either render prop,
// children render function, or component prop
function $a22611c327162735$var$renderComponent(props, lazyProps, name) {
    var render = props.render, children = props.children, component = props.component, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a22611c327162735$var$_excluded$3);
    if (component) return /*#__PURE__*/ $acw62.createElement(component, Object.assign(lazyProps, rest, {
        children: children,
        render: render
    }));
    if (render) return render(children === undefined ? Object.assign(lazyProps, rest) : Object.assign(lazyProps, rest, {
        children: children
    }));
    if (typeof children !== "function") throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
    return children(Object.assign(lazyProps, rest));
}
function $a22611c327162735$var$useWhenValueChanges(value, callback, isEqual) {
    if (isEqual === void 0) isEqual = function isEqual(a, b) {
        return a === b;
    };
    var previous = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (!isEqual(value, previous.current)) {
            callback();
            previous.current = value;
        }
    });
}
/**
 * A simple hook to create a constant value that lives for
 * the lifetime of the component.
 *
 * Plagiarized from https://github.com/Andarist/use-constant
 *
 * Do NOT reuse this code unless you know what you're doing.
 * Use Andarist's hook; it's more fault tolerant to things like
 * falsy values.
 *
 * @param {Function} init - A function to generate the value
 */ function $a22611c327162735$var$useConstant(init) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    if (!ref.current) ref.current = init();
    return ref.current;
}
var $a22611c327162735$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
var $a22611c327162735$var$isSyntheticEvent = function isSyntheticEvent(candidate) {
    return !!(candidate && typeof candidate.stopPropagation === "function");
};
var $a22611c327162735$var$ReactFinalFormContext = /*#__PURE__*/ $acw62.createContext();
function $a22611c327162735$var$useLatest(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        ref.current = value;
    });
    return ref;
}
var $a22611c327162735$export$83d89fbfd8236492 = "6.5.8";
var $a22611c327162735$var$addLazyState = function addLazyState(dest, state, keys) {
    keys.forEach(function(key) {
        Object.defineProperty(dest, key, {
            get: function get() {
                return state[key];
            },
            enumerable: true
        });
    });
};
var $a22611c327162735$var$addLazyFormState = function addLazyFormState(dest, state) {
    return $a22611c327162735$var$addLazyState(dest, state, [
        "active",
        "dirty",
        "dirtyFields",
        "dirtySinceLastSubmit",
        "dirtyFieldsSinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ]);
};
var $a22611c327162735$var$addLazyFieldMetaState = function addLazyFieldMetaState(dest, state) {
    return $a22611c327162735$var$addLazyState(dest, state, [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "visited"
    ]);
};
var $a22611c327162735$var$_excluded$2 = [
    "debug",
    "decorators",
    "destroyOnUnregister",
    "form",
    "initialValues",
    "initialValuesEqual",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "subscription",
    "validate",
    "validateOnBlur"
];
var $a22611c327162735$var$versions = {
    "final-form": (0, $7f17f1906b9f3211$export$83d89fbfd8236492),
    "react-final-form": $a22611c327162735$export$83d89fbfd8236492
};
var $a22611c327162735$var$all$1 = (0, $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
function $a22611c327162735$export$a7fed597f4b8afd8(_ref) {
    var debug = _ref.debug, _ref$decorators = _ref.decorators, decorators = _ref$decorators === void 0 ? [] : _ref$decorators, destroyOnUnregister = _ref.destroyOnUnregister, alternateFormApi = _ref.form, initialValues = _ref.initialValues, initialValuesEqual = _ref.initialValuesEqual, keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize, mutators = _ref.mutators, onSubmit = _ref.onSubmit, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $a22611c327162735$var$all$1 : _ref$subscription, validate = _ref.validate, validateOnBlur = _ref.validateOnBlur, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a22611c327162735$var$_excluded$2);
    var config = {
        debug: debug,
        destroyOnUnregister: destroyOnUnregister,
        initialValues: initialValues,
        keepDirtyOnReinitialize: keepDirtyOnReinitialize,
        mutators: mutators,
        onSubmit: onSubmit,
        validate: validate,
        validateOnBlur: validateOnBlur
    };
    var form = $a22611c327162735$var$useConstant(function() {
        var f = alternateFormApi || (0, $7f17f1906b9f3211$export$f681a8129d2e9d28)(config); // pause validation until children register all fields on first render (unpaused in useEffect() below)
        f.pauseValidation();
        return f;
    }); // synchronously register and unregister to query form state for our subscription on first render
    var _React$useState = $acw62.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1]; // save a copy of state that can break through the closure
    // on the shallowEqual() line below.
    var stateRef = $a22611c327162735$var$useLatest(state);
    $acw62.useEffect(function() {
        // We have rendered, so all fields are now registered, so we can unpause validation
        form.isValidationPaused() && form.resumeValidation();
        var unsubscriptions = [
            form.subscribe(function(s) {
                if (!$a22611c327162735$var$shallowEqual(s, stateRef.current)) setState(s);
            }, subscription)
        ].concat(decorators ? decorators.map(function(decorator) {
            return(// istanbul ignore next
            decorator(form));
        }) : []);
        return function() {
            form.pauseValidation(); // pause validation so we don't revalidate on every field deregistration
            unsubscriptions.reverse().forEach(function(unsubscribe) {
                return unsubscribe();
            }); // don't need to resume validation here; either unmounting, or will re-run this hook with new deps
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, decorators); // warn about decorator changes
    $a22611c327162735$var$useWhenValueChanges(debug, function() {
        form.setConfig("debug", debug);
    });
    $a22611c327162735$var$useWhenValueChanges(destroyOnUnregister, function() {
        form.destroyOnUnregister = !!destroyOnUnregister;
    });
    $a22611c327162735$var$useWhenValueChanges(keepDirtyOnReinitialize, function() {
        form.setConfig("keepDirtyOnReinitialize", keepDirtyOnReinitialize);
    });
    $a22611c327162735$var$useWhenValueChanges(initialValues, function() {
        form.setConfig("initialValues", initialValues);
    }, initialValuesEqual || $a22611c327162735$var$shallowEqual);
    $a22611c327162735$var$useWhenValueChanges(mutators, function() {
        form.setConfig("mutators", mutators);
    });
    $a22611c327162735$var$useWhenValueChanges(onSubmit, function() {
        form.setConfig("onSubmit", onSubmit);
    });
    $a22611c327162735$var$useWhenValueChanges(validate, function() {
        form.setConfig("validate", validate);
    });
    $a22611c327162735$var$useWhenValueChanges(validateOnBlur, function() {
        form.setConfig("validateOnBlur", validateOnBlur);
    });
    var handleSubmit = function handleSubmit(event) {
        if (event) {
            // sometimes not true, e.g. React Native
            if (typeof event.preventDefault === "function") event.preventDefault();
            if (typeof event.stopPropagation === "function") // prevent any outer forms from receiving the event too
            event.stopPropagation();
        }
        return form.submit();
    };
    var renderProps = {
        form: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, form, {
            reset: function reset(eventOrValues) {
                if ($a22611c327162735$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                form.reset();
                else form.reset(eventOrValues);
            }
        }),
        handleSubmit: handleSubmit
    };
    $a22611c327162735$var$addLazyFormState(renderProps, state);
    return /*#__PURE__*/ $acw62.createElement($a22611c327162735$var$ReactFinalFormContext.Provider, {
        value: form
    }, $a22611c327162735$var$renderComponent((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, {
        __versions: $a22611c327162735$var$versions
    }), renderProps, "ReactFinalForm"));
}
function $a22611c327162735$export$87c0cf8eb5a167e0(componentName) {
    var form = $acw62.useContext($a22611c327162735$var$ReactFinalFormContext);
    if (!form) throw new Error((componentName || "useForm") + " must be used inside of a <Form> component");
    return form;
}
function $a22611c327162735$export$606f11b2eb45ecc6(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, onChange = _ref.onChange, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $a22611c327162735$var$all$1 : _ref$subscription;
    var form = $a22611c327162735$export$87c0cf8eb5a167e0("useFormState");
    var firstRender = $acw62.useRef(true);
    var onChangeRef = $acw62.useRef(onChange);
    onChangeRef.current = onChange; // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $acw62.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        if (onChange) onChange(initialState);
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $acw62.useEffect(function() {
        return form.subscribe(function(newState) {
            if (firstRender.current) firstRender.current = false;
            else {
                setState(newState);
                if (onChangeRef.current) onChangeRef.current(newState);
            }
        }, subscription);
    }, []);
    var lazyState = {};
    $a22611c327162735$var$addLazyFormState(lazyState, state);
    return lazyState;
}
var $a22611c327162735$var$_excluded$1 = [
    "onChange",
    "subscription"
];
function $a22611c327162735$export$d2e89184086487cb(_ref) {
    var onChange = _ref.onChange, subscription = _ref.subscription, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a22611c327162735$var$_excluded$1);
    var reactFinalForm = $a22611c327162735$export$87c0cf8eb5a167e0("FormSpy");
    var state = $a22611c327162735$export$606f11b2eb45ecc6({
        onChange: onChange,
        subscription: subscription
    });
    if (onChange) return null;
    var renderProps = {
        form: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reactFinalForm, {
            reset: function reset(eventOrValues) {
                if ($a22611c327162735$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                reactFinalForm.reset();
                else reactFinalForm.reset(eventOrValues);
            }
        })
    };
    return $a22611c327162735$var$renderComponent((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, renderProps), state, "FormSpy");
}
var $a22611c327162735$var$isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";
var $a22611c327162735$var$getSelectedValues = function getSelectedValues(options) {
    var result = [];
    if (options) for(var index = 0; index < options.length; index++){
        var option = options[index];
        if (option.selected) result.push(option.value);
    }
    return result;
};
var $a22611c327162735$var$getValue = function getValue(event, currentValue, valueProp, isReactNative) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) return event.nativeEvent.text;
    if (isReactNative && event.nativeEvent) return event.nativeEvent.text;
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target, type = _detypedEvent$target.type, value = _detypedEvent$target.value, checked = _detypedEvent$target.checked;
    switch(type){
        case "checkbox":
            if (valueProp !== undefined) {
                // we are maintaining an array, not just a boolean
                if (checked) // add value to current array value
                return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [
                    valueProp
                ];
                else {
                    // remove value from current array value
                    if (!Array.isArray(currentValue)) return currentValue;
                    var index = currentValue.indexOf(valueProp);
                    if (index < 0) return currentValue;
                    else return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
                }
            } else // it's just a boolean
            return !!checked;
        case "select-multiple":
            return $a22611c327162735$var$getSelectedValues(event.target.options);
        default:
            return value;
    }
};
/**
 * Creates a callback, even with closures, that will be
 * instance === for the lifetime of the component, always
 * calling the most recent version of the function and its
 * closures.
 */ function $a22611c327162735$var$useConstantCallback(callback) {
    var ref = $acw62.useRef(callback);
    $acw62.useEffect(function() {
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(null, args);
    }, []);
}
var $a22611c327162735$var$all = (0, $7f17f1906b9f3211$export$41e855cb628c1b55).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
var $a22611c327162735$var$defaultFormat = function defaultFormat(value, name) {
    return value === undefined ? "" : value;
};
var $a22611c327162735$var$defaultParse = function defaultParse(value, name) {
    return value === "" ? undefined : value;
};
var $a22611c327162735$var$defaultIsEqual = function defaultIsEqual(a, b) {
    return a === b;
};
function $a22611c327162735$export$294aa081a6c6f55d(name, config) {
    if (config === void 0) config = {};
    var _config = config, afterSubmit = _config.afterSubmit, allowNull = _config.allowNull, component = _config.component, data = _config.data, defaultValue = _config.defaultValue, _config$format = _config.format, format = _config$format === void 0 ? $a22611c327162735$var$defaultFormat : _config$format, formatOnBlur = _config.formatOnBlur, initialValue = _config.initialValue, multiple = _config.multiple, _config$parse = _config.parse, parse = _config$parse === void 0 ? $a22611c327162735$var$defaultParse : _config$parse, _config$subscription = _config.subscription, subscription = _config$subscription === void 0 ? $a22611c327162735$var$all : _config$subscription, type = _config.type, validateFields = _config.validateFields, _value = _config.value;
    var form = $a22611c327162735$export$87c0cf8eb5a167e0("useField");
    var configRef = $a22611c327162735$var$useLatest(config);
    var register = function register(callback, silent) {
        return(// because they would refer `state` from current execution context
        // whereas actual `state` would defined in the subsequent `useField` hook
        // execution
        // (that would be caused by `setState` call performed in `register` callback)
        form.registerField(name, callback, subscription, {
            afterSubmit: afterSubmit,
            beforeSubmit: function beforeSubmit() {
                var _configRef$current = configRef.current, beforeSubmit = _configRef$current.beforeSubmit, formatOnBlur = _configRef$current.formatOnBlur, _configRef$current$fo = _configRef$current.format, format = _configRef$current$fo === void 0 ? $a22611c327162735$var$defaultFormat : _configRef$current$fo;
                if (formatOnBlur) {
                    var _ref = form.getFieldState(name), value = _ref.value;
                    var formatted = format(value, name);
                    if (formatted !== value) form.change(name, formatted);
                }
                return beforeSubmit && beforeSubmit();
            },
            data: data,
            defaultValue: defaultValue,
            getValidator: function getValidator() {
                return configRef.current.validate;
            },
            initialValue: initialValue,
            isEqual: function isEqual(a, b) {
                return (configRef.current.isEqual || $a22611c327162735$var$defaultIsEqual)(a, b);
            },
            silent: silent,
            validateFields: validateFields
        }));
    };
    var firstRender = $acw62.useRef(true); // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $acw62.useState(function() {
        var initialState = {}; // temporarily disable destroyOnUnregister
        // temporarily disable destroyOnUnregister
        var destroyOnUnregister = form.destroyOnUnregister;
        form.destroyOnUnregister = false;
        register(function(state) {
            initialState = state;
        }, true)(); // return destroyOnUnregister to its original value
        // return destroyOnUnregister to its original value
        form.destroyOnUnregister = destroyOnUnregister;
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $acw62.useEffect(function() {
        return register(function(state) {
            if (firstRender.current) firstRender.current = false;
            else setState(state);
        }, false);
    }, [
        name,
        data,
        defaultValue,
        // cannot reregister field every time validate function !==.
        // validate,
        initialValue // The validateFields array is often passed as validateFields={[]}, creating
    ]);
    var meta = {};
    $a22611c327162735$var$addLazyFieldMetaState(meta, state);
    var input = {
        name: name,
        get value () {
            var value = state.value;
            if (formatOnBlur) {
                if (component === "input") value = $a22611c327162735$var$defaultFormat(value);
            } else value = format(value, name);
            if (value === null && !allowNull) value = "";
            if (type === "checkbox" || type === "radio") return _value;
            else if (component === "select" && multiple) return value || [];
            return value;
        },
        get checked () {
            var value1 = state.value;
            if (type === "checkbox") {
                value1 = format(value1, name);
                if (_value === undefined) return !!value1;
                else return !!(Array.isArray(value1) && ~value1.indexOf(_value));
            } else if (type === "radio") return format(value1, name) === _value;
            return undefined;
        },
        onBlur: $a22611c327162735$var$useConstantCallback(function(event) {
            state.blur();
            if (formatOnBlur) {
                /**
         * Here we must fetch the value directly from Final Form because we cannot
         * trust that our `state` closure has the most recent value. This is a problem
         * if-and-only-if the library consumer has called `onChange()` immediately
         * before calling `onBlur()`, but before the field has had a chance to receive
         * the value update from Final Form.
         */ var fieldState = form.getFieldState(state.name);
                state.change(format(fieldState.value, state.name));
            }
        }),
        onChange: $a22611c327162735$var$useConstantCallback(function(event) {
            var targetType, unknown, _value2;
            var value = event && event.target ? $a22611c327162735$var$getValue(event, state.value, _value, $a22611c327162735$var$isReactNative) : event;
            state.change(parse(value, name));
        }),
        onFocus: $a22611c327162735$var$useConstantCallback(function(event) {
            return state.focus();
        })
    };
    if (multiple) input.multiple = multiple;
    if (type !== undefined) input.type = type;
    var renderProps = {
        input: input,
        meta: meta
    }; // assign to force Flow check
    return renderProps;
}
var $a22611c327162735$var$_excluded = [
    "afterSubmit",
    "allowNull",
    "beforeSubmit",
    "children",
    "component",
    "data",
    "defaultValue",
    "format",
    "formatOnBlur",
    "initialValue",
    "isEqual",
    "multiple",
    "name",
    "parse",
    "subscription",
    "type",
    "validate",
    "validateFields",
    "value"
];
var $a22611c327162735$export$a455218a85c89869 = /*#__PURE__*/ $acw62.forwardRef(function Field(_ref, ref) {
    var afterSubmit = _ref.afterSubmit, allowNull = _ref.allowNull, beforeSubmit = _ref.beforeSubmit, children = _ref.children, component = _ref.component, data = _ref.data, defaultValue = _ref.defaultValue, format = _ref.format, formatOnBlur = _ref.formatOnBlur, initialValue = _ref.initialValue, isEqual = _ref.isEqual, multiple = _ref.multiple, name = _ref.name, parse = _ref.parse, subscription = _ref.subscription, type = _ref.type, validate = _ref.validate, validateFields = _ref.validateFields, value = _ref.value, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a22611c327162735$var$_excluded);
    var field = $a22611c327162735$export$294aa081a6c6f55d(name, {
        afterSubmit: afterSubmit,
        allowNull: allowNull,
        beforeSubmit: beforeSubmit,
        children: children,
        component: component,
        data: data,
        defaultValue: defaultValue,
        format: format,
        formatOnBlur: formatOnBlur,
        initialValue: initialValue,
        isEqual: isEqual,
        multiple: multiple,
        parse: parse,
        subscription: subscription,
        type: type,
        validate: validate,
        validateFields: validateFields,
        value: value
    });
    if (typeof children === "function") return children((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, field, rest));
    if (typeof component === "string") // ignore meta, combine input with any other props
    return /*#__PURE__*/ $acw62.createElement(component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, field.input, {
        children: children,
        ref: ref
    }, rest));
    if (!name) throw new Error("prop name cannot be undefined in <Field> component");
    return $a22611c327162735$var$renderComponent((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        children: children,
        component: component,
        ref: ref
    }, rest), field, "Field(" + name + ")");
});
function $a22611c327162735$export$38f9b05178901e14() {
    return {
        Form: $a22611c327162735$export$a7fed597f4b8afd8,
        FormSpy: $a22611c327162735$export$d2e89184086487cb
    };
}



parcelRequire("acw62");



parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


const $75a48a2374c3e07e$var$InputField = ({ name: name, title: title, format: format, required: required, placeholder: placeholder, ...rest })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a455218a85c89869), {
        name: name,
        format: format,
        children: ({ input: input, meta: meta })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("flex flex-col", rest.className),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        placeholder: placeholder,
                        ...rest,
                        ...input,
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("form-input focus:border-mustard text-caringwire rounded-md border-2 bg-transparent px-6 py-4 text-lg font-thin transition-colors duration-200 ease-in-out focus:outline-none", meta.error && meta.touched ? "border-red-500" : "border-caringwire")
                    }),
                    meta.error && meta.touched && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 w-fit rounded-md border border-red-500 bg-red-100 p-2 text-sm text-red-800",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                role: "img",
                                "aria-label": "alert",
                                className: "mr-2",
                                children: "\u26A0\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: meta.error
                            })
                        ]
                    })
                ]
            })
    });
};
var $75a48a2374c3e07e$export$2e2bcd8739ae039 = $75a48a2374c3e07e$var$InputField;



var $59TQn = parcelRequire("59TQn");
const $3ef5978a8f0aae1f$export$a7a0278c004aac3f = (value)=>value ? undefined : "Please fill this in";
const $3ef5978a8f0aae1f$export$d290fa47940df19d = (value)=>value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? undefined : "Invalid email";
const $3ef5978a8f0aae1f$export$d6781b696a0576d1 = (number, countryCode)=>{
    try {
        var phoneUtil = (0, $59TQn.PhoneNumberUtil).getInstance();
        var numberObj = phoneUtil.parseAndKeepRawInput(number, countryCode);
        return phoneUtil.isValidNumber(numberObj);
    } catch (e) {
        return false;
    }
};



function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : String(i);
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(arr, i) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(arr) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(arr, i) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr, i) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}



function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $acw62 = parcelRequire("acw62");


function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(self);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}



function $95003165623aa54c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(arr);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(arr) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $5e4f012072913cb4$export$2335f513bbd82c6d = Math.abs;
var $5e4f012072913cb4$export$6788812c4e6611e6 = String.fromCharCode;
var $5e4f012072913cb4$export$e6e34fd1f2686227 = Object.assign;
function $5e4f012072913cb4$export$d6af199866bfb566(value, length) {
    return $5e4f012072913cb4$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 0)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 1)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 2)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 3) : 0;
}
function $5e4f012072913cb4$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $5e4f012072913cb4$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $5e4f012072913cb4$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $5e4f012072913cb4$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $5e4f012072913cb4$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $5e4f012072913cb4$export$36776f635604f274(value) {
    return value.length;
}
function $5e4f012072913cb4$export$f9084667e487ed46(value) {
    return value.length;
}
function $5e4f012072913cb4$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $5e4f012072913cb4$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join("");
}


var $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = 1;
var $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1;
var $f4f4fca9115ed8bd$export$f24224f1c91d8156 = 0;
var $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0;
var $f4f4fca9115ed8bd$export$c0306caf338ac095 = 0;
var $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = "";
function $f4f4fca9115ed8bd$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c,
        column: $f4f4fca9115ed8bd$export$4e0c71f277ca26b3,
        length: length,
        return: ""
    };
}
function $f4f4fca9115ed8bd$export$784d13d8ee351f07(root, props) {
    return (0, $5e4f012072913cb4$export$e6e34fd1f2686227)($f4f4fca9115ed8bd$export$35059013cd4a06db("", null, null, "", null, null, 0), root, {
        length: -root.length
    }, props);
}
function $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7() {
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$232faf9add678146() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 > 0 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, --$f4f4fca9115ed8bd$export$5880b8b5730aff45) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3--, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c--;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 < $f4f4fca9115ed8bd$export$f24224f1c91d8156 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45++) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3++, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c++;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() {
    return (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}
function $f4f4fca9115ed8bd$export$e88cb2efb12ae807() {
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$58adb3bec8346d0f(begin, end) {
    return (0, $5e4f012072913cb4$export$2f35ab04d2335697)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, begin, end);
}
function $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f4f4fca9115ed8bd$export$2de70f21292aac9e(value) {
    return $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$f24224f1c91d8156 = (0, $5e4f012072913cb4$export$36776f635604f274)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = value), $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0, [];
}
function $f4f4fca9115ed8bd$export$45918ac1574455b1(value) {
    return $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = "", value;
}
function $f4f4fca9115ed8bd$export$410ac95b9ec204b8(type) {
    return (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)($f4f4fca9115ed8bd$export$58adb3bec8346d0f($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1, $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff(value) {
    return $f4f4fca9115ed8bd$export$45918ac1574455b1($f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1($f4f4fca9115ed8bd$export$2de70f21292aac9e(value)));
}
function $f4f4fca9115ed8bd$export$7af1228ff777d175(type) {
    while($f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$4d3fb11e950abb9e())if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 33) $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    else break;
    return $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) > 2 || $f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1(children) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095)){
        case 0:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$c2ab62c7bf24634($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$410ac95b9ec204b8($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
            break;
        default:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)((0, $5e4f012072913cb4$export$6788812c4e6611e6)($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
    }
    return children;
}
function $f4f4fca9115ed8bd$export$955ba06d119e085e(index, count) {
    while(--count && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 48 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 102 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 57 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 65 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 70 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 97) break;
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$e88cb2efb12ae807() + (count < 6 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() == 32 && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() == 32));
}
function $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12($f4f4fca9115ed8bd$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
            break;
    }
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$4254d4e2b3745c4c(type, index) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// //
    if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 57) break;
    else if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 84 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1) + "*" + (0, $5e4f012072913cb4$export$6788812c4e6611e6)(type === 47 ? type : $f4f4fca9115ed8bd$export$48cfd1e771a65c4f());
}
function $f4f4fca9115ed8bd$export$c2ab62c7bf24634(index) {
    while(!$f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$4d3fb11e950abb9e()))$f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}

var $e853ac0080e24cb4$export$71ad59f2e432cfe8 = "-ms-";
var $e853ac0080e24cb4$export$2c0f367103c8d01c = "-moz-";
var $e853ac0080e24cb4$export$39dfd62a25e0fe93 = "-webkit-";
var $e853ac0080e24cb4$export$a29989082612d0d9 = "comm";
var $e853ac0080e24cb4$export$aa3a2e812ca8570d = "rule";
var $e853ac0080e24cb4$export$527d108ccf083c2b = "decl";
var $e853ac0080e24cb4$export$d3d35020fa5b54f0 = "@page";
var $e853ac0080e24cb4$export$500415a86c544f73 = "@media";
var $e853ac0080e24cb4$export$a763edbf796b780a = "@import";
var $e853ac0080e24cb4$export$2790aeb8b4e5c826 = "@charset";
var $e853ac0080e24cb4$export$1cc683e23b84b133 = "@viewport";
var $e853ac0080e24cb4$export$9447a5efea57e862 = "@supports";
var $e853ac0080e24cb4$export$ef011b4e114b1fba = "@document";
var $e853ac0080e24cb4$export$6aad947bda0f3f46 = "@namespace";
var $e853ac0080e24cb4$export$b44a8529a35fcb60 = "@keyframes";
var $e853ac0080e24cb4$export$2c16de31893252e6 = "@font-face";
var $e853ac0080e24cb4$export$3d846dd52e150c6f = "@counter-style";
var $e853ac0080e24cb4$export$22314bfbb57653fe = "@font-feature-values";
var $e853ac0080e24cb4$export$d773506282b3cfe6 = "@layer";




function $36ea00327b41abe1$export$ef7acd7185315e22(value) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($36ea00327b41abe1$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], value = (0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $36ea00327b41abe1$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = "";
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $5e4f012072913cb4$export$f8e21b1e77979a08)(characters += (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character), "&", "&\f"), "&\f") != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $f4f4fca9115ed8bd$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $f4f4fca9115ed8bd$export$955ba06d119e085e)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$4a34f930e789283c((0, $f4f4fca9115ed8bd$export$4254d4e2b3745c4c)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)(), (0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += "/";
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $5e4f012072913cb4$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, /\f/g, "");
                    if (property > 0 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) - length) (0, $5e4f012072913cb4$export$10d8903dec122b9d)(property > 32 ? $36ea00327b41abe1$export$f8483753829ec8f3(characters + ";", rule, parent, length - 1) : $36ea00327b41abe1$export$f8483753829ec8f3((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, " ", "") + ";", rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ";";
                // { rule/at-rule
                default:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(reference = $36ea00327b41abe1$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $36ea00327b41abe1$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $36ea00327b41abe1$export$98e6a39c04603d36(value, reference, reference, rule && (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $36ea00327b41abe1$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ""
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = "", length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $5e4f012072913cb4$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $f4f4fca9115ed8bd$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += "\f", -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $5e4f012072913cb4$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 45) characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
                    atrule = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(), offset = length = (0, $5e4f012072913cb4$export$36776f635604f274)(type = characters += (0, $f4f4fca9115ed8bd$export$c2ab62c7bf24634)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $36ea00327b41abe1$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ""
    ];
    var size = (0, $5e4f012072913cb4$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, post + 1, post = (0, $5e4f012072913cb4$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + " " + y : (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $e853ac0080e24cb4$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $36ea00327b41abe1$export$4a34f930e789283c(value, root, parent) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$a29989082612d0d9), (0, $5e4f012072913cb4$export$6788812c4e6611e6)((0, $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7)()), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $36ea00327b41abe1$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$527d108ccf083c2b), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 0, length), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $8f2522f8594faa86$export$dfdc1655ccc5b9cb(children, callback) {
    var output = "";
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || "";
    return output;
}
function $8f2522f8594faa86$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $e853ac0080e24cb4$export$a763edbf796b780a:
        case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $e853ac0080e24cb4$export$a29989082612d0d9:
            return "";
        case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
            return element.return = element.value + "{" + $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback) + "}";
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.value = element.props.join(",");
    }
    return (0, $5e4f012072913cb4$export$36776f635604f274)(children = $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}




function $be3fa667258f7944$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-item-" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, "") + (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "grid-row-" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, "") : "") + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, "") + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "grid-column-align" + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "template-", "") + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value + (children = children[length].value), "span") ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "-start", "") + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "grid-row-span:" + (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(children, "span") ? (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /\d+/)) + ";";
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "-start", "") + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "-end", "-span"), "span ", "") + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, "stretch") ? $be3fa667258f7944$export$82e9f45cca5ba907((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + ":" + b + f + (c ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + "-span:" + (d ? e : +e - +b) + f : "") + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "$2box$3") + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "scroll-", "scroll-snap-") + value;
    }
    return value;
}


function $b9a8452e0aabfcf6$export$5a7767152ae0305f(collection) {
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = "";
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || "";
        return output;
    };
}
function $b9a8452e0aabfcf6$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $b9a8452e0aabfcf6$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element.return = (0, $be3fa667258f7944$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
}
function $b9a8452e0aabfcf6$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)((0, $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 1, (0, $5e4f012072913cb4$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === "global") children[index] = "", children[++index] = "\f" + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? "" : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) > 1 ? "" : value;
                                case index = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(character)) break;
        (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)();
    }
    return (0, $f4f4fca9115ed8bd$export$58adb3bec8346d0f)(begin, (0, $f4f4fca9115ed8bd$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $f4f4fca9115ed8bd$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-item-" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-" + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$36776f635604f274)(value) - 3 - (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $8f2522f8594faa86$export$fac44ee5b035f737),
        (0, $b9a8452e0aabfcf6$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $b9a8452e0aabfcf6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)((0, $36ea00327b41abe1$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e18645ac1956fbe6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $72623ab6bcb0a33b$exports = {};
"use strict";
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;


var $a25287fda858c019$export$23f2a1d2818174ef = true;
var $a25287fda858c019$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $a25287fda858c019$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $a25287fda858c019$export$e7094788287c5e9b = $a25287fda858c019$var$EmotionCacheContext.Provider;
var $a25287fda858c019$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($a25287fda858c019$var$EmotionCacheContext);
};
var $a25287fda858c019$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($a25287fda858c019$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$a25287fda858c019$export$23f2a1d2818174ef) $a25287fda858c019$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($a25287fda858c019$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($a25287fda858c019$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $a25287fda858c019$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $a25287fda858c019$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($a25287fda858c019$export$971d5caa766a69d7);
};
var $a25287fda858c019$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $a25287fda858c019$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $a25287fda858c019$var$getTheme(outerTheme, theme);
    });
});
var $a25287fda858c019$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($a25287fda858c019$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $a25287fda858c019$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($a25287fda858c019$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $a25287fda858c019$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($a25287fda858c019$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $a25287fda858c019$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $a25287fda858c019$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $a25287fda858c019$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $a25287fda858c019$var$getLastPart(match[1]);
    return undefined;
};
var $a25287fda858c019$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $a25287fda858c019$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $a25287fda858c019$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $a25287fda858c019$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($a25287fda858c019$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $a25287fda858c019$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $a25287fda858c019$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $a25287fda858c019$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $a25287fda858c019$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($a25287fda858c019$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$a25287fda858c019$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $a25287fda858c019$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $a25287fda858c019$var$Emotion = /* #__PURE__ */ $a25287fda858c019$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$a25287fda858c019$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($a25287fda858c019$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($a25287fda858c019$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $a25287fda858c019$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($a25287fda858c019$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $a25287fda858c019$export$a9c23c6ac3fc3eca = $a25287fda858c019$var$Emotion;



var $acw62 = parcelRequire("acw62");








var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $a25287fda858c019$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $a25287fda858c019$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $a25287fda858c019$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $acw62.createElement.apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $a25287fda858c019$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $a25287fda858c019$export$971d5caa766a69d7)));
    if (!(0, $a25287fda858c019$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $a25287fda858c019$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $a25287fda858c019$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;





function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $acw62 = parcelRequire("acw62");

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $204931a4986f463b$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $204931a4986f463b$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $204931a4986f463b$export$803cd8101b6c182b = /*#__PURE__*/ $204931a4986f463b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[0], side + "-" + $204931a4986f463b$export$27b07d8a310ed8b5[1]), []);
const $204931a4986f463b$export$96ec731ed4dcb222 = Math.min;
const $204931a4986f463b$export$8960430cfd85939f = Math.max;
const $204931a4986f463b$export$2077e0241d6afd3c = Math.round;
const $204931a4986f463b$export$a3fe094919f356fd = Math.floor;
const $204931a4986f463b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $204931a4986f463b$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $204931a4986f463b$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $204931a4986f463b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $204931a4986f463b$export$8960430cfd85939f(start, $204931a4986f463b$export$96ec731ed4dcb222(value, end));
}
function $204931a4986f463b$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $204931a4986f463b$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $204931a4986f463b$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $204931a4986f463b$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $204931a4986f463b$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $204931a4986f463b$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($204931a4986f463b$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $204931a4986f463b$export$2b57e0052a6d6d4c(placement) {
    return $204931a4986f463b$export$8a000a963141ac32($204931a4986f463b$export$f28e8f882010718a(placement));
}
function $204931a4986f463b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $204931a4986f463b$export$2b57e0052a6d6d4c(placement);
    const length = $204931a4986f463b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $204931a4986f463b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $204931a4986f463b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $204931a4986f463b$export$9c5e28bad23365fa(placement);
    return [
        $204931a4986f463b$export$2b182c584985588b(placement),
        oppositePlacement,
        $204931a4986f463b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $204931a4986f463b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$204931a4986f463b$var$oppositeAlignmentMap[alignment]);
}
function $204931a4986f463b$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $204931a4986f463b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $204931a4986f463b$export$f0989780f32bfcda(placement);
    let list = $204931a4986f463b$var$getSideList($204931a4986f463b$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($204931a4986f463b$export$2b182c584985588b));
    }
    return list;
}
function $204931a4986f463b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$204931a4986f463b$var$oppositeSideMap[side]);
}
function $204931a4986f463b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $204931a4986f463b$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $204931a4986f463b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $204931a4986f463b$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $9dccb9a8753b0e86$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $204931a4986f463b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $204931a4986f463b$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9dccb9a8753b0e86$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9dccb9a8753b0e86$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $204931a4986f463b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9dccb9a8753b0e86$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $204931a4986f463b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $204931a4986f463b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $204931a4986f463b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9dccb9a8753b0e86$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $204931a4986f463b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $204931a4986f463b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9dccb9a8753b0e86$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $204931a4986f463b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $204931a4986f463b$export$803cd8101b6c182b) ? $9dccb9a8753b0e86$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $204931a4986f463b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $204931a4986f463b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $204931a4986f463b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9dccb9a8753b0e86$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $204931a4986f463b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $204931a4986f463b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $204931a4986f463b$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $204931a4986f463b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $204931a4986f463b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9dccb9a8753b0e86$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9dccb9a8753b0e86$var$isAnySideFullyClipped(overflow) {
    return (0, $204931a4986f463b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9dccb9a8753b0e86$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9dccb9a8753b0e86$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9dccb9a8753b0e86$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9dccb9a8753b0e86$var$getBoundingRect(rects) {
    const minX = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $204931a4986f463b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9dccb9a8753b0e86$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9dccb9a8753b0e86$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9dccb9a8753b0e86$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $204931a4986f463b$export$ee05aea0aeecbad4)($9dccb9a8753b0e86$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $204931a4986f463b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $204931a4986f463b$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $204931a4986f463b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $204931a4986f463b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9dccb9a8753b0e86$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9dccb9a8753b0e86$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9dccb9a8753b0e86$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9dccb9a8753b0e86$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $204931a4986f463b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9dccb9a8753b0e86$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $204931a4986f463b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $204931a4986f463b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $204931a4986f463b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9dccb9a8753b0e86$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $204931a4986f463b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $9dccb9a8753b0e86$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $204931a4986f463b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $204931a4986f463b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $204931a4986f463b$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $204931a4986f463b$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $204931a4986f463b$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $204931a4986f463b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $c51400d9a81fca36$export$651544f548703224(node) {
    if ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $c51400d9a81fca36$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $c51400d9a81fca36$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($c51400d9a81fca36$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $c51400d9a81fca36$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Node;
}
function $c51400d9a81fca36$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).Element;
}
function $c51400d9a81fca36$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).HTMLElement;
}
function $c51400d9a81fca36$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $c51400d9a81fca36$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $c51400d9a81fca36$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $c51400d9a81fca36$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $c51400d9a81fca36$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($c51400d9a81fca36$export$651544f548703224(element));
}
function $c51400d9a81fca36$export$d6c4e8150c35fed1(element) {
    const webkit = $c51400d9a81fca36$export$78551043582a6a98();
    const css = $c51400d9a81fca36$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $c51400d9a81fca36$export$940d8225183e1404(element) {
    let currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(element);
    while($c51400d9a81fca36$export$1b3bfaa9684536aa(currentNode) && !$c51400d9a81fca36$export$d1162fb0b6d4cd51(currentNode)){
        if ($c51400d9a81fca36$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $c51400d9a81fca36$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $c51400d9a81fca36$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($c51400d9a81fca36$export$651544f548703224(node));
}
function $c51400d9a81fca36$export$3735103072e4a80(element) {
    return $c51400d9a81fca36$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $c51400d9a81fca36$export$dc8fc79fa2800137(element) {
    if ($c51400d9a81fca36$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $c51400d9a81fca36$export$4e12058fc4d51d56(node) {
    if ($c51400d9a81fca36$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $c51400d9a81fca36$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $c51400d9a81fca36$export$e495491855dc5418(node);
    return $c51400d9a81fca36$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $c51400d9a81fca36$export$7cd01a57c8ca906c(node) {
    const parentNode = $c51400d9a81fca36$export$4e12058fc4d51d56(node);
    if ($c51400d9a81fca36$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($c51400d9a81fca36$export$1b3bfaa9684536aa(parentNode) && $c51400d9a81fca36$export$989e911fa9af580a(parentNode)) return parentNode;
    return $c51400d9a81fca36$export$7cd01a57c8ca906c(parentNode);
}
function $c51400d9a81fca36$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $c51400d9a81fca36$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $c51400d9a81fca36$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $c51400d9a81fca36$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $c51400d9a81fca36$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $c51400d9a81fca36$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $bede215d88ec3aee$var$getCssDimensions(element) {
    const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $204931a4986f463b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $204931a4986f463b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bede215d88ec3aee$var$unwrapElement(element) {
    return !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $bede215d88ec3aee$var$getScale(element) {
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(domElement)) return (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bede215d88ec3aee$var$getCssDimensions(domElement);
    let x = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $204931a4986f463b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bede215d88ec3aee$var$noOffsets = /*#__PURE__*/ (0, $204931a4986f463b$export$a397704b5e280835)(0);
function $bede215d88ec3aee$var$getVisualOffsets(element) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if (!(0, $c51400d9a81fca36$export$78551043582a6a98)() || !win.visualViewport) return $bede215d88ec3aee$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bede215d88ec3aee$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $bede215d88ec3aee$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bede215d88ec3aee$var$unwrapElement(element);
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent)) scale = $bede215d88ec3aee$var$getScale(offsetParent);
        } else scale = $bede215d88ec3aee$var$getScale(element);
    }
    const visualOffsets = $bede215d88ec3aee$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bede215d88ec3aee$var$getVisualOffsets(domElement) : (0, $204931a4986f463b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bede215d88ec3aee$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $bede215d88ec3aee$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $bede215d88ec3aee$var$isTopLayer(floating) {
    return $bede215d88ec3aee$var$topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $bede215d88ec3aee$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== "body" || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent);
            scale = $bede215d88ec3aee$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $bede215d88ec3aee$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $bede215d88ec3aee$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $bede215d88ec3aee$var$getBoundingClientRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element)).left + (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bede215d88ec3aee$var$getDocumentRect(element) {
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $204931a4986f463b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bede215d88ec3aee$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $c51400d9a81fca36$export$3735103072e4a80)(body).direction === "rtl") x += (0, $204931a4986f463b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getViewportRect(element, strategy) {
    const win = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    const html = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $c51400d9a81fca36$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bede215d88ec3aee$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) ? $bede215d88ec3aee$var$getScale(element) : (0, $204931a4986f463b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $bede215d88ec3aee$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $bede215d88ec3aee$var$getDocumentRect((0, $c51400d9a81fca36$export$e495491855dc5418)(element));
    else if ((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $bede215d88ec3aee$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bede215d88ec3aee$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $204931a4986f463b$export$ee05aea0aeecbad4)(rect);
}
function $bede215d88ec3aee$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(parentNode) || (0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(parentNode).position === "fixed" || $bede215d88ec3aee$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bede215d88ec3aee$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c51400d9a81fca36$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(el) && (0, $c51400d9a81fca36$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c51400d9a81fca36$export$45a5e7f76e0caa8d)(currentNode) && !(0, $c51400d9a81fca36$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $c51400d9a81fca36$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $c51400d9a81fca36$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $bede215d88ec3aee$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $c51400d9a81fca36$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bede215d88ec3aee$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $bede215d88ec3aee$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $204931a4986f463b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $204931a4986f463b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $bede215d88ec3aee$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bede215d88ec3aee$var$getDimensions(element) {
    const { width: width, height: height } = $bede215d88ec3aee$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bede215d88ec3aee$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $c51400d9a81fca36$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $bede215d88ec3aee$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $204931a4986f463b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) !== "body" || (0, $c51400d9a81fca36$export$989e911fa9af580a)(documentElement)) scroll = (0, $c51400d9a81fca36$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bede215d88ec3aee$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $bede215d88ec3aee$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) || (0, $c51400d9a81fca36$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bede215d88ec3aee$var$getOffsetParent(element, polyfill) {
    const window = (0, $c51400d9a81fca36$export$38b2d434cce3ea22)(element);
    if (!(0, $c51400d9a81fca36$export$1b3bfaa9684536aa)(element) || $bede215d88ec3aee$var$isTopLayer(element)) return window;
    let offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c51400d9a81fca36$export$71535ffaa902797f)(offsetParent) && (0, $c51400d9a81fca36$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $bede215d88ec3aee$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) === "html" || (0, $c51400d9a81fca36$export$651544f548703224)(offsetParent) === "body" && (0, $c51400d9a81fca36$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $c51400d9a81fca36$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $c51400d9a81fca36$export$940d8225183e1404)(element) || window;
}
const $bede215d88ec3aee$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bede215d88ec3aee$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $bede215d88ec3aee$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(data.floating)
        }
    };
};
function $bede215d88ec3aee$var$isRTL(element) {
    return (0, $c51400d9a81fca36$export$3735103072e4a80)(element).direction === "rtl";
}
const $bede215d88ec3aee$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bede215d88ec3aee$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c51400d9a81fca36$export$e495491855dc5418,
    getClippingRect: $bede215d88ec3aee$var$getClippingRect,
    getOffsetParent: $bede215d88ec3aee$var$getOffsetParent,
    getElementRects: $bede215d88ec3aee$var$getElementRects,
    getClientRects: $bede215d88ec3aee$var$getClientRects,
    getDimensions: $bede215d88ec3aee$var$getDimensions,
    getScale: $bede215d88ec3aee$var$getScale,
    isElement: $c51400d9a81fca36$export$45a5e7f76e0caa8d,
    isRTL: $bede215d88ec3aee$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bede215d88ec3aee$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $c51400d9a81fca36$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $204931a4986f463b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $204931a4986f463b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $204931a4986f463b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $204931a4986f463b$export$8960430cfd85939f)(0, (0, $204931a4986f463b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bede215d88ec3aee$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $bede215d88ec3aee$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c51400d9a81fca36$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $c51400d9a81fca36$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bede215d88ec3aee$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bede215d88ec3aee$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bede215d88ec3aee$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bede215d88ec3aee$export$91fb6ecbd551914 = (0, $9dccb9a8753b0e86$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bede215d88ec3aee$export$fba63a578e423eb = (0, $9dccb9a8753b0e86$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bede215d88ec3aee$export$8a83211c878a3f1f = (0, $9dccb9a8753b0e86$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bede215d88ec3aee$export$346677f925de839c = (0, $9dccb9a8753b0e86$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bede215d88ec3aee$export$fe8985bb6374093c = (0, $9dccb9a8753b0e86$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bede215d88ec3aee$export$f2120bbfa5450bd2 = (0, $9dccb9a8753b0e86$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bede215d88ec3aee$export$18c8ad048e32c7d5 = (0, $9dccb9a8753b0e86$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bede215d88ec3aee$export$7bf07e38f3dc4b69 = (0, $9dccb9a8753b0e86$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bede215d88ec3aee$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bede215d88ec3aee$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $9dccb9a8753b0e86$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$var$index = (0, $acw62.useLayoutEffect);
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = $e62b4578a0a2b358$var$index;


var $a9284aba291bbde9$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $a9284aba291bbde9$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $a9284aba291bbde9$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $a9284aba291bbde9$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($a9284aba291bbde9$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $a9284aba291bbde9$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($a9284aba291bbde9$var$isArray(value)) return value.filter(Boolean);
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $a9284aba291bbde9$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $a9284aba291bbde9$var$_excluded$4);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $a9284aba291bbde9$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $a9284aba291bbde9$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $a9284aba291bbde9$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $a9284aba291bbde9$var$normalizedHeight(el) {
    if ($a9284aba291bbde9$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $a9284aba291bbde9$var$getScrollTop(el) {
    if ($a9284aba291bbde9$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $a9284aba291bbde9$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($a9284aba291bbde9$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $a9284aba291bbde9$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $a9284aba291bbde9$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $a9284aba291bbde9$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $a9284aba291bbde9$export$b4171a6734a65d42;
    var start = $a9284aba291bbde9$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $a9284aba291bbde9$var$easeOutCubic(currentTime, start, change, duration);
        $a9284aba291bbde9$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $a9284aba291bbde9$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $a9284aba291bbde9$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $a9284aba291bbde9$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $a9284aba291bbde9$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $a9284aba291bbde9$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $a9284aba291bbde9$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $a9284aba291bbde9$var$passiveOptionAccessed = false;
var $a9284aba291bbde9$var$options = {
    get passive () {
        return $a9284aba291bbde9$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $a9284aba291bbde9$var$w = typeof window !== "undefined" ? window : {};
if ($a9284aba291bbde9$var$w.addEventListener && $a9284aba291bbde9$var$w.removeEventListener) {
    $a9284aba291bbde9$var$w.addEventListener("p", $a9284aba291bbde9$export$b4171a6734a65d42, $a9284aba291bbde9$var$options);
    $a9284aba291bbde9$var$w.removeEventListener("p", $a9284aba291bbde9$export$b4171a6734a65d42, false);
}
var $a9284aba291bbde9$export$2408f22a0fab9ae5 = $a9284aba291bbde9$var$passiveOptionAccessed;
function $a9284aba291bbde9$export$3466f893ebf79586(item) {
    return item != null;
}
function $a9284aba291bbde9$var$isArray(arg) {
    return Array.isArray(arg);
}
function $a9284aba291bbde9$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $a9284aba291bbde9$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $a9284aba291bbde9$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $a9284aba291bbde9$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $a9284aba291bbde9$var$_excluded$3 = [
    "children",
    "innerProps"
], $a9284aba291bbde9$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $a9284aba291bbde9$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $a9284aba291bbde9$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $a9284aba291bbde9$var$normalizedHeight(scrollParent);
    var scrollTop = $a9284aba291bbde9$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $a9284aba291bbde9$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $a9284aba291bbde9$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $a9284aba291bbde9$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $a9284aba291bbde9$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $a9284aba291bbde9$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: "menu"
    }, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, $a9284aba291bbde9$var$alignToControl(placement), "100%"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "position", "absolute"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "width", "100%"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $a9284aba291bbde9$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $a9284aba291bbde9$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($a9284aba291bbde9$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $a9284aba291bbde9$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $a9284aba291bbde9$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $a9284aba291bbde9$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $a9284aba291bbde9$var$Menu$1 = $a9284aba291bbde9$var$Menu;
// ==============================
// Menu List
// ==============================
var $a9284aba291bbde9$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $a9284aba291bbde9$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $a9284aba291bbde9$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $a9284aba291bbde9$export$3b14a55fb2447963 = $a9284aba291bbde9$var$noticeCSS;
var $a9284aba291bbde9$export$342063e11d6c3cad = $a9284aba291bbde9$var$noticeCSS;
var $a9284aba291bbde9$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref6, $a9284aba291bbde9$var$_excluded$3);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $a9284aba291bbde9$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $a9284aba291bbde9$var$_excluded2$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $a9284aba291bbde9$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $a9284aba291bbde9$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($a9284aba291bbde9$var$coercePlacement(menuPlacement)), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $a9284aba291bbde9$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $bede215d88ec3aee$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $a9284aba291bbde9$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $a9284aba291bbde9$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $a9284aba291bbde9$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $a9284aba291bbde9$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $a9284aba291bbde9$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $a9284aba291bbde9$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $a9284aba291bbde9$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $a9284aba291bbde9$var$_templateObject;
var $a9284aba291bbde9$var$_excluded$2 = [
    "size"
], $a9284aba291bbde9$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $a9284aba291bbde9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $a9284aba291bbde9$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $a9284aba291bbde9$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $a9284aba291bbde9$var$_excluded$2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $a9284aba291bbde9$var$_ref2
    }, props));
};
var $a9284aba291bbde9$var$CrossIcon = function CrossIcon(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $a9284aba291bbde9$var$DownChevron = function DownChevron(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$Svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $a9284aba291bbde9$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $a9284aba291bbde9$export$f1e1789686576879 = $a9284aba291bbde9$var$baseCSS;
var $a9284aba291bbde9$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$DownChevron, null));
};
var $a9284aba291bbde9$export$407448d2b89b1813 = $a9284aba291bbde9$var$baseCSS;
var $a9284aba291bbde9$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $a9284aba291bbde9$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $a9284aba291bbde9$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerProps, $a9284aba291bbde9$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $a9284aba291bbde9$var$loadingDotAnimations = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)($a9284aba291bbde9$var$_templateObject || ($a9284aba291bbde9$var$_templateObject = (0, $cbe7edbf3ccb8828$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $a9284aba291bbde9$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $a9284aba291bbde9$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            animation: "".concat($a9284aba291bbde9$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $a9284aba291bbde9$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $a9284aba291bbde9$var$_excluded2);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $a9284aba291bbde9$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $a9284aba291bbde9$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $a9284aba291bbde9$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $a9284aba291bbde9$var$Control$1 = $a9284aba291bbde9$var$Control;
var $a9284aba291bbde9$var$_excluded$1 = [
    "data"
];
var $a9284aba291bbde9$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $a9284aba291bbde9$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Heading, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", null, children));
};
var $a9284aba291bbde9$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $a9284aba291bbde9$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $a9284aba291bbde9$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $a9284aba291bbde9$var$_excluded$1);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $a9284aba291bbde9$var$Group$1 = $a9284aba291bbde9$var$Group;
var $a9284aba291bbde9$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $a9284aba291bbde9$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $a9284aba291bbde9$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $a9284aba291bbde9$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $a9284aba291bbde9$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $a9284aba291bbde9$var$spacingStyle)
};
var $a9284aba291bbde9$var$inputStyle = function inputStyle(isHidden) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $a9284aba291bbde9$var$spacingStyle);
};
var $a9284aba291bbde9$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $a9284aba291bbde9$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $a9284aba291bbde9$var$_excluded);
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $a9284aba291bbde9$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $a9284aba291bbde9$var$Input$1 = $a9284aba291bbde9$var$Input;
var $a9284aba291bbde9$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $a9284aba291bbde9$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $a9284aba291bbde9$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $a9284aba291bbde9$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $a9284aba291bbde9$var$MultiValueContainer = $a9284aba291bbde9$var$MultiValueGeneric;
var $a9284aba291bbde9$var$MultiValueLabel = $a9284aba291bbde9$var$MultiValueGeneric;
function $a9284aba291bbde9$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($a9284aba291bbde9$var$CrossIcon, {
        size: 14
    }));
}
var $a9284aba291bbde9$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $a9284aba291bbde9$var$MultiValue$1 = $a9284aba291bbde9$var$MultiValue;
var $a9284aba291bbde9$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $a9284aba291bbde9$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $a9284aba291bbde9$var$Option$1 = $a9284aba291bbde9$var$Option;
var $a9284aba291bbde9$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a9284aba291bbde9$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $a9284aba291bbde9$var$Placeholder$1 = $a9284aba291bbde9$var$Placeholder;
var $a9284aba291bbde9$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a9284aba291bbde9$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $a9284aba291bbde9$var$SingleValue$1 = $a9284aba291bbde9$var$SingleValue;
var $a9284aba291bbde9$export$db3b6bfb95261072 = {
    ClearIndicator: $a9284aba291bbde9$var$ClearIndicator,
    Control: $a9284aba291bbde9$var$Control$1,
    DropdownIndicator: $a9284aba291bbde9$var$DropdownIndicator,
    DownChevron: $a9284aba291bbde9$var$DownChevron,
    CrossIcon: $a9284aba291bbde9$var$CrossIcon,
    Group: $a9284aba291bbde9$var$Group$1,
    GroupHeading: $a9284aba291bbde9$var$GroupHeading,
    IndicatorsContainer: $a9284aba291bbde9$var$IndicatorsContainer,
    IndicatorSeparator: $a9284aba291bbde9$var$IndicatorSeparator,
    Input: $a9284aba291bbde9$var$Input$1,
    LoadingIndicator: $a9284aba291bbde9$var$LoadingIndicator,
    Menu: $a9284aba291bbde9$var$Menu$1,
    MenuList: $a9284aba291bbde9$var$MenuList,
    MenuPortal: $a9284aba291bbde9$var$MenuPortal,
    LoadingMessage: $a9284aba291bbde9$var$LoadingMessage,
    NoOptionsMessage: $a9284aba291bbde9$var$NoOptionsMessage,
    MultiValue: $a9284aba291bbde9$var$MultiValue$1,
    MultiValueContainer: $a9284aba291bbde9$var$MultiValueContainer,
    MultiValueLabel: $a9284aba291bbde9$var$MultiValueLabel,
    MultiValueRemove: $a9284aba291bbde9$var$MultiValueRemove,
    Option: $a9284aba291bbde9$var$Option$1,
    Placeholder: $a9284aba291bbde9$var$Placeholder$1,
    SelectContainer: $a9284aba291bbde9$var$SelectContainer,
    SingleValue: $a9284aba291bbde9$var$SingleValue$1,
    ValueContainer: $a9284aba291bbde9$var$ValueContainer
};
var $a9284aba291bbde9$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $a9284aba291bbde9$export$db3b6bfb95261072), props.components);
};



var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $02a6ea8308eefe55$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $02a6ea8308eefe55$var$A11yText = function A11yText(props) {
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        css: $02a6ea8308eefe55$var$_ref
    }, props));
};
var $02a6ea8308eefe55$var$A11yText$1 = $02a6ea8308eefe55$var$A11yText;
var $02a6ea8308eefe55$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $02a6ea8308eefe55$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $02a6ea8308eefe55$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($02a6ea8308eefe55$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $63d46a01db878c10$export$c8a8987d4410bf2d)($02a6ea8308eefe55$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $02a6ea8308eefe55$var$LiveRegion$1 = $02a6ea8308eefe55$var$LiveRegion;
var $02a6ea8308eefe55$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $02a6ea8308eefe55$var$anyDiacritic = new RegExp("[" + $02a6ea8308eefe55$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $02a6ea8308eefe55$var$diacriticToBase = {};
for(var $02a6ea8308eefe55$var$i = 0; $02a6ea8308eefe55$var$i < $02a6ea8308eefe55$var$diacritics.length; $02a6ea8308eefe55$var$i++){
    var $02a6ea8308eefe55$var$diacritic = $02a6ea8308eefe55$var$diacritics[$02a6ea8308eefe55$var$i];
    for(var $02a6ea8308eefe55$var$j = 0; $02a6ea8308eefe55$var$j < $02a6ea8308eefe55$var$diacritic.letters.length; $02a6ea8308eefe55$var$j++)$02a6ea8308eefe55$var$diacriticToBase[$02a6ea8308eefe55$var$diacritic.letters[$02a6ea8308eefe55$var$j]] = $02a6ea8308eefe55$var$diacritic.base;
}
var $02a6ea8308eefe55$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($02a6ea8308eefe55$var$anyDiacritic, function(match) {
        return $02a6ea8308eefe55$var$diacriticToBase[match];
    });
};
var $02a6ea8308eefe55$var$memoizedStripDiacriticsForInput = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)($02a6ea8308eefe55$var$stripDiacritics);
var $02a6ea8308eefe55$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $02a6ea8308eefe55$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $02a6ea8308eefe55$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $02a6ea8308eefe55$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $02a6ea8308eefe55$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $02a6ea8308eefe55$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $02a6ea8308eefe55$var$memoizedStripDiacriticsForInput(input);
            candidate = $02a6ea8308eefe55$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $02a6ea8308eefe55$var$_excluded = [
    "innerRef"
];
function $02a6ea8308eefe55$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $02a6ea8308eefe55$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $a9284aba291bbde9$export$43caf9889c228507)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $63d46a01db878c10$export$dbf350e5966cf602)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $02a6ea8308eefe55$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $02a6ea8308eefe55$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $02a6ea8308eefe55$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $a9284aba291bbde9$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $02a6ea8308eefe55$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $02a6ea8308eefe55$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $02a6ea8308eefe55$var$preventTouchMove(e) {
    e.preventDefault();
}
function $02a6ea8308eefe55$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $02a6ea8308eefe55$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $02a6ea8308eefe55$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $02a6ea8308eefe55$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $02a6ea8308eefe55$var$activeScrollLocks = 0;
var $02a6ea8308eefe55$var$listenerOptions = {
    capture: false,
    passive: false
};
function $02a6ea8308eefe55$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$02a6ea8308eefe55$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $02a6ea8308eefe55$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $02a6ea8308eefe55$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($02a6ea8308eefe55$var$LOCK_STYLES).forEach(function(key) {
                var val = $02a6ea8308eefe55$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $02a6ea8308eefe55$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $02a6ea8308eefe55$var$preventTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $02a6ea8308eefe55$var$preventInertiaScroll, $02a6ea8308eefe55$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $02a6ea8308eefe55$var$allowTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $02a6ea8308eefe55$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$02a6ea8308eefe55$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $02a6ea8308eefe55$var$activeScrollLocks = Math.max($02a6ea8308eefe55$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $02a6ea8308eefe55$var$activeScrollLocks < 1) $02a6ea8308eefe55$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $02a6ea8308eefe55$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $02a6ea8308eefe55$var$preventTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $02a6ea8308eefe55$var$preventInertiaScroll, $02a6ea8308eefe55$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $02a6ea8308eefe55$var$allowTouchMove, $02a6ea8308eefe55$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $02a6ea8308eefe55$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $02a6ea8308eefe55$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $02a6ea8308eefe55$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $02a6ea8308eefe55$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $02a6ea8308eefe55$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)((0, $acw62.Fragment), null, lockEnabled && (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("div", {
        onClick: $02a6ea8308eefe55$var$blurSelectInput,
        css: $02a6ea8308eefe55$var$_ref2$1
    }), children(targetRef));
}
function $02a6ea8308eefe55$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $02a6ea8308eefe55$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $02a6ea8308eefe55$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $63d46a01db878c10$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $02a6ea8308eefe55$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $02a6ea8308eefe55$var$RequiredInput$1 = $02a6ea8308eefe55$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $02a6ea8308eefe55$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $02a6ea8308eefe55$var$isIPhone() {
    return $02a6ea8308eefe55$var$testPlatform(/^iPhone/i);
}
function $02a6ea8308eefe55$var$isMac() {
    return $02a6ea8308eefe55$var$testPlatform(/^Mac/i);
}
function $02a6ea8308eefe55$var$isIPad() {
    return $02a6ea8308eefe55$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $02a6ea8308eefe55$var$isMac() && navigator.maxTouchPoints > 1;
}
function $02a6ea8308eefe55$var$isIOS() {
    return $02a6ea8308eefe55$var$isIPhone() || $02a6ea8308eefe55$var$isIPad();
}
function $02a6ea8308eefe55$var$isAppleDevice() {
    return $02a6ea8308eefe55$var$isMac() || $02a6ea8308eefe55$var$isIOS();
}
var $02a6ea8308eefe55$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $02a6ea8308eefe55$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $02a6ea8308eefe55$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $02a6ea8308eefe55$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $02a6ea8308eefe55$var$defaultStyles = {
    clearIndicator: (0, $a9284aba291bbde9$export$407448d2b89b1813),
    container: (0, $a9284aba291bbde9$export$8b22cf2602fb60ce),
    control: (0, $a9284aba291bbde9$export$4368d992c4eafac0),
    dropdownIndicator: (0, $a9284aba291bbde9$export$f1e1789686576879),
    group: (0, $a9284aba291bbde9$export$39b482c5e57630a8),
    groupHeading: (0, $a9284aba291bbde9$export$2d1720544b23b823),
    indicatorsContainer: (0, $a9284aba291bbde9$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $a9284aba291bbde9$export$dda1d9f60106f0e9),
    input: (0, $a9284aba291bbde9$export$35e795649ee09318),
    loadingIndicator: (0, $a9284aba291bbde9$export$882b5998b3b9117c),
    loadingMessage: (0, $a9284aba291bbde9$export$342063e11d6c3cad),
    menu: (0, $a9284aba291bbde9$export$953cecd6e717a553),
    menuList: (0, $a9284aba291bbde9$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $a9284aba291bbde9$export$ae1af26003f05816),
    multiValue: (0, $a9284aba291bbde9$export$ffb5f4729a158638),
    multiValueLabel: (0, $a9284aba291bbde9$export$9e5f44173e64f162),
    multiValueRemove: (0, $a9284aba291bbde9$export$625550452a3fa3ec),
    noOptionsMessage: (0, $a9284aba291bbde9$export$3b14a55fb2447963),
    option: (0, $a9284aba291bbde9$export$90a7f3efeed30595),
    placeholder: (0, $a9284aba291bbde9$export$efccba1c4a2ef57b),
    singleValue: (0, $a9284aba291bbde9$export$d141bba7fdc215a3),
    valueContainer: (0, $a9284aba291bbde9$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $02a6ea8308eefe55$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $02a6ea8308eefe55$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $02a6ea8308eefe55$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $02a6ea8308eefe55$var$baseUnit = 4;
// The minimum height of the control
var $02a6ea8308eefe55$var$controlHeight = 38;
// The amount of space between the control and menu */
var $02a6ea8308eefe55$var$menuGutter = $02a6ea8308eefe55$var$baseUnit * 2;
var $02a6ea8308eefe55$var$spacing = {
    baseUnit: $02a6ea8308eefe55$var$baseUnit,
    controlHeight: $02a6ea8308eefe55$var$controlHeight,
    menuGutter: $02a6ea8308eefe55$var$menuGutter
};
var $02a6ea8308eefe55$export$4368d992c4eafac0 = {
    borderRadius: $02a6ea8308eefe55$var$borderRadius,
    colors: $02a6ea8308eefe55$var$colors,
    spacing: $02a6ea8308eefe55$var$spacing
};
var $02a6ea8308eefe55$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $a9284aba291bbde9$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $a9284aba291bbde9$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $02a6ea8308eefe55$export$db3b6bfb95261072(),
    formatGroupLabel: $02a6ea8308eefe55$var$formatGroupLabel,
    getOptionLabel: $02a6ea8308eefe55$export$8b22cf2602fb60ce,
    getOptionValue: $02a6ea8308eefe55$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $02a6ea8308eefe55$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $a9284aba291bbde9$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $02a6ea8308eefe55$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $02a6ea8308eefe55$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $02a6ea8308eefe55$var$_isOptionSelected(props, option, selectValue);
    var label = $02a6ea8308eefe55$var$getOptionLabel(props, option);
    var value = $02a6ea8308eefe55$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $02a6ea8308eefe55$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $02a6ea8308eefe55$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $02a6ea8308eefe55$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $02a6ea8308eefe55$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $02a6ea8308eefe55$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $a9284aba291bbde9$export$3466f893ebf79586));
}
function $02a6ea8308eefe55$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $02a6ea8308eefe55$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $02a6ea8308eefe55$var$buildFocusableOptions(props, selectValue) {
    return $02a6ea8308eefe55$var$buildFocusableOptionsFromCategorizedOptions($02a6ea8308eefe55$var$buildCategorizedOptions(props, selectValue));
}
function $02a6ea8308eefe55$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$02a6ea8308eefe55$var$shouldHideSelectedOptions(props) || !isSelected) && $02a6ea8308eefe55$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $02a6ea8308eefe55$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $02a6ea8308eefe55$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $02a6ea8308eefe55$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $02a6ea8308eefe55$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $02a6ea8308eefe55$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $02a6ea8308eefe55$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $02a6ea8308eefe55$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $02a6ea8308eefe55$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $02a6ea8308eefe55$var$getOptionValue(props, i) === candidate;
    });
}
function $02a6ea8308eefe55$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $02a6ea8308eefe55$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $02a6ea8308eefe55$var$instanceId = 1;
var $02a6ea8308eefe55$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $02a6ea8308eefe55$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $a9284aba291bbde9$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $a9284aba291bbde9$export$ef35774e6d314e91)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $a9284aba291bbde9$export$e7094788287c5e9b)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $a9284aba291bbde9$export$e7094788287c5e9b)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $a9284aba291bbde9$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $a9284aba291bbde9$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $a9284aba291bbde9$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $02a6ea8308eefe55$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $02a6ea8308eefe55$var$buildFocusableOptionsWithIds($02a6ea8308eefe55$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $a9284aba291bbde9$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $02a6ea8308eefe55$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $02a6ea8308eefe55$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $02a6ea8308eefe55$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $a9284aba291bbde9$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $02a6ea8308eefe55$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $02a6ea8308eefe55$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $a9284aba291bbde9$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $02a6ea8308eefe55$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$02a6ea8308eefe55$var$instanceId);
        _this.state.selectValue = (0, $a9284aba291bbde9$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $02a6ea8308eefe55$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $a9284aba291bbde9$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $a9284aba291bbde9$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $02a6ea8308eefe55$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($02a6ea8308eefe55$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $02a6ea8308eefe55$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $02a6ea8308eefe55$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $02a6ea8308eefe55$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $02a6ea8308eefe55$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$DummyInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $a9284aba291bbde9$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $a9284aba291bbde9$export$3a1a48c8f6ef640e), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($02a6ea8308eefe55$var$LiveRegion$1, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $a9284aba291bbde9$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $02a6ea8308eefe55$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $02a6ea8308eefe55$var$buildFocusableOptionsWithIds($02a6ea8308eefe55$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $02a6ea8308eefe55$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $02a6ea8308eefe55$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $02a6ea8308eefe55$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $a9284aba291bbde9$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$02a6ea8308eefe55$export$25ce5a424b770e84.defaultProps = $02a6ea8308eefe55$export$407448d2b89b1813;




















var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $9d88f0746ba78f85$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $02a6ea8308eefe55$export$25ce5a424b770e84), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $a25287fda858c019$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};


var $8159aa64a7960b5d$exports = {};
$8159aa64a7960b5d$exports = JSON.parse('{"options":[{"value":"AL","label":"Alabama"},{"value":"AK","label":"Alaska"},{"value":"AZ","label":"Arizona"},{"value":"AR","label":"Arkansas"},{"value":"CA","label":"California"},{"value":"CO","label":"Colorado"},{"value":"CT","label":"Connecticut"},{"value":"DE","label":"Delaware"},{"value":"DC","label":"District Of Columbia"},{"value":"FL","label":"Florida"},{"value":"GA","label":"Georgia"},{"value":"HI","label":"Hawaii"},{"value":"ID","label":"Idaho"},{"value":"IL","label":"Illinois"},{"value":"IN","label":"Indiana"},{"value":"IA","label":"Iowa"},{"value":"KS","label":"Kansas"},{"value":"KY","label":"Kentucky"},{"value":"LA","label":"Louisiana"},{"value":"ME","label":"Maine"},{"value":"MD","label":"Maryland"},{"value":"MA","label":"Massachusetts"},{"value":"MI","label":"Michigan"},{"value":"MN","label":"Minnesota"},{"value":"MS","label":"Mississippi"},{"value":"MO","label":"Missouri"},{"value":"MT","label":"Montana"},{"value":"NE","label":"Nebraska"},{"value":"NV","label":"Nevada"},{"value":"NH","label":"New Hampshire"},{"value":"NJ","label":"New Jersey"},{"value":"NM","label":"New Mexico"},{"value":"NY","label":"New York"},{"value":"NC","label":"North Carolina"},{"value":"ND","label":"North Dakota"},{"value":"OH","label":"Ohio"},{"value":"OK","label":"Oklahoma"},{"value":"OR","label":"Oregon"},{"value":"PA","label":"Pennsylvania"},{"value":"RI","label":"Rhode Island"},{"value":"SC","label":"South Carolina"},{"value":"SD","label":"South Dakota"},{"value":"TN","label":"Tennessee"},{"value":"TX","label":"Texas"},{"value":"UT","label":"Utah"},{"value":"VT","label":"Vermont"},{"value":"VA","label":"Virginia"},{"value":"WA","label":"Washington"},{"value":"WV","label":"West Virginia"},{"value":"WI","label":"Wisconsin"},{"value":"WY","label":"Wyoming"},{"value":"AS","label":"American Samoa"},{"value":"GU","label":"Guam"},{"value":"MP","label":"Northern Mariana Islands"},{"value":"PR","label":"Puerto Rico"},{"value":"VI","label":"Virgin Islands"}]}');


//Import Mixpanel SDK
var $3017a5eb21b16dc2$exports = {};
"use strict";
var $3017a5eb21b16dc2$var$Config = {
    DEBUG: false,
    LIB_VERSION: "2.50.0"
};
/* eslint camelcase: "off", eqeqeq: "off" */ // since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var $3017a5eb21b16dc2$var$win;
if (typeof window === "undefined") {
    var $3017a5eb21b16dc2$var$loc = {
        hostname: ""
    };
    $3017a5eb21b16dc2$var$win = {
        navigator: {
            userAgent: ""
        },
        document: {
            location: $3017a5eb21b16dc2$var$loc,
            referrer: ""
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $3017a5eb21b16dc2$var$loc
    };
} else $3017a5eb21b16dc2$var$win = window;
// Maximum allowed session recording length
var $3017a5eb21b16dc2$var$MAX_RECORDING_MS = 86400000; // 24 hours
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $3017a5eb21b16dc2$var$ArrayProto = Array.prototype, $3017a5eb21b16dc2$var$FuncProto = Function.prototype, $3017a5eb21b16dc2$var$ObjProto = Object.prototype, $3017a5eb21b16dc2$var$slice = $3017a5eb21b16dc2$var$ArrayProto.slice, $3017a5eb21b16dc2$var$toString = $3017a5eb21b16dc2$var$ObjProto.toString, $3017a5eb21b16dc2$var$hasOwnProperty = $3017a5eb21b16dc2$var$ObjProto.hasOwnProperty, $3017a5eb21b16dc2$var$windowConsole = $3017a5eb21b16dc2$var$win.console, $3017a5eb21b16dc2$var$navigator = $3017a5eb21b16dc2$var$win.navigator, $3017a5eb21b16dc2$var$document$1 = $3017a5eb21b16dc2$var$win.document, $3017a5eb21b16dc2$var$windowOpera = $3017a5eb21b16dc2$var$win.opera, $3017a5eb21b16dc2$var$screen = $3017a5eb21b16dc2$var$win.screen, $3017a5eb21b16dc2$var$userAgent = $3017a5eb21b16dc2$var$navigator.userAgent;
var $3017a5eb21b16dc2$var$nativeBind = $3017a5eb21b16dc2$var$FuncProto.bind, $3017a5eb21b16dc2$var$nativeForEach = $3017a5eb21b16dc2$var$ArrayProto.forEach, $3017a5eb21b16dc2$var$nativeIndexOf = $3017a5eb21b16dc2$var$ArrayProto.indexOf, $3017a5eb21b16dc2$var$nativeMap = $3017a5eb21b16dc2$var$ArrayProto.map, $3017a5eb21b16dc2$var$nativeIsArray = Array.isArray, $3017a5eb21b16dc2$var$breaker = {};
var $3017a5eb21b16dc2$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }
};
// Console override
var $3017a5eb21b16dc2$var$console = {
    /** @type {function(...*)} */ log: function() {
        if ($3017a5eb21b16dc2$var$Config.DEBUG && !$3017a5eb21b16dc2$var$_.isUndefined($3017a5eb21b16dc2$var$windowConsole) && $3017a5eb21b16dc2$var$windowConsole) try {
            $3017a5eb21b16dc2$var$windowConsole.log.apply($3017a5eb21b16dc2$var$windowConsole, arguments);
        } catch (err) {
            $3017a5eb21b16dc2$var$_.each(arguments, function(arg) {
                $3017a5eb21b16dc2$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($3017a5eb21b16dc2$var$Config.DEBUG && !$3017a5eb21b16dc2$var$_.isUndefined($3017a5eb21b16dc2$var$windowConsole) && $3017a5eb21b16dc2$var$windowConsole) {
            var args = [
                "Mixpanel warning:"
            ].concat($3017a5eb21b16dc2$var$_.toArray(arguments));
            try {
                $3017a5eb21b16dc2$var$windowConsole.warn.apply($3017a5eb21b16dc2$var$windowConsole, args);
            } catch (err) {
                $3017a5eb21b16dc2$var$_.each(args, function(arg) {
                    $3017a5eb21b16dc2$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($3017a5eb21b16dc2$var$Config.DEBUG && !$3017a5eb21b16dc2$var$_.isUndefined($3017a5eb21b16dc2$var$windowConsole) && $3017a5eb21b16dc2$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($3017a5eb21b16dc2$var$_.toArray(arguments));
            try {
                $3017a5eb21b16dc2$var$windowConsole.error.apply($3017a5eb21b16dc2$var$windowConsole, args);
            } catch (err) {
                $3017a5eb21b16dc2$var$_.each(args, function(arg) {
                    $3017a5eb21b16dc2$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$3017a5eb21b16dc2$var$_.isUndefined($3017a5eb21b16dc2$var$windowConsole) && $3017a5eb21b16dc2$var$windowConsole) {
            var args = [
                "Mixpanel error:"
            ].concat($3017a5eb21b16dc2$var$_.toArray(arguments));
            try {
                $3017a5eb21b16dc2$var$windowConsole.error.apply($3017a5eb21b16dc2$var$windowConsole, args);
            } catch (err) {
                $3017a5eb21b16dc2$var$_.each(args, function(arg) {
                    $3017a5eb21b16dc2$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $3017a5eb21b16dc2$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = "[" + prefix + "] " + arguments[0];
        return func.apply($3017a5eb21b16dc2$var$console, arguments);
    };
};
var $3017a5eb21b16dc2$var$console_with_prefix = function(prefix) {
    return {
        log: $3017a5eb21b16dc2$var$log_func_with_prefix($3017a5eb21b16dc2$var$console.log, prefix),
        error: $3017a5eb21b16dc2$var$log_func_with_prefix($3017a5eb21b16dc2$var$console.error, prefix),
        critical: $3017a5eb21b16dc2$var$log_func_with_prefix($3017a5eb21b16dc2$var$console.critical, prefix)
    };
};
// UNDERSCORE
// Embed part of the Underscore Library
$3017a5eb21b16dc2$var$_.bind = function(func, context) {
    var args, bound;
    if ($3017a5eb21b16dc2$var$nativeBind && func.bind === $3017a5eb21b16dc2$var$nativeBind) return $3017a5eb21b16dc2$var$nativeBind.apply(func, $3017a5eb21b16dc2$var$slice.call(arguments, 1));
    if (!$3017a5eb21b16dc2$var$_.isFunction(func)) throw new TypeError();
    args = $3017a5eb21b16dc2$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($3017a5eb21b16dc2$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat($3017a5eb21b16dc2$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $3017a5eb21b16dc2$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($3017a5eb21b16dc2$var$nativeForEach && obj.forEach === $3017a5eb21b16dc2$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $3017a5eb21b16dc2$var$breaker) return;
    }
    else {
        for(var key in obj)if ($3017a5eb21b16dc2$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $3017a5eb21b16dc2$var$breaker) return;
        }
    }
};
$3017a5eb21b16dc2$var$_.extend = function(obj) {
    $3017a5eb21b16dc2$var$_.each($3017a5eb21b16dc2$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$3017a5eb21b16dc2$var$_.isArray = $3017a5eb21b16dc2$var$nativeIsArray || function(obj) {
    return $3017a5eb21b16dc2$var$toString.call(obj) === "[object Array]";
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$3017a5eb21b16dc2$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$3017a5eb21b16dc2$var$_.isArguments = function(obj) {
    return !!(obj && $3017a5eb21b16dc2$var$hasOwnProperty.call(obj, "callee"));
};
$3017a5eb21b16dc2$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($3017a5eb21b16dc2$var$_.isArray(iterable)) return $3017a5eb21b16dc2$var$slice.call(iterable);
    if ($3017a5eb21b16dc2$var$_.isArguments(iterable)) return $3017a5eb21b16dc2$var$slice.call(iterable);
    return $3017a5eb21b16dc2$var$_.values(iterable);
};
$3017a5eb21b16dc2$var$_.map = function(arr, callback, context) {
    if ($3017a5eb21b16dc2$var$nativeMap && arr.map === $3017a5eb21b16dc2$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $3017a5eb21b16dc2$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$3017a5eb21b16dc2$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $3017a5eb21b16dc2$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$3017a5eb21b16dc2$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $3017a5eb21b16dc2$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$3017a5eb21b16dc2$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($3017a5eb21b16dc2$var$nativeIndexOf && obj.indexOf === $3017a5eb21b16dc2$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $3017a5eb21b16dc2$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $3017a5eb21b16dc2$var$breaker;
    });
    return found;
};
$3017a5eb21b16dc2$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$3017a5eb21b16dc2$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$3017a5eb21b16dc2$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$3017a5eb21b16dc2$var$_.isArray(obj);
};
$3017a5eb21b16dc2$var$_.isEmptyObject = function(obj) {
    if ($3017a5eb21b16dc2$var$_.isObject(obj)) {
        for(var key in obj){
            if ($3017a5eb21b16dc2$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$3017a5eb21b16dc2$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$3017a5eb21b16dc2$var$_.isString = function(obj) {
    return $3017a5eb21b16dc2$var$toString.call(obj) == "[object String]";
};
$3017a5eb21b16dc2$var$_.isDate = function(obj) {
    return $3017a5eb21b16dc2$var$toString.call(obj) == "[object Date]";
};
$3017a5eb21b16dc2$var$_.isNumber = function(obj) {
    return $3017a5eb21b16dc2$var$toString.call(obj) == "[object Number]";
};
$3017a5eb21b16dc2$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$3017a5eb21b16dc2$var$_.encodeDates = function(obj) {
    $3017a5eb21b16dc2$var$_.each(obj, function(v, k) {
        if ($3017a5eb21b16dc2$var$_.isDate(v)) obj[k] = $3017a5eb21b16dc2$var$_.formatDate(v);
        else if ($3017a5eb21b16dc2$var$_.isObject(v)) obj[k] = $3017a5eb21b16dc2$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$3017a5eb21b16dc2$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$3017a5eb21b16dc2$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? "0" + n : n;
    }
    return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate()) + "T" + pad(d.getUTCHours()) + ":" + pad(d.getUTCMinutes()) + ":" + pad(d.getUTCSeconds());
};
$3017a5eb21b16dc2$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $3017a5eb21b16dc2$var$_.each(p, function(v, k) {
        if ($3017a5eb21b16dc2$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $3017a5eb21b16dc2$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === "string") ret = obj.slice(0, length);
    else if ($3017a5eb21b16dc2$var$_.isArray(obj)) {
        ret = [];
        $3017a5eb21b16dc2$var$_.each(obj, function(val) {
            ret.push($3017a5eb21b16dc2$var$_.truncate(val, length));
        });
    } else if ($3017a5eb21b16dc2$var$_.isObject(obj)) {
        ret = {};
        $3017a5eb21b16dc2$var$_.each(obj, function(val, key) {
            ret[key] = $3017a5eb21b16dc2$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$3017a5eb21b16dc2$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                "\b": "\\b",
                "	": "\\t",
                "\n": "\\n",
                "\f": "\\f",
                "\r": "\\r",
                '"': '\\"',
                "\\": "\\\\"
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = "";
            var indent = "    ";
            var i = 0; // The loop counter.
            var k = ""; // The member key.
            var v = ""; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case "string":
                    return quote(value);
                case "number":
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : "null";
                case "boolean":
                case "null":
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case "object":
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return "null";
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($3017a5eb21b16dc2$var$toString.apply(value) === "[object Array]") {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($3017a5eb21b16dc2$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? "{}" : gap ? "{" + partial.join(",") + "" + mind + "}" : "{" + partial.join(",") + "}";
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str("", {
            "": value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $3017a5eb21b16dc2$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        "b": "\b",
        "f": "\f",
        "n": "\n",
        "r": "\r",
        "t": "	"
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error("Expected '" + c + "' instead of '" + ch + "'");
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = "";
        if (ch === "-") {
            string = "-";
            next("-");
        }
        while(ch >= "0" && ch <= "9"){
            string += ch;
            next();
        }
        if (ch === ".") {
            string += ".";
            while(next() && ch >= "0" && ch <= "9")string += ch;
        }
        if (ch === "e" || ch === "E") {
            string += ch;
            next();
            if (ch === "-" || ch === "+") {
                string += ch;
                next();
            }
            while(ch >= "0" && ch <= "9"){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error("Bad number");
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = "", uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === "\\") {
                next();
                if (ch === "u") {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === "string") string += escapee[ch];
                else break;
            } else string += ch;
        }
        error("Bad string");
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= " ")next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case "t":
                next("t");
                next("r");
                next("u");
                next("e");
                return true;
            case "f":
                next("f");
                next("a");
                next("l");
                next("s");
                next("e");
                return false;
            case "n":
                next("n");
                next("u");
                next("l");
                next("l");
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === "[") {
            next("[");
            white();
            if (ch === "]") {
                next("]");
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === "]") {
                    next("]");
                    return array;
                }
                next(",");
                white();
            }
        }
        error("Bad array");
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === "{") {
            next("{");
            white();
            if (ch === "}") {
                next("}");
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(":");
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === "}") {
                    next("}");
                    return object;
                }
                next(",");
                white();
            }
        }
        error("Bad object");
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case "{":
                return object();
            case "[":
                return array();
            case '"':
                return string();
            case "-":
                return number();
            default:
                return ch >= "0" && ch <= "9" ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = " ";
        result = value();
        white();
        if (ch) error("Syntax error");
        return result;
    };
}();
$3017a5eb21b16dc2$var$_.base64Encode = function(data) {
    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = "", tmp_arr = [];
    if (!data) return data;
    data = $3017a5eb21b16dc2$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join("");
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + "==";
            break;
        case 2:
            enc = enc.slice(0, -1) + "=";
            break;
    }
    return enc;
};
$3017a5eb21b16dc2$var$_.utf8Encode = function(string) {
    string = (string + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    var utftext = "", start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$3017a5eb21b16dc2$var$_.UUID = function() {
    // Time-based entropy
    var T = function() {
        var time = 1 * new Date(); // cross-browser version of Date.now()
        var ticks;
        if ($3017a5eb21b16dc2$var$win.performance && $3017a5eb21b16dc2$var$win.performance.now) ticks = $3017a5eb21b16dc2$var$win.performance.now();
        else {
            // fall back to busy loop
            ticks = 0;
            // this while loop figures how many browser ticks go by
            // before 1*new Date() returns a new number, ie the amount
            // of ticks that go by per millisecond
            while(time == 1 * new Date())ticks++;
        }
        return time.toString(16) + Math.floor(ticks).toString(16);
    };
    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace(".", "");
    };
    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = $3017a5eb21b16dc2$var$userAgent, i, ch, buffer = [], ret = 0;
        function xor(result, byte_array) {
            var j, tmp = 0;
            for(j = 0; j < byte_array.length; j++)tmp |= buffer[j] << j * 8;
            return result ^ tmp;
        }
        for(i = 0; i < ua.length; i++){
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }
        if (buffer.length > 0) ret = xor(ret, buffer);
        return ret.toString(16);
    };
    return function() {
        var se = ($3017a5eb21b16dc2$var$screen.height * $3017a5eb21b16dc2$var$screen.width).toString(16);
        return T() + "-" + R() + "-" + UA() + "-" + se + "-" + T();
    };
}();
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $3017a5eb21b16dc2$var$BLOCKED_UA_STRS = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "facebookexternal",
    "petalbot",
    "pinterest",
    "screaming frog",
    "yahoo! slurp",
    "yandexbot",
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google"
];
$3017a5eb21b16dc2$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $3017a5eb21b16dc2$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($3017a5eb21b16dc2$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $3017a5eb21b16dc2$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($3017a5eb21b16dc2$var$_.isUndefined(arg_separator)) arg_separator = "&";
    $3017a5eb21b16dc2$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + "=" + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$3017a5eb21b16dc2$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + param + "=([^&#]*)", regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== "string" && results[1].length) return "";
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $3017a5eb21b16dc2$var$console.error("Skipping decoding for malformed query param: " + result);
        }
        return result.replace(/\+/g, " ");
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$3017a5eb21b16dc2$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + "=";
        var ca = $3017a5eb21b16dc2$var$document$1.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $3017a5eb21b16dc2$var$_.JSONDecode($3017a5eb21b16dc2$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $3017a5eb21b16dc2$var$extract_domain($3017a5eb21b16dc2$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        $3017a5eb21b16dc2$var$document$1.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = "", expires = "", secure = "";
        if (domain_override) cdomain = "; domain=" + domain_override;
        else if (is_cross_subdomain) {
            var domain = $3017a5eb21b16dc2$var$extract_domain($3017a5eb21b16dc2$var$document$1.location.hostname);
            cdomain = domain ? "; domain=." + domain : "";
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = "; SameSite=None";
        }
        if (is_secure) secure += "; secure";
        var new_cookie_val = name + "=" + encodeURIComponent(value) + expires + "; path=/" + cdomain + secure;
        $3017a5eb21b16dc2$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $3017a5eb21b16dc2$var$_.cookie.set(name, "", -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $3017a5eb21b16dc2$var$_localStorageSupported = null;
var $3017a5eb21b16dc2$var$localStorageSupported = function(storage, forceCheck) {
    if ($3017a5eb21b16dc2$var$_localStorageSupported !== null && !forceCheck) return $3017a5eb21b16dc2$var$_localStorageSupported;
    var supported = true;
    try {
        storage = storage || window.localStorage;
        var key = "__mplss_" + $3017a5eb21b16dc2$var$cheap_guid(8), val = "xyz";
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    $3017a5eb21b16dc2$var$_localStorageSupported = supported;
    return supported;
};
// _.localStorage
$3017a5eb21b16dc2$var$_.localStorage = {
    is_supported: function(force_check) {
        var supported = $3017a5eb21b16dc2$var$localStorageSupported(null, force_check);
        if (!supported) $3017a5eb21b16dc2$var$console.error("localStorage unsupported; falling back to cookie store");
        return supported;
    },
    error: function(msg) {
        $3017a5eb21b16dc2$var$console.error("localStorage error: " + msg);
    },
    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            $3017a5eb21b16dc2$var$_.localStorage.error(err);
        }
        return null;
    },
    parse: function(name) {
        try {
            return $3017a5eb21b16dc2$var$_.JSONDecode($3017a5eb21b16dc2$var$_.localStorage.get(name)) || {};
        } catch (err) {
        // noop
        }
        return null;
    },
    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            $3017a5eb21b16dc2$var$_.localStorage.error(err);
        }
    },
    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            $3017a5eb21b16dc2$var$_.localStorage.error(err);
        }
    }
};
$3017a5eb21b16dc2$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $3017a5eb21b16dc2$var$console.error("No valid element provided to register_event");
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = "on" + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($3017a5eb21b16dc2$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $3017a5eb21b16dc2$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$3017a5eb21b16dc2$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName("*");
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = " " + selector + " ";
        return (" " + elem.className + " ").replace(bad_whitespace, " ").indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$3017a5eb21b16dc2$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(" ");
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $3017a5eb21b16dc2$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, "").replace(/\s+$/, "");
            if (token.indexOf("#") > -1) {
                // Token is an ID selector
                bits = token.split("#");
                tagName = bits[0];
                var id = bits[1];
                var element = $3017a5eb21b16dc2$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf(".") > -1) {
                // Token contains a class selector
                bits = token.split(".");
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = "*";
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $3017a5eb21b16dc2$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($3017a5eb21b16dc2$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = "*";
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == "*") elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case "=":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case "~":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("\\b" + attrValue + "\\b"));
                        };
                        break;
                    case "|":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp("^" + attrValue + "-?"));
                        };
                        break;
                    case "^":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case "$":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case "*":
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($3017a5eb21b16dc2$var$_.isElement(query)) return [
            query
        ];
        else if ($3017a5eb21b16dc2$var$_.isObject(query) && !$3017a5eb21b16dc2$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $3017a5eb21b16dc2$var$CAMPAIGN_KEYWORDS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term"
];
var $3017a5eb21b16dc2$var$CLICK_IDS = [
    "dclid",
    "fbclid",
    "gclid",
    "ko_click_id",
    "li_fat_id",
    "msclkid",
    "ttclid",
    "twclid",
    "wbraid"
];
$3017a5eb21b16dc2$var$_.info = {
    campaignParams: function(default_value) {
        var kw = "", params = {};
        $3017a5eb21b16dc2$var$_.each($3017a5eb21b16dc2$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $3017a5eb21b16dc2$var$_.getQueryParam($3017a5eb21b16dc2$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = "", params = {};
        $3017a5eb21b16dc2$var$_.each($3017a5eb21b16dc2$var$CLICK_IDS, function(idkey) {
            id = $3017a5eb21b16dc2$var$_.getQueryParam($3017a5eb21b16dc2$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return $3017a5eb21b16dc2$var$_.extend($3017a5eb21b16dc2$var$_.info.campaignParams(), $3017a5eb21b16dc2$var$_.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search("https?://(.*)google.([^/?]*)") === 0) return "google";
        else if (referrer.search("https?://(.*)bing.com") === 0) return "bing";
        else if (referrer.search("https?://(.*)yahoo.com") === 0) return "yahoo";
        else if (referrer.search("https?://(.*)duckduckgo.com") === 0) return "duckduckgo";
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $3017a5eb21b16dc2$var$_.info.searchEngine(referrer), param = search != "yahoo" ? "q" : "p", ret = {};
        if (search !== null) {
            ret["$search_engine"] = search;
            var keyword = $3017a5eb21b16dc2$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret["mp_keyword"] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ""; // vendor is undefined for at least IE9
        if (opera || $3017a5eb21b16dc2$var$_.includes(user_agent, " OPR/")) {
            if ($3017a5eb21b16dc2$var$_.includes(user_agent, "Mini")) return "Opera Mini";
            return "Opera";
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "IEMobile") || $3017a5eb21b16dc2$var$_.includes(user_agent, "WPDesktop")) return "Internet Explorer Mobile";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "SamsungBrowser/")) // https://developer.samsung.com/internet/user-agent-string-format
        return "Samsung Internet";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "Edge") || $3017a5eb21b16dc2$var$_.includes(user_agent, "Edg/")) return "Microsoft Edge";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "FBIOS")) return "Facebook Mobile";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "Chrome")) return "Chrome";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "CriOS")) return "Chrome iOS";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "UCWEB") || $3017a5eb21b16dc2$var$_.includes(user_agent, "UCBrowser")) return "UC Browser";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "FxiOS")) return "Firefox iOS";
        else if ($3017a5eb21b16dc2$var$_.includes(vendor, "Apple")) {
            if ($3017a5eb21b16dc2$var$_.includes(user_agent, "Mobile")) return "Mobile Safari";
            return "Safari";
        } else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "Android")) return "Android Mobile";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "Konqueror")) return "Konqueror";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "Firefox")) return "Firefox";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "MSIE") || $3017a5eb21b16dc2$var$_.includes(user_agent, "Trident/")) return "Internet Explorer";
        else if ($3017a5eb21b16dc2$var$_.includes(user_agent, "Gecko")) return "Mozilla";
        else return "";
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $3017a5eb21b16dc2$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
            "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
            "Chrome": /Chrome\/(\d+(\.\d+)?)/,
            "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
            "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            "Safari": /Version\/(\d+(\.\d+)?)/,
            "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
            "Opera": /(Opera|OPR)\/(\d+(\.\d+)?)/,
            "Firefox": /Firefox\/(\d+(\.\d+)?)/,
            "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
            "Konqueror": /Konqueror:(\d+(\.\d+)?)/,
            "BlackBerry": /BlackBerry (\d+(\.\d+)?)/,
            "Android Mobile": /android\s(\d+(\.\d+)?)/,
            "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
            "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
            "Mozilla": /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $3017a5eb21b16dc2$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return "Windows Phone";
            return "Windows";
        } else if (/(iPhone|iPad|iPod)/.test(a)) return "iOS";
        else if (/Android/.test(a)) return "Android";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return "BlackBerry";
        else if (/Mac/i.test(a)) return "Mac OS X";
        else if (/Linux/.test(a)) return "Linux";
        else if (/CrOS/.test(a)) return "Chrome OS";
        else return "";
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return "Windows Phone";
        else if (/iPad/.test(user_agent)) return "iPad";
        else if (/iPod/.test(user_agent)) return "iPod Touch";
        else if (/iPhone/.test(user_agent)) return "iPhone";
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return "BlackBerry";
        else if (/Android/.test(user_agent)) return "Android";
        else return "";
    },
    referringDomain: function(referrer) {
        var split = referrer.split("/");
        if (split.length >= 3) return split[2];
        return "";
    },
    currentUrl: function() {
        return $3017a5eb21b16dc2$var$win.location.href;
    },
    properties: function(extra_props) {
        if (typeof extra_props !== "object") extra_props = {};
        return $3017a5eb21b16dc2$var$_.extend($3017a5eb21b16dc2$var$_.strip_empty_properties({
            "$os": $3017a5eb21b16dc2$var$_.info.os(),
            "$browser": $3017a5eb21b16dc2$var$_.info.browser($3017a5eb21b16dc2$var$userAgent, $3017a5eb21b16dc2$var$navigator.vendor, $3017a5eb21b16dc2$var$windowOpera),
            "$referrer": $3017a5eb21b16dc2$var$document$1.referrer,
            "$referring_domain": $3017a5eb21b16dc2$var$_.info.referringDomain($3017a5eb21b16dc2$var$document$1.referrer),
            "$device": $3017a5eb21b16dc2$var$_.info.device($3017a5eb21b16dc2$var$userAgent)
        }), {
            "$current_url": $3017a5eb21b16dc2$var$_.info.currentUrl(),
            "$browser_version": $3017a5eb21b16dc2$var$_.info.browserVersion($3017a5eb21b16dc2$var$userAgent, $3017a5eb21b16dc2$var$navigator.vendor, $3017a5eb21b16dc2$var$windowOpera),
            "$screen_height": $3017a5eb21b16dc2$var$screen.height,
            "$screen_width": $3017a5eb21b16dc2$var$screen.width,
            "mp_lib": "web",
            "$lib_version": $3017a5eb21b16dc2$var$Config.LIB_VERSION,
            "$insert_id": $3017a5eb21b16dc2$var$cheap_guid(),
            "time": $3017a5eb21b16dc2$var$_.timestamp() / 1000 // epoch time in seconds
        }, $3017a5eb21b16dc2$var$_.strip_empty_properties(extra_props));
    },
    people_properties: function() {
        return $3017a5eb21b16dc2$var$_.extend($3017a5eb21b16dc2$var$_.strip_empty_properties({
            "$os": $3017a5eb21b16dc2$var$_.info.os(),
            "$browser": $3017a5eb21b16dc2$var$_.info.browser($3017a5eb21b16dc2$var$userAgent, $3017a5eb21b16dc2$var$navigator.vendor, $3017a5eb21b16dc2$var$windowOpera)
        }), {
            "$browser_version": $3017a5eb21b16dc2$var$_.info.browserVersion($3017a5eb21b16dc2$var$userAgent, $3017a5eb21b16dc2$var$navigator.vendor, $3017a5eb21b16dc2$var$windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return $3017a5eb21b16dc2$var$_.strip_empty_properties({
            "current_page_title": $3017a5eb21b16dc2$var$document$1.title,
            "current_domain": $3017a5eb21b16dc2$var$win.location.hostname,
            "current_url_path": $3017a5eb21b16dc2$var$win.location.pathname,
            "current_url_protocol": $3017a5eb21b16dc2$var$win.location.protocol,
            "current_url_search": $3017a5eb21b16dc2$var$win.location.search
        });
    }
};
var $3017a5eb21b16dc2$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $3017a5eb21b16dc2$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $3017a5eb21b16dc2$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $3017a5eb21b16dc2$var$extract_domain = function(hostname) {
    var domain_regex = $3017a5eb21b16dc2$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split(".");
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === "com" || tld === "org") domain_regex = $3017a5eb21b16dc2$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : "";
};
var $3017a5eb21b16dc2$var$JSONStringify = null, $3017a5eb21b16dc2$var$JSONParse = null;
if (typeof JSON !== "undefined") {
    $3017a5eb21b16dc2$var$JSONStringify = JSON.stringify;
    $3017a5eb21b16dc2$var$JSONParse = JSON.parse;
}
$3017a5eb21b16dc2$var$JSONStringify = $3017a5eb21b16dc2$var$JSONStringify || $3017a5eb21b16dc2$var$_.JSONEncode;
$3017a5eb21b16dc2$var$JSONParse = $3017a5eb21b16dc2$var$JSONParse || $3017a5eb21b16dc2$var$_.JSONDecode;
// EXPORTS (for closure compiler)
$3017a5eb21b16dc2$var$_["toArray"] = $3017a5eb21b16dc2$var$_.toArray;
$3017a5eb21b16dc2$var$_["isObject"] = $3017a5eb21b16dc2$var$_.isObject;
$3017a5eb21b16dc2$var$_["JSONEncode"] = $3017a5eb21b16dc2$var$_.JSONEncode;
$3017a5eb21b16dc2$var$_["JSONDecode"] = $3017a5eb21b16dc2$var$_.JSONDecode;
$3017a5eb21b16dc2$var$_["isBlockedUA"] = $3017a5eb21b16dc2$var$_.isBlockedUA;
$3017a5eb21b16dc2$var$_["isEmptyObject"] = $3017a5eb21b16dc2$var$_.isEmptyObject;
$3017a5eb21b16dc2$var$_["info"] = $3017a5eb21b16dc2$var$_.info;
$3017a5eb21b16dc2$var$_["info"]["device"] = $3017a5eb21b16dc2$var$_.info.device;
$3017a5eb21b16dc2$var$_["info"]["browser"] = $3017a5eb21b16dc2$var$_.info.browser;
$3017a5eb21b16dc2$var$_["info"]["browserVersion"] = $3017a5eb21b16dc2$var$_.info.browserVersion;
$3017a5eb21b16dc2$var$_["info"]["properties"] = $3017a5eb21b16dc2$var$_.info.properties;
/* eslint camelcase: "off" */ /**
 * DomTracker Object
 * @constructor
 */ var $3017a5eb21b16dc2$var$DomTracker = function() {};
// interface
$3017a5eb21b16dc2$var$DomTracker.prototype.create_properties = function() {};
$3017a5eb21b16dc2$var$DomTracker.prototype.event_handler = function() {};
$3017a5eb21b16dc2$var$DomTracker.prototype.after_track_handler = function() {};
$3017a5eb21b16dc2$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $3017a5eb21b16dc2$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $3017a5eb21b16dc2$var$_.dom_query(query);
    if (elements.length === 0) {
        $3017a5eb21b16dc2$var$console.error("The DOM query (" + query + ") returned 0 elements");
        return;
    }
    $3017a5eb21b16dc2$var$_.each(elements, function(element) {
        $3017a5eb21b16dc2$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config("track_links_timeout");
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $3017a5eb21b16dc2$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$3017a5eb21b16dc2$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === "function") props = properties(element);
    else props = $3017a5eb21b16dc2$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $3017a5eb21b16dc2$var$LinkTracker = function() {
    this.override_event = "click";
};
$3017a5eb21b16dc2$var$_.inherit($3017a5eb21b16dc2$var$LinkTracker, $3017a5eb21b16dc2$var$DomTracker);
$3017a5eb21b16dc2$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $3017a5eb21b16dc2$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props["url"] = element.href;
    return props;
};
$3017a5eb21b16dc2$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === "_blank";
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$3017a5eb21b16dc2$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $3017a5eb21b16dc2$var$FormTracker = function() {
    this.override_event = "submit";
};
$3017a5eb21b16dc2$var$_.inherit($3017a5eb21b16dc2$var$FormTracker, $3017a5eb21b16dc2$var$DomTracker);
$3017a5eb21b16dc2$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$3017a5eb21b16dc2$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
var $3017a5eb21b16dc2$var$logger$2 = $3017a5eb21b16dc2$var$console_with_prefix("lock");
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $3017a5eb21b16dc2$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$3017a5eb21b16dc2$var$SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
    if (!pid && typeof errorCB !== "function") {
        pid = errorCB;
        errorCB = null;
    }
    var i = pid || new Date().getTime() + "|" + Math.random();
    var startTime = new Date().getTime();
    var key = this.storageKey;
    var pollIntervalMS = this.pollIntervalMS;
    var timeoutMS = this.timeoutMS;
    var storage = this.storage;
    var keyX = key + ":X";
    var keyY = key + ":Y";
    var keyZ = key + ":Z";
    var reportError = function(err) {
        errorCB && errorCB(err);
    };
    var delay = function(cb) {
        if (new Date().getTime() - startTime > timeoutMS) {
            $3017a5eb21b16dc2$var$logger$2.error("Timeout waiting for mutex on " + key + "; clearing lock. [" + i + "]");
            storage.removeItem(keyZ);
            storage.removeItem(keyY);
            loop();
            return;
        }
        setTimeout(function() {
            try {
                cb();
            } catch (err) {
                reportError(err);
            }
        }, pollIntervalMS * (Math.random() + 0.1));
    };
    var waitFor = function(predicate, cb) {
        if (predicate()) cb();
        else delay(function() {
            waitFor(predicate, cb);
        });
    };
    var getSetY = function() {
        var valY = storage.getItem(keyY);
        if (valY && valY !== i) return false;
        else {
            storage.setItem(keyY, i);
            if (storage.getItem(keyY) === i) return true;
            else {
                if (!$3017a5eb21b16dc2$var$localStorageSupported(storage, true)) throw new Error("localStorage support dropped while acquiring lock");
                return false;
            }
        }
    };
    var loop = function() {
        storage.setItem(keyX, i);
        waitFor(getSetY, function() {
            if (storage.getItem(keyX) === i) {
                criticalSection();
                return;
            }
            delay(function() {
                if (storage.getItem(keyY) !== i) {
                    loop();
                    return;
                }
                waitFor(function() {
                    return !storage.getItem(keyZ);
                }, criticalSection);
            });
        });
    };
    var criticalSection = function() {
        storage.setItem(keyZ, "1");
        try {
            lockedCB();
        } finally{
            storage.removeItem(keyZ);
            if (storage.getItem(keyY) === i) storage.removeItem(keyY);
            if (storage.getItem(keyX) === i) storage.removeItem(keyX);
        }
    };
    try {
        if ($3017a5eb21b16dc2$var$localStorageSupported(storage, true)) loop();
        else throw new Error("localStorage support check failed");
    } catch (err) {
        reportError(err);
    }
};
var $3017a5eb21b16dc2$var$logger$1 = $3017a5eb21b16dc2$var$console_with_prefix("batch");
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $3017a5eb21b16dc2$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.storage = options.storage || window.localStorage;
    this.reportError = options.errorReporter || $3017a5eb21b16dc2$var$_.bind($3017a5eb21b16dc2$var$logger$1.error, $3017a5eb21b16dc2$var$logger$1);
    this.lock = new $3017a5eb21b16dc2$var$SharedLock(storageKey, {
        storage: this.storage
    });
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $3017a5eb21b16dc2$var$RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
    var queueEntry = {
        "id": $3017a5eb21b16dc2$var$cheap_guid(),
        "flushAfter": new Date().getTime() + flushInterval * 2,
        "payload": item
    };
    this.lock.withLock($3017a5eb21b16dc2$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue.push(queueEntry);
            succeeded = this.saveToStorage(storedQueue);
            if (succeeded) // only add to in-memory queue when storage succeeds
            this.memQueue.push(queueEntry);
        } catch (err) {
            this.reportError("Error enqueueing item", item);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $3017a5eb21b16dc2$var$_.bind(function lockFailure(err) {
        this.reportError("Error acquiring storage lock", err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $3017a5eb21b16dc2$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (batch.length < batchSize) {
        // don't need lock just to read events; localStorage is thread-safe
        // and the worst that could happen is a duplicate send of some
        // orphaned events, which will be deduplicated on the server side
        var storedQueue = this.readFromStorage();
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $3017a5eb21b16dc2$var$_.each(batch, function(item) {
                idsInBatch[item["id"]] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item["flushAfter"] && !idsInBatch[item["id"]]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
    }
    return batch;
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $3017a5eb21b16dc2$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $3017a5eb21b16dc2$var$_.each(items, function(item) {
        if (item["id"] && !idSet[item["id"]]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $3017a5eb21b16dc2$var$RequestQueue.prototype.removeItemsByID = function(ids, cb) {
    var idSet = {}; // poor man's Set
    $3017a5eb21b16dc2$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $3017a5eb21b16dc2$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    var removeFromStorage = $3017a5eb21b16dc2$var$_.bind(function() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $3017a5eb21b16dc2$var$filterOutIDsAndInvalid(storedQueue, idSet);
            succeeded = this.saveToStorage(storedQueue);
            // an extra check: did storage report success but somehow
            // the items are still there?
            if (succeeded) {
                storedQueue = this.readFromStorage();
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item["id"] && !!idSet[item["id"]]) {
                        this.reportError("Item not removed from storage");
                        return false;
                    }
                }
            }
        } catch (err) {
            this.reportError("Error removing items", ids);
            succeeded = false;
        }
        return succeeded;
    }, this);
    this.lock.withLock(function lockAcquired() {
        var succeeded = removeFromStorage();
        if (cb) cb(succeeded);
    }, $3017a5eb21b16dc2$var$_.bind(function lockFailure(err) {
        var succeeded = false;
        this.reportError("Error acquiring storage lock", err);
        if (!$3017a5eb21b16dc2$var$localStorageSupported(this.storage, true)) {
            // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            succeeded = removeFromStorage();
            if (!succeeded) // OK, we couldn't even write out the smaller queue. Try clearing it
            // entirely.
            try {
                this.storage.removeItem(this.storageKey);
            } catch (err) {
                this.reportError("Error clearing queue", err);
            }
        }
        if (cb) cb(succeeded);
    }, this), this.pid);
};
// internal helper for RequestQueue.updatePayloads
var $3017a5eb21b16dc2$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $3017a5eb21b16dc2$var$_.each(existingItems, function(item) {
        var id = item["id"];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item["payload"] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $3017a5eb21b16dc2$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
    this.memQueue = $3017a5eb21b16dc2$var$updatePayloads(this.memQueue, itemsToUpdate);
    this.lock.withLock($3017a5eb21b16dc2$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $3017a5eb21b16dc2$var$updatePayloads(storedQueue, itemsToUpdate);
            succeeded = this.saveToStorage(storedQueue);
        } catch (err) {
            this.reportError("Error updating items", itemsToUpdate);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $3017a5eb21b16dc2$var$_.bind(function lockFailure(err) {
        this.reportError("Error acquiring storage lock", err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $3017a5eb21b16dc2$var$RequestQueue.prototype.readFromStorage = function() {
    var storageEntry;
    try {
        storageEntry = this.storage.getItem(this.storageKey);
        if (storageEntry) {
            storageEntry = $3017a5eb21b16dc2$var$JSONParse(storageEntry);
            if (!$3017a5eb21b16dc2$var$_.isArray(storageEntry)) {
                this.reportError("Invalid storage entry:", storageEntry);
                storageEntry = null;
            }
        }
    } catch (err) {
        this.reportError("Error retrieving queue", err);
        storageEntry = null;
    }
    return storageEntry || [];
};
/**
 * Serialize the given items array to localStorage.
 */ $3017a5eb21b16dc2$var$RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        this.storage.setItem(this.storageKey, $3017a5eb21b16dc2$var$JSONStringify(queue));
        return true;
    } catch (err) {
        this.reportError("Error saving queue", err);
        return false;
    }
};
/**
 * Clear out queues (memory and localStorage).
 */ $3017a5eb21b16dc2$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    this.storage.removeItem(this.storageKey);
};
// maximum interval between request retries after exponential backoff
var $3017a5eb21b16dc2$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $3017a5eb21b16dc2$var$logger = $3017a5eb21b16dc2$var$console_with_prefix("batch");
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $3017a5eb21b16dc2$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $3017a5eb21b16dc2$var$RequestQueue(storageKey, {
        errorReporter: $3017a5eb21b16dc2$var$_.bind(this.reportError, this),
        storage: options.storage
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig["batch_size"];
    this.flushInterval = this.libConfig["batch_flush_interval_ms"];
    this.stopped = !this.libConfig["batch_autostart"];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
};
/**
 * Add one item to queue.
 */ $3017a5eb21b16dc2$var$RequestBatcher.prototype.enqueue = function(item, cb) {
    this.queue.enqueue(item, this.flushInterval, cb);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $3017a5eb21b16dc2$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $3017a5eb21b16dc2$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $3017a5eb21b16dc2$var$RequestBatcher.prototype.clear = function() {
    this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $3017a5eb21b16dc2$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig["batch_size"];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $3017a5eb21b16dc2$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig["batch_flush_interval_ms"]);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $3017a5eb21b16dc2$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($3017a5eb21b16dc2$var$_.bind(this.flush, this), this.flushInterval);
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $3017a5eb21b16dc2$var$RequestBatcher.prototype.flush = function(options) {
    try {
        if (this.requestInProgress) {
            $3017a5eb21b16dc2$var$logger.log("Flush: Request already in progress");
            return;
        }
        options = options || {};
        var timeoutMS = this.libConfig["batch_request_timeout_ms"];
        var startTime = new Date().getTime();
        var currentBatchSize = this.batchSize;
        var batch = this.queue.fillBatch(currentBatchSize);
        var dataForRequest = [];
        var transformedItems = {};
        $3017a5eb21b16dc2$var$_.each(batch, function(item) {
            var payload = item["payload"];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload["event"] && payload["properties"]) payload["properties"] = $3017a5eb21b16dc2$var$_.extend({}, payload["properties"], {
                    "mp_sent_by_lib_version": $3017a5eb21b16dc2$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item["id"];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError("[dupe] item ID sent too many times, not sending", {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError("[dupe] found item with no ID", {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item["id"]] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.resetFlush();
            return; // nothing to do
        }
        this.requestInProgress = true;
        var batchSendCallback = $3017a5eb21b16dc2$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                var removeItemsFromQueue = false;
                if (options.unloading) // update persisted data to include hook transformations
                this.queue.updatePayloads(transformedItems);
                else if ($3017a5eb21b16dc2$var$_.isObject(res) && res.error === "timeout" && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError("Network timeout; retrying");
                    this.flush();
                } else if ($3017a5eb21b16dc2$var$_.isObject(res) && res.xhr_req && (res.xhr_req["status"] >= 500 || res.xhr_req["status"] === 429 || res.error === "timeout")) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    var headers = res.xhr_req["responseHeaders"];
                    if (headers) {
                        var retryAfter = headers["Retry-After"];
                        if (retryAfter) retryMS = parseInt(retryAfter, 10) * 1000 || retryMS;
                    }
                    retryMS = Math.min($3017a5eb21b16dc2$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError("Error; retry in " + retryMS + " ms");
                    this.scheduleFlush(retryMS);
                } else if ($3017a5eb21b16dc2$var$_.isObject(res) && res.xhr_req && res.xhr_req["status"] === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError("413 response; reducing batch size to " + this.batchSize);
                        this.resetFlush();
                    } else {
                        this.reportError("Single-event request too large; dropping", batch);
                        this.resetBatchSize();
                        removeItemsFromQueue = true;
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                removeItemsFromQueue = true;
                if (removeItemsFromQueue) {
                    this.queue.removeItemsByID($3017a5eb21b16dc2$var$_.map(batch, function(item) {
                        return item["id"];
                    }), $3017a5eb21b16dc2$var$_.bind(function(succeeded) {
                        if (succeeded) {
                            this.consecutiveRemovalFailures = 0;
                            this.flush(); // handle next batch if the queue isn't empty
                        } else {
                            this.reportError("Failed to remove items from queue");
                            if (++this.consecutiveRemovalFailures > 5) {
                                this.reportError("Too many queue failures; disabling batching system.");
                                this.stopAllBatching();
                            } else this.resetFlush();
                        }
                    }, this));
                    // client-side dedupe
                    $3017a5eb21b16dc2$var$_.each(batch, $3017a5eb21b16dc2$var$_.bind(function(item) {
                        var itemId = item["id"];
                        if (itemId) {
                            this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                            this.itemIdsSentSuccessfully[itemId]++;
                            if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError("[dupe] item ID sent too many times", {
                                item: item,
                                batchSize: batch.length,
                                timesSent: this.itemIdsSentSuccessfully[itemId]
                            });
                        } else this.reportError("[dupe] found item with no ID while removing", {
                            item: item
                        });
                    }, this));
                }
            } catch (err) {
                this.reportError("Error handling API response", err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: "POST",
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = "sendBeacon";
        $3017a5eb21b16dc2$var$logger.log("MIXPANEL REQUEST:", dataForRequest);
        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);
    } catch (err) {
        this.reportError("Error flushing request queue", err);
        this.resetFlush();
    }
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $3017a5eb21b16dc2$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $3017a5eb21b16dc2$var$logger.error.apply($3017a5eb21b16dc2$var$logger.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $3017a5eb21b16dc2$var$logger.error(err);
    }
};
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ /**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $3017a5eb21b16dc2$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = "__mp_opt_in_out_";
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $3017a5eb21b16dc2$var$optIn(token, options) {
    $3017a5eb21b16dc2$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $3017a5eb21b16dc2$var$optOut(token, options) {
    $3017a5eb21b16dc2$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $3017a5eb21b16dc2$var$hasOptedIn(token, options) {
    return $3017a5eb21b16dc2$var$_getStorageValue(token, options) === "1";
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $3017a5eb21b16dc2$var$hasOptedOut(token, options) {
    if ($3017a5eb21b16dc2$var$_hasDoNotTrackFlagOn(options)) {
        $3017a5eb21b16dc2$var$console.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $3017a5eb21b16dc2$var$_getStorageValue(token, options) === "0";
    if (optedOut) $3017a5eb21b16dc2$var$console.warn("You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.");
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $3017a5eb21b16dc2$var$addOptOutCheckMixpanelLib(method) {
    return $3017a5eb21b16dc2$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $3017a5eb21b16dc2$var$addOptOutCheckMixpanelPeople(method) {
    return $3017a5eb21b16dc2$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $3017a5eb21b16dc2$var$addOptOutCheckMixpanelGroup(method) {
    return $3017a5eb21b16dc2$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $3017a5eb21b16dc2$var$clearOptInOut(token, options) {
    options = options || {};
    $3017a5eb21b16dc2$var$_getStorage(options).remove($3017a5eb21b16dc2$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $3017a5eb21b16dc2$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === "localStorage" ? $3017a5eb21b16dc2$var$_.localStorage : $3017a5eb21b16dc2$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $3017a5eb21b16dc2$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $3017a5eb21b16dc2$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $3017a5eb21b16dc2$var$_getStorageValue(token, options) {
    return $3017a5eb21b16dc2$var$_getStorage(options).get($3017a5eb21b16dc2$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $3017a5eb21b16dc2$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win$1 = options && options.window || $3017a5eb21b16dc2$var$win;
    var nav = win$1["navigator"] || {};
    var hasDntOn = false;
    $3017a5eb21b16dc2$var$_.each([
        nav["doNotTrack"],
        nav["msDoNotTrack"],
        win$1["doNotTrack"]
    ], function(dntValue) {
        if ($3017a5eb21b16dc2$var$_.includes([
            true,
            1,
            "1",
            "yes"
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $3017a5eb21b16dc2$var$_optInOut(optValue, token, options) {
    if (!$3017a5eb21b16dc2$var$_.isString(token) || !token.length) {
        $3017a5eb21b16dc2$var$console.error("gdpr." + (optValue ? "optIn" : "optOut") + " called with an invalid token");
        return;
    }
    options = options || {};
    $3017a5eb21b16dc2$var$_getStorage(options).set($3017a5eb21b16dc2$var$_getStorageKey(token, options), optValue ? 1 : 0, $3017a5eb21b16dc2$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || "$opt_in", options.trackProperties, {
        "send_immediately": true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $3017a5eb21b16dc2$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, "token");
            var ignoreDnt = getConfigValue.call(this, "ignore_dnt");
            var persistenceType = getConfigValue.call(this, "opt_out_tracking_persistence_type");
            var persistencePrefix = getConfigValue.call(this, "opt_out_tracking_cookie_prefix");
            var win = getConfigValue.call(this, "window"); // used to override window during browser tests
            if (token) optedOut = $3017a5eb21b16dc2$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $3017a5eb21b16dc2$var$console.error("Unexpected error when checking tracking opt-out status: " + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === "function") callback(0);
        return;
    };
}
/* eslint camelcase: "off" */ /** @const */ var $3017a5eb21b16dc2$var$SET_ACTION = "$set";
/** @const */ var $3017a5eb21b16dc2$var$SET_ONCE_ACTION = "$set_once";
/** @const */ var $3017a5eb21b16dc2$var$UNSET_ACTION = "$unset";
/** @const */ var $3017a5eb21b16dc2$var$ADD_ACTION = "$add";
/** @const */ var $3017a5eb21b16dc2$var$APPEND_ACTION = "$append";
/** @const */ var $3017a5eb21b16dc2$var$UNION_ACTION = "$union";
/** @const */ var $3017a5eb21b16dc2$var$REMOVE_ACTION = "$remove";
/** @const */ var $3017a5eb21b16dc2$var$DELETE_ACTION = "$delete";
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $3017a5eb21b16dc2$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($3017a5eb21b16dc2$var$_.isObject(prop)) $3017a5eb21b16dc2$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$3017a5eb21b16dc2$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$3017a5eb21b16dc2$var$_.isArray(prop)) prop = [
            prop
        ];
        $3017a5eb21b16dc2$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$3017a5eb21b16dc2$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($3017a5eb21b16dc2$var$_.isObject(prop)) $3017a5eb21b16dc2$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$3017a5eb21b16dc2$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($3017a5eb21b16dc2$var$_.isObject(list_name)) $3017a5eb21b16dc2$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $3017a5eb21b16dc2$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $3017a5eb21b16dc2$var$_.isArray(values) ? values : [
            values
        ];
        data[$3017a5eb21b16dc2$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($3017a5eb21b16dc2$var$_.isObject(list_name)) $3017a5eb21b16dc2$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$3017a5eb21b16dc2$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($3017a5eb21b16dc2$var$_.isObject(list_name)) $3017a5eb21b16dc2$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$3017a5eb21b16dc2$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$3017a5eb21b16dc2$var$DELETE_ACTION] = "";
        return data;
    }
};
/* eslint camelcase: "off" */ /**
 * Mixpanel Group Object
 * @constructor
 */ var $3017a5eb21b16dc2$var$MixpanelGroup = function() {};
$3017a5eb21b16dc2$var$_.extend($3017a5eb21b16dc2$var$MixpanelGroup.prototype, $3017a5eb21b16dc2$var$apiActions);
$3017a5eb21b16dc2$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $3017a5eb21b16dc2$var$MixpanelGroup.prototype.set = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($3017a5eb21b16dc2$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $3017a5eb21b16dc2$var$MixpanelGroup.prototype.set_once = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($3017a5eb21b16dc2$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $3017a5eb21b16dc2$var$MixpanelGroup.prototype.unset = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $3017a5eb21b16dc2$var$MixpanelGroup.prototype.union = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($3017a5eb21b16dc2$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $3017a5eb21b16dc2$var$MixpanelGroup.prototype["delete"] = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $3017a5eb21b16dc2$var$MixpanelGroup.prototype.remove = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$3017a5eb21b16dc2$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data["$group_key"] = this._group_key;
    data["$group_id"] = this._group_id;
    data["$token"] = this._get_config("token");
    var date_encoded_data = $3017a5eb21b16dc2$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: "groups",
        data: date_encoded_data,
        endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes")["groups"],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$3017a5eb21b16dc2$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === "$group_key" || prop === "$group_id";
};
$3017a5eb21b16dc2$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$3017a5eb21b16dc2$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + ".group." + this._group_key + "." + this._group_id;
};
// MixpanelGroup Exports
$3017a5eb21b16dc2$var$MixpanelGroup.prototype["remove"] = $3017a5eb21b16dc2$var$MixpanelGroup.prototype.remove;
$3017a5eb21b16dc2$var$MixpanelGroup.prototype["set"] = $3017a5eb21b16dc2$var$MixpanelGroup.prototype.set;
$3017a5eb21b16dc2$var$MixpanelGroup.prototype["set_once"] = $3017a5eb21b16dc2$var$MixpanelGroup.prototype.set_once;
$3017a5eb21b16dc2$var$MixpanelGroup.prototype["union"] = $3017a5eb21b16dc2$var$MixpanelGroup.prototype.union;
$3017a5eb21b16dc2$var$MixpanelGroup.prototype["unset"] = $3017a5eb21b16dc2$var$MixpanelGroup.prototype.unset;
$3017a5eb21b16dc2$var$MixpanelGroup.prototype["toString"] = $3017a5eb21b16dc2$var$MixpanelGroup.prototype.toString;
/* eslint camelcase: "off" */ /**
 * Mixpanel People Object
 * @constructor
 */ var $3017a5eb21b16dc2$var$MixpanelPeople = function() {};
$3017a5eb21b16dc2$var$_.extend($3017a5eb21b16dc2$var$MixpanelPeople.prototype, $3017a5eb21b16dc2$var$apiActions);
$3017a5eb21b16dc2$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $3017a5eb21b16dc2$var$MixpanelPeople.prototype.set = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($3017a5eb21b16dc2$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config("save_referrer")) this._mixpanel["persistence"].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$3017a5eb21b16dc2$var$SET_ACTION] = $3017a5eb21b16dc2$var$_.extend({}, $3017a5eb21b16dc2$var$_.info.people_properties(), data[$3017a5eb21b16dc2$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $3017a5eb21b16dc2$var$MixpanelPeople.prototype.set_once = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($3017a5eb21b16dc2$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $3017a5eb21b16dc2$var$MixpanelPeople.prototype.unset = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $3017a5eb21b16dc2$var$MixpanelPeople.prototype.increment = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($3017a5eb21b16dc2$var$_.isObject(prop)) {
        $3017a5eb21b16dc2$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $3017a5eb21b16dc2$var$console.error("Invalid increment value passed to mixpanel.people.increment - must be a number");
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($3017a5eb21b16dc2$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$3017a5eb21b16dc2$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $3017a5eb21b16dc2$var$MixpanelPeople.prototype.append = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($3017a5eb21b16dc2$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $3017a5eb21b16dc2$var$MixpanelPeople.prototype.remove = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($3017a5eb21b16dc2$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $3017a5eb21b16dc2$var$MixpanelPeople.prototype.union = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($3017a5eb21b16dc2$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $3017a5eb21b16dc2$var$MixpanelPeople.prototype.track_charge = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!$3017a5eb21b16dc2$var$_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            $3017a5eb21b16dc2$var$console.error("Invalid value passed to mixpanel.people.track_charge - must be a number");
            return;
        }
    }
    return this.append("$transactions", $3017a5eb21b16dc2$var$_.extend({
        "$amount": amount
    }, properties), callback);
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $3017a5eb21b16dc2$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set("$transactions", [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $3017a5eb21b16dc2$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $3017a5eb21b16dc2$var$console.error("mixpanel.people.delete_user() requires you to call identify() first");
        return;
    }
    var data = {
        "$delete": this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$3017a5eb21b16dc2$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + ".people";
};
$3017a5eb21b16dc2$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data["$token"] = this._get_config("token");
    data["$distinct_id"] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property("$device_id");
    var user_id = this._mixpanel.get_property("$user_id");
    var had_persisted_distinct_id = this._mixpanel.get_property("$had_persisted_distinct_id");
    if (device_id) data["$device_id"] = device_id;
    if (user_id) data["$user_id"] = user_id;
    if (had_persisted_distinct_id) data["$had_persisted_distinct_id"] = had_persisted_distinct_id;
    var date_encoded_data = $3017a5eb21b16dc2$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$3017a5eb21b16dc2$var$_.isUndefined(callback)) {
            if (this._get_config("verbose")) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $3017a5eb21b16dc2$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: "people",
        data: date_encoded_data,
        endpoint: this._get_config("api_host") + "/" + this._get_config("api_routes")["engage"],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$3017a5eb21b16dc2$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$3017a5eb21b16dc2$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$3017a5eb21b16dc2$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($3017a5eb21b16dc2$var$SET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($3017a5eb21b16dc2$var$SET_ACTION, data);
    else if ($3017a5eb21b16dc2$var$SET_ONCE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($3017a5eb21b16dc2$var$SET_ONCE_ACTION, data);
    else if ($3017a5eb21b16dc2$var$UNSET_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($3017a5eb21b16dc2$var$UNSET_ACTION, data);
    else if ($3017a5eb21b16dc2$var$ADD_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($3017a5eb21b16dc2$var$ADD_ACTION, data);
    else if ($3017a5eb21b16dc2$var$APPEND_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($3017a5eb21b16dc2$var$APPEND_ACTION, data);
    else if ($3017a5eb21b16dc2$var$REMOVE_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($3017a5eb21b16dc2$var$REMOVE_ACTION, data);
    else if ($3017a5eb21b16dc2$var$UNION_ACTION in data) this._mixpanel["persistence"]._add_to_people_queue($3017a5eb21b16dc2$var$UNION_ACTION, data);
    else $3017a5eb21b16dc2$var$console.error("Invalid call to _enqueue():", data);
};
$3017a5eb21b16dc2$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $3017a5eb21b16dc2$var$_.extend({}, this._mixpanel["persistence"].load_queue(action));
    var action_params = queued_data;
    if (!$3017a5eb21b16dc2$var$_.isUndefined(queued_data) && $3017a5eb21b16dc2$var$_.isObject(queued_data) && !$3017a5eb21b16dc2$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel["persistence"]._pop_from_people_queue(action, queued_data);
        _this._mixpanel["persistence"].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue(action, queued_data);
            if (!$3017a5eb21b16dc2$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$3017a5eb21b16dc2$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue($3017a5eb21b16dc2$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($3017a5eb21b16dc2$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($3017a5eb21b16dc2$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $3017a5eb21b16dc2$var$_.keys(queue);
    });
    this._flush_one_queue($3017a5eb21b16dc2$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($3017a5eb21b16dc2$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel["persistence"].load_queue($3017a5eb21b16dc2$var$APPEND_ACTION);
    if (!$3017a5eb21b16dc2$var$_.isUndefined($append_queue) && $3017a5eb21b16dc2$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($3017a5eb21b16dc2$var$APPEND_ACTION, $append_item);
            if (!$3017a5eb21b16dc2$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel["persistence"].load_queue($3017a5eb21b16dc2$var$APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel["persistence"].save();
            if (!$3017a5eb21b16dc2$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel["persistence"].load_queue($3017a5eb21b16dc2$var$REMOVE_ACTION);
    if (!$3017a5eb21b16dc2$var$_.isUndefined($remove_queue) && $3017a5eb21b16dc2$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel["persistence"]._add_to_people_queue($3017a5eb21b16dc2$var$REMOVE_ACTION, $remove_item);
            if (!$3017a5eb21b16dc2$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel["persistence"].load_queue($3017a5eb21b16dc2$var$REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel["persistence"].save();
            if (!$3017a5eb21b16dc2$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
$3017a5eb21b16dc2$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === "$distinct_id" || prop === "$token" || prop === "$device_id" || prop === "$user_id" || prop === "$had_persisted_distinct_id";
};
// MixpanelPeople Exports
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["set"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.set;
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["set_once"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.set_once;
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["unset"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.unset;
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["increment"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.increment;
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["append"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.append;
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["remove"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.remove;
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["union"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.union;
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["track_charge"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.track_charge;
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["clear_charges"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.clear_charges;
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["delete_user"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.delete_user;
$3017a5eb21b16dc2$var$MixpanelPeople.prototype["toString"] = $3017a5eb21b16dc2$var$MixpanelPeople.prototype.toString;
/* eslint camelcase: "off" */ /*
 * Constants
 */ /** @const */ var $3017a5eb21b16dc2$var$SET_QUEUE_KEY = "__mps";
/** @const */ var $3017a5eb21b16dc2$var$SET_ONCE_QUEUE_KEY = "__mpso";
/** @const */ var $3017a5eb21b16dc2$var$UNSET_QUEUE_KEY = "__mpus";
/** @const */ var $3017a5eb21b16dc2$var$ADD_QUEUE_KEY = "__mpa";
/** @const */ var $3017a5eb21b16dc2$var$APPEND_QUEUE_KEY = "__mpap";
/** @const */ var $3017a5eb21b16dc2$var$REMOVE_QUEUE_KEY = "__mpr";
/** @const */ var $3017a5eb21b16dc2$var$UNION_QUEUE_KEY = "__mpu";
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $3017a5eb21b16dc2$var$PEOPLE_DISTINCT_ID_KEY = "$people_distinct_id";
/** @const */ var $3017a5eb21b16dc2$var$ALIAS_ID_KEY = "__alias";
/** @const */ var $3017a5eb21b16dc2$var$EVENT_TIMERS_KEY = "__timers";
/** @const */ var $3017a5eb21b16dc2$var$RESERVED_PROPERTIES = [
    $3017a5eb21b16dc2$var$SET_QUEUE_KEY,
    $3017a5eb21b16dc2$var$SET_ONCE_QUEUE_KEY,
    $3017a5eb21b16dc2$var$UNSET_QUEUE_KEY,
    $3017a5eb21b16dc2$var$ADD_QUEUE_KEY,
    $3017a5eb21b16dc2$var$APPEND_QUEUE_KEY,
    $3017a5eb21b16dc2$var$REMOVE_QUEUE_KEY,
    $3017a5eb21b16dc2$var$UNION_QUEUE_KEY,
    $3017a5eb21b16dc2$var$PEOPLE_DISTINCT_ID_KEY,
    $3017a5eb21b16dc2$var$ALIAS_ID_KEY,
    $3017a5eb21b16dc2$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $3017a5eb21b16dc2$var$MixpanelPersistence = function(config) {
    this["props"] = {};
    this.campaign_params_saved = false;
    if (config["persistence_name"]) this.name = "mp_" + config["persistence_name"];
    else this.name = "mp_" + config["token"] + "_mixpanel";
    var storage_type = config["persistence"];
    if (storage_type !== "cookie" && storage_type !== "localStorage") {
        $3017a5eb21b16dc2$var$console.critical("Unknown persistence type " + storage_type + "; falling back to cookie");
        storage_type = config["persistence"] = "cookie";
    }
    if (storage_type === "localStorage" && $3017a5eb21b16dc2$var$_.localStorage.is_supported()) this.storage = $3017a5eb21b16dc2$var$_.localStorage;
    else this.storage = $3017a5eb21b16dc2$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    $3017a5eb21b16dc2$var$_.each(this["props"], function(v, k) {
        if (!$3017a5eb21b16dc2$var$_.include($3017a5eb21b16dc2$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this["props"] = $3017a5eb21b16dc2$var$_.extend({}, entry);
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.upgrade = function(config) {
    var upgrade_from_old_lib = config["upgrade"], old_cookie_name, old_cookie;
    if (upgrade_from_old_lib) {
        old_cookie_name = "mp_super_properties";
        // Case where they had a custom cookie name before.
        if (typeof upgrade_from_old_lib === "string") old_cookie_name = upgrade_from_old_lib;
        old_cookie = this.storage.parse(old_cookie_name);
        // remove the cookie
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);
        if (old_cookie) this["props"] = $3017a5eb21b16dc2$var$_.extend(this["props"], old_cookie["all"], old_cookie["events"]);
    }
    if (!config["cookie_name"] && config["name"] !== "mixpanel") {
        // special case to handle people with cookies of the form
        // mp_TOKEN_INSTANCENAME from the first release of this library
        old_cookie_name = "mp_" + config["token"] + "_" + config["name"];
        old_cookie = this.storage.parse(old_cookie_name);
        if (old_cookie) {
            this.storage.remove(old_cookie_name);
            this.storage.remove(old_cookie_name, true);
            // Save the prop values that were in the cookie from before -
            // this should only happen once as we delete the old one.
            this.register_once(old_cookie);
        }
    }
    if (this.storage === $3017a5eb21b16dc2$var$_.localStorage) {
        old_cookie = $3017a5eb21b16dc2$var$_.cookie.parse(this.name);
        $3017a5eb21b16dc2$var$_.cookie.remove(this.name);
        $3017a5eb21b16dc2$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    }
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $3017a5eb21b16dc2$var$_.JSONEncode(this["props"]), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this["props"][key];
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this["props"] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $3017a5eb21b16dc2$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($3017a5eb21b16dc2$var$_.isObject(props)) {
        if (typeof default_value === "undefined") default_value = "None";
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        this.load();
        $3017a5eb21b16dc2$var$_.each(props, function(val, prop) {
            if (!this["props"].hasOwnProperty(prop) || this["props"][prop] === default_value) this["props"][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $3017a5eb21b16dc2$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($3017a5eb21b16dc2$var$_.isObject(props)) {
        this.expire_days = typeof days === "undefined" ? this.default_expiry : days;
        this.load();
        $3017a5eb21b16dc2$var$_.extend(this["props"], props);
        this.save();
        return true;
    }
    return false;
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this["props"]) {
        delete this["props"][prop];
        this.save();
    }
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($3017a5eb21b16dc2$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        "$initial_referrer": referrer || "$direct",
        "$initial_referring_domain": $3017a5eb21b16dc2$var$_.info.referringDomain(referrer) || "$direct"
    }, "");
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $3017a5eb21b16dc2$var$_.strip_empty_properties({
        "$initial_referrer": this["props"]["$initial_referrer"],
        "$initial_referring_domain": this["props"]["$initial_referring_domain"]
    });
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config["cookie_expiration"];
    this.set_disabled(config["disable_persistence"]);
    this.set_cookie_domain(config["cookie_domain"]);
    this.set_cross_site(config["cross_site_cookie"]);
    this.set_cross_subdomain(config["cross_subdomain_cookie"]);
    this.set_secure(config["secure_cookie"]);
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($3017a5eb21b16dc2$var$SET_ACTION), set_once_q = this._get_or_create_queue($3017a5eb21b16dc2$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($3017a5eb21b16dc2$var$UNSET_ACTION), add_q = this._get_or_create_queue($3017a5eb21b16dc2$var$ADD_ACTION), union_q = this._get_or_create_queue($3017a5eb21b16dc2$var$UNION_ACTION), remove_q = this._get_or_create_queue($3017a5eb21b16dc2$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($3017a5eb21b16dc2$var$APPEND_ACTION, []);
    if (q_key === $3017a5eb21b16dc2$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $3017a5eb21b16dc2$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($3017a5eb21b16dc2$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($3017a5eb21b16dc2$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($3017a5eb21b16dc2$var$UNSET_ACTION, q_data);
    } else if (q_key === $3017a5eb21b16dc2$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $3017a5eb21b16dc2$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($3017a5eb21b16dc2$var$UNSET_ACTION, q_data);
    } else if (q_key === $3017a5eb21b16dc2$var$UNSET_QUEUE_KEY) $3017a5eb21b16dc2$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $3017a5eb21b16dc2$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $3017a5eb21b16dc2$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $3017a5eb21b16dc2$var$ADD_QUEUE_KEY) {
        $3017a5eb21b16dc2$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($3017a5eb21b16dc2$var$UNSET_ACTION, q_data);
    } else if (q_key === $3017a5eb21b16dc2$var$UNION_QUEUE_KEY) {
        $3017a5eb21b16dc2$var$_.each(q_data, function(v, k) {
            if ($3017a5eb21b16dc2$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue($3017a5eb21b16dc2$var$UNSET_ACTION, q_data);
    } else if (q_key === $3017a5eb21b16dc2$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($3017a5eb21b16dc2$var$APPEND_ACTION, q_data);
    } else if (q_key === $3017a5eb21b16dc2$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($3017a5eb21b16dc2$var$UNSET_ACTION, q_data);
    }
    $3017a5eb21b16dc2$var$console.log("MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):");
    $3017a5eb21b16dc2$var$console.log(data);
    this.save();
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this["props"][this._get_queue_key(queue)];
    if (!$3017a5eb21b16dc2$var$_.isUndefined(q)) $3017a5eb21b16dc2$var$_.each(data, function(v, k) {
        if (queue === $3017a5eb21b16dc2$var$APPEND_ACTION || queue === $3017a5eb21b16dc2$var$REMOVE_ACTION) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        $3017a5eb21b16dc2$var$_.each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $3017a5eb21b16dc2$var$SET_ACTION) return $3017a5eb21b16dc2$var$SET_QUEUE_KEY;
    else if (queue === $3017a5eb21b16dc2$var$SET_ONCE_ACTION) return $3017a5eb21b16dc2$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $3017a5eb21b16dc2$var$UNSET_ACTION) return $3017a5eb21b16dc2$var$UNSET_QUEUE_KEY;
    else if (queue === $3017a5eb21b16dc2$var$ADD_ACTION) return $3017a5eb21b16dc2$var$ADD_QUEUE_KEY;
    else if (queue === $3017a5eb21b16dc2$var$APPEND_ACTION) return $3017a5eb21b16dc2$var$APPEND_QUEUE_KEY;
    else if (queue === $3017a5eb21b16dc2$var$REMOVE_ACTION) return $3017a5eb21b16dc2$var$REMOVE_QUEUE_KEY;
    else if (queue === $3017a5eb21b16dc2$var$UNION_ACTION) return $3017a5eb21b16dc2$var$UNION_QUEUE_KEY;
    else $3017a5eb21b16dc2$var$console.error("Invalid queue:", queue);
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $3017a5eb21b16dc2$var$_.isUndefined(default_val) ? {} : default_val;
    return this["props"][key] || (this["props"][key] = default_val);
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop($3017a5eb21b16dc2$var$EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this["props"][$3017a5eb21b16dc2$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop($3017a5eb21b16dc2$var$EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!$3017a5eb21b16dc2$var$_.isUndefined(timestamp)) {
        delete this["props"][$3017a5eb21b16dc2$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/* eslint camelcase: "off" */ /*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ // ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==
/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $3017a5eb21b16dc2$var$init_type; // MODULE or SNIPPET loader
var $3017a5eb21b16dc2$var$mixpanel_master; // main mixpanel instance / object
var $3017a5eb21b16dc2$var$INIT_MODULE = 0;
var $3017a5eb21b16dc2$var$INIT_SNIPPET = 1;
var $3017a5eb21b16dc2$var$IDENTITY_FUNC = function(x) {
    return x;
};
var $3017a5eb21b16dc2$var$NOOP_FUNC = function() {};
/** @const */ var $3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME = "mixpanel";
/** @const */ var $3017a5eb21b16dc2$var$PAYLOAD_TYPE_BASE64 = "base64";
/** @const */ var $3017a5eb21b16dc2$var$PAYLOAD_TYPE_JSON = "json";
/** @const */ var $3017a5eb21b16dc2$var$DEVICE_ID_PREFIX = "$device:";
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $3017a5eb21b16dc2$var$USE_XHR = $3017a5eb21b16dc2$var$win.XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $3017a5eb21b16dc2$var$ENQUEUE_REQUESTS = !$3017a5eb21b16dc2$var$USE_XHR && $3017a5eb21b16dc2$var$userAgent.indexOf("MSIE") === -1 && $3017a5eb21b16dc2$var$userAgent.indexOf("Mozilla") === -1;
// save reference to navigator.sendBeacon so it can be minified
var $3017a5eb21b16dc2$var$sendBeacon = null;
if ($3017a5eb21b16dc2$var$navigator["sendBeacon"]) $3017a5eb21b16dc2$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $3017a5eb21b16dc2$var$navigator["sendBeacon"].apply($3017a5eb21b16dc2$var$navigator, arguments);
};
var $3017a5eb21b16dc2$var$DEFAULT_API_ROUTES = {
    "track": "track/",
    "engage": "engage/",
    "groups": "groups/",
    "record": "record/"
};
/*
 * Module-level globals
 */ var $3017a5eb21b16dc2$var$DEFAULT_CONFIG = {
    "api_host": "https://api-js.mixpanel.com",
    "api_routes": $3017a5eb21b16dc2$var$DEFAULT_API_ROUTES,
    "api_method": "POST",
    "api_transport": "XHR",
    "api_payload_format": $3017a5eb21b16dc2$var$PAYLOAD_TYPE_BASE64,
    "app_host": "https://mixpanel.com",
    "cdn": "https://cdn.mxpnl.com",
    "cross_site_cookie": false,
    "cross_subdomain_cookie": true,
    "error_reporter": $3017a5eb21b16dc2$var$NOOP_FUNC,
    "persistence": "cookie",
    "persistence_name": "",
    "cookie_domain": "",
    "cookie_name": "",
    "loaded": $3017a5eb21b16dc2$var$NOOP_FUNC,
    "mp_loader": null,
    "track_marketing": true,
    "track_pageview": false,
    "skip_first_touch_marketing": false,
    "store_google": true,
    "stop_utm_persistence": false,
    "save_referrer": true,
    "test": false,
    "verbose": false,
    "img": false,
    "debug": false,
    "track_links_timeout": 300,
    "cookie_expiration": 365,
    "upgrade": false,
    "disable_persistence": false,
    "disable_cookie": false,
    "secure_cookie": false,
    "ip": true,
    "opt_out_tracking_by_default": false,
    "opt_out_persistence_by_default": false,
    "opt_out_tracking_persistence_type": "localStorage",
    "opt_out_tracking_cookie_prefix": null,
    "property_blacklist": [],
    "xhr_headers": {},
    "ignore_dnt": false,
    "batch_requests": true,
    "batch_size": 50,
    "batch_flush_interval_ms": 5000,
    "batch_request_timeout_ms": 90000,
    "batch_autostart": true,
    "hooks": {},
    "record_sessions_percent": 0,
    "record_idle_timeout_ms": 1800000,
    "record_max_ms": $3017a5eb21b16dc2$var$MAX_RECORDING_MS,
    "record_mask_text_selector": "*",
    "recorder_src": "https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js"
};
var $3017a5eb21b16dc2$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $3017a5eb21b16dc2$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $3017a5eb21b16dc2$var$create_mplib = function(token, config, name) {
    var instance, target = name === $3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME ? $3017a5eb21b16dc2$var$mixpanel_master : $3017a5eb21b16dc2$var$mixpanel_master[name];
    if (target && $3017a5eb21b16dc2$var$init_type === $3017a5eb21b16dc2$var$INIT_MODULE) instance = target;
    else {
        if (target && !$3017a5eb21b16dc2$var$_.isArray(target)) {
            $3017a5eb21b16dc2$var$console.error("You have already initialized " + name);
            return;
        }
        instance = new $3017a5eb21b16dc2$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance["people"] = new $3017a5eb21b16dc2$var$MixpanelPeople();
    instance["people"]._init(instance);
    if (!instance.get_config("skip_first_touch_marketing")) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $3017a5eb21b16dc2$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $3017a5eb21b16dc2$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params["initial_" + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance["people"].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $3017a5eb21b16dc2$var$Config.DEBUG = $3017a5eb21b16dc2$var$Config.DEBUG || instance.get_config("debug");
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$3017a5eb21b16dc2$var$_.isUndefined(target) && $3017a5eb21b16dc2$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance["people"], target["people"]);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($3017a5eb21b16dc2$var$_.isUndefined(name)) {
        this.report_error("You must name your new library: init(token, config, name)");
        return;
    }
    if (name === $3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME) {
        this.report_error("You must initialize the main mixpanel object right after you include the Mixpanel js snippet");
        return;
    }
    var instance = $3017a5eb21b16dc2$var$create_mplib(token, config, name);
    $3017a5eb21b16dc2$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$3017a5eb21b16dc2$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this["__loaded"] = true;
    this["config"] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!("api_payload_format" in config)) {
        var api_host = config["api_host"] || $3017a5eb21b16dc2$var$DEFAULT_CONFIG["api_host"];
        if (api_host.match(/\.mixpanel\.com/)) variable_features["api_payload_format"] = $3017a5eb21b16dc2$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($3017a5eb21b16dc2$var$_.extend({}, $3017a5eb21b16dc2$var$DEFAULT_CONFIG, variable_features, config, {
        "name": name,
        "token": token,
        "callback_fn": (name === $3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME ? name : $3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME + "." + name) + "._jsc"
    }));
    this["_jsc"] = $3017a5eb21b16dc2$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        "disable_all_events": false,
        "identify_called": false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config("batch_requests");
    if (this._batch_requests) {
        if (!$3017a5eb21b16dc2$var$_.localStorage.is_supported(true) || !$3017a5eb21b16dc2$var$USE_XHR) {
            this._batch_requests = false;
            $3017a5eb21b16dc2$var$console.log("Turning off Mixpanel request-queueing; needs XHR and localStorage support");
            $3017a5eb21b16dc2$var$_.each(this.get_batcher_configs(), function(batcher_config) {
                $3017a5eb21b16dc2$var$console.log("Clearing batch queue " + batcher_config.queue_key);
                $3017a5eb21b16dc2$var$_.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if ($3017a5eb21b16dc2$var$sendBeacon && $3017a5eb21b16dc2$var$win.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $3017a5eb21b16dc2$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $3017a5eb21b16dc2$var$win.addEventListener("pagehide", function(ev) {
                    if (ev["persisted"]) flush_on_unload();
                });
                $3017a5eb21b16dc2$var$win.addEventListener("visibilitychange", function() {
                    if ($3017a5eb21b16dc2$var$document$1["visibilityState"] === "hidden") flush_on_unload();
                });
            }
        }
    }
    this["persistence"] = this["cookie"] = new $3017a5eb21b16dc2$var$MixpanelPersistence(this["config"]);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $3017a5eb21b16dc2$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        "distinct_id": $3017a5eb21b16dc2$var$DEVICE_ID_PREFIX + uuid,
        "$device_id": uuid
    }, "");
    var track_pageview_option = this.get_config("track_pageview");
    if (track_pageview_option) this._init_url_change_tracking(track_pageview_option);
    if (this.get_config("record_sessions_percent") > 0 && Math.random() * 100 <= this.get_config("record_sessions_percent")) this.start_session_recording();
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype.start_session_recording = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelLib(function() {
    if (!$3017a5eb21b16dc2$var$win["MutationObserver"]) {
        $3017a5eb21b16dc2$var$console.critical("Browser does not support MutationObserver; skipping session recording");
        return;
    }
    var handleLoadedRecorder = $3017a5eb21b16dc2$var$_.bind(function() {
        this._recorder = this._recorder || new $3017a5eb21b16dc2$var$win["__mp_recorder"](this);
        this._recorder["startRecording"]();
    }, this);
    if ($3017a5eb21b16dc2$var$_.isUndefined($3017a5eb21b16dc2$var$win["__mp_recorder"])) {
        var scriptEl = $3017a5eb21b16dc2$var$document$1.createElement("script");
        scriptEl.type = "text/javascript";
        scriptEl.async = true;
        scriptEl.onload = handleLoadedRecorder;
        scriptEl.src = this.get_config("recorder_src");
        $3017a5eb21b16dc2$var$document$1.head.appendChild(scriptEl);
    } else handleLoadedRecorder();
});
$3017a5eb21b16dc2$var$MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) this._recorder["stopRecording"]();
    else $3017a5eb21b16dc2$var$console.critical("Session recorder module not loaded");
};
// Private methods
$3017a5eb21b16dc2$var$MixpanelLib.prototype._loaded = function() {
    this.get_config("loaded")(this);
    this._set_default_superprops();
    this["people"].set_once(this["persistence"].get_referrer_info());
    // The original 'store_google' functionality will be deprecated and the config will be
    // used to clear previously managed UTM parameters from persistence.
    // stop_utm_persistence is `false` by default now but will be default `true` in the future.
    if (this.get_config("store_google") && this.get_config("stop_utm_persistence")) {
        var utm_params = $3017a5eb21b16dc2$var$_.info.campaignParams(null);
        $3017a5eb21b16dc2$var$_.each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
$3017a5eb21b16dc2$var$MixpanelLib.prototype._set_default_superprops = function() {
    this["persistence"].update_search_keyword($3017a5eb21b16dc2$var$document$1.referrer);
    if (this.get_config("store_google") && !this.get_config("stop_utm_persistence")) this.register($3017a5eb21b16dc2$var$_.info.campaignParams());
    if (this.get_config("save_referrer")) this["persistence"].update_referrer_info($3017a5eb21b16dc2$var$document$1.referrer);
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype._dom_loaded = function() {
    $3017a5eb21b16dc2$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $3017a5eb21b16dc2$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config("img")) {
        this.report_error("You can't use DOM tracking functions with img = true.");
        return false;
    }
    if (!$3017a5eb21b16dc2$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype._init_url_change_tracking = function(track_pageview_option) {
    var previous_tracked_url = "";
    var tracked = this.track_pageview();
    if (tracked) previous_tracked_url = $3017a5eb21b16dc2$var$_.info.currentUrl();
    if ($3017a5eb21b16dc2$var$_.include([
        "full-url",
        "url-with-path-and-query-string",
        "url-with-path"
    ], track_pageview_option)) {
        $3017a5eb21b16dc2$var$win.addEventListener("popstate", function() {
            $3017a5eb21b16dc2$var$win.dispatchEvent(new Event("mp_locationchange"));
        });
        $3017a5eb21b16dc2$var$win.addEventListener("hashchange", function() {
            $3017a5eb21b16dc2$var$win.dispatchEvent(new Event("mp_locationchange"));
        });
        var nativePushState = $3017a5eb21b16dc2$var$win.history.pushState;
        if (typeof nativePushState === "function") $3017a5eb21b16dc2$var$win.history.pushState = function(state, unused, url) {
            nativePushState.call($3017a5eb21b16dc2$var$win.history, state, unused, url);
            $3017a5eb21b16dc2$var$win.dispatchEvent(new Event("mp_locationchange"));
        };
        var nativeReplaceState = $3017a5eb21b16dc2$var$win.history.replaceState;
        if (typeof nativeReplaceState === "function") $3017a5eb21b16dc2$var$win.history.replaceState = function(state, unused, url) {
            nativeReplaceState.call($3017a5eb21b16dc2$var$win.history, state, unused, url);
            $3017a5eb21b16dc2$var$win.dispatchEvent(new Event("mp_locationchange"));
        };
        $3017a5eb21b16dc2$var$win.addEventListener("mp_locationchange", (function() {
            var current_url = $3017a5eb21b16dc2$var$_.info.currentUrl();
            var should_track = false;
            if (track_pageview_option === "full-url") should_track = current_url !== previous_tracked_url;
            else if (track_pageview_option === "url-with-path-and-query-string") should_track = current_url.split("#")[0] !== previous_tracked_url.split("#")[0];
            else if (track_pageview_option === "url-with-path") should_track = current_url.split("#")[0].split("?")[0] !== previous_tracked_url.split("#")[0].split("?")[0];
            if (should_track) {
                var tracked = this.track_pageview();
                if (tracked) previous_tracked_url = current_url;
            }
        }).bind(this));
    }
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($3017a5eb21b16dc2$var$_.isUndefined(callback)) return null;
    if ($3017a5eb21b16dc2$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this["_jsc"];
        var randomized_cb = "" + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config("callback_fn") + "[" + randomized_cb + "]";
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($3017a5eb21b16dc2$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config("api_method"),
        transport: this.get_config("api_transport"),
        verbose: this.get_config("verbose")
    };
    var body_data = null;
    if (!callback && ($3017a5eb21b16dc2$var$_.isFunction(options) || typeof options === "string")) {
        callback = options;
        options = null;
    }
    options = $3017a5eb21b16dc2$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$3017a5eb21b16dc2$var$USE_XHR) options.method = "GET";
    var use_post = options.method === "POST";
    var use_sendBeacon = $3017a5eb21b16dc2$var$sendBeacon && use_post && options.transport.toLowerCase() === "sendbeacon";
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data["verbose"]) verbose_mode = true;
    if (this.get_config("test")) data["test"] = 1;
    if (verbose_mode) data["verbose"] = 1;
    if (this.get_config("img")) data["img"] = 1;
    if (!$3017a5eb21b16dc2$var$USE_XHR) {
        if (callback) data["callback"] = callback;
        else if (verbose_mode || this.get_config("test")) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data["callback"] = "(function(){})";
    }
    data["ip"] = this.get_config("ip") ? 1 : 0;
    data["_"] = new Date().getTime().toString();
    if (use_post) {
        body_data = "data=" + encodeURIComponent(data["data"]);
        delete data["data"];
    }
    url += "?" + $3017a5eb21b16dc2$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ("img" in data) {
        var img = $3017a5eb21b16dc2$var$document$1.createElement("img");
        img.src = url;
        $3017a5eb21b16dc2$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $3017a5eb21b16dc2$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($3017a5eb21b16dc2$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config("xhr_headers");
        if (use_post) headers["Content-Type"] = "application/x-www-form-urlencoded";
        $3017a5eb21b16dc2$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== "undefined") {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $3017a5eb21b16dc2$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = "timeout";
                    else error = "Bad HTTP status: " + req.status + " " + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) callback({
                            status: 0,
                            error: error,
                            xhr_req: req
                        });
                        else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $3017a5eb21b16dc2$var$document$1.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $3017a5eb21b16dc2$var$document$1.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $3017a5eb21b16dc2$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($3017a5eb21b16dc2$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === "function") item.call(this);
            else if ($3017a5eb21b16dc2$var$_.isArray(item) && fn_name === "alias") alias_calls.push(item);
            else if ($3017a5eb21b16dc2$var$_.isArray(item) && fn_name.indexOf("track") !== -1 && typeof this[fn_name] === "function") tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $3017a5eb21b16dc2$var$_.each(calls, function(item) {
            if ($3017a5eb21b16dc2$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $3017a5eb21b16dc2$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$3017a5eb21b16dc2$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = "__mpq_" + this.get_config("token");
    var api_routes = this.get_config("api_routes");
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: "events",
            endpoint: "/" + api_routes["track"],
            queue_key: queue_prefix + "_ev"
        },
        people: {
            type: "people",
            endpoint: "/" + api_routes["engage"],
            queue_key: queue_prefix + "_pp"
        },
        groups: {
            type: "groups",
            endpoint: "/" + api_routes["groups"],
            queue_key: queue_prefix + "_gr"
        }
    };
    return this._batcher_configs;
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = $3017a5eb21b16dc2$var$_.bind(function(attrs) {
            return new $3017a5eb21b16dc2$var$RequestBatcher(attrs.queue_key, {
                libConfig: this["config"],
                sendRequestFunc: $3017a5eb21b16dc2$var$_.bind(function(data, options, cb) {
                    this._send_request(this.get_config("api_host") + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $3017a5eb21b16dc2$var$_.bind(function(item) {
                    return this._run_hook("before_send_" + attrs.type, item);
                }, this),
                errorReporter: this.get_config("error_reporter"),
                stopAllBatchingFunc: $3017a5eb21b16dc2$var$_.bind(this.stop_batch_senders, this)
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config("batch_autostart")) this.start_batch_senders();
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $3017a5eb21b16dc2$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $3017a5eb21b16dc2$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === "undefined") this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $3017a5eb21b16dc2$var$_.JSONEncode(data);
    if (this.get_config("api_payload_format") === $3017a5eb21b16dc2$var$PAYLOAD_TYPE_BASE64) encoded_data = $3017a5eb21b16dc2$var$_.base64Encode(encoded_data);
    return {
        "data": encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$3017a5eb21b16dc2$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $3017a5eb21b16dc2$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $3017a5eb21b16dc2$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $3017a5eb21b16dc2$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook("before_send_" + options.type, truncated_data);
        if (truncated_data) {
            $3017a5eb21b16dc2$var$console.log("MIXPANEL REQUEST:");
            $3017a5eb21b16dc2$var$console.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data, function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.track = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === "function") {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options["transport"]; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options["send_immediately"];
    if (typeof callback !== "function") callback = $3017a5eb21b16dc2$var$NOOP_FUNC;
    if ($3017a5eb21b16dc2$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.track");
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = $3017a5eb21b16dc2$var$_.extend({}, properties);
    properties["token"] = this.get_config("token");
    // set $duration if time_event was previously called for this event
    var start_timestamp = this["persistence"].remove_event_timer(event_name);
    if (!$3017a5eb21b16dc2$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties["$duration"] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config("track_marketing") ? $3017a5eb21b16dc2$var$_.info.marketingParams() : {};
    if (this._recorder) {
        var replay_id = this._recorder["replayId"];
        if (replay_id) properties["$mp_replay_id"] = replay_id;
    }
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $3017a5eb21b16dc2$var$_.extend({}, $3017a5eb21b16dc2$var$_.info.properties({
        "mp_loader": this.get_config("mp_loader")
    }), marketing_properties, this["persistence"].properties(), this.unpersisted_superprops, properties);
    var property_blacklist = this.get_config("property_blacklist");
    if ($3017a5eb21b16dc2$var$_.isArray(property_blacklist)) $3017a5eb21b16dc2$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error("Invalid value for property_blacklist config: " + property_blacklist);
    var data = {
        "event": event_name,
        "properties": properties
    };
    var ret = this._track_or_batch({
        type: "events",
        data: data,
        endpoint: this.get_config("api_host") + "/" + this.get_config("api_routes")["track"],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.set_group = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$3017a5eb21b16dc2$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this["people"].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.add_group = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this["people"].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.remove_group = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this["people"].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.track_with_groups = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $3017a5eb21b16dc2$var$_.extend({}, properties || {});
    $3017a5eb21b16dc2$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$3017a5eb21b16dc2$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + "_" + JSON.stringify(group_id);
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $3017a5eb21b16dc2$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.track_pageview = $3017a5eb21b16dc2$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== "object") properties = {};
    options = options || {};
    var event_name = options["event_name"] || "$mp_web_page_view";
    var default_page_properties = $3017a5eb21b16dc2$var$_.extend($3017a5eb21b16dc2$var$_.info.mpPageViewProperties(), $3017a5eb21b16dc2$var$_.info.campaignParams(), $3017a5eb21b16dc2$var$_.info.clickParams());
    var event_properties = $3017a5eb21b16dc2$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $3017a5eb21b16dc2$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $3017a5eb21b16dc2$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($3017a5eb21b16dc2$var$_.isUndefined(event_name)) {
        this.report_error("No event name provided to mixpanel.time_event");
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this["persistence"].set_event_timer(event_name, new Date().getTime());
};
var $3017a5eb21b16dc2$var$REGISTER_DEFAULTS = {
    "persistent": true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $3017a5eb21b16dc2$var$options_for_register = function(days_or_options) {
    var options;
    if ($3017a5eb21b16dc2$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$3017a5eb21b16dc2$var$_.isUndefined(days_or_options)) options = {
        "days": days_or_options
    };
    else options = {};
    return $3017a5eb21b16dc2$var$_.extend({}, $3017a5eb21b16dc2$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $3017a5eb21b16dc2$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register(props, options["days"]);
    else $3017a5eb21b16dc2$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $3017a5eb21b16dc2$var$options_for_register(days_or_options);
    if (options["persistent"]) this["persistence"].register_once(props, default_value, options["days"]);
    else {
        if (typeof default_value === "undefined") default_value = "None";
        $3017a5eb21b16dc2$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $3017a5eb21b16dc2$var$options_for_register(options);
    if (options["persistent"]) this["persistence"].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === "string" && new_distinct_id.indexOf($3017a5eb21b16dc2$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error("distinct_id cannot have $device: prefix");
            return -1;
        }
        this.register({
            "$user_id": new_distinct_id
        });
    }
    if (!this.get_property("$device_id")) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            "$had_persisted_distinct_id": true,
            "$device_id": device_id
        }, "");
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($3017a5eb21b16dc2$var$ALIAS_ID_KEY)) {
        this.unregister($3017a5eb21b16dc2$var$ALIAS_ID_KEY);
        this.register({
            "distinct_id": new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this["people"]._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track("$identify", {
        "distinct_id": new_distinct_id,
        "$anon_distinct_id": previous_distinct_id
    }, {
        skip_hooks: true
    });
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.reset = function() {
    this["persistence"].clear();
    this._flags.identify_called = false;
    var uuid = $3017a5eb21b16dc2$var$_.UUID();
    this.register_once({
        "distinct_id": $3017a5eb21b16dc2$var$DEVICE_ID_PREFIX + uuid,
        "$device_id": uuid
    }, "");
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property("distinct_id");
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($3017a5eb21b16dc2$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error("Attempting to create alias for existing People user - aborting.");
        return -2;
    }
    var _this = this;
    if ($3017a5eb21b16dc2$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($3017a5eb21b16dc2$var$ALIAS_ID_KEY, alias);
        return this.track("$create_alias", {
            "alias": alias,
            "distinct_id": original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error("alias matches current distinct_id - skipping api call.");
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single("mp_name_tag", name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.set_config = function(config) {
    if ($3017a5eb21b16dc2$var$_.isObject(config)) {
        $3017a5eb21b16dc2$var$_.extend(this["config"], config);
        var new_batch_size = config["batch_size"];
        if (new_batch_size) $3017a5eb21b16dc2$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config("persistence_name")) this["config"]["persistence_name"] = this["config"]["cookie_name"];
        if (!this.get_config("disable_persistence")) this["config"]["disable_persistence"] = this["config"]["disable_cookie"];
        if (this["persistence"]) this["persistence"].update_config(this["config"]);
        $3017a5eb21b16dc2$var$Config.DEBUG = $3017a5eb21b16dc2$var$Config.DEBUG || this.get_config("debug");
    }
};
/**
 * returns the current config object for the library.
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this["config"][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this["config"]["hooks"][hook_name] || $3017a5eb21b16dc2$var$IDENTITY_FUNC).apply(this, $3017a5eb21b16dc2$var$slice.call(arguments, 1));
    if (typeof ret === "undefined") {
        this.report_error(hook_name + " hook did not return a value");
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this["persistence"].load_prop([
        property_name
    ]);
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config("name");
    if (name !== $3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME) name = $3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME + "." + name;
    return name;
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $3017a5eb21b16dc2$var$_.isBlockedUA($3017a5eb21b16dc2$var$userAgent) || this._flags.disable_all_events || $3017a5eb21b16dc2$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$3017a5eb21b16dc2$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config("opt_out_tracking_persistence_type") === "localStorage";
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $3017a5eb21b16dc2$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            "persistence_type": "cookie"
        })) this.opt_in_tracking({
            "enable_persistence": false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            "persistence_type": "cookie"
        })) this.opt_out_tracking({
            "clear_persistence": false
        });
        this.clear_opt_in_out_tracking({
            "persistence_type": "cookie",
            "enable_persistence": false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        "clear_persistence": true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config("opt_out_tracking_by_default") || $3017a5eb21b16dc2$var$_.cookie.get("mp_optout"))) {
        $3017a5eb21b16dc2$var$_.cookie.remove("mp_optout");
        this.opt_out_tracking({
            "clear_persistence": this.get_config("opt_out_persistence_by_default")
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options["clear_persistence"]) disabled = true;
    else if (options && options["enable_persistence"]) disabled = false;
    else return;
    if (!this.get_config("disable_persistence") && this["persistence"].disabled !== disabled) this["persistence"].set_disabled(disabled);
    if (disabled) this.stop_batch_senders();
    else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
$3017a5eb21b16dc2$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $3017a5eb21b16dc2$var$_.extend({
        "track": $3017a5eb21b16dc2$var$_.bind(this.track, this),
        "persistence_type": this.get_config("opt_out_tracking_persistence_type"),
        "cookie_prefix": this.get_config("opt_out_tracking_cookie_prefix"),
        "cookie_expiration": this.get_config("cookie_expiration"),
        "cross_site_cookie": this.get_config("cross_site_cookie"),
        "cross_subdomain_cookie": this.get_config("cross_subdomain_cookie"),
        "cookie_domain": this.get_config("cookie_domain"),
        "secure_cookie": this.get_config("secure_cookie"),
        "ignore_dnt": this.get_config("ignore_dnt")
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$3017a5eb21b16dc2$var$_.localStorage.is_supported()) options["persistence_type"] = "cookie";
    return func(this.get_config("token"), {
        track: options["track"],
        trackEventName: options["track_event_name"],
        trackProperties: options["track_properties"],
        persistenceType: options["persistence_type"],
        persistencePrefix: options["cookie_prefix"],
        cookieDomain: options["cookie_domain"],
        cookieExpiration: options["cookie_expiration"],
        crossSiteCookie: options["cross_site_cookie"],
        crossSubdomainCookie: options["cross_subdomain_cookie"],
        secureCookie: options["secure_cookie"],
        ignoreDnt: options["ignore_dnt"]
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $3017a5eb21b16dc2$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($3017a5eb21b16dc2$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $3017a5eb21b16dc2$var$_.extend({
        "clear_persistence": true,
        "delete_user": true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options["delete_user"] && this["people"] && this["people"]._identify_called()) {
        this["people"].delete_user();
        this["people"].clear_charges();
    }
    this._gdpr_call_func($3017a5eb21b16dc2$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($3017a5eb21b16dc2$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($3017a5eb21b16dc2$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $3017a5eb21b16dc2$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $3017a5eb21b16dc2$var$_.extend({
        "enable_persistence": true
    }, options);
    this._gdpr_call_func($3017a5eb21b16dc2$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$3017a5eb21b16dc2$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $3017a5eb21b16dc2$var$console.error.apply($3017a5eb21b16dc2$var$console.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config("error_reporter")(msg, err);
    } catch (err) {
        $3017a5eb21b16dc2$var$console.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$3017a5eb21b16dc2$var$MixpanelLib.prototype["init"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.init;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["reset"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.reset;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["disable"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.disable;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["time_event"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.time_event;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["track"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.track;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["track_links"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.track_links;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["track_forms"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.track_forms;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["track_pageview"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.track_pageview;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["register"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.register;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["register_once"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.register_once;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["unregister"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.unregister;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["identify"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.identify;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["alias"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.alias;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["name_tag"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.name_tag;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["set_config"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.set_config;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["get_config"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.get_config;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["get_property"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.get_property;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["get_distinct_id"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.get_distinct_id;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["toString"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.toString;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["opt_out_tracking"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.opt_out_tracking;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["opt_in_tracking"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.opt_in_tracking;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["has_opted_out_tracking"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.has_opted_out_tracking;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["has_opted_in_tracking"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.has_opted_in_tracking;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["clear_opt_in_out_tracking"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["get_group"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.get_group;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["set_group"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.set_group;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["add_group"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.add_group;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["remove_group"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.remove_group;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["track_with_groups"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.track_with_groups;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["start_batch_senders"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.start_batch_senders;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["stop_batch_senders"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.stop_batch_senders;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["start_session_recording"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.start_session_recording;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["stop_session_recording"] = $3017a5eb21b16dc2$var$MixpanelLib.prototype.stop_session_recording;
$3017a5eb21b16dc2$var$MixpanelLib.prototype["DEFAULT_API_ROUTES"] = $3017a5eb21b16dc2$var$DEFAULT_API_ROUTES;
// MixpanelPersistence Exports
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype["properties"] = $3017a5eb21b16dc2$var$MixpanelPersistence.prototype.properties;
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype["update_search_keyword"] = $3017a5eb21b16dc2$var$MixpanelPersistence.prototype.update_search_keyword;
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype["update_referrer_info"] = $3017a5eb21b16dc2$var$MixpanelPersistence.prototype.update_referrer_info;
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype["get_cross_subdomain"] = $3017a5eb21b16dc2$var$MixpanelPersistence.prototype.get_cross_subdomain;
$3017a5eb21b16dc2$var$MixpanelPersistence.prototype["clear"] = $3017a5eb21b16dc2$var$MixpanelPersistence.prototype.clear;
var $3017a5eb21b16dc2$var$instances = {};
var $3017a5eb21b16dc2$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $3017a5eb21b16dc2$var$_.each($3017a5eb21b16dc2$var$instances, function(instance, name) {
        if (name !== $3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME) $3017a5eb21b16dc2$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $3017a5eb21b16dc2$var$mixpanel_master["_"] = $3017a5eb21b16dc2$var$_;
};
var $3017a5eb21b16dc2$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $3017a5eb21b16dc2$var$mixpanel_master["init"] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$3017a5eb21b16dc2$var$mixpanel_master[name]) {
                $3017a5eb21b16dc2$var$mixpanel_master[name] = $3017a5eb21b16dc2$var$instances[name] = $3017a5eb21b16dc2$var$create_mplib(token, config, name);
                $3017a5eb21b16dc2$var$mixpanel_master[name]._loaded();
            }
            return $3017a5eb21b16dc2$var$mixpanel_master[name];
        } else {
            var instance = $3017a5eb21b16dc2$var$mixpanel_master;
            if ($3017a5eb21b16dc2$var$instances[$3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $3017a5eb21b16dc2$var$instances[$3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $3017a5eb21b16dc2$var$create_mplib(token, config, $3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $3017a5eb21b16dc2$var$instances[$3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $3017a5eb21b16dc2$var$mixpanel_master = instance;
            if ($3017a5eb21b16dc2$var$init_type === $3017a5eb21b16dc2$var$INIT_SNIPPET) $3017a5eb21b16dc2$var$win[$3017a5eb21b16dc2$var$PRIMARY_INSTANCE_NAME] = $3017a5eb21b16dc2$var$mixpanel_master;
            $3017a5eb21b16dc2$var$extend_mp();
        }
    };
};
var $3017a5eb21b16dc2$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $3017a5eb21b16dc2$var$DOM_LOADED = true;
        $3017a5eb21b16dc2$var$ENQUEUE_REQUESTS = false;
        $3017a5eb21b16dc2$var$_.each($3017a5eb21b16dc2$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $3017a5eb21b16dc2$var$document$1.documentElement.doScroll("left");
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($3017a5eb21b16dc2$var$document$1.addEventListener) {
        if ($3017a5eb21b16dc2$var$document$1.readyState === "complete") // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $3017a5eb21b16dc2$var$document$1.addEventListener("DOMContentLoaded", dom_loaded_handler, false);
    } else if ($3017a5eb21b16dc2$var$document$1.attachEvent) {
        // IE
        $3017a5eb21b16dc2$var$document$1.attachEvent("onreadystatechange", dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $3017a5eb21b16dc2$var$win.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($3017a5eb21b16dc2$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $3017a5eb21b16dc2$var$_.register_event($3017a5eb21b16dc2$var$win, "load", dom_loaded_handler, true);
};
function $3017a5eb21b16dc2$var$init_as_module() {
    $3017a5eb21b16dc2$var$init_type = $3017a5eb21b16dc2$var$INIT_MODULE;
    $3017a5eb21b16dc2$var$mixpanel_master = new $3017a5eb21b16dc2$var$MixpanelLib();
    $3017a5eb21b16dc2$var$override_mp_init_func();
    $3017a5eb21b16dc2$var$mixpanel_master["init"]();
    $3017a5eb21b16dc2$var$add_dom_loaded_handler();
    return $3017a5eb21b16dc2$var$mixpanel_master;
}
/* eslint camelcase: "off" */ var $3017a5eb21b16dc2$var$mixpanel = $3017a5eb21b16dc2$var$init_as_module();
$3017a5eb21b16dc2$exports = $3017a5eb21b16dc2$var$mixpanel;


// Near entry of your product, init Mixpanel
(0, (/*@__PURE__*/$parcel$interopDefault($3017a5eb21b16dc2$exports))).init("d61c65daaf1004001601eb7615f614ac", {
    debug: true,
    persistence: "localStorage"
});


const $cbd5e2ca5ac31863$var$AddressForm = ()=>{
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    (0, (/*@__PURE__*/$parcel$interopDefault($3017a5eb21b16dc2$exports))).track("form-page-viewed", {
        "form-name": "address"
    });
    const options = (0, (/*@__PURE__*/$parcel$interopDefault($8159aa64a7960b5d$exports))).options;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            const newState = {
                ...state,
                ...values
            };
            // Form submission logic here
            console.log(newState);
            navigate("/hahs/payment", {
                state: newState
            });
        },
        validate: (values)=>{
            const errors = {};
            const addressError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.address);
            errors.address = addressError;
            const cityError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.city);
            errors.city = cityError;
            const stateError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.state);
            errors.state = stateError;
            const zipError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.zip);
            errors.zip = zipError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid, form: form })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-clip rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Home Address"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                                    children: "Your address is used to connect you with clinicians who are licensed in your state. Your personal information is never sold or shared."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "address",
                                        title: "Address",
                                        placeholder: "Address *",
                                        autoComplete: "street-address",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "addressLine2",
                                        title: "Address Line 2",
                                        placeholder: "Address Line 2",
                                        autoComplete: "address-line2"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "city",
                                        title: "City",
                                        placeholder: "City",
                                        autoComplete: "address-level2",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                        name: "state",
                                        placeholder: "State",
                                        options: options,
                                        className: "react-select-container min-w-40 max-w-64 form-input focus:border-mustard text-caringwire rounded-md bg-transparent text-2xl font-thin transition-colors duration-200 ease-in-out focus:outline-none",
                                        required: true,
                                        onChange: (option)=>{
                                            form.change("state", option.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "zip",
                                        title: "Zip",
                                        placeholder: "Zip",
                                        autoComplete: "postal-code",
                                        required: true
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    // print all the values
                                                    console.log(state);
                                                    navigate("/hahs/dob", {
                                                        state: {
                                                            ...state,
                                                            country: "United States"
                                                        }
                                                    });
                                                },
                                                className: "bg-caringwire mr-8 inline-flex items-center px-4 py-2 font-bold text-white hover:bg-blue-700",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u2190"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", !valid && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", !valid && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $cbd5e2ca5ac31863$export$2e2bcd8739ae039 = $cbd5e2ca5ac31863$var$AddressForm;





parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $59TQn = parcelRequire("59TQn");
function $41bb2bdb656054d2$export$842dcfa371c6bb83(val, countryCode, addSuffix, allowExtension, isAllowedKey) {
    try {
        var clean = val.replace(/\D/g, ""), // NOTE: we use AsYouTypeFormatter because the default format function can't handle incomplete numbers e.g. "+17024" formats to "+1 7024" as opposed to "+1 702-4"
        formatter = new (0, $59TQn.AsYouTypeFormatter)(countryCode), // if clean is empty, we still need this to be a string otherwise we get errors later
        result = "", next, extSuffix = " ext. ";
        if (val.substr(0, 1) == "+") clean = "+" + clean;
        for(var i = 0; i < clean.length; i++){
            // TODO: improve this so don't just pump in every digit every time - we should just cache this formatter object, and just call inputDigit once each time the user enters a new digit
            next = formatter.inputDigit(clean.charAt(i));
            // if adding this char didn't change the length, or made it smaller (and there's no longer any spaces): that means that formatting failed which means the number was no longer a potentially valid number, so if we're allowing extensions: assume the rest is the ext
            if (allowExtension && result && next.length <= result.length && next.indexOf(" ") == -1) {
                // set flag for extension
                next = -1;
                break;
            }
            result = next;
        }
        // for some reason libphonenumber formats "+44" to "+44 ", but doesn't do the same with "+1"
        if (result.charAt(result.length - 1) == " ") result = result.substr(0, result.length - 1);
        // check if there's a suffix to add (unless there's an ext)
        if (addSuffix && !val.split(extSuffix)[1]) {
            // hack to get formatting suffix
            var test = formatter.inputDigit("5");
            // again the "+44 " problem... (also affects "+45" apparently)
            if (test.charAt(test.length - 1) == " ") test = test.substr(0, test.length - 1);
            // if adding a '5' introduces a formatting char - check if the penultimate char is not-a-number
            var penultimate = test.substr(test.length - 2, 1);
            // Note: never use isNaN without parseFloat
            if (isNaN(parseFloat(penultimate))) // return the new value (minus that last '5' we just added)
            return test.substr(0, test.length - 1);
            else if (allowExtension && result && test.length <= result.length && test.indexOf(" ") == -1 && !isAllowedKey) // else if the next digit would break the formating, and we're allowing extensions, AND this is not an allowed key: add the suffix
            // NOTE: we must check this is not an allowed key because if it was that means it was the last digit in a valid number and we dont want to add the "ext" suffix in that case. This whole condition is just here to catch the case that: after typing a valid number, they try to type "ext" - this will not automatically add it for them.
            return result + extSuffix;
        }
        // if the clean number contains an extension we need to add it
        if (next == -1) result += extSuffix + clean.substring(i, clean.length);
        return result;
    } catch (e) {
        return val;
    }
}


// Define a list of options for the dropdown
const $036040cd3bc5e884$var$countryOptions = [
    {
        label: "United States",
        code: "1",
        value: "US",
        flag: "\uD83C\uDDFA\uD83C\uDDF8"
    },
    {
        label: "Australia",
        code: "61",
        value: "AU",
        flag: "\uD83C\uDDE6\uD83C\uDDFA"
    },
    {
        label: "Brazil",
        code: "55",
        value: "BR",
        flag: "\uD83C\uDDE7\uD83C\uDDF7"
    },
    {
        label: "Canada",
        code: "1",
        value: "CA",
        flag: "\uD83C\uDDE8\uD83C\uDDE6"
    },
    {
        label: "China",
        code: "86",
        value: "CN",
        flag: "\uD83C\uDDE8\uD83C\uDDF3"
    },
    {
        label: "France",
        code: "33",
        value: "FR",
        flag: "\uD83C\uDDEB\uD83C\uDDF7"
    },
    {
        label: "Germany",
        code: "49",
        value: "DE",
        flag: "\uD83C\uDDE9\uD83C\uDDEA"
    },
    {
        label: "India",
        code: "91",
        value: "IN",
        flag: "\uD83C\uDDEE\uD83C\uDDF3"
    },
    {
        label: "Italy",
        code: "39",
        value: "IT",
        flag: "\uD83C\uDDEE\uD83C\uDDF9"
    },
    {
        label: "Japan",
        code: "81",
        value: "JP",
        flag: "\uD83C\uDDEF\uD83C\uDDF5"
    },
    {
        label: "Mexico",
        code: "52",
        value: "MX",
        flag: "\uD83C\uDDF2\uD83C\uDDFD"
    },
    {
        label: "New Zealand",
        code: "64",
        value: "NZ",
        flag: "\uD83C\uDDF3\uD83C\uDDFF"
    },
    {
        label: "Russia",
        code: "7",
        value: "RU",
        flag: "\uD83C\uDDF7\uD83C\uDDFA"
    },
    {
        label: "South Africa",
        code: "27",
        value: "ZA",
        flag: "\uD83C\uDDFF\uD83C\uDDE6"
    },
    {
        label: "Spain",
        code: "34",
        value: "ES",
        flag: "\uD83C\uDDEA\uD83C\uDDF8"
    },
    {
        label: "United Kingdom",
        code: "44",
        value: "GB",
        flag: "\uD83C\uDDEC\uD83C\uDDE7"
    }
];
const $036040cd3bc5e884$var$FlagMenuList = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9284aba291bbde9$export$db3b6bfb95261072).MenuList, {
        ...props,
        className: "w-72"
    });
const $036040cd3bc5e884$var$FlagMenu = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a9284aba291bbde9$export$db3b6bfb95261072).Menu, {
        ...props,
        className: "w-fit"
    });
const $036040cd3bc5e884$var$PhoneNumberInput = ({ name: name, title: title, required: required })=>{
    const [selectedCountry, setSelectedCountry] = (0, $acw62.useState)($036040cd3bc5e884$var$countryOptions[0]);
    const { change: change } = (0, $a22611c327162735$export$87c0cf8eb5a167e0)();
    const handleCountryChange = (option)=>{
        setSelectedCountry(option);
        change("phoneNumber", "");
    };
    const formatPhoneNumber = (value)=>{
        let cleanValue = value?.replace(/\D/g, "").substring(0, 16);
        if (cleanValue?.length === 0 || !cleanValue) return "+" + selectedCountry.code;
        return `${(0, $41bb2bdb656054d2$export$842dcfa371c6bb83)(value, selectedCountry.value, true, true, false)}`.replace("ext.", "").trim();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a455218a85c89869), {
        name: name,
        validate: (value)=>{
            return (0, $3ef5978a8f0aae1f$export$d6781b696a0576d1)(value || "", selectedCountry.value) ? undefined : "Invalid phone number";
        },
        format: formatPhoneNumber,
        render: ({ input: input, meta: meta })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("focus-within:border-mustard flex flex-row flex-wrap rounded-md border-2 bg-transparent px-4 py-2 text-2xl transition-colors duration-200  ease-in-out ", meta.error && meta.touched ? "border-red-500" : "border-caringwire"),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                options: $036040cd3bc5e884$var$countryOptions,
                                value: selectedCountry,
                                onChange: handleCountryChange,
                                formatOptionLabel: (option, { context: context })=>context === "value" ? option.flag : `${option.flag} ${option.label}`,
                                components: {
                                    MenuList: $036040cd3bc5e884$var$FlagMenuList,
                                    Menu: $036040cd3bc5e884$var$FlagMenu
                                },
                                placeholder: "Select a country",
                                className: "mr-4 flex-none rounded-none bg-transparent text-lg transition-colors duration-200 ease-in-out focus:border-blue-500 focus:outline-none"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                ...input,
                                type: "tel",
                                autoComplete: "tel",
                                placeholder: "+1(123)456-7890",
                                className: "w-52 flex-auto border-0 outline-none font-light text-caringwire"
                            })
                        ]
                    }),
                    meta.error && meta.touched && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 w-fit rounded-md border border-red-500 bg-red-100 p-2 text-sm text-red-800",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                role: "img",
                                "aria-label": "alert",
                                className: "mr-2",
                                children: "\u26A0\uFE0F"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: meta.error
                            })
                        ]
                    })
                ]
            })
    });
};
var $036040cd3bc5e884$export$2e2bcd8739ae039 = $036040cd3bc5e884$var$PhoneNumberInput;






const $1a00bb0b32f3727d$var$InfoForm = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const params = new URLSearchParams(searchParams);
    const orgId = params.get("org_id");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            // only keep the digits and remove whitespace
            const phoneNumber = `+${values.phoneNumber.replace(/\D/g, "")}`;
            const params = {
                ...values,
                phoneNumber: phoneNumber,
                orgId: orgId
            };
            // Form submission logic here
            (0, (/*@__PURE__*/$parcel$interopDefault($3017a5eb21b16dc2$exports))).track("form-page-viewed", {
                "form-name": "info"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($3017a5eb21b16dc2$exports))).track("form-started", params);
            console.log(params);
            navigate("/hahs/dob", {
                state: params
            });
        },
        validate: (values)=>{
            const errors = {};
            const firstNameError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.firstName);
            errors.firstName = firstNameError;
            const lastNameError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.lastName);
            errors.lastName = lastNameError;
            const phoneNumberError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.phoneNumber);
            errors.phoneNumber = phoneNumberError;
            const emailError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.email) || (0, $3ef5978a8f0aae1f$export$d290fa47940df19d)(values.email);
            errors.email = emailError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-clip rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 bg-white p-10 pb-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Register for HAHS"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue text-center text-xl font-light",
                                    children: "The following information is used to setup your HAHS account and provide access."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "firstName",
                                        title: "First Name",
                                        placeholder: "First Name *",
                                        type: "text",
                                        autoComplete: "given-name",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "lastName",
                                        title: "Last Name",
                                        placeholder: "Last Name *",
                                        type: "text",
                                        autoComplete: "family-name",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $036040cd3bc5e884$export$2e2bcd8739ae039), {
                                        name: "phoneNumber",
                                        title: "Phone number",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "email",
                                        title: "Email",
                                        placeholder: "Email *",
                                        type: "email",
                                        autoComplete: "email",
                                        required: true
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", !valid && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", !valid && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $1a00bb0b32f3727d$export$2e2bcd8739ae039 = $1a00bb0b32f3727d$var$InfoForm;





parcelRequire("acw62");





const $81e332e9c2fc3191$var$DateOfBirthForm = ()=>{
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    (0, (/*@__PURE__*/$parcel$interopDefault($3017a5eb21b16dc2$exports))).track("form-page-viewed", {
        "form-name": "date-of-birth"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        initialValues: state,
        onSubmit: async (values)=>{
            const newState = {
                ...state,
                ...values
            };
            // Form submission logic here
            console.log(newState);
            navigate("/hahs/address", {
                state: newState
            });
        },
        validate: (values)=>{
            const errors = {};
            const monthError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.dateOfBirthMonth);
            errors.dateOfBirthMonth = monthError;
            const dayError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.dateOfBirthDay);
            errors.dateOfBirthDay = dayError;
            const yearError = (0, $3ef5978a8f0aae1f$export$a7a0278c004aac3f)(values.dateOfBirthYear);
            errors.dateOfBirthYear = yearError;
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-clip rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Date of Birth"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                                    children: "This is required to establish access to on-demand Telehealth and Tele-Therapy. Your personal information is encrypted, secured and protected by HIPPA."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthMonth",
                                        title: "MM",
                                        placeholder: "MM *",
                                        type: "text",
                                        maxLength: 2,
                                        format: (value)=>{
                                            // only allow 01-12
                                            const month = value?.replace(/\D/g, "");
                                            if (month && parseInt(month) > 12) return "12";
                                            else return month;
                                        },
                                        autoComplete: "bday-month",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthDay",
                                        title: "DD",
                                        placeholder: "DD *",
                                        type: "text",
                                        maxLength: 2,
                                        format: (value)=>{
                                            // only allow 01-31
                                            const day = value?.replace(/\D/g, "");
                                            if (day && parseInt(day) > 31) return "31";
                                            else return day;
                                        },
                                        autoComplete: "bday-day",
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75a48a2374c3e07e$export$2e2bcd8739ae039), {
                                        name: "dateOfBirthYear",
                                        title: "YYYY",
                                        placeholder: "YYYY *",
                                        type: "text",
                                        maxLength: 4,
                                        format: (value)=>value?.replace(/\D/g, ""),
                                        autoComplete: "bday-year",
                                        required: true
                                    }),
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    navigate("/hahs", {
                                                        state: state
                                                    });
                                                },
                                                className: "bg-caringwire mr-8 inline-flex items-center px-4 py-2 font-bold text-white hover:bg-blue-700",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u2190"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", !valid && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", !valid && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $81e332e9c2fc3191$export$2e2bcd8739ae039 = $81e332e9c2fc3191$var$DateOfBirthForm;





parcelRequire("acw62");


var $7bf3b98cbc00db03$exports = {};

(function(global, factory) {
    factory($7bf3b98cbc00db03$exports, (parcelRequire("acw62")));
})($7bf3b98cbc00db03$exports, function(exports1, React) {
    "use strict";
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = "Invariant Violation";
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === "object";
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === "function";
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === "function" && typeof raw.createToken === "function" && typeof raw.createPaymentMethod === "function" && typeof raw.confirmCardPayment === "function";
    };
    var PLAIN_OBJECT_STR = "[object Object]";
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$2 = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details."; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (isPromise(raw)) return {
            tag: "async",
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: "empty"
        };
        return {
            tag: "sync",
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: "react-stripe-js",
            version: "2.6.2"
        });
        stripe.registerAppInfo({
            name: "react-stripe-js",
            version: "2.6.2",
            url: "https://stripe.com/docs/stripe-js/react"
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = "ElementsContext";
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    var CartElementContext = /*#__PURE__*/ React.createContext(null);
    CartElementContext.displayName = "CartElementContext";
    var parseCartElementContext = function parseCartElementContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), cart = _React$useState2[0], setCart = _React$useState2[1];
        var _React$useState3 = React.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), cartState = _React$useState4[0], setCartState = _React$useState4[1]; // For a sync stripe instance, initialize into context
        var _React$useState5 = React.useState(function() {
            return {
                stripe: parsed.tag === "sync" ? parsed.stripe : null,
                elements: parsed.tag === "sync" ? parsed.stripe.elements(options) : null
            };
        }), _React$useState6 = _slicedToArray(_React$useState5, 2), ctx = _React$useState6[0], setContext = _React$useState6[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === "sync" && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                "clientSecret",
                "fonts"
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CartElementContext.Provider, {
            value: {
                cart: cart,
                setCart: setCart,
                cartState: cartState,
                setCartState: setCartState
            }
        }, children));
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    var DUMMY_CART_ELEMENT_CONTEXT = {
        cart: null,
        cartState: null,
        setCart: function setCart() {},
        setCartState: function setCartState() {}
    };
    var useCartElementContextWithUseCase = function useCartElementContextWithUseCase(useCaseMessage) {
        var isInCustomCheckout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var ctx = React.useContext(CartElementContext);
        if (isInCustomCheckout) return DUMMY_CART_ELEMENT_CONTEXT;
        return parseCartElementContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase("calls useElements()"), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/payments/checkout/cart-element
   */ var useCartElement = function useCartElement() {
        var _useCartElementContex = useCartElementContextWithUseCase("calls useCartElement()"), cart = _useCartElementContex.cart;
        return cart;
    };
    /**
   * @docs https://stripe.com/docs/payments/checkout/cart-element
   */ var useCartElementState = function useCartElementState() {
        var _useCartElementContex2 = useCartElementContextWithUseCase("calls useCartElementState()"), cartState = _useCartElementContex2.cartState;
        return cartState;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase("mounts <ElementsConsumer>"); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var _excluded = [
        "on",
        "session"
    ];
    var CustomCheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutSdkContext.displayName = "CustomCheckoutSdkContext";
    var parseCustomCheckoutSdkContext = function parseCustomCheckoutSdkContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(useCase, " in an <CustomCheckoutProvider> provider."));
        return ctx;
    };
    var CustomCheckoutContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutContext.displayName = "CustomCheckoutContext";
    var extractCustomCheckoutContextValue = function extractCustomCheckoutContextValue(customCheckoutSdk, sessionState) {
        if (!customCheckoutSdk) return null;
        customCheckoutSdk.on;
        customCheckoutSdk.session;
        var actions = _objectWithoutProperties(customCheckoutSdk, _excluded);
        if (!sessionState) return _objectSpread2(_objectSpread2({}, actions), customCheckoutSdk.session());
        return _objectSpread2(_objectSpread2({}, actions), sessionState);
    };
    var INVALID_STRIPE_ERROR$1 = "Invalid prop `stripe` supplied to `CustomCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.";
    var CustomCheckoutProvider = function CustomCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR$1);
        }, [
            rawStripeProp
        ]); // State used to trigger a re-render when sdk.session is updated
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), session = _React$useState2[0], setSession = _React$useState2[1];
        var _React$useState3 = React.useState(function() {
            return {
                stripe: parsed.tag === "sync" ? parsed.stripe : null,
                customCheckoutSdk: null
            };
        }), _React$useState4 = _slicedToArray(_React$useState3, 2), ctx = _React$useState4[0], setContext = _React$useState4[1];
        var safeSetContext = function safeSetContext(stripe, customCheckoutSdk) {
            setContext(function(ctx) {
                if (ctx.stripe && ctx.customCheckoutSdk) return ctx;
                return {
                    stripe: stripe,
                    customCheckoutSdk: customCheckoutSdk
                };
            });
        }; // Ref used to avoid calling initCustomCheckout multiple times when options changes
        var initCustomCheckoutCalledRef = React.useRef(false);
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted && !initCustomCheckoutCalledRef.current) {
                    // Only update context if the component is still mounted
                    // and stripe is not null. We allow stripe to be null to make
                    // handling SSR easier.
                    initCustomCheckoutCalledRef.current = true;
                    stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                        if (customCheckoutSdk) {
                            safeSetContext(stripe, customCheckoutSdk);
                            customCheckoutSdk.on("change", setSession);
                        }
                    });
                }
            });
            else if (parsed.tag === "sync" && parsed.stripe && !initCustomCheckoutCalledRef.current) {
                initCustomCheckoutCalledRef.current = true;
                parsed.stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                    if (customCheckoutSdk) {
                        safeSetContext(parsed.stripe, customCheckoutSdk);
                        customCheckoutSdk.on("change", setSession);
                    }
                });
            }
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options,
            setSession
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on CustomCheckoutProvider: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            var _prevOptions$elements, _options$elementsOpti;
            if (!ctx.customCheckoutSdk) return;
            if (options.clientSecret && !isUnknownObject(prevOptions) && !isEqual(options.clientSecret, prevOptions.clientSecret)) console.warn("Unsupported prop change: options.client_secret is not a mutable property.");
            var previousAppearance = prevOptions === null || prevOptions === void 0 ? void 0 : (_prevOptions$elements = prevOptions.elementsOptions) === null || _prevOptions$elements === void 0 ? void 0 : _prevOptions$elements.appearance;
            var currentAppearance = options === null || options === void 0 ? void 0 : (_options$elementsOpti = options.elementsOptions) === null || _options$elementsOpti === void 0 ? void 0 : _options$elementsOpti.appearance;
            if (currentAppearance && !isEqual(currentAppearance, previousAppearance)) ctx.customCheckoutSdk.changeAppearance(currentAppearance);
        }, [
            options,
            prevOptions,
            ctx.customCheckoutSdk
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        var customCheckoutContextValue = React.useMemo(function() {
            return extractCustomCheckoutContextValue(ctx.customCheckoutSdk, session);
        }, [
            ctx.customCheckoutSdk,
            session
        ]);
        if (!ctx.customCheckoutSdk) return null;
        return /*#__PURE__*/ React.createElement(CustomCheckoutSdkContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CustomCheckoutContext.Provider, {
            value: customCheckoutContextValue
        }, children));
    };
    CustomCheckoutProvider.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.shape({
            clientSecret: PropTypes.string.isRequired,
            elementsOptions: PropTypes.object
        }).isRequired
    };
    var useCustomCheckoutSdkContextWithUseCase = function useCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var ctx = React.useContext(CustomCheckoutSdkContext);
        return parseCustomCheckoutSdkContext(ctx, useCaseString);
    };
    var useElementsOrCustomCheckoutSdkContextWithUseCase = function useElementsOrCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var customCheckoutSdkContext = React.useContext(CustomCheckoutSdkContext);
        var elementsContext = React.useContext(ElementsContext);
        if (customCheckoutSdkContext && elementsContext) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CustomCheckoutProvider> and <Elements> providers."));
        if (customCheckoutSdkContext) return parseCustomCheckoutSdkContext(customCheckoutSdkContext, useCaseString);
        return parseElementsContext(elementsContext, useCaseString);
    };
    var useCustomCheckout = function useCustomCheckout() {
        // ensure it's in CustomCheckoutProvider
        useCustomCheckoutSdkContextWithUseCase("calls useCustomCheckout()");
        var ctx = React.useContext(CustomCheckoutContext);
        if (!ctx) throw new Error("Could not find CustomCheckout Context; You need to wrap the part of your app that calls useCustomCheckout() in an <CustomCheckoutProvider> provider.");
        return ctx;
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onCheckout = _ref.onCheckout, onLineItemClick = _ref.onLineItemClick, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var ctx = useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = "elements" in ctx ? ctx.elements : null;
            var customCheckoutSdk = "customCheckoutSdk" in ctx ? ctx.customCheckoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null);
            var _useCartElementContex = useCartElementContextWithUseCase("mounts <".concat(displayName, ">"), "customCheckoutSdk" in ctx), setCart = _useCartElementContex.setCart, setCartState = _useCartElementContex.setCartState; // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, "blur", onBlur);
            useAttachEvent(element, "focus", onFocus);
            useAttachEvent(element, "escape", onEscape);
            useAttachEvent(element, "click", onClick);
            useAttachEvent(element, "loaderror", onLoadError);
            useAttachEvent(element, "loaderstart", onLoaderStart);
            useAttachEvent(element, "networkschange", onNetworksChange);
            useAttachEvent(element, "lineitemclick", onLineItemClick);
            useAttachEvent(element, "confirm", onConfirm);
            useAttachEvent(element, "cancel", onCancel);
            useAttachEvent(element, "shippingaddresschange", onShippingAddressChange);
            useAttachEvent(element, "shippingratechange", onShippingRateChange);
            var readyCallback;
            if (type === "cart") readyCallback = function readyCallback(event) {
                setCartState(event);
                onReady && onReady(event);
            };
            else if (onReady) {
                if (type === "expressCheckout") // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, "ready", readyCallback);
            var changeCallback = type === "cart" ? function(event) {
                setCartState(event);
                onChange && onChange(event);
            } : onChange;
            useAttachEvent(element, "change", changeCallback);
            var checkoutCallback = type === "cart" ? function(event) {
                setCartState(event);
                onCheckout && onCheckout(event);
            } : onCheckout;
            useAttachEvent(element, "checkout", checkoutCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || customCheckoutSdk)) {
                    var newElement = null;
                    if (customCheckoutSdk) newElement = customCheckoutSdk.createElement(type, options);
                    else if (elements) newElement = elements.create(type, options);
                    if (type === "cart" && setCart) // we know that elements.create return value must be of type StripeCartElement if type is 'cart',
                    // we need to cast because typescript is not able to infer which overloaded method is used based off param type
                    setCart(newElement);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                customCheckoutSdk,
                options,
                setCart
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    "paymentRequest"
                ]);
                if (updates) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === "function") try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            // Validate that we are in the right context by calling useElementsContextWithUseCase.
            var ctx = useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            useCartElementContextWithUseCase("mounts <".concat(displayName, ">"), "customCheckoutSdk" in ctx);
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onCheckout: PropTypes.func,
            onLineItemClick: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === "undefined";
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = "EmbeddedCheckoutProviderContext";
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error("<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>");
        return ctx;
    };
    var INVALID_STRIPE_ERROR = "Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.";
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === "async" && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === "sync" && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.");
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn("Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.");
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.");
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.");
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.");
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCustomC = useElementsOrCustomCheckoutSdkContextWithUseCase("calls useStripe()"), stripe = _useElementsOrCustomC.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent("auBankAccount", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent("card", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent("cardNumber", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent("cardExpiry", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent("cardCvc", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent("fpxBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent("iban", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent("idealBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent("p24Bank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent("epsBank", isServer);
    var PaymentElement = createElementComponent("payment", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent("expressCheckout", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent("paymentRequestButton", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent("linkAuthentication", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent("address", isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent("shippingAddress", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/elements/cart-element
   */ var CartElement = createElementComponent("cart", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent("paymentMethodMessaging", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent("affirmMessage", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent("afterpayClearpayMessage", isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CartElement = CartElement;
    exports1.CustomCheckoutProvider = CustomCheckoutProvider;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.EpsBankElement = EpsBankElement;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCartElement = useCartElement;
    exports1.useCartElementState = useCartElementState;
    exports1.useCustomCheckout = useCustomCheckout;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});



const $5ca181f363cd7023$var$PaymentForm = ()=>{
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { state: state } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const stripe = (0, $7bf3b98cbc00db03$exports.useStripe)();
    const elements = (0, $7bf3b98cbc00db03$exports.useElements)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        onSubmit: async (values)=>{
            // only keep the digits and remove whitespace
            const params = {
                ...state,
                ...values
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($3017a5eb21b16dc2$exports))).track("form-page-viewed", {
                "form-name": "payment"
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($3017a5eb21b16dc2$exports))).track("form-ended", state);
            await elements.submit();
            try {
                const apiCall = await fetch("https://rqhmlju8s0.execute-api.us-east-1.amazonaws.com/hahs-prod/stripe/create-subscription", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(params)
                });
                const responseJSON = await apiCall.json();
                const { secret: secret, type: type } = responseJSON;
                const confirmIntent = type === "setup" ? stripe.confirmSetup : stripe.confirmPayment;
                const { error: error } = await confirmIntent({
                    elements: elements,
                    clientSecret: secret,
                    confirmParams: {
                        return_url: `${"https://core.forms.caringwire.com"}/hahs/success`
                    }
                });
                if (error) console.error(error.message);
            } catch (e) {
                console.error(e);
            }
        },
        validate: (values)=>{
            const errors = {};
            return errors;
        },
        render: ({ handleSubmit: handleSubmit, submitError: submitError, valid: valid })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "m-8 overflow-clip rounded-3xl bg-white",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                                    children: "Payment Information"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                                    children: "Great! Now all we need are your payment details and we're good to go!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-caringwireDarkBlue mt-4 text-center text-sm",
                            children: [
                                "HAHS Subscription is $99/yr + Tax",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                "Your credit card will be charged: ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                    children: "$104.49"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                "We never store your card number or CVC number"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8 pt-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4",
                                children: [
                                    submitError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-500",
                                        children: (0, $7f17f1906b9f3211$export$97cd7fc25dd32915)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.PaymentElement), {
                                        className: "focus-visible:outline-none"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "mt-4 flex items-center justify-start",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>{
                                                    navigate("/hahs/address", {
                                                        state: state
                                                    });
                                                },
                                                className: "bg-caringwire mr-8 inline-flex items-center px-4 py-2 font-bold text-white hover:bg-blue-700",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u2190"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                type: "submit",
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("bg-caringwire inline-flex w-20 items-center justify-center px-4 py-2 font-bold text-white hover:bg-blue-700", !valid && "opacity-20"),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "OK"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("ml-2 text-xs", !valid && "opacity-20"),
                                                children: [
                                                    "\u23CE press ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "Enter"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
};
var $5ca181f363cd7023$export$2e2bcd8739ae039 = $5ca181f363cd7023$var$PaymentForm;


var $7eea542a2a30f949$var$V3_URL = "https://js.stripe.com/v3";
var $7eea542a2a30f949$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $7eea542a2a30f949$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $7eea542a2a30f949$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($7eea542a2a30f949$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$7eea542a2a30f949$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $7eea542a2a30f949$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($7eea542a2a30f949$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $7eea542a2a30f949$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "3.0.10",
        startTime: startTime
    });
};
var $7eea542a2a30f949$var$stripePromise = null;
var $7eea542a2a30f949$var$onErrorListener = null;
var $7eea542a2a30f949$var$onLoadListener = null;
var $7eea542a2a30f949$var$onError = function onError(reject) {
    return function() {
        reject(new Error("Failed to load Stripe.js"));
    };
};
var $7eea542a2a30f949$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error("Stripe.js not available"));
    };
};
var $7eea542a2a30f949$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($7eea542a2a30f949$var$stripePromise !== null) return $7eea542a2a30f949$var$stripePromise;
    $7eea542a2a30f949$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($7eea542a2a30f949$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $7eea542a2a30f949$var$findScript();
            if (script && params) console.warn($7eea542a2a30f949$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $7eea542a2a30f949$var$injectScript(params);
            else if (script && $7eea542a2a30f949$var$onLoadListener !== null && $7eea542a2a30f949$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener("load", $7eea542a2a30f949$var$onLoadListener);
                script.removeEventListener("error", $7eea542a2a30f949$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $7eea542a2a30f949$var$injectScript(params);
            }
            $7eea542a2a30f949$var$onLoadListener = $7eea542a2a30f949$var$onLoad(resolve, reject);
            $7eea542a2a30f949$var$onErrorListener = $7eea542a2a30f949$var$onError(reject);
            script.addEventListener("load", $7eea542a2a30f949$var$onLoadListener);
            script.addEventListener("error", $7eea542a2a30f949$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $7eea542a2a30f949$var$stripePromise["catch"](function(error) {
        $7eea542a2a30f949$var$stripePromise = null;
        return Promise.reject(error);
    });
};
var $7eea542a2a30f949$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $7eea542a2a30f949$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $7eea542a2a30f949$var$stripePromise$1;
var $7eea542a2a30f949$var$loadCalled = false;
var $7eea542a2a30f949$var$getStripePromise = function getStripePromise() {
    if ($7eea542a2a30f949$var$stripePromise$1) return $7eea542a2a30f949$var$stripePromise$1;
    $7eea542a2a30f949$var$stripePromise$1 = $7eea542a2a30f949$var$loadScript(null)["catch"](function(error) {
        // clear cache on error
        $7eea542a2a30f949$var$stripePromise$1 = null;
        return Promise.reject(error);
    });
    return $7eea542a2a30f949$var$stripePromise$1;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return $7eea542a2a30f949$var$getStripePromise();
})["catch"](function(error) {
    if (!$7eea542a2a30f949$var$loadCalled) console.warn(error);
});
var $7eea542a2a30f949$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $7eea542a2a30f949$var$loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return $7eea542a2a30f949$var$getStripePromise().then(function(maybeStripe) {
        return $7eea542a2a30f949$var$initStripe(maybeStripe, args, startTime);
    });
};




parcelRequire("acw62");

const $ce0d1bd640cc8431$var$SuccessPage = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($3017a5eb21b16dc2$exports))).track("form-page-viewed", {
        "form-name": "success"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "m-8 overflow-clip rounded-3xl bg-white",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex flex-col",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col content-center justify-center gap-1 bg-white p-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "text-caringwireDarkBlue mb-2 text-center text-3xl font-bold",
                        children: [
                            "Success",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-caringwireDarkBlue mb-2 text-center text-xl font-light",
                        children: "Your information has been successfully submitted. We will contact you shortly!"
                    })
                ]
            })
        })
    });
};
var $ce0d1bd640cc8431$export$2e2bcd8739ae039 = $ce0d1bd640cc8431$var$SuccessPage;


const $cd93687958c8007e$var$stripePromise = (0, $7eea542a2a30f949$export$de80f7562c3fd6b1)("pk_test_51OniN4CYoJkhdgxLABsTZOr83Ja31XJu6b4jQInGwnpAyaYVf9odha7Ch22fQgDdsisxrHBsQEH3fuOEg3DJPjND00e4xndxM2");
const $cd93687958c8007e$var$stripeHahsSubscriptionOptions = {
    mode: "subscription",
    amount: 10449,
    currency: "usd",
    appearance: {
        theme: "stripe",
        rules: {
            ".Input": {
                border: "2px solid #038fca",
                outline: "none",
                borderRadius: "0.375rem;"
            },
            ".Input:focus": {
                border: "1px solid #C4C4C4",
                outline: "none"
            }
        }
    }
};
function $cd93687958c8007e$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$Layout, {}),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "hahs",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$Layout, {}),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a00bb0b32f3727d$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "dob",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81e332e9c2fc3191$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "address",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbd5e2ca5ac31863$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "success",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce0d1bd640cc8431$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "payment",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bf3b98cbc00db03$exports.Elements), {
                                stripe: $cd93687958c8007e$var$stripePromise,
                                options: $cd93687958c8007e$var$stripeHahsSubscriptionOptions,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca181f363cd7023$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                })
            })
        })
    });
}
function $cd93687958c8007e$var$Layout() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
    });
}
function $cd93687958c8007e$var$NoMatch() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Nothing to see here!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: "Go to the home page "
                })
            })
        ]
    });
}


const $35da740d59af89ba$var$container = document.getElementById("app");
const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($35da740d59af89ba$var$container);
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=index.baa4c58b.js.map
